!(function () {
    (window.WootricSurvey =
        window.WootricSurvey ||
        (function () {
            function o(o, t, e) {
                if (4 !== t.length)
                    throw new d.exception.invalid("invalid aes block size");
                var r = o.b[e],
                    i = t[0] ^ r[0],
                    n = t[e ? 3 : 1] ^ r[1],
                    c = t[2] ^ r[2];
                t = t[e ? 1 : 3] ^ r[3];
                var a,
                    l,
                    s,
                    u,
                    m = r.length / 4 - 2,
                    p = 4,
                    f = [0, 0, 0, 0];
                o = (a = o.s[e])[0];
                var w = a[1],
                    h = a[2],
                    g = a[3],
                    b = a[4];
                for (u = 0; u < m; u++)
                    (a =
                        o[i >>> 24] ^
                        w[(n >> 16) & 255] ^
                        h[(c >> 8) & 255] ^
                        g[255 & t] ^
                        r[p]),
                        (l =
                            o[n >>> 24] ^
                            w[(c >> 16) & 255] ^
                            h[(t >> 8) & 255] ^
                            g[255 & i] ^
                            r[p + 1]),
                        (s =
                            o[c >>> 24] ^
                            w[(t >> 16) & 255] ^
                            h[(i >> 8) & 255] ^
                            g[255 & n] ^
                            r[p + 2]),
                        (t =
                            o[t >>> 24] ^
                            w[(i >> 16) & 255] ^
                            h[(n >> 8) & 255] ^
                            g[255 & c] ^
                            r[p + 3]),
                        (p += 4),
                        (i = a),
                        (n = l),
                        (c = s);
                for (u = 0; u < 4; u++)
                    (f[e ? 3 & -u : u] =
                        (b[i >>> 24] << 24) ^
                        (b[(n >> 16) & 255] << 16) ^
                        (b[(c >> 8) & 255] << 8) ^
                        b[255 & t] ^
                        r[p++]),
                        (a = i),
                        (i = n),
                        (n = c),
                        (c = t),
                        (t = a);
                return f;
            }
            function t(o, t) {
                var e,
                    r,
                    i,
                    n = t.slice(0),
                    c = o.F,
                    a = o.b,
                    l = c[0],
                    s = c[1],
                    d = c[2],
                    u = c[3],
                    m = c[4],
                    p = c[5],
                    f = c[6],
                    w = c[7];
                for (e = 0; e < 64; e++)
                    (r =
                        (r =
                            e < 16
                                ? n[e]
                                : ((r = n[(e + 1) & 15]),
                                  (i = n[(e + 14) & 15]),
                                  (n[15 & e] =
                                      (((r >>> 7) ^
                                          (r >>> 18) ^
                                          (r >>> 3) ^
                                          (r << 25) ^
                                          (r << 14)) +
                                          ((i >>> 17) ^
                                              (i >>> 19) ^
                                              (i >>> 10) ^
                                              (i << 15) ^
                                              (i << 13)) +
                                          n[15 & e] +
                                          n[(e + 9) & 15]) |
                                      0))) +
                        w +
                        ((m >>> 6) ^
                            (m >>> 11) ^
                            (m >>> 25) ^
                            (m << 26) ^
                            (m << 21) ^
                            (m << 7)) +
                        (f ^ (m & (p ^ f))) +
                        a[e]),
                        (w = f),
                        (f = p),
                        (p = m),
                        (m = (u + r) | 0),
                        (u = d),
                        (d = s),
                        (l =
                            (r +
                                (((s = l) & d) ^ (u & (s ^ d))) +
                                ((s >>> 2) ^
                                    (s >>> 13) ^
                                    (s >>> 22) ^
                                    (s << 30) ^
                                    (s << 19) ^
                                    (s << 10))) |
                            0);
                (c[0] = (c[0] + l) | 0),
                    (c[1] = (c[1] + s) | 0),
                    (c[2] = (c[2] + d) | 0),
                    (c[3] = (c[3] + u) | 0),
                    (c[4] = (c[4] + m) | 0),
                    (c[5] = (c[5] + p) | 0),
                    (c[6] = (c[6] + f) | 0),
                    (c[7] = (c[7] + w) | 0);
            }
            function e(o, t) {
                var e,
                    r = d.random.K[o],
                    i = [];
                for (e in r) r.hasOwnProperty(e) && i.push(r[e]);
                for (e = 0; e < i.length; e++) i[e](t);
            }
            function r(o) {
                "undefined" != typeof window &&
                window.performance &&
                "function" == typeof window.performance.now
                    ? d.random.addEntropy(
                          window.performance.now(),
                          o,
                          "loadtime"
                      )
                    : d.random.addEntropy(new Date().valueOf(), o, "loadtime");
            }
            function i(o) {
                (o.b = n(o).concat(n(o))), (o.L = new d.cipher.aes(o.b));
            }
            function n(o) {
                for (
                    var t = 0;
                    t < 4 && ((o.h[t] = (o.h[t] + 1) | 0), !o.h[t]);
                    t++
                );
                return o.L.encrypt(o.h);
            }
            function c(o, t) {
                return function () {
                    t.apply(o, arguments);
                };
            }
            var a, l, s;
            !(function (o) {
                function t(o, t) {
                    return b.call(o, t);
                }
                function e(o, t) {
                    var e,
                        r,
                        i,
                        n,
                        c,
                        a,
                        l,
                        s,
                        d,
                        u,
                        m,
                        p = t && t.split("/"),
                        f = h.map,
                        w = (f && f["*"]) || {};
                    if (o && "." === o.charAt(0))
                        if (t) {
                            for (
                                c = (o = o.split("/")).length - 1,
                                    h.nodeIdCompat &&
                                        y.test(o[c]) &&
                                        (o[c] = o[c].replace(y, "")),
                                    o = p.slice(0, p.length - 1).concat(o),
                                    d = 0;
                                d < o.length;
                                d += 1
                            )
                                if ("." === (m = o[d]))
                                    o.splice(d, 1), (d -= 1);
                                else if (".." === m) {
                                    if (
                                        1 === d &&
                                        (".." === o[2] || ".." === o[0])
                                    )
                                        break;
                                    0 < d && (o.splice(d - 1, 2), (d -= 2));
                                }
                            o = o.join("/");
                        } else 0 === o.indexOf("./") && (o = o.substring(2));
                    if ((p || w) && f) {
                        for (d = (e = o.split("/")).length; 0 < d; d -= 1) {
                            if (((r = e.slice(0, d).join("/")), p))
                                for (u = p.length; 0 < u; u -= 1)
                                    if (
                                        (i =
                                            (i = f[p.slice(0, u).join("/")]) &&
                                            i[r])
                                    ) {
                                        (n = i), (a = d);
                                        break;
                                    }
                            if (n) break;
                            !l && w && w[r] && ((l = w[r]), (s = d));
                        }
                        !n && l && ((n = l), (a = s)),
                            n && (e.splice(0, a, n), (o = e.join("/")));
                    }
                    return o;
                }
                function r(t, e) {
                    return function () {
                        var r = v.call(arguments, 0);
                        return (
                            "string" != typeof r[0] &&
                                1 === r.length &&
                                r.push(null),
                            u.apply(o, r.concat([t, e]))
                        );
                    };
                }
                function i(o) {
                    return function (t) {
                        f[o] = t;
                    };
                }
                function n(e) {
                    if (t(w, e)) {
                        var r = w[e];
                        delete w[e], (g[e] = !0), d.apply(o, r);
                    }
                    if (!t(f, e) && !t(g, e)) throw new Error("No " + e);
                    return f[e];
                }
                function c(o) {
                    var t,
                        e = o ? o.indexOf("!") : -1;
                    return (
                        -1 < e &&
                            ((t = o.substring(0, e)),
                            (o = o.substring(e + 1, o.length))),
                        [t, o]
                    );
                }
                var d,
                    u,
                    m,
                    p,
                    f = {},
                    w = {},
                    h = {},
                    g = {},
                    b = Object.prototype.hasOwnProperty,
                    v = [].slice,
                    y = /\.js$/;
                (m = function (o, t) {
                    var r,
                        i = c(o),
                        a = i[0];
                    return (
                        (o = i[1]),
                        a && (r = n((a = e(a, t)))),
                        a
                            ? (o =
                                  r && r.normalize
                                      ? r.normalize(
                                            o,
                                            (function (o) {
                                                return function (t) {
                                                    return e(t, o);
                                                };
                                            })(t)
                                        )
                                      : e(o, t))
                            : ((a = (i = c((o = e(o, t))))[0]),
                              (o = i[1]),
                              a && (r = n(a))),
                        { f: a ? a + "!" + o : o, n: o, pr: a, p: r }
                    );
                }),
                    (p = {
                        require: function (o) {
                            return r(o);
                        },
                        exports: function (o) {
                            var t = f[o];
                            return void 0 !== t ? t : (f[o] = {});
                        },
                        module: function (o) {
                            return {
                                id: o,
                                uri: "",
                                exports: f[o],
                                config: (function (o) {
                                    return function () {
                                        return (
                                            (h && h.config && h.config[o]) || {}
                                        );
                                    };
                                })(o),
                            };
                        },
                    }),
                    (d = function (e, c, a, l) {
                        var s,
                            d,
                            u,
                            h,
                            b,
                            v,
                            y = [],
                            _ = typeof a;
                        if (
                            ((l = l || e), "undefined" == _ || "function" == _)
                        ) {
                            for (
                                c =
                                    !c.length && a.length
                                        ? ["require", "exports", "module"]
                                        : c,
                                    b = 0;
                                b < c.length;
                                b += 1
                            )
                                if ("require" === (d = (h = m(c[b], l)).f))
                                    y[b] = p.require(e);
                                else if ("exports" === d)
                                    (y[b] = p.exports(e)), (v = !0);
                                else if ("module" === d) s = y[b] = p.module(e);
                                else if (t(f, d) || t(w, d) || t(g, d))
                                    y[b] = n(d);
                                else {
                                    if (!h.p)
                                        throw new Error(e + " missing " + d);
                                    h.p.load(h.n, r(l, !0), i(d), {}),
                                        (y[b] = f[d]);
                                }
                            (u = a ? a.apply(f[e], y) : void 0),
                                e &&
                                    (s && s.exports !== o && s.exports !== f[e]
                                        ? (f[e] = s.exports)
                                        : (u === o && v) || (f[e] = u));
                        } else e && (f[e] = a);
                    }),
                    (a =
                        l =
                        u =
                            function (t, e, r, i, c) {
                                if ("string" == typeof t)
                                    return p[t] ? p[t](e) : n(m(t, e).f);
                                if (!t.splice) {
                                    if (
                                        ((h = t).deps && u(h.deps, h.callback),
                                        !e)
                                    )
                                        return;
                                    e.splice
                                        ? ((t = e), (e = r), (r = null))
                                        : (t = o);
                                }
                                return (
                                    (e = e || function () {}),
                                    "function" == typeof r &&
                                        ((r = i), (i = c)),
                                    i
                                        ? d(o, t, e, r)
                                        : setTimeout(function () {
                                              d(o, t, e, r);
                                          }, 4),
                                    u
                                );
                            }),
                    (u.config = function (o) {
                        return u(o);
                    }),
                    (a._defined = f),
                    ((s = function (o, e, r) {
                        if ("string" != typeof o)
                            throw new Error(
                                "See almond README: incorrect module build, no module name"
                            );
                        e.splice || ((r = e), (e = [])),
                            t(f, o) || t(w, o) || (w[o] = [o, e, r]);
                    }).amd = { jQuery: !0 });
            })(),
                s("lib/almond", function () {}),
                (function (o, t) {
                    "use strict";
                    "object" == typeof module &&
                    "object" == typeof module.exports
                        ? (module.exports = o.document
                              ? t(o, !0)
                              : function (o) {
                                    if (!o.document)
                                        throw new Error(
                                            "jQuery requires a window with a document"
                                        );
                                    return t(o);
                                })
                        : t(o);
                })(
                    "undefined" != typeof window ? window : this,
                    function (o, t) {
                        "use strict";
                        function e(o, t, e) {
                            var r,
                                i,
                                n = (e = e || Z).createElement("script");
                            if (((n.text = o), t))
                                for (r in fo)
                                    (i =
                                        t[r] ||
                                        (t.getAttribute &&
                                            t.getAttribute(r))) &&
                                        n.setAttribute(r, i);
                            e.head.appendChild(n).parentNode.removeChild(n);
                        }
                        function r(o) {
                            return null == o
                                ? o + ""
                                : "object" == typeof o || "function" == typeof o
                                ? no[co.call(o)] || "object"
                                : typeof o;
                        }
                        function i(o) {
                            var t = !!o && "length" in o && o.length,
                                e = r(o);
                            return (
                                !mo(o) &&
                                !po(o) &&
                                ("array" === e ||
                                    0 === t ||
                                    ("number" == typeof t &&
                                        0 < t &&
                                        t - 1 in o))
                            );
                        }
                        function n(o, t) {
                            return (
                                o.nodeName &&
                                o.nodeName.toLowerCase() === t.toLowerCase()
                            );
                        }
                        function c(o, t, e) {
                            return mo(t)
                                ? ho.grep(o, function (o, r) {
                                      return !!t.call(o, r, o) !== e;
                                  })
                                : t.nodeType
                                ? ho.grep(o, function (o) {
                                      return (o === t) !== e;
                                  })
                                : "string" != typeof t
                                ? ho.grep(o, function (o) {
                                      return -1 < io.call(t, o) !== e;
                                  })
                                : ho.filter(t, o, e);
                        }
                        function a(o, t) {
                            for (; (o = o[t]) && 1 !== o.nodeType; );
                            return o;
                        }
                        function l(o) {
                            return o;
                        }
                        function d(o) {
                            throw o;
                        }
                        function u(o, t, e, r) {
                            var i;
                            try {
                                o && mo((i = o.promise))
                                    ? i.call(o).done(t).fail(e)
                                    : o && mo((i = o.then))
                                    ? i.call(o, t, e)
                                    : t.apply(void 0, [o].slice(r));
                            } catch (o) {
                                e.apply(void 0, [o]);
                            }
                        }
                        function m() {
                            Z.removeEventListener("DOMContentLoaded", m),
                                o.removeEventListener("load", m),
                                ho.ready();
                        }
                        function p(o, t) {
                            return t.toUpperCase();
                        }
                        function f(o) {
                            return o.replace(qo, "ms-").replace(Lo, p);
                        }
                        function w() {
                            this.expando = ho.expando + w.uid++;
                        }
                        function h(o, t, e) {
                            var r, i;
                            if (void 0 === e && 1 === o.nodeType)
                                if (
                                    ((r =
                                        "data-" +
                                        t.replace(Po, "-$&").toLowerCase()),
                                    "string" == typeof (e = o.getAttribute(r)))
                                ) {
                                    try {
                                        e =
                                            "true" === (i = e) ||
                                            ("false" !== i &&
                                                ("null" === i
                                                    ? null
                                                    : i === +i + ""
                                                    ? +i
                                                    : Mo.test(i)
                                                    ? JSON.parse(i)
                                                    : i));
                                    } catch (o) {}
                                    Oo.set(o, t, e);
                                } else e = void 0;
                            return e;
                        }
                        function g(o, t, e, r) {
                            var i,
                                n,
                                c = 20,
                                a = r
                                    ? function () {
                                          return r.cur();
                                      }
                                    : function () {
                                          return ho.css(o, t, "");
                                      },
                                l = a(),
                                s =
                                    (e && e[3]) ||
                                    (ho.cssNumber[t] ? "" : "px"),
                                d =
                                    o.nodeType &&
                                    (ho.cssNumber[t] || ("px" !== s && +l)) &&
                                    Io.exec(ho.css(o, t));
                            if (d && d[3] !== s) {
                                for (l /= 2, s = s || d[3], d = +l || 1; c--; )
                                    ho.style(o, t, d + s),
                                        (1 - n) * (1 - (n = a() / l || 0.5)) <=
                                            0 && (c = 0),
                                        (d /= n);
                                (d *= 2), ho.style(o, t, d + s), (e = e || []);
                            }
                            return (
                                e &&
                                    ((d = +d || +l || 0),
                                    (i = e[1] ? d + (e[1] + 1) * e[2] : +e[2]),
                                    r &&
                                        ((r.unit = s),
                                        (r.start = d),
                                        (r.end = i))),
                                i
                            );
                        }
                        function b(o, t) {
                            for (
                                var e,
                                    r,
                                    i,
                                    n,
                                    c,
                                    a,
                                    l,
                                    s = [],
                                    d = 0,
                                    u = o.length;
                                d < u;
                                d++
                            )
                                (r = o[d]).style &&
                                    ((e = r.style.display),
                                    t
                                        ? ("none" === e &&
                                              ((s[d] =
                                                  Do.get(r, "display") || null),
                                              s[d] || (r.style.display = "")),
                                          "" === r.style.display &&
                                              Uo(r) &&
                                              (s[d] =
                                                  ((l = c = n = void 0),
                                                  (c = (i = r).ownerDocument),
                                                  (a = i.nodeName),
                                                  (l = Xo[a]) ||
                                                      ((n = c.body.appendChild(
                                                          c.createElement(a)
                                                      )),
                                                      (l = ho.css(
                                                          n,
                                                          "display"
                                                      )),
                                                      n.parentNode.removeChild(
                                                          n
                                                      ),
                                                      "none" === l &&
                                                          (l = "block"),
                                                      (Xo[a] = l)))))
                                        : "none" !== e &&
                                          ((s[d] = "none"),
                                          Do.set(r, "display", e)));
                            for (d = 0; d < u; d++)
                                null != s[d] && (o[d].style.display = s[d]);
                            return o;
                        }
                        function v(o, t) {
                            var e;
                            return (
                                (e =
                                    void 0 !== o.getElementsByTagName
                                        ? o.getElementsByTagName(t || "*")
                                        : void 0 !== o.querySelectorAll
                                        ? o.querySelectorAll(t || "*")
                                        : []),
                                void 0 === t || (t && n(o, t))
                                    ? ho.merge([o], e)
                                    : e
                            );
                        }
                        function y(o, t) {
                            for (var e = 0, r = o.length; e < r; e++)
                                Do.set(
                                    o[e],
                                    "globalEval",
                                    !t || Do.get(t[e], "globalEval")
                                );
                        }
                        function _(o, t, e, i, n) {
                            for (
                                var c,
                                    a,
                                    l,
                                    s,
                                    d,
                                    u,
                                    m = t.createDocumentFragment(),
                                    p = [],
                                    f = 0,
                                    w = o.length;
                                f < w;
                                f++
                            )
                                if ((c = o[f]) || 0 === c)
                                    if ("object" === r(c))
                                        ho.merge(p, c.nodeType ? [c] : c);
                                    else if (Zo.test(c)) {
                                        for (
                                            a =
                                                a ||
                                                m.appendChild(
                                                    t.createElement("div")
                                                ),
                                                l = (Vo.exec(c) || [
                                                    "",
                                                    "",
                                                ])[1].toLowerCase(),
                                                s = Jo[l] || Jo._default,
                                                a.innerHTML =
                                                    s[1] +
                                                    ho.htmlPrefilter(c) +
                                                    s[2],
                                                u = s[0];
                                            u--;

                                        )
                                            a = a.lastChild;
                                        ho.merge(p, a.childNodes),
                                            ((a = m.firstChild).textContent =
                                                "");
                                    } else p.push(t.createTextNode(c));
                            for (m.textContent = "", f = 0; (c = p[f++]); )
                                if (i && -1 < ho.inArray(c, i)) n && n.push(c);
                                else if (
                                    ((d = Wo(c)),
                                    (a = v(m.appendChild(c), "script")),
                                    d && y(a),
                                    e)
                                )
                                    for (u = 0; (c = a[u++]); )
                                        Go.test(c.type || "") && e.push(c);
                            return m;
                        }
                        function x() {
                            return !0;
                        }
                        function k() {
                            return !1;
                        }
                        function z(o, t) {
                            return (
                                (o ===
                                    (function () {
                                        try {
                                            return Z.activeElement;
                                        } catch (o) {}
                                    })()) ==
                                ("focus" === t)
                            );
                        }
                        function C(o, t, e, r, i, n) {
                            var c, a;
                            if ("object" == typeof t) {
                                for (a in ("string" != typeof e &&
                                    ((r = r || e), (e = void 0)),
                                t))
                                    C(o, a, e, r, t[a], n);
                                return o;
                            }
                            if (
                                (null == r && null == i
                                    ? ((i = e), (r = e = void 0))
                                    : null == i &&
                                      ("string" == typeof e
                                          ? ((i = r), (r = void 0))
                                          : ((i = r), (r = e), (e = void 0))),
                                !1 === i)
                            )
                                i = k;
                            else if (!i) return o;
                            return (
                                1 === n &&
                                    ((c = i),
                                    ((i = function (o) {
                                        return (
                                            ho().off(o),
                                            c.apply(this, arguments)
                                        );
                                    }).guid = c.guid || (c.guid = ho.guid++))),
                                o.each(function () {
                                    ho.event.add(this, t, i, r, e);
                                })
                            );
                        }
                        function T(o, t, e) {
                            e
                                ? (Do.set(o, t, !1),
                                  ho.event.add(o, t, {
                                      namespace: !1,
                                      handler: function (o) {
                                          var r,
                                              i,
                                              n = Do.get(this, t);
                                          if (1 & o.isTrigger && this[t]) {
                                              if (n.length)
                                                  (ho.event.special[t] || {})
                                                      .delegateType &&
                                                      o.stopPropagation();
                                              else if (
                                                  ((n = to.call(arguments)),
                                                  Do.set(this, t, n),
                                                  (r = e(this, t)),
                                                  this[t](),
                                                  n !== (i = Do.get(this, t)) ||
                                                  r
                                                      ? Do.set(this, t, !1)
                                                      : (i = {}),
                                                  n !== i)
                                              )
                                                  return (
                                                      o.stopImmediatePropagation(),
                                                      o.preventDefault(),
                                                      i.value
                                                  );
                                          } else
                                              n.length &&
                                                  (Do.set(this, t, {
                                                      value: ho.event.trigger(
                                                          ho.extend(
                                                              n[0],
                                                              ho.Event.prototype
                                                          ),
                                                          n.slice(1),
                                                          this
                                                      ),
                                                  }),
                                                  o.stopImmediatePropagation());
                                      },
                                  }))
                                : void 0 === Do.get(o, t) &&
                                  ho.event.add(o, t, x);
                        }
                        function S(o, t) {
                            return (
                                (n(o, "table") &&
                                    n(
                                        11 !== t.nodeType ? t : t.firstChild,
                                        "tr"
                                    ) &&
                                    ho(o).children("tbody")[0]) ||
                                o
                            );
                        }
                        function E(o) {
                            return (
                                (o.type =
                                    (null !== o.getAttribute("type")) +
                                    "/" +
                                    o.type),
                                o
                            );
                        }
                        function A(o) {
                            return (
                                "true/" === (o.type || "").slice(0, 5)
                                    ? (o.type = o.type.slice(5))
                                    : o.removeAttribute("type"),
                                o
                            );
                        }
                        function j(o, t) {
                            var e, r, i, n, c, a, l, s;
                            if (1 === t.nodeType) {
                                if (
                                    Do.hasData(o) &&
                                    ((n = Do.access(o)),
                                    (c = Do.set(t, n)),
                                    (s = n.events))
                                )
                                    for (i in (delete c.handle,
                                    (c.events = {}),
                                    s))
                                        for (e = 0, r = s[i].length; e < r; e++)
                                            ho.event.add(t, i, s[i][e]);
                                Oo.hasData(o) &&
                                    ((a = Oo.access(o)),
                                    (l = ho.extend({}, a)),
                                    Oo.set(t, l));
                            }
                        }
                        function q(o, t, r, i) {
                            t = eo.apply([], t);
                            var n,
                                c,
                                a,
                                l,
                                s,
                                d,
                                u = 0,
                                m = o.length,
                                p = m - 1,
                                f = t[0],
                                w = mo(f);
                            if (
                                w ||
                                (1 < m &&
                                    "string" == typeof f &&
                                    !uo.checkClone &&
                                    nt.test(f))
                            )
                                return o.each(function (e) {
                                    var n = o.eq(e);
                                    w && (t[0] = f.call(this, e, n.html())),
                                        q(n, t, r, i);
                                });
                            if (
                                m &&
                                ((c = (n = _(t, o[0].ownerDocument, !1, o, i))
                                    .firstChild),
                                1 === n.childNodes.length && (n = c),
                                c || i)
                            ) {
                                for (
                                    l = (a = ho.map(v(n, "script"), E)).length;
                                    u < m;
                                    u++
                                )
                                    (s = n),
                                        u !== p &&
                                            ((s = ho.clone(s, !0, !0)),
                                            l && ho.merge(a, v(s, "script"))),
                                        r.call(o[u], s, u);
                                if (l)
                                    for (
                                        d = a[a.length - 1].ownerDocument,
                                            ho.map(a, A),
                                            u = 0;
                                        u < l;
                                        u++
                                    )
                                        (s = a[u]),
                                            Go.test(s.type || "") &&
                                                !Do.access(s, "globalEval") &&
                                                ho.contains(d, s) &&
                                                (s.src &&
                                                "module" !==
                                                    (s.type || "").toLowerCase()
                                                    ? ho._evalUrl &&
                                                      !s.noModule &&
                                                      ho._evalUrl(s.src, {
                                                          nonce:
                                                              s.nonce ||
                                                              s.getAttribute(
                                                                  "nonce"
                                                              ),
                                                      })
                                                    : e(
                                                          s.textContent.replace(
                                                              ct,
                                                              ""
                                                          ),
                                                          s,
                                                          d
                                                      ));
                            }
                            return o;
                        }
                        function L(o, t, e) {
                            for (
                                var r, i = t ? ho.filter(t, o) : o, n = 0;
                                null != (r = i[n]);
                                n++
                            )
                                e || 1 !== r.nodeType || ho.cleanData(v(r)),
                                    r.parentNode &&
                                        (e && Wo(r) && y(v(r, "script")),
                                        r.parentNode.removeChild(r));
                            return o;
                        }
                        function N(o, t, e) {
                            var r,
                                i,
                                n,
                                c,
                                a = o.style;
                            return (
                                (e = e || lt(o)) &&
                                    ("" !==
                                        (c = e.getPropertyValue(t) || e[t]) ||
                                        Wo(o) ||
                                        (c = ho.style(o, t)),
                                    !uo.pixelBoxStyles() &&
                                        at.test(c) &&
                                        st.test(t) &&
                                        ((r = a.width),
                                        (i = a.minWidth),
                                        (n = a.maxWidth),
                                        (a.minWidth = a.maxWidth = a.width = c),
                                        (c = e.width),
                                        (a.width = r),
                                        (a.minWidth = i),
                                        (a.maxWidth = n))),
                                void 0 !== c ? c + "" : c
                            );
                        }
                        function D(o, t) {
                            return {
                                get: function () {
                                    if (!o())
                                        return (this.get = t).apply(
                                            this,
                                            arguments
                                        );
                                    delete this.get;
                                },
                            };
                        }
                        function O(o) {
                            return (
                                ho.cssProps[o] ||
                                mt[o] ||
                                (o in ut
                                    ? o
                                    : (mt[o] =
                                          (function (o) {
                                              for (
                                                  var t =
                                                          o[0].toUpperCase() +
                                                          o.slice(1),
                                                      e = dt.length;
                                                  e--;

                                              )
                                                  if ((o = dt[e] + t) in ut)
                                                      return o;
                                          })(o) || o))
                            );
                        }
                        function M(o, t, e) {
                            var r = Io.exec(t);
                            return r
                                ? Math.max(0, r[2] - (e || 0)) + (r[3] || "px")
                                : t;
                        }
                        function P(o, t, e, r, i, n) {
                            var c = "width" === t ? 1 : 0,
                                a = 0,
                                l = 0;
                            if (e === (r ? "border" : "content")) return 0;
                            for (; c < 4; c += 2)
                                "margin" === e &&
                                    (l += ho.css(o, e + Ro[c], !0, i)),
                                    r
                                        ? ("content" === e &&
                                              (l -= ho.css(
                                                  o,
                                                  "padding" + Ro[c],
                                                  !0,
                                                  i
                                              )),
                                          "margin" !== e &&
                                              (l -= ho.css(
                                                  o,
                                                  "border" + Ro[c] + "Width",
                                                  !0,
                                                  i
                                              )))
                                        : ((l += ho.css(
                                              o,
                                              "padding" + Ro[c],
                                              !0,
                                              i
                                          )),
                                          "padding" !== e
                                              ? (l += ho.css(
                                                    o,
                                                    "border" + Ro[c] + "Width",
                                                    !0,
                                                    i
                                                ))
                                              : (a += ho.css(
                                                    o,
                                                    "border" + Ro[c] + "Width",
                                                    !0,
                                                    i
                                                )));
                            return (
                                !r &&
                                    0 <= n &&
                                    (l +=
                                        Math.max(
                                            0,
                                            Math.ceil(
                                                o[
                                                    "offset" +
                                                        t[0].toUpperCase() +
                                                        t.slice(1)
                                                ] -
                                                    n -
                                                    l -
                                                    a -
                                                    0.5
                                            )
                                        ) || 0),
                                l
                            );
                        }
                        function B(o, t, e) {
                            var r = lt(o),
                                i =
                                    (!uo.boxSizingReliable() || e) &&
                                    "border-box" ===
                                        ho.css(o, "boxSizing", !1, r),
                                n = i,
                                c = N(o, t, r),
                                a = "offset" + t[0].toUpperCase() + t.slice(1);
                            if (at.test(c)) {
                                if (!e) return c;
                                c = "auto";
                            }
                            return (
                                ((!uo.boxSizingReliable() && i) ||
                                    "auto" === c ||
                                    (!parseFloat(c) &&
                                        "inline" ===
                                            ho.css(o, "display", !1, r))) &&
                                    o.getClientRects().length &&
                                    ((i =
                                        "border-box" ===
                                        ho.css(o, "boxSizing", !1, r)),
                                    (n = a in o) && (c = o[a])),
                                (c = parseFloat(c) || 0) +
                                    P(
                                        o,
                                        t,
                                        e || (i ? "border" : "content"),
                                        n,
                                        r,
                                        c
                                    ) +
                                    "px"
                            );
                        }
                        function I(o, t, e, r, i) {
                            return new I.prototype.init(o, t, e, r, i);
                        }
                        function R() {
                            bt &&
                                (!1 === Z.hidden && o.requestAnimationFrame
                                    ? o.requestAnimationFrame(R)
                                    : o.setTimeout(R, ho.fx.interval),
                                ho.fx.tick());
                        }
                        function H() {
                            return (
                                o.setTimeout(function () {
                                    gt = void 0;
                                }),
                                (gt = Date.now())
                            );
                        }
                        function W(o, t) {
                            var e,
                                r = 0,
                                i = { height: o };
                            for (t = t ? 1 : 0; r < 4; r += 2 - t)
                                i["margin" + (e = Ro[r])] = i["padding" + e] =
                                    o;
                            return t && (i.opacity = i.width = o), i;
                        }
                        function F(o, t, e) {
                            for (
                                var r,
                                    i = (U.tweeners[t] || []).concat(
                                        U.tweeners["*"]
                                    ),
                                    n = 0,
                                    c = i.length;
                                n < c;
                                n++
                            )
                                if ((r = i[n].call(e, t, o))) return r;
                        }
                        function U(o, t, e) {
                            var r,
                                i,
                                n = 0,
                                c = U.prefilters.length,
                                a = ho.Deferred().always(function () {
                                    delete l.elem;
                                }),
                                l = function () {
                                    if (i) return !1;
                                    for (
                                        var t = gt || H(),
                                            e = Math.max(
                                                0,
                                                s.startTime + s.duration - t
                                            ),
                                            r = 1 - (e / s.duration || 0),
                                            n = 0,
                                            c = s.tweens.length;
                                        n < c;
                                        n++
                                    )
                                        s.tweens[n].run(r);
                                    return (
                                        a.notifyWith(o, [s, r, e]),
                                        r < 1 && c
                                            ? e
                                            : (c || a.notifyWith(o, [s, 1, 0]),
                                              a.resolveWith(o, [s]),
                                              !1)
                                    );
                                },
                                s = a.promise({
                                    elem: o,
                                    props: ho.extend({}, t),
                                    opts: ho.extend(
                                        !0,
                                        {
                                            specialEasing: {},
                                            easing: ho.easing._default,
                                        },
                                        e
                                    ),
                                    originalProperties: t,
                                    originalOptions: e,
                                    startTime: gt || H(),
                                    duration: e.duration,
                                    tweens: [],
                                    createTween: function (t, e) {
                                        var r = ho.Tween(
                                            o,
                                            s.opts,
                                            t,
                                            e,
                                            s.opts.specialEasing[t] ||
                                                s.opts.easing
                                        );
                                        return s.tweens.push(r), r;
                                    },
                                    stop: function (t) {
                                        var e = 0,
                                            r = t ? s.tweens.length : 0;
                                        if (i) return this;
                                        for (i = !0; e < r; e++)
                                            s.tweens[e].run(1);
                                        return (
                                            t
                                                ? (a.notifyWith(o, [s, 1, 0]),
                                                  a.resolveWith(o, [s, t]))
                                                : a.rejectWith(o, [s, t]),
                                            this
                                        );
                                    },
                                }),
                                d = s.props;
                            for (
                                !(function (o, t) {
                                    var e, r, i, n, c;
                                    for (e in o)
                                        if (
                                            ((i = t[(r = f(e))]),
                                            (n = o[e]),
                                            Array.isArray(n) &&
                                                ((i = n[1]), (n = o[e] = n[0])),
                                            e !== r &&
                                                ((o[r] = n), delete o[e]),
                                            (c = ho.cssHooks[r]) &&
                                                ("expand" in c))
                                        )
                                            for (e in ((n = c.expand(n)),
                                            delete o[r],
                                            n))
                                                (e in o) ||
                                                    ((o[e] = n[e]), (t[e] = i));
                                        else t[r] = i;
                                })(d, s.opts.specialEasing);
                                n < c;
                                n++
                            )
                                if ((r = U.prefilters[n].call(s, o, d, s.opts)))
                                    return (
                                        mo(r.stop) &&
                                            (ho._queueHooks(
                                                s.elem,
                                                s.opts.queue
                                            ).stop = r.stop.bind(r)),
                                        r
                                    );
                            return (
                                ho.map(d, F, s),
                                mo(s.opts.start) && s.opts.start.call(o, s),
                                s
                                    .progress(s.opts.progress)
                                    .done(s.opts.done, s.opts.complete)
                                    .fail(s.opts.fail)
                                    .always(s.opts.always),
                                ho.fx.timer(
                                    ho.extend(l, {
                                        elem: o,
                                        anim: s,
                                        queue: s.opts.queue,
                                    })
                                ),
                                s
                            );
                        }
                        function $(o) {
                            return (o.match(So) || []).join(" ");
                        }
                        function X(o) {
                            return (
                                (o.getAttribute && o.getAttribute("class")) ||
                                ""
                            );
                        }
                        function Y(o) {
                            return Array.isArray(o)
                                ? o
                                : ("string" == typeof o && o.match(So)) || [];
                        }
                        function V(o, t, e, i) {
                            var n;
                            if (Array.isArray(t))
                                ho.each(t, function (t, r) {
                                    e || Nt.test(o)
                                        ? i(o, r)
                                        : V(
                                              o +
                                                  "[" +
                                                  ("object" == typeof r &&
                                                  null != r
                                                      ? t
                                                      : "") +
                                                  "]",
                                              r,
                                              e,
                                              i
                                          );
                                });
                            else if (e || "object" !== r(t)) i(o, t);
                            else for (n in t) V(o + "[" + n + "]", t[n], e, i);
                        }
                        function G(o) {
                            return function (t, e) {
                                "string" != typeof t && ((e = t), (t = "*"));
                                var r,
                                    i = 0,
                                    n = t.toLowerCase().match(So) || [];
                                if (mo(e))
                                    for (; (r = n[i++]); )
                                        "+" === r[0]
                                            ? ((r = r.slice(1) || "*"),
                                              (o[r] = o[r] || []).unshift(e))
                                            : (o[r] = o[r] || []).push(e);
                            };
                        }
                        function J(o, t, e, r) {
                            function i(a) {
                                var l;
                                return (
                                    (n[a] = !0),
                                    ho.each(o[a] || [], function (o, a) {
                                        var s = a(t, e, r);
                                        return "string" != typeof s || c || n[s]
                                            ? c
                                                ? !(l = s)
                                                : void 0
                                            : (t.dataTypes.unshift(s),
                                              i(s),
                                              !1);
                                    }),
                                    l
                                );
                            }
                            var n = {},
                                c = o === Ut;
                            return i(t.dataTypes[0]) || (!n["*"] && i("*"));
                        }
                        function K(o, t) {
                            var e,
                                r,
                                i = ho.ajaxSettings.flatOptions || {};
                            for (e in t)
                                void 0 !== t[e] &&
                                    ((i[e] ? o : r || (r = {}))[e] = t[e]);
                            return r && ho.extend(!0, o, r), o;
                        }
                        var Q = [],
                            Z = o.document,
                            oo = Object.getPrototypeOf,
                            to = Q.slice,
                            eo = Q.concat,
                            ro = Q.push,
                            io = Q.indexOf,
                            no = {},
                            co = no.toString,
                            ao = no.hasOwnProperty,
                            lo = ao.toString,
                            so = lo.call(Object),
                            uo = {},
                            mo = function (o) {
                                return (
                                    "function" == typeof o &&
                                    "number" != typeof o.nodeType
                                );
                            },
                            po = function (o) {
                                return null != o && o === o.window;
                            },
                            fo = { type: !0, src: !0, nonce: !0, noModule: !0 },
                            wo = "3.4.1",
                            ho = function (o, t) {
                                return new ho.fn.init(o, t);
                            },
                            go = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
                        (ho.fn = ho.prototype =
                            {
                                jquery: wo,
                                constructor: ho,
                                length: 0,
                                toArray: function () {
                                    return to.call(this);
                                },
                                get: function (o) {
                                    return null == o
                                        ? to.call(this)
                                        : o < 0
                                        ? this[o + this.length]
                                        : this[o];
                                },
                                pushStack: function (o) {
                                    var t = ho.merge(this.constructor(), o);
                                    return (t.prevObject = this), t;
                                },
                                each: function (o) {
                                    return ho.each(this, o);
                                },
                                map: function (o) {
                                    return this.pushStack(
                                        ho.map(this, function (t, e) {
                                            return o.call(t, e, t);
                                        })
                                    );
                                },
                                slice: function () {
                                    return this.pushStack(
                                        to.apply(this, arguments)
                                    );
                                },
                                first: function () {
                                    return this.eq(0);
                                },
                                last: function () {
                                    return this.eq(-1);
                                },
                                eq: function (o) {
                                    var t = this.length,
                                        e = +o + (o < 0 ? t : 0);
                                    return this.pushStack(
                                        0 <= e && e < t ? [this[e]] : []
                                    );
                                },
                                end: function () {
                                    return (
                                        this.prevObject || this.constructor()
                                    );
                                },
                                push: ro,
                                sort: Q.sort,
                                splice: Q.splice,
                            }),
                            (ho.extend = ho.fn.extend =
                                function () {
                                    var o,
                                        t,
                                        e,
                                        r,
                                        i,
                                        n,
                                        c = arguments[0] || {},
                                        a = 1,
                                        l = arguments.length,
                                        s = !1;
                                    for (
                                        "boolean" == typeof c &&
                                            ((s = c),
                                            (c = arguments[a] || {}),
                                            a++),
                                            "object" == typeof c ||
                                                mo(c) ||
                                                (c = {}),
                                            a === l && ((c = this), a--);
                                        a < l;
                                        a++
                                    )
                                        if (null != (o = arguments[a]))
                                            for (t in o)
                                                (r = o[t]),
                                                    "__proto__" !== t &&
                                                        c !== r &&
                                                        (s &&
                                                        r &&
                                                        (ho.isPlainObject(r) ||
                                                            (i =
                                                                Array.isArray(
                                                                    r
                                                                )))
                                                            ? ((e = c[t]),
                                                              (n =
                                                                  i &&
                                                                  !Array.isArray(
                                                                      e
                                                                  )
                                                                      ? []
                                                                      : i ||
                                                                        ho.isPlainObject(
                                                                            e
                                                                        )
                                                                      ? e
                                                                      : {}),
                                                              (i = !1),
                                                              (c[t] = ho.extend(
                                                                  s,
                                                                  n,
                                                                  r
                                                              )))
                                                            : void 0 !== r &&
                                                              (c[t] = r));
                                    return c;
                                }),
                            ho.extend({
                                expando:
                                    "jQuery" +
                                    (wo + Math.random()).replace(/\D/g, ""),
                                isReady: !0,
                                error: function (o) {
                                    throw new Error(o);
                                },
                                noop: function () {},
                                isPlainObject: function (o) {
                                    var t, e;
                                    return !(
                                        !o ||
                                        "[object Object]" !== co.call(o) ||
                                        ((t = oo(o)) &&
                                            ("function" !=
                                                typeof (e =
                                                    ao.call(t, "constructor") &&
                                                    t.constructor) ||
                                                lo.call(e) !== so))
                                    );
                                },
                                isEmptyObject: function (o) {
                                    var t;
                                    for (t in o) return !1;
                                    return !0;
                                },
                                globalEval: function (o, t) {
                                    e(o, { nonce: t && t.nonce });
                                },
                                each: function (o, t) {
                                    var e,
                                        r = 0;
                                    if (i(o))
                                        for (
                                            e = o.length;
                                            r < e &&
                                            !1 !== t.call(o[r], r, o[r]);
                                            r++
                                        );
                                    else
                                        for (r in o)
                                            if (!1 === t.call(o[r], r, o[r]))
                                                break;
                                    return o;
                                },
                                trim: function (o) {
                                    return null == o
                                        ? ""
                                        : (o + "").replace(go, "");
                                },
                                makeArray: function (o, t) {
                                    var e = t || [];
                                    return (
                                        null != o &&
                                            (i(Object(o))
                                                ? ho.merge(
                                                      e,
                                                      "string" == typeof o
                                                          ? [o]
                                                          : o
                                                  )
                                                : ro.call(e, o)),
                                        e
                                    );
                                },
                                inArray: function (o, t, e) {
                                    return null == t ? -1 : io.call(t, o, e);
                                },
                                merge: function (o, t) {
                                    for (
                                        var e = +t.length, r = 0, i = o.length;
                                        r < e;
                                        r++
                                    )
                                        o[i++] = t[r];
                                    return (o.length = i), o;
                                },
                                grep: function (o, t, e) {
                                    for (
                                        var r = [], i = 0, n = o.length, c = !e;
                                        i < n;
                                        i++
                                    )
                                        !t(o[i], i) !== c && r.push(o[i]);
                                    return r;
                                },
                                map: function (o, t, e) {
                                    var r,
                                        n,
                                        c = 0,
                                        a = [];
                                    if (i(o))
                                        for (r = o.length; c < r; c++)
                                            null != (n = t(o[c], c, e)) &&
                                                a.push(n);
                                    else
                                        for (c in o)
                                            null != (n = t(o[c], c, e)) &&
                                                a.push(n);
                                    return eo.apply([], a);
                                },
                                guid: 1,
                                support: uo,
                            }),
                            "function" == typeof Symbol &&
                                (ho.fn[Symbol.iterator] = Q[Symbol.iterator]),
                            ho.each(
                                "Boolean Number String Function Array Date RegExp Object Error Symbol".split(
                                    " "
                                ),
                                function (o, t) {
                                    no["[object " + t + "]"] = t.toLowerCase();
                                }
                            );
                        var bo = (function (o) {
                            function t(o, t, e, r) {
                                var i,
                                    n,
                                    c,
                                    a,
                                    l,
                                    d,
                                    m,
                                    p = t && t.ownerDocument,
                                    f = t ? t.nodeType : 9;
                                if (
                                    ((e = e || []),
                                    "string" != typeof o ||
                                        !o ||
                                        (1 !== f && 9 !== f && 11 !== f))
                                )
                                    return e;
                                if (
                                    !r &&
                                    ((t ? t.ownerDocument || t : P) !== A &&
                                        E(t),
                                    (t = t || A),
                                    q)
                                ) {
                                    if (11 !== f && (l = ho.exec(o)))
                                        if ((i = l[1])) {
                                            if (9 === f) {
                                                if (!(c = t.getElementById(i)))
                                                    return e;
                                                if (c.id === i)
                                                    return e.push(c), e;
                                            } else if (
                                                p &&
                                                (c = p.getElementById(i)) &&
                                                O(t, c) &&
                                                c.id === i
                                            )
                                                return e.push(c), e;
                                        } else {
                                            if (l[2])
                                                return (
                                                    G.apply(
                                                        e,
                                                        t.getElementsByTagName(
                                                            o
                                                        )
                                                    ),
                                                    e
                                                );
                                            if (
                                                (i = l[3]) &&
                                                b.getElementsByClassName &&
                                                t.getElementsByClassName
                                            )
                                                return (
                                                    G.apply(
                                                        e,
                                                        t.getElementsByClassName(
                                                            i
                                                        )
                                                    ),
                                                    e
                                                );
                                        }
                                    if (
                                        b.qsa &&
                                        !F[o + " "] &&
                                        (!L || !L.test(o)) &&
                                        (1 !== f ||
                                            "object" !==
                                                t.nodeName.toLowerCase())
                                    ) {
                                        if (
                                            ((m = o),
                                            (p = t),
                                            1 === f && ao.test(o))
                                        ) {
                                            for (
                                                (a = t.getAttribute("id"))
                                                    ? (a = a.replace(yo, _o))
                                                    : t.setAttribute(
                                                          "id",
                                                          (a = M)
                                                      ),
                                                    n = (d = x(o)).length;
                                                n--;

                                            )
                                                d[n] = "#" + a + " " + u(d[n]);
                                            (m = d.join(",")),
                                                (p =
                                                    (go.test(o) &&
                                                        s(t.parentNode)) ||
                                                    t);
                                        }
                                        try {
                                            return (
                                                G.apply(
                                                    e,
                                                    p.querySelectorAll(m)
                                                ),
                                                e
                                            );
                                        } catch (t) {
                                            F(o, !0);
                                        } finally {
                                            a === M && t.removeAttribute("id");
                                        }
                                    }
                                }
                                return z(o.replace(io, "$1"), t, e, r);
                            }
                            function e() {
                                var o = [];
                                return function t(e, r) {
                                    return (
                                        o.push(e + " ") > v.cacheLength &&
                                            delete t[o.shift()],
                                        (t[e + " "] = r)
                                    );
                                };
                            }
                            function r(o) {
                                return (o[M] = !0), o;
                            }
                            function i(o) {
                                var t = A.createElement("fieldset");
                                try {
                                    return !!o(t);
                                } catch (o) {
                                    return !1;
                                } finally {
                                    t.parentNode && t.parentNode.removeChild(t),
                                        (t = null);
                                }
                            }
                            function n(o, t) {
                                for (var e = o.split("|"), r = e.length; r--; )
                                    v.attrHandle[e[r]] = t;
                            }
                            function c(o, t) {
                                var e = t && o,
                                    r =
                                        e &&
                                        1 === o.nodeType &&
                                        1 === t.nodeType &&
                                        o.sourceIndex - t.sourceIndex;
                                if (r) return r;
                                if (e)
                                    for (; (e = e.nextSibling); )
                                        if (e === t) return -1;
                                return o ? 1 : -1;
                            }
                            function a(o) {
                                return function (t) {
                                    return "form" in t
                                        ? t.parentNode && !1 === t.disabled
                                            ? "label" in t
                                                ? "label" in t.parentNode
                                                    ? t.parentNode.disabled ===
                                                      o
                                                    : t.disabled === o
                                                : t.isDisabled === o ||
                                                  (t.isDisabled !== !o &&
                                                      ko(t) === o)
                                            : t.disabled === o
                                        : "label" in t && t.disabled === o;
                                };
                            }
                            function l(o) {
                                return r(function (t) {
                                    return (
                                        (t = +t),
                                        r(function (e, r) {
                                            for (
                                                var i,
                                                    n = o([], e.length, t),
                                                    c = n.length;
                                                c--;

                                            )
                                                e[(i = n[c])] &&
                                                    (e[i] = !(r[i] = e[i]));
                                        })
                                    );
                                });
                            }
                            function s(o) {
                                return (
                                    o && void 0 !== o.getElementsByTagName && o
                                );
                            }
                            function d() {}
                            function u(o) {
                                for (
                                    var t = 0, e = o.length, r = "";
                                    t < e;
                                    t++
                                )
                                    r += o[t].value;
                                return r;
                            }
                            function m(o, t, e) {
                                var r = t.dir,
                                    i = t.next,
                                    n = i || r,
                                    c = e && "parentNode" === n,
                                    a = I++;
                                return t.first
                                    ? function (t, e, i) {
                                          for (; (t = t[r]); )
                                              if (1 === t.nodeType || c)
                                                  return o(t, e, i);
                                          return !1;
                                      }
                                    : function (t, e, l) {
                                          var s,
                                              d,
                                              u,
                                              m = [B, a];
                                          if (l) {
                                              for (; (t = t[r]); )
                                                  if (
                                                      (1 === t.nodeType || c) &&
                                                      o(t, e, l)
                                                  )
                                                      return !0;
                                          } else
                                              for (; (t = t[r]); )
                                                  if (1 === t.nodeType || c)
                                                      if (
                                                          ((d =
                                                              (u =
                                                                  t[M] ||
                                                                  (t[M] = {}))[
                                                                  t.uniqueID
                                                              ] ||
                                                              (u[t.uniqueID] =
                                                                  {})),
                                                          i &&
                                                              i ===
                                                                  t.nodeName.toLowerCase())
                                                      )
                                                          t = t[r] || t;
                                                      else {
                                                          if (
                                                              (s = d[n]) &&
                                                              s[0] === B &&
                                                              s[1] === a
                                                          )
                                                              return (m[2] =
                                                                  s[2]);
                                                          if (
                                                              ((d[n] = m)[2] =
                                                                  o(t, e, l))
                                                          )
                                                              return !0;
                                                      }
                                          return !1;
                                      };
                            }
                            function p(o) {
                                return 1 < o.length
                                    ? function (t, e, r) {
                                          for (var i = o.length; i--; )
                                              if (!o[i](t, e, r)) return !1;
                                          return !0;
                                      }
                                    : o[0];
                            }
                            function f(o, t, e, r, i) {
                                for (
                                    var n,
                                        c = [],
                                        a = 0,
                                        l = o.length,
                                        s = null != t;
                                    a < l;
                                    a++
                                )
                                    (n = o[a]) &&
                                        ((e && !e(n, r, i)) ||
                                            (c.push(n), s && t.push(a)));
                                return c;
                            }
                            function w(o, e, i, n, c, a) {
                                return (
                                    n && !n[M] && (n = w(n)),
                                    c && !c[M] && (c = w(c, a)),
                                    r(function (r, a, l, s) {
                                        var d,
                                            u,
                                            m,
                                            p = [],
                                            w = [],
                                            h = a.length,
                                            g =
                                                r ||
                                                (function (o, e, r) {
                                                    for (
                                                        var i = 0, n = e.length;
                                                        i < n;
                                                        i++
                                                    )
                                                        t(o, e[i], r);
                                                    return r;
                                                })(
                                                    e || "*",
                                                    l.nodeType ? [l] : l,
                                                    []
                                                ),
                                            b =
                                                !o || (!r && e)
                                                    ? g
                                                    : f(g, p, o, l, s),
                                            v = i
                                                ? c || (r ? o : h || n)
                                                    ? []
                                                    : a
                                                : b;
                                        if ((i && i(b, v, l, s), n))
                                            for (
                                                d = f(v, w),
                                                    n(d, [], l, s),
                                                    u = d.length;
                                                u--;

                                            )
                                                (m = d[u]) &&
                                                    (v[w[u]] = !(b[w[u]] = m));
                                        if (r) {
                                            if (c || o) {
                                                if (c) {
                                                    for (
                                                        d = [], u = v.length;
                                                        u--;

                                                    )
                                                        (m = v[u]) &&
                                                            d.push((b[u] = m));
                                                    c(null, (v = []), d, s);
                                                }
                                                for (u = v.length; u--; )
                                                    (m = v[u]) &&
                                                        -1 <
                                                            (d = c
                                                                ? K(r, m)
                                                                : p[u]) &&
                                                        (r[d] = !(a[d] = m));
                                            }
                                        } else (v = f(v === a ? v.splice(h, v.length) : v)), c ? c(null, a, v, s) : G.apply(a, v);
                                    })
                                );
                            }
                            function h(o) {
                                for (
                                    var t,
                                        e,
                                        r,
                                        i = o.length,
                                        n = v.relative[o[0].type],
                                        c = n || v.relative[" "],
                                        a = n ? 1 : 0,
                                        l = m(
                                            function (o) {
                                                return o === t;
                                            },
                                            c,
                                            !0
                                        ),
                                        s = m(
                                            function (o) {
                                                return -1 < K(t, o);
                                            },
                                            c,
                                            !0
                                        ),
                                        d = [
                                            function (o, e, r) {
                                                var i =
                                                    (!n && (r || e !== C)) ||
                                                    ((t = e).nodeType
                                                        ? l(o, e, r)
                                                        : s(o, e, r));
                                                return (t = null), i;
                                            },
                                        ];
                                    a < i;
                                    a++
                                )
                                    if ((e = v.relative[o[a].type]))
                                        d = [m(p(d), e)];
                                    else {
                                        if (
                                            (e = v.filter[o[a].type].apply(
                                                null,
                                                o[a].matches
                                            ))[M]
                                        ) {
                                            for (
                                                r = ++a;
                                                r < i && !v.relative[o[r].type];
                                                r++
                                            );
                                            return w(
                                                1 < a && p(d),
                                                1 < a &&
                                                    u(
                                                        o
                                                            .slice(0, a - 1)
                                                            .concat({
                                                                value:
                                                                    " " ===
                                                                    o[a - 2]
                                                                        .type
                                                                        ? "*"
                                                                        : "",
                                                            })
                                                    ).replace(io, "$1"),
                                                e,
                                                a < r && h(o.slice(a, r)),
                                                r < i && h((o = o.slice(r))),
                                                r < i && u(o)
                                            );
                                        }
                                        d.push(e);
                                    }
                                return p(d);
                            }
                            var g,
                                b,
                                v,
                                y,
                                _,
                                x,
                                k,
                                z,
                                C,
                                T,
                                S,
                                E,
                                A,
                                j,
                                q,
                                L,
                                N,
                                D,
                                O,
                                M = "sizzle" + 1 * new Date(),
                                P = o.document,
                                B = 0,
                                I = 0,
                                R = e(),
                                H = e(),
                                W = e(),
                                F = e(),
                                U = function (o, t) {
                                    return o === t && (S = !0), 0;
                                },
                                $ = {}.hasOwnProperty,
                                X = [],
                                Y = X.pop,
                                V = X.push,
                                G = X.push,
                                J = X.slice,
                                K = function (o, t) {
                                    for (var e = 0, r = o.length; e < r; e++)
                                        if (o[e] === t) return e;
                                    return -1;
                                },
                                Q =
                                    "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
                                Z = "[\\x20\\t\\r\\n\\f]",
                                oo = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",
                                to =
                                    "\\[" +
                                    Z +
                                    "*(" +
                                    oo +
                                    ")(?:" +
                                    Z +
                                    "*([*^$|!~]?=)" +
                                    Z +
                                    "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" +
                                    oo +
                                    "))|)" +
                                    Z +
                                    "*\\]",
                                eo =
                                    ":(" +
                                    oo +
                                    ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" +
                                    to +
                                    ")*)|.*)\\)|)",
                                ro = new RegExp(Z + "+", "g"),
                                io = new RegExp(
                                    "^" +
                                        Z +
                                        "+|((?:^|[^\\\\])(?:\\\\.)*)" +
                                        Z +
                                        "+$",
                                    "g"
                                ),
                                no = new RegExp("^" + Z + "*," + Z + "*"),
                                co = new RegExp(
                                    "^" + Z + "*([>+~]|" + Z + ")" + Z + "*"
                                ),
                                ao = new RegExp(Z + "|>"),
                                lo = new RegExp(eo),
                                so = new RegExp("^" + oo + "$"),
                                uo = {
                                    ID: new RegExp("^#(" + oo + ")"),
                                    CLASS: new RegExp("^\\.(" + oo + ")"),
                                    TAG: new RegExp("^(" + oo + "|[*])"),
                                    ATTR: new RegExp("^" + to),
                                    PSEUDO: new RegExp("^" + eo),
                                    CHILD: new RegExp(
                                        "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
                                            Z +
                                            "*(even|odd|(([+-]|)(\\d*)n|)" +
                                            Z +
                                            "*(?:([+-]|)" +
                                            Z +
                                            "*(\\d+)|))" +
                                            Z +
                                            "*\\)|)",
                                        "i"
                                    ),
                                    bool: new RegExp("^(?:" + Q + ")$", "i"),
                                    needsContext: new RegExp(
                                        "^" +
                                            Z +
                                            "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
                                            Z +
                                            "*((?:-\\d)?\\d*)" +
                                            Z +
                                            "*\\)|)(?=[^-]|$)",
                                        "i"
                                    ),
                                },
                                mo = /HTML$/i,
                                po = /^(?:input|select|textarea|button)$/i,
                                fo = /^h\d$/i,
                                wo = /^[^{]+\{\s*\[native \w/,
                                ho = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
                                go = /[+~]/,
                                bo = new RegExp(
                                    "\\\\([\\da-f]{1,6}" +
                                        Z +
                                        "?|(" +
                                        Z +
                                        ")|.)",
                                    "ig"
                                ),
                                vo = function (o, t, e) {
                                    var r = "0x" + t - 65536;
                                    return r != r || e
                                        ? t
                                        : r < 0
                                        ? String.fromCharCode(r + 65536)
                                        : String.fromCharCode(
                                              (r >> 10) | 55296,
                                              (1023 & r) | 56320
                                          );
                                },
                                yo =
                                    /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
                                _o = function (o, t) {
                                    return t
                                        ? "\0" === o
                                            ? "ï¿½"
                                            : o.slice(0, -1) +
                                              "\\" +
                                              o
                                                  .charCodeAt(o.length - 1)
                                                  .toString(16) +
                                              " "
                                        : "\\" + o;
                                },
                                xo = function () {
                                    E();
                                },
                                ko = m(
                                    function (o) {
                                        return (
                                            !0 === o.disabled &&
                                            "fieldset" ===
                                                o.nodeName.toLowerCase()
                                        );
                                    },
                                    { dir: "parentNode", next: "legend" }
                                );
                            try {
                                G.apply(
                                    (X = J.call(P.childNodes)),
                                    P.childNodes
                                ),
                                    X[P.childNodes.length].nodeType;
                            } catch (g) {
                                G = {
                                    apply: X.length
                                        ? function (o, t) {
                                              V.apply(o, J.call(t));
                                          }
                                        : function (o, t) {
                                              for (
                                                  var e = o.length, r = 0;
                                                  (o[e++] = t[r++]);

                                              );
                                              o.length = e - 1;
                                          },
                                };
                            }
                            for (g in ((b = t.support = {}),
                            (_ = t.isXML =
                                function (o) {
                                    var t = o.namespaceURI,
                                        e = (o.ownerDocument || o)
                                            .documentElement;
                                    return !mo.test(
                                        t || (e && e.nodeName) || "HTML"
                                    );
                                }),
                            (E = t.setDocument =
                                function (o) {
                                    var t,
                                        e,
                                        r = o ? o.ownerDocument || o : P;
                                    return (
                                        r !== A &&
                                            9 === r.nodeType &&
                                            r.documentElement &&
                                            ((j = (A = r).documentElement),
                                            (q = !_(A)),
                                            P !== A &&
                                                (e = A.defaultView) &&
                                                e.top !== e &&
                                                (e.addEventListener
                                                    ? e.addEventListener(
                                                          "unload",
                                                          xo,
                                                          !1
                                                      )
                                                    : e.attachEvent &&
                                                      e.attachEvent(
                                                          "onunload",
                                                          xo
                                                      )),
                                            (b.attributes = i(function (o) {
                                                return (
                                                    (o.className = "i"),
                                                    !o.getAttribute("className")
                                                );
                                            })),
                                            (b.getElementsByTagName = i(
                                                function (o) {
                                                    return (
                                                        o.appendChild(
                                                            A.createComment("")
                                                        ),
                                                        !o.getElementsByTagName(
                                                            "*"
                                                        ).length
                                                    );
                                                }
                                            )),
                                            (b.getElementsByClassName = wo.test(
                                                A.getElementsByClassName
                                            )),
                                            (b.getById = i(function (o) {
                                                return (
                                                    (j.appendChild(o).id = M),
                                                    !A.getElementsByName ||
                                                        !A.getElementsByName(M)
                                                            .length
                                                );
                                            })),
                                            b.getById
                                                ? ((v.filter.ID = function (o) {
                                                      var t = o.replace(bo, vo);
                                                      return function (o) {
                                                          return (
                                                              o.getAttribute(
                                                                  "id"
                                                              ) === t
                                                          );
                                                      };
                                                  }),
                                                  (v.find.ID = function (o, t) {
                                                      if (
                                                          void 0 !==
                                                              t.getElementById &&
                                                          q
                                                      ) {
                                                          var e =
                                                              t.getElementById(
                                                                  o
                                                              );
                                                          return e ? [e] : [];
                                                      }
                                                  }))
                                                : ((v.filter.ID = function (o) {
                                                      var t = o.replace(bo, vo);
                                                      return function (o) {
                                                          var e =
                                                              void 0 !==
                                                                  o.getAttributeNode &&
                                                              o.getAttributeNode(
                                                                  "id"
                                                              );
                                                          return (
                                                              e && e.value === t
                                                          );
                                                      };
                                                  }),
                                                  (v.find.ID = function (o, t) {
                                                      if (
                                                          void 0 !==
                                                              t.getElementById &&
                                                          q
                                                      ) {
                                                          var e,
                                                              r,
                                                              i,
                                                              n =
                                                                  t.getElementById(
                                                                      o
                                                                  );
                                                          if (n) {
                                                              if (
                                                                  (e =
                                                                      n.getAttributeNode(
                                                                          "id"
                                                                      )) &&
                                                                  e.value === o
                                                              )
                                                                  return [n];
                                                              for (
                                                                  i =
                                                                      t.getElementsByName(
                                                                          o
                                                                      ),
                                                                      r = 0;
                                                                  (n = i[r++]);

                                                              )
                                                                  if (
                                                                      (e =
                                                                          n.getAttributeNode(
                                                                              "id"
                                                                          )) &&
                                                                      e.value ===
                                                                          o
                                                                  )
                                                                      return [
                                                                          n,
                                                                      ];
                                                          }
                                                          return [];
                                                      }
                                                  })),
                                            (v.find.TAG = b.getElementsByTagName
                                                ? function (o, t) {
                                                      return void 0 !==
                                                          t.getElementsByTagName
                                                          ? t.getElementsByTagName(
                                                                o
                                                            )
                                                          : b.qsa
                                                          ? t.querySelectorAll(
                                                                o
                                                            )
                                                          : void 0;
                                                  }
                                                : function (o, t) {
                                                      var e,
                                                          r = [],
                                                          i = 0,
                                                          n =
                                                              t.getElementsByTagName(
                                                                  o
                                                              );
                                                      if ("*" === o) {
                                                          for (; (e = n[i++]); )
                                                              1 ===
                                                                  e.nodeType &&
                                                                  r.push(e);
                                                          return r;
                                                      }
                                                      return n;
                                                  }),
                                            (v.find.CLASS =
                                                b.getElementsByClassName &&
                                                function (o, t) {
                                                    if (
                                                        void 0 !==
                                                            t.getElementsByClassName &&
                                                        q
                                                    )
                                                        return t.getElementsByClassName(
                                                            o
                                                        );
                                                }),
                                            (N = []),
                                            (L = []),
                                            (b.qsa = wo.test(
                                                A.querySelectorAll
                                            )) &&
                                                (i(function (o) {
                                                    (j.appendChild(
                                                        o
                                                    ).innerHTML =
                                                        "<a id='" +
                                                        M +
                                                        "'></a><select id='" +
                                                        M +
                                                        "-\r\\' msallowcapture=''><option selected=''></option></select>"),
                                                        o.querySelectorAll(
                                                            "[msallowcapture^='']"
                                                        ).length &&
                                                            L.push(
                                                                "[*^$]=" +
                                                                    Z +
                                                                    "*(?:''|\"\")"
                                                            ),
                                                        o.querySelectorAll(
                                                            "[selected]"
                                                        ).length ||
                                                            L.push(
                                                                "\\[" +
                                                                    Z +
                                                                    "*(?:value|" +
                                                                    Q +
                                                                    ")"
                                                            ),
                                                        o.querySelectorAll(
                                                            "[id~=" + M + "-]"
                                                        ).length ||
                                                            L.push("~="),
                                                        o.querySelectorAll(
                                                            ":checked"
                                                        ).length ||
                                                            L.push(":checked"),
                                                        o.querySelectorAll(
                                                            "a#" + M + "+*"
                                                        ).length ||
                                                            L.push(".#.+[+~]");
                                                }),
                                                i(function (o) {
                                                    o.innerHTML =
                                                        "<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";
                                                    var t =
                                                        A.createElement(
                                                            "input"
                                                        );
                                                    t.setAttribute(
                                                        "type",
                                                        "hidden"
                                                    ),
                                                        o
                                                            .appendChild(t)
                                                            .setAttribute(
                                                                "name",
                                                                "D"
                                                            ),
                                                        o.querySelectorAll(
                                                            "[name=d]"
                                                        ).length &&
                                                            L.push(
                                                                "name" +
                                                                    Z +
                                                                    "*[*^$|!~]?="
                                                            ),
                                                        2 !==
                                                            o.querySelectorAll(
                                                                ":enabled"
                                                            ).length &&
                                                            L.push(
                                                                ":enabled",
                                                                ":disabled"
                                                            ),
                                                        (j.appendChild(
                                                            o
                                                        ).disabled = !0),
                                                        2 !==
                                                            o.querySelectorAll(
                                                                ":disabled"
                                                            ).length &&
                                                            L.push(
                                                                ":enabled",
                                                                ":disabled"
                                                            ),
                                                        o.querySelectorAll(
                                                            "*,:x"
                                                        ),
                                                        L.push(",.*:");
                                                })),
                                            (b.matchesSelector = wo.test(
                                                (D =
                                                    j.matches ||
                                                    j.webkitMatchesSelector ||
                                                    j.mozMatchesSelector ||
                                                    j.oMatchesSelector ||
                                                    j.msMatchesSelector)
                                            )) &&
                                                i(function (o) {
                                                    (b.disconnectedMatch =
                                                        D.call(o, "*")),
                                                        D.call(o, "[s!='']:x"),
                                                        N.push("!=", eo);
                                                }),
                                            (L =
                                                L.length &&
                                                new RegExp(L.join("|"))),
                                            (N =
                                                N.length &&
                                                new RegExp(N.join("|"))),
                                            (t = wo.test(
                                                j.compareDocumentPosition
                                            )),
                                            (O =
                                                t || wo.test(j.contains)
                                                    ? function (o, t) {
                                                          var e =
                                                                  9 ===
                                                                  o.nodeType
                                                                      ? o.documentElement
                                                                      : o,
                                                              r =
                                                                  t &&
                                                                  t.parentNode;
                                                          return (
                                                              o === r ||
                                                              !(
                                                                  !r ||
                                                                  1 !==
                                                                      r.nodeType ||
                                                                  !(e.contains
                                                                      ? e.contains(
                                                                            r
                                                                        )
                                                                      : o.compareDocumentPosition &&
                                                                        16 &
                                                                            o.compareDocumentPosition(
                                                                                r
                                                                            ))
                                                              )
                                                          );
                                                      }
                                                    : function (o, t) {
                                                          if (t)
                                                              for (
                                                                  ;
                                                                  (t =
                                                                      t.parentNode);

                                                              )
                                                                  if (t === o)
                                                                      return !0;
                                                          return !1;
                                                      }),
                                            (U = t
                                                ? function (o, t) {
                                                      if (o === t)
                                                          return (S = !0), 0;
                                                      var e =
                                                          !o.compareDocumentPosition -
                                                          !t.compareDocumentPosition;
                                                      return (
                                                          e ||
                                                          (1 &
                                                              (e =
                                                                  (o.ownerDocument ||
                                                                      o) ===
                                                                  (t.ownerDocument ||
                                                                      t)
                                                                      ? o.compareDocumentPosition(
                                                                            t
                                                                        )
                                                                      : 1) ||
                                                          (!b.sortDetached &&
                                                              t.compareDocumentPosition(
                                                                  o
                                                              ) === e)
                                                              ? o === A ||
                                                                (o.ownerDocument ===
                                                                    P &&
                                                                    O(P, o))
                                                                  ? -1
                                                                  : t === A ||
                                                                    (t.ownerDocument ===
                                                                        P &&
                                                                        O(P, t))
                                                                  ? 1
                                                                  : T
                                                                  ? K(T, o) -
                                                                    K(T, t)
                                                                  : 0
                                                              : 4 & e
                                                              ? -1
                                                              : 1)
                                                      );
                                                  }
                                                : function (o, t) {
                                                      if (o === t)
                                                          return (S = !0), 0;
                                                      var e,
                                                          r = 0,
                                                          i = o.parentNode,
                                                          n = t.parentNode,
                                                          a = [o],
                                                          l = [t];
                                                      if (!i || !n)
                                                          return o === A
                                                              ? -1
                                                              : t === A
                                                              ? 1
                                                              : i
                                                              ? -1
                                                              : n
                                                              ? 1
                                                              : T
                                                              ? K(T, o) -
                                                                K(T, t)
                                                              : 0;
                                                      if (i === n)
                                                          return c(o, t);
                                                      for (
                                                          e = o;
                                                          (e = e.parentNode);

                                                      )
                                                          a.unshift(e);
                                                      for (
                                                          e = t;
                                                          (e = e.parentNode);

                                                      )
                                                          l.unshift(e);
                                                      for (; a[r] === l[r]; )
                                                          r++;
                                                      return r
                                                          ? c(a[r], l[r])
                                                          : a[r] === P
                                                          ? -1
                                                          : l[r] === P
                                                          ? 1
                                                          : 0;
                                                  })),
                                        A
                                    );
                                }),
                            (t.matches = function (o, e) {
                                return t(o, null, null, e);
                            }),
                            (t.matchesSelector = function (o, e) {
                                if (
                                    ((o.ownerDocument || o) !== A && E(o),
                                    b.matchesSelector &&
                                        q &&
                                        !F[e + " "] &&
                                        (!N || !N.test(e)) &&
                                        (!L || !L.test(e)))
                                )
                                    try {
                                        var r = D.call(o, e);
                                        if (
                                            r ||
                                            b.disconnectedMatch ||
                                            (o.document &&
                                                11 !== o.document.nodeType)
                                        )
                                            return r;
                                    } catch (o) {
                                        F(e, !0);
                                    }
                                return 0 < t(e, A, null, [o]).length;
                            }),
                            (t.contains = function (o, t) {
                                return (
                                    (o.ownerDocument || o) !== A && E(o),
                                    O(o, t)
                                );
                            }),
                            (t.attr = function (o, t) {
                                (o.ownerDocument || o) !== A && E(o);
                                var e = v.attrHandle[t.toLowerCase()],
                                    r =
                                        e &&
                                        $.call(v.attrHandle, t.toLowerCase())
                                            ? e(o, t, !q)
                                            : void 0;
                                return void 0 !== r
                                    ? r
                                    : b.attributes || !q
                                    ? o.getAttribute(t)
                                    : (r = o.getAttributeNode(t)) && r.specified
                                    ? r.value
                                    : null;
                            }),
                            (t.escape = function (o) {
                                return (o + "").replace(yo, _o);
                            }),
                            (t.error = function (o) {
                                throw new Error(
                                    "Syntax error, unrecognized expression: " +
                                        o
                                );
                            }),
                            (t.uniqueSort = function (o) {
                                var t,
                                    e = [],
                                    r = 0,
                                    i = 0;
                                if (
                                    ((S = !b.detectDuplicates),
                                    (T = !b.sortStable && o.slice(0)),
                                    o.sort(U),
                                    S)
                                ) {
                                    for (; (t = o[i++]); )
                                        t === o[i] && (r = e.push(i));
                                    for (; r--; ) o.splice(e[r], 1);
                                }
                                return (T = null), o;
                            }),
                            (y = t.getText =
                                function (o) {
                                    var t,
                                        e = "",
                                        r = 0,
                                        i = o.nodeType;
                                    if (i) {
                                        if (1 === i || 9 === i || 11 === i) {
                                            if (
                                                "string" == typeof o.textContent
                                            )
                                                return o.textContent;
                                            for (
                                                o = o.firstChild;
                                                o;
                                                o = o.nextSibling
                                            )
                                                e += y(o);
                                        } else if (3 === i || 4 === i)
                                            return o.nodeValue;
                                    } else for (; (t = o[r++]); ) e += y(t);
                                    return e;
                                }),
                            ((v = t.selectors =
                                {
                                    cacheLength: 50,
                                    createPseudo: r,
                                    match: uo,
                                    attrHandle: {},
                                    find: {},
                                    relative: {
                                        ">": { dir: "parentNode", first: !0 },
                                        " ": { dir: "parentNode" },
                                        "+": {
                                            dir: "previousSibling",
                                            first: !0,
                                        },
                                        "~": { dir: "previousSibling" },
                                    },
                                    preFilter: {
                                        ATTR: function (o) {
                                            return (
                                                (o[1] = o[1].replace(bo, vo)),
                                                (o[3] = (
                                                    o[3] ||
                                                    o[4] ||
                                                    o[5] ||
                                                    ""
                                                ).replace(bo, vo)),
                                                "~=" === o[2] &&
                                                    (o[3] = " " + o[3] + " "),
                                                o.slice(0, 4)
                                            );
                                        },
                                        CHILD: function (o) {
                                            return (
                                                (o[1] = o[1].toLowerCase()),
                                                "nth" === o[1].slice(0, 3)
                                                    ? (o[3] || t.error(o[0]),
                                                      (o[4] = +(o[4]
                                                          ? o[5] + (o[6] || 1)
                                                          : 2 *
                                                            ("even" === o[3] ||
                                                                "odd" ===
                                                                    o[3]))),
                                                      (o[5] = +(
                                                          o[7] + o[8] ||
                                                          "odd" === o[3]
                                                      )))
                                                    : o[3] && t.error(o[0]),
                                                o
                                            );
                                        },
                                        PSEUDO: function (o) {
                                            var t,
                                                e = !o[6] && o[2];
                                            return uo.CHILD.test(o[0])
                                                ? null
                                                : (o[3]
                                                      ? (o[2] =
                                                            o[4] || o[5] || "")
                                                      : e &&
                                                        lo.test(e) &&
                                                        (t = x(e, !0)) &&
                                                        (t =
                                                            e.indexOf(
                                                                ")",
                                                                e.length - t
                                                            ) - e.length) &&
                                                        ((o[0] = o[0].slice(
                                                            0,
                                                            t
                                                        )),
                                                        (o[2] = e.slice(0, t))),
                                                  o.slice(0, 3));
                                        },
                                    },
                                    filter: {
                                        TAG: function (o) {
                                            var t = o
                                                .replace(bo, vo)
                                                .toLowerCase();
                                            return "*" === o
                                                ? function () {
                                                      return !0;
                                                  }
                                                : function (o) {
                                                      return (
                                                          o.nodeName &&
                                                          o.nodeName.toLowerCase() ===
                                                              t
                                                      );
                                                  };
                                        },
                                        CLASS: function (o) {
                                            var t = R[o + " "];
                                            return (
                                                t ||
                                                ((t = new RegExp(
                                                    "(^|" +
                                                        Z +
                                                        ")" +
                                                        o +
                                                        "(" +
                                                        Z +
                                                        "|$)"
                                                )) &&
                                                    R(o, function (o) {
                                                        return t.test(
                                                            ("string" ==
                                                                typeof o.className &&
                                                                o.className) ||
                                                                (void 0 !==
                                                                    o.getAttribute &&
                                                                    o.getAttribute(
                                                                        "class"
                                                                    )) ||
                                                                ""
                                                        );
                                                    }))
                                            );
                                        },
                                        ATTR: function (o, e, r) {
                                            return function (i) {
                                                var n = t.attr(i, o);
                                                return null == n
                                                    ? "!=" === e
                                                    : !e ||
                                                          ((n += ""),
                                                          "=" === e
                                                              ? n === r
                                                              : "!=" === e
                                                              ? n !== r
                                                              : "^=" === e
                                                              ? r &&
                                                                0 ===
                                                                    n.indexOf(r)
                                                              : "*=" === e
                                                              ? r &&
                                                                -1 <
                                                                    n.indexOf(r)
                                                              : "$=" === e
                                                              ? r &&
                                                                n.slice(
                                                                    -r.length
                                                                ) === r
                                                              : "~=" === e
                                                              ? -1 <
                                                                (
                                                                    " " +
                                                                    n.replace(
                                                                        ro,
                                                                        " "
                                                                    ) +
                                                                    " "
                                                                ).indexOf(r)
                                                              : "|=" === e &&
                                                                (n === r ||
                                                                    n.slice(
                                                                        0,
                                                                        r.length +
                                                                            1
                                                                    ) ===
                                                                        r +
                                                                            "-"));
                                            };
                                        },
                                        CHILD: function (o, t, e, r, i) {
                                            var n = "nth" !== o.slice(0, 3),
                                                c = "last" !== o.slice(-4),
                                                a = "of-type" === t;
                                            return 1 === r && 0 === i
                                                ? function (o) {
                                                      return !!o.parentNode;
                                                  }
                                                : function (t, e, l) {
                                                      var s,
                                                          d,
                                                          u,
                                                          m,
                                                          p,
                                                          f,
                                                          w =
                                                              n !== c
                                                                  ? "nextSibling"
                                                                  : "previousSibling",
                                                          h = t.parentNode,
                                                          g =
                                                              a &&
                                                              t.nodeName.toLowerCase(),
                                                          b = !l && !a,
                                                          v = !1;
                                                      if (h) {
                                                          if (n) {
                                                              for (; w; ) {
                                                                  for (
                                                                      m = t;
                                                                      (m =
                                                                          m[w]);

                                                                  )
                                                                      if (
                                                                          a
                                                                              ? m.nodeName.toLowerCase() ===
                                                                                g
                                                                              : 1 ===
                                                                                m.nodeType
                                                                      )
                                                                          return !1;
                                                                  f = w =
                                                                      "only" ===
                                                                          o &&
                                                                      !f &&
                                                                      "nextSibling";
                                                              }
                                                              return !0;
                                                          }
                                                          if (
                                                              ((f = [
                                                                  c
                                                                      ? h.firstChild
                                                                      : h.lastChild,
                                                              ]),
                                                              c && b)
                                                          ) {
                                                              for (
                                                                  v =
                                                                      (p =
                                                                          (s =
                                                                              (d =
                                                                                  (u =
                                                                                      (m =
                                                                                          h)[
                                                                                          M
                                                                                      ] ||
                                                                                      (m[
                                                                                          M
                                                                                      ] =
                                                                                          {}))[
                                                                                      m
                                                                                          .uniqueID
                                                                                  ] ||
                                                                                  (u[
                                                                                      m.uniqueID
                                                                                  ] =
                                                                                      {}))[
                                                                                  o
                                                                              ] ||
                                                                              [])[0] ===
                                                                              B &&
                                                                          s[1]) &&
                                                                      s[2],
                                                                      m =
                                                                          p &&
                                                                          h
                                                                              .childNodes[
                                                                              p
                                                                          ];
                                                                  (m =
                                                                      (++p &&
                                                                          m &&
                                                                          m[
                                                                              w
                                                                          ]) ||
                                                                      (v = p =
                                                                          0) ||
                                                                      f.pop());

                                                              )
                                                                  if (
                                                                      1 ===
                                                                          m.nodeType &&
                                                                      ++v &&
                                                                      m === t
                                                                  ) {
                                                                      d[o] = [
                                                                          B,
                                                                          p,
                                                                          v,
                                                                      ];
                                                                      break;
                                                                  }
                                                          } else if (
                                                              (b &&
                                                                  (v = p =
                                                                      (s =
                                                                          (d =
                                                                              (u =
                                                                                  (m =
                                                                                      t)[
                                                                                      M
                                                                                  ] ||
                                                                                  (m[
                                                                                      M
                                                                                  ] =
                                                                                      {}))[
                                                                                  m
                                                                                      .uniqueID
                                                                              ] ||
                                                                              (u[
                                                                                  m.uniqueID
                                                                              ] =
                                                                                  {}))[
                                                                              o
                                                                          ] ||
                                                                          [])[0] ===
                                                                          B &&
                                                                      s[1]),
                                                              !1 === v)
                                                          )
                                                              for (
                                                                  ;
                                                                  (m =
                                                                      (++p &&
                                                                          m &&
                                                                          m[
                                                                              w
                                                                          ]) ||
                                                                      (v = p =
                                                                          0) ||
                                                                      f.pop()) &&
                                                                  ((a
                                                                      ? m.nodeName.toLowerCase() !==
                                                                        g
                                                                      : 1 !==
                                                                        m.nodeType) ||
                                                                      !++v ||
                                                                      (b &&
                                                                          ((d =
                                                                              (u =
                                                                                  m[
                                                                                      M
                                                                                  ] ||
                                                                                  (m[
                                                                                      M
                                                                                  ] =
                                                                                      {}))[
                                                                                  m
                                                                                      .uniqueID
                                                                              ] ||
                                                                              (u[
                                                                                  m.uniqueID
                                                                              ] =
                                                                                  {}))[
                                                                              o
                                                                          ] = [
                                                                              B,
                                                                              v,
                                                                          ]),
                                                                      m !== t));

                                                              );
                                                          return (
                                                              (v -= i) === r ||
                                                              (v % r == 0 &&
                                                                  0 <= v / r)
                                                          );
                                                      }
                                                  };
                                        },
                                        PSEUDO: function (o, e) {
                                            var i,
                                                n =
                                                    v.pseudos[o] ||
                                                    v.setFilters[
                                                        o.toLowerCase()
                                                    ] ||
                                                    t.error(
                                                        "unsupported pseudo: " +
                                                            o
                                                    );
                                            return n[M]
                                                ? n(e)
                                                : 1 < n.length
                                                ? ((i = [o, o, "", e]),
                                                  v.setFilters.hasOwnProperty(
                                                      o.toLowerCase()
                                                  )
                                                      ? r(function (o, t) {
                                                            for (
                                                                var r,
                                                                    i = n(o, e),
                                                                    c =
                                                                        i.length;
                                                                c--;

                                                            )
                                                                o[
                                                                    (r = K(
                                                                        o,
                                                                        i[c]
                                                                    ))
                                                                ] = !(t[r] =
                                                                    i[c]);
                                                        })
                                                      : function (o) {
                                                            return n(o, 0, i);
                                                        })
                                                : n;
                                        },
                                    },
                                    pseudos: {
                                        not: r(function (o) {
                                            var t = [],
                                                e = [],
                                                i = k(o.replace(io, "$1"));
                                            return i[M]
                                                ? r(function (o, t, e, r) {
                                                      for (
                                                          var n,
                                                              c = i(
                                                                  o,
                                                                  null,
                                                                  r,
                                                                  []
                                                              ),
                                                              a = o.length;
                                                          a--;

                                                      )
                                                          (n = c[a]) &&
                                                              (o[a] = !(t[a] =
                                                                  n));
                                                  })
                                                : function (o, r, n) {
                                                      return (
                                                          (t[0] = o),
                                                          i(t, null, n, e),
                                                          (t[0] = null),
                                                          !e.pop()
                                                      );
                                                  };
                                        }),
                                        has: r(function (o) {
                                            return function (e) {
                                                return 0 < t(o, e).length;
                                            };
                                        }),
                                        contains: r(function (o) {
                                            return (
                                                (o = o.replace(bo, vo)),
                                                function (t) {
                                                    return (
                                                        -1 <
                                                        (
                                                            t.textContent ||
                                                            y(t)
                                                        ).indexOf(o)
                                                    );
                                                }
                                            );
                                        }),
                                        lang: r(function (o) {
                                            return (
                                                so.test(o || "") ||
                                                    t.error(
                                                        "unsupported lang: " + o
                                                    ),
                                                (o = o
                                                    .replace(bo, vo)
                                                    .toLowerCase()),
                                                function (t) {
                                                    var e;
                                                    do {
                                                        if (
                                                            (e = q
                                                                ? t.lang
                                                                : t.getAttribute(
                                                                      "xml:lang"
                                                                  ) ||
                                                                  t.getAttribute(
                                                                      "lang"
                                                                  ))
                                                        )
                                                            return (
                                                                (e =
                                                                    e.toLowerCase()) ===
                                                                    o ||
                                                                0 ===
                                                                    e.indexOf(
                                                                        o + "-"
                                                                    )
                                                            );
                                                    } while (
                                                        (t = t.parentNode) &&
                                                        1 === t.nodeType
                                                    );
                                                    return !1;
                                                }
                                            );
                                        }),
                                        target: function (t) {
                                            var e =
                                                o.location && o.location.hash;
                                            return e && e.slice(1) === t.id;
                                        },
                                        root: function (o) {
                                            return o === j;
                                        },
                                        focus: function (o) {
                                            return (
                                                o === A.activeElement &&
                                                (!A.hasFocus || A.hasFocus()) &&
                                                !!(
                                                    o.type ||
                                                    o.href ||
                                                    ~o.tabIndex
                                                )
                                            );
                                        },
                                        enabled: a(!1),
                                        disabled: a(!0),
                                        checked: function (o) {
                                            var t = o.nodeName.toLowerCase();
                                            return (
                                                ("input" === t &&
                                                    !!o.checked) ||
                                                ("option" === t && !!o.selected)
                                            );
                                        },
                                        selected: function (o) {
                                            return (
                                                o.parentNode &&
                                                    o.parentNode.selectedIndex,
                                                !0 === o.selected
                                            );
                                        },
                                        empty: function (o) {
                                            for (
                                                o = o.firstChild;
                                                o;
                                                o = o.nextSibling
                                            )
                                                if (o.nodeType < 6) return !1;
                                            return !0;
                                        },
                                        parent: function (o) {
                                            return !v.pseudos.empty(o);
                                        },
                                        header: function (o) {
                                            return fo.test(o.nodeName);
                                        },
                                        input: function (o) {
                                            return po.test(o.nodeName);
                                        },
                                        button: function (o) {
                                            var t = o.nodeName.toLowerCase();
                                            return (
                                                ("input" === t &&
                                                    "button" === o.type) ||
                                                "button" === t
                                            );
                                        },
                                        text: function (o) {
                                            var t;
                                            return (
                                                "input" ===
                                                    o.nodeName.toLowerCase() &&
                                                "text" === o.type &&
                                                (null ==
                                                    (t =
                                                        o.getAttribute(
                                                            "type"
                                                        )) ||
                                                    "text" === t.toLowerCase())
                                            );
                                        },
                                        first: l(function () {
                                            return [0];
                                        }),
                                        last: l(function (o, t) {
                                            return [t - 1];
                                        }),
                                        eq: l(function (o, t, e) {
                                            return [e < 0 ? e + t : e];
                                        }),
                                        even: l(function (o, t) {
                                            for (var e = 0; e < t; e += 2)
                                                o.push(e);
                                            return o;
                                        }),
                                        odd: l(function (o, t) {
                                            for (var e = 1; e < t; e += 2)
                                                o.push(e);
                                            return o;
                                        }),
                                        lt: l(function (o, t, e) {
                                            for (
                                                var r =
                                                    e < 0
                                                        ? e + t
                                                        : t < e
                                                        ? t
                                                        : e;
                                                0 <= --r;

                                            )
                                                o.push(r);
                                            return o;
                                        }),
                                        gt: l(function (o, t, e) {
                                            for (
                                                var r = e < 0 ? e + t : e;
                                                ++r < t;

                                            )
                                                o.push(r);
                                            return o;
                                        }),
                                    },
                                }).pseudos.nth = v.pseudos.eq),
                            {
                                radio: !0,
                                checkbox: !0,
                                file: !0,
                                password: !0,
                                image: !0,
                            }))
                                v.pseudos[g] = (function (o) {
                                    return function (t) {
                                        return (
                                            "input" ===
                                                t.nodeName.toLowerCase() &&
                                            t.type === o
                                        );
                                    };
                                })(g);
                            for (g in { submit: !0, reset: !0 })
                                v.pseudos[g] = (function (o) {
                                    return function (t) {
                                        var e = t.nodeName.toLowerCase();
                                        return (
                                            ("input" === e || "button" === e) &&
                                            t.type === o
                                        );
                                    };
                                })(g);
                            return (
                                (d.prototype = v.filters = v.pseudos),
                                (v.setFilters = new d()),
                                (x = t.tokenize =
                                    function (o, e) {
                                        var r,
                                            i,
                                            n,
                                            c,
                                            a,
                                            l,
                                            s,
                                            d = H[o + " "];
                                        if (d) return e ? 0 : d.slice(0);
                                        for (
                                            a = o, l = [], s = v.preFilter;
                                            a;

                                        ) {
                                            for (c in ((r &&
                                                !(i = no.exec(a))) ||
                                                (i &&
                                                    (a =
                                                        a.slice(i[0].length) ||
                                                        a),
                                                l.push((n = []))),
                                            (r = !1),
                                            (i = co.exec(a)) &&
                                                ((r = i.shift()),
                                                n.push({
                                                    value: r,
                                                    type: i[0].replace(io, " "),
                                                }),
                                                (a = a.slice(r.length))),
                                            v.filter))
                                                !(i = uo[c].exec(a)) ||
                                                    (s[c] && !(i = s[c](i))) ||
                                                    ((r = i.shift()),
                                                    n.push({
                                                        value: r,
                                                        type: c,
                                                        matches: i,
                                                    }),
                                                    (a = a.slice(r.length)));
                                            if (!r) break;
                                        }
                                        return e
                                            ? a.length
                                            : a
                                            ? t.error(o)
                                            : H(o, l).slice(0);
                                    }),
                                (k = t.compile =
                                    function (o, e) {
                                        var i,
                                            n,
                                            c,
                                            a,
                                            l,
                                            s,
                                            d = [],
                                            u = [],
                                            m = W[o + " "];
                                        if (!m) {
                                            for (
                                                e || (e = x(o)), i = e.length;
                                                i--;

                                            )
                                                (m = h(e[i]))[M]
                                                    ? d.push(m)
                                                    : u.push(m);
                                            (m = W(
                                                o,
                                                ((n = u),
                                                (a = 0 < (c = d).length),
                                                (l = 0 < n.length),
                                                (s = function (o, e, r, i, s) {
                                                    var d,
                                                        u,
                                                        m,
                                                        p = 0,
                                                        w = "0",
                                                        h = o && [],
                                                        g = [],
                                                        b = C,
                                                        y =
                                                            o ||
                                                            (l &&
                                                                v.find.TAG(
                                                                    "*",
                                                                    s
                                                                )),
                                                        _ = (B +=
                                                            null == b
                                                                ? 1
                                                                : Math.random() ||
                                                                  0.1),
                                                        x = y.length;
                                                    for (
                                                        s &&
                                                        (C = e === A || e || s);
                                                        w !== x &&
                                                        null != (d = y[w]);
                                                        w++
                                                    ) {
                                                        if (l && d) {
                                                            for (
                                                                u = 0,
                                                                    e ||
                                                                        d.ownerDocument ===
                                                                            A ||
                                                                        (E(d),
                                                                        (r =
                                                                            !q));
                                                                (m = n[u++]);

                                                            )
                                                                if (
                                                                    m(
                                                                        d,
                                                                        e || A,
                                                                        r
                                                                    )
                                                                ) {
                                                                    i.push(d);
                                                                    break;
                                                                }
                                                            s && (B = _);
                                                        }
                                                        a &&
                                                            ((d = !m && d) &&
                                                                p--,
                                                            o && h.push(d));
                                                    }
                                                    if (
                                                        ((p += w), a && w !== p)
                                                    ) {
                                                        for (
                                                            u = 0;
                                                            (m = c[u++]);

                                                        )
                                                            m(h, g, e, r);
                                                        if (o) {
                                                            if (0 < p)
                                                                for (; w--; )
                                                                    h[w] ||
                                                                        g[w] ||
                                                                        (g[w] =
                                                                            Y.call(
                                                                                i
                                                                            ));
                                                            g = f(g);
                                                        }
                                                        G.apply(i, g),
                                                            s &&
                                                                !o &&
                                                                0 < g.length &&
                                                                1 <
                                                                    p +
                                                                        c.length &&
                                                                t.uniqueSort(i);
                                                    }
                                                    return (
                                                        s && ((B = _), (C = b)),
                                                        h
                                                    );
                                                }),
                                                a ? r(s) : s)
                                            )).selector = o;
                                        }
                                        return m;
                                    }),
                                (z = t.select =
                                    function (o, t, e, r) {
                                        var i,
                                            n,
                                            c,
                                            a,
                                            l,
                                            d = "function" == typeof o && o,
                                            m = !r && x((o = d.selector || o));
                                        if (((e = e || []), 1 === m.length)) {
                                            if (
                                                2 <
                                                    (n = m[0] = m[0].slice(0))
                                                        .length &&
                                                "ID" === (c = n[0]).type &&
                                                9 === t.nodeType &&
                                                q &&
                                                v.relative[n[1].type]
                                            ) {
                                                if (
                                                    !(t = (v.find.ID(
                                                        c.matches[0].replace(
                                                            bo,
                                                            vo
                                                        ),
                                                        t
                                                    ) || [])[0])
                                                )
                                                    return e;
                                                d && (t = t.parentNode),
                                                    (o = o.slice(
                                                        n.shift().value.length
                                                    ));
                                            }
                                            for (
                                                i = uo.needsContext.test(o)
                                                    ? 0
                                                    : n.length;
                                                i-- &&
                                                ((c = n[i]),
                                                !v.relative[(a = c.type)]);

                                            )
                                                if (
                                                    (l = v.find[a]) &&
                                                    (r = l(
                                                        c.matches[0].replace(
                                                            bo,
                                                            vo
                                                        ),
                                                        (go.test(n[0].type) &&
                                                            s(t.parentNode)) ||
                                                            t
                                                    ))
                                                ) {
                                                    if (
                                                        (n.splice(i, 1),
                                                        !(o = r.length && u(n)))
                                                    )
                                                        return G.apply(e, r), e;
                                                    break;
                                                }
                                        }
                                        return (
                                            (d || k(o, m))(
                                                r,
                                                t,
                                                !q,
                                                e,
                                                !t ||
                                                    (go.test(o) &&
                                                        s(t.parentNode)) ||
                                                    t
                                            ),
                                            e
                                        );
                                    }),
                                (b.sortStable =
                                    M.split("").sort(U).join("") === M),
                                (b.detectDuplicates = !!S),
                                E(),
                                (b.sortDetached = i(function (o) {
                                    return (
                                        1 &
                                        o.compareDocumentPosition(
                                            A.createElement("fieldset")
                                        )
                                    );
                                })),
                                i(function (o) {
                                    return (
                                        (o.innerHTML = "<a href='#'></a>"),
                                        "#" ===
                                            o.firstChild.getAttribute("href")
                                    );
                                }) ||
                                    n(
                                        "type|href|height|width",
                                        function (o, t, e) {
                                            if (!e)
                                                return o.getAttribute(
                                                    t,
                                                    "type" === t.toLowerCase()
                                                        ? 1
                                                        : 2
                                                );
                                        }
                                    ),
                                (b.attributes &&
                                    i(function (o) {
                                        return (
                                            (o.innerHTML = "<input/>"),
                                            o.firstChild.setAttribute(
                                                "value",
                                                ""
                                            ),
                                            "" ===
                                                o.firstChild.getAttribute(
                                                    "value"
                                                )
                                        );
                                    })) ||
                                    n("value", function (o, t, e) {
                                        if (
                                            !e &&
                                            "input" === o.nodeName.toLowerCase()
                                        )
                                            return o.defaultValue;
                                    }),
                                i(function (o) {
                                    return null == o.getAttribute("disabled");
                                }) ||
                                    n(Q, function (o, t, e) {
                                        var r;
                                        if (!e)
                                            return !0 === o[t]
                                                ? t.toLowerCase()
                                                : (r = o.getAttributeNode(t)) &&
                                                  r.specified
                                                ? r.value
                                                : null;
                                    }),
                                t
                            );
                        })(o);
                        (ho.find = bo),
                            (ho.expr = bo.selectors),
                            (ho.expr[":"] = ho.expr.pseudos),
                            (ho.uniqueSort = ho.unique = bo.uniqueSort),
                            (ho.text = bo.getText),
                            (ho.isXMLDoc = bo.isXML),
                            (ho.contains = bo.contains),
                            (ho.escapeSelector = bo.escape);
                        var vo = function (o, t, e) {
                                for (
                                    var r = [], i = void 0 !== e;
                                    (o = o[t]) && 9 !== o.nodeType;

                                )
                                    if (1 === o.nodeType) {
                                        if (i && ho(o).is(e)) break;
                                        r.push(o);
                                    }
                                return r;
                            },
                            yo = function (o, t) {
                                for (var e = []; o; o = o.nextSibling)
                                    1 === o.nodeType && o !== t && e.push(o);
                                return e;
                            },
                            _o = ho.expr.match.needsContext,
                            xo =
                                /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
                        (ho.filter = function (o, t, e) {
                            var r = t[0];
                            return (
                                e && (o = ":not(" + o + ")"),
                                1 === t.length && 1 === r.nodeType
                                    ? ho.find.matchesSelector(r, o)
                                        ? [r]
                                        : []
                                    : ho.find.matches(
                                          o,
                                          ho.grep(t, function (o) {
                                              return 1 === o.nodeType;
                                          })
                                      )
                            );
                        }),
                            ho.fn.extend({
                                find: function (o) {
                                    var t,
                                        e,
                                        r = this.length,
                                        i = this;
                                    if ("string" != typeof o)
                                        return this.pushStack(
                                            ho(o).filter(function () {
                                                for (t = 0; t < r; t++)
                                                    if (ho.contains(i[t], this))
                                                        return !0;
                                            })
                                        );
                                    for (
                                        e = this.pushStack([]), t = 0;
                                        t < r;
                                        t++
                                    )
                                        ho.find(o, i[t], e);
                                    return 1 < r ? ho.uniqueSort(e) : e;
                                },
                                filter: function (o) {
                                    return this.pushStack(c(this, o || [], !1));
                                },
                                not: function (o) {
                                    return this.pushStack(c(this, o || [], !0));
                                },
                                is: function (o) {
                                    return !!c(
                                        this,
                                        "string" == typeof o && _o.test(o)
                                            ? ho(o)
                                            : o || [],
                                        !1
                                    ).length;
                                },
                            });
                        var ko,
                            zo = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;
                        ((ho.fn.init = function (o, t, e) {
                            var r, i;
                            if (!o) return this;
                            if (((e = e || ko), "string" == typeof o)) {
                                if (
                                    !(r =
                                        "<" === o[0] &&
                                        ">" === o[o.length - 1] &&
                                        3 <= o.length
                                            ? [null, o, null]
                                            : zo.exec(o)) ||
                                    (!r[1] && t)
                                )
                                    return !t || t.jquery
                                        ? (t || e).find(o)
                                        : this.constructor(t).find(o);
                                if (r[1]) {
                                    if (
                                        ((t = t instanceof ho ? t[0] : t),
                                        ho.merge(
                                            this,
                                            ho.parseHTML(
                                                r[1],
                                                t && t.nodeType
                                                    ? t.ownerDocument || t
                                                    : Z,
                                                !0
                                            )
                                        ),
                                        xo.test(r[1]) && ho.isPlainObject(t))
                                    )
                                        for (r in t)
                                            mo(this[r])
                                                ? this[r](t[r])
                                                : this.attr(r, t[r]);
                                    return this;
                                }
                                return (
                                    (i = Z.getElementById(r[2])) &&
                                        ((this[0] = i), (this.length = 1)),
                                    this
                                );
                            }
                            return o.nodeType
                                ? ((this[0] = o), (this.length = 1), this)
                                : mo(o)
                                ? void 0 !== e.ready
                                    ? e.ready(o)
                                    : o(ho)
                                : ho.makeArray(o, this);
                        }).prototype = ho.fn),
                            (ko = ho(Z));
                        var Co = /^(?:parents|prev(?:Until|All))/,
                            To = {
                                children: !0,
                                contents: !0,
                                next: !0,
                                prev: !0,
                            };
                        ho.fn.extend({
                            has: function (o) {
                                var t = ho(o, this),
                                    e = t.length;
                                return this.filter(function () {
                                    for (var o = 0; o < e; o++)
                                        if (ho.contains(this, t[o])) return !0;
                                });
                            },
                            closest: function (o, t) {
                                var e,
                                    r = 0,
                                    i = this.length,
                                    n = [],
                                    c = "string" != typeof o && ho(o);
                                if (!_o.test(o))
                                    for (; r < i; r++)
                                        for (
                                            e = this[r];
                                            e && e !== t;
                                            e = e.parentNode
                                        )
                                            if (
                                                e.nodeType < 11 &&
                                                (c
                                                    ? -1 < c.index(e)
                                                    : 1 === e.nodeType &&
                                                      ho.find.matchesSelector(
                                                          e,
                                                          o
                                                      ))
                                            ) {
                                                n.push(e);
                                                break;
                                            }
                                return this.pushStack(
                                    1 < n.length ? ho.uniqueSort(n) : n
                                );
                            },
                            index: function (o) {
                                return o
                                    ? "string" == typeof o
                                        ? io.call(ho(o), this[0])
                                        : io.call(this, o.jquery ? o[0] : o)
                                    : this[0] && this[0].parentNode
                                    ? this.first().prevAll().length
                                    : -1;
                            },
                            add: function (o, t) {
                                return this.pushStack(
                                    ho.uniqueSort(
                                        ho.merge(this.get(), ho(o, t))
                                    )
                                );
                            },
                            addBack: function (o) {
                                return this.add(
                                    null == o
                                        ? this.prevObject
                                        : this.prevObject.filter(o)
                                );
                            },
                        }),
                            ho.each(
                                {
                                    parent: function (o) {
                                        var t = o.parentNode;
                                        return t && 11 !== t.nodeType
                                            ? t
                                            : null;
                                    },
                                    parents: function (o) {
                                        return vo(o, "parentNode");
                                    },
                                    parentsUntil: function (o, t, e) {
                                        return vo(o, "parentNode", e);
                                    },
                                    next: function (o) {
                                        return a(o, "nextSibling");
                                    },
                                    prev: function (o) {
                                        return a(o, "previousSibling");
                                    },
                                    nextAll: function (o) {
                                        return vo(o, "nextSibling");
                                    },
                                    prevAll: function (o) {
                                        return vo(o, "previousSibling");
                                    },
                                    nextUntil: function (o, t, e) {
                                        return vo(o, "nextSibling", e);
                                    },
                                    prevUntil: function (o, t, e) {
                                        return vo(o, "previousSibling", e);
                                    },
                                    siblings: function (o) {
                                        return yo(
                                            (o.parentNode || {}).firstChild,
                                            o
                                        );
                                    },
                                    children: function (o) {
                                        return yo(o.firstChild);
                                    },
                                    contents: function (o) {
                                        return void 0 !== o.contentDocument
                                            ? o.contentDocument
                                            : (n(o, "template") &&
                                                  (o = o.content || o),
                                              ho.merge([], o.childNodes));
                                    },
                                },
                                function (o, t) {
                                    ho.fn[o] = function (e, r) {
                                        var i = ho.map(this, t, e);
                                        return (
                                            "Until" !== o.slice(-5) && (r = e),
                                            r &&
                                                "string" == typeof r &&
                                                (i = ho.filter(r, i)),
                                            1 < this.length &&
                                                (To[o] || ho.uniqueSort(i),
                                                Co.test(o) && i.reverse()),
                                            this.pushStack(i)
                                        );
                                    };
                                }
                            );
                        var So = /[^\x20\t\r\n\f]+/g;
                        (ho.Callbacks = function (o) {
                            var t, e;
                            o =
                                "string" == typeof o
                                    ? ((t = o),
                                      (e = {}),
                                      ho.each(
                                          t.match(So) || [],
                                          function (o, t) {
                                              e[t] = !0;
                                          }
                                      ),
                                      e)
                                    : ho.extend({}, o);
                            var i,
                                n,
                                c,
                                a,
                                l = [],
                                s = [],
                                d = -1,
                                u = function () {
                                    for (
                                        a = a || o.once, c = i = !0;
                                        s.length;
                                        d = -1
                                    )
                                        for (n = s.shift(); ++d < l.length; )
                                            !1 === l[d].apply(n[0], n[1]) &&
                                                o.stopOnFalse &&
                                                ((d = l.length), (n = !1));
                                    o.memory || (n = !1),
                                        (i = !1),
                                        a && (l = n ? [] : "");
                                },
                                m = {
                                    add: function () {
                                        return (
                                            l &&
                                                (n &&
                                                    !i &&
                                                    ((d = l.length - 1),
                                                    s.push(n)),
                                                (function t(e) {
                                                    ho.each(e, function (e, i) {
                                                        mo(i)
                                                            ? (o.unique &&
                                                                  m.has(i)) ||
                                                              l.push(i)
                                                            : i &&
                                                              i.length &&
                                                              "string" !==
                                                                  r(i) &&
                                                              t(i);
                                                    });
                                                })(arguments),
                                                n && !i && u()),
                                            this
                                        );
                                    },
                                    remove: function () {
                                        return (
                                            ho.each(arguments, function (o, t) {
                                                for (
                                                    var e;
                                                    -1 <
                                                    (e = ho.inArray(t, l, e));

                                                )
                                                    l.splice(e, 1),
                                                        e <= d && d--;
                                            }),
                                            this
                                        );
                                    },
                                    has: function (o) {
                                        return o
                                            ? -1 < ho.inArray(o, l)
                                            : 0 < l.length;
                                    },
                                    empty: function () {
                                        return l && (l = []), this;
                                    },
                                    disable: function () {
                                        return (a = s = []), (l = n = ""), this;
                                    },
                                    disabled: function () {
                                        return !l;
                                    },
                                    lock: function () {
                                        return (
                                            (a = s = []),
                                            n || i || (l = n = ""),
                                            this
                                        );
                                    },
                                    locked: function () {
                                        return !!a;
                                    },
                                    fireWith: function (o, t) {
                                        return (
                                            a ||
                                                ((t = [
                                                    o,
                                                    (t = t || []).slice
                                                        ? t.slice()
                                                        : t,
                                                ]),
                                                s.push(t),
                                                i || u()),
                                            this
                                        );
                                    },
                                    fire: function () {
                                        return (
                                            m.fireWith(this, arguments), this
                                        );
                                    },
                                    fired: function () {
                                        return !!c;
                                    },
                                };
                            return m;
                        }),
                            ho.extend({
                                Deferred: function (t) {
                                    var e = [
                                            [
                                                "notify",
                                                "progress",
                                                ho.Callbacks("memory"),
                                                ho.Callbacks("memory"),
                                                2,
                                            ],
                                            [
                                                "resolve",
                                                "done",
                                                ho.Callbacks("once memory"),
                                                ho.Callbacks("once memory"),
                                                0,
                                                "resolved",
                                            ],
                                            [
                                                "reject",
                                                "fail",
                                                ho.Callbacks("once memory"),
                                                ho.Callbacks("once memory"),
                                                1,
                                                "rejected",
                                            ],
                                        ],
                                        r = "pending",
                                        i = {
                                            state: function () {
                                                return r;
                                            },
                                            always: function () {
                                                return (
                                                    n
                                                        .done(arguments)
                                                        .fail(arguments),
                                                    this
                                                );
                                            },
                                            catch: function (o) {
                                                return i.then(null, o);
                                            },
                                            pipe: function () {
                                                var o = arguments;
                                                return ho
                                                    .Deferred(function (t) {
                                                        ho.each(
                                                            e,
                                                            function (e, r) {
                                                                var i =
                                                                    mo(
                                                                        o[r[4]]
                                                                    ) &&
                                                                    o[r[4]];
                                                                n[r[1]](
                                                                    function () {
                                                                        var o =
                                                                            i &&
                                                                            i.apply(
                                                                                this,
                                                                                arguments
                                                                            );
                                                                        o &&
                                                                        mo(
                                                                            o.promise
                                                                        )
                                                                            ? o
                                                                                  .promise()
                                                                                  .progress(
                                                                                      t.notify
                                                                                  )
                                                                                  .done(
                                                                                      t.resolve
                                                                                  )
                                                                                  .fail(
                                                                                      t.reject
                                                                                  )
                                                                            : t[
                                                                                  r[0] +
                                                                                      "With"
                                                                              ](
                                                                                  this,
                                                                                  i
                                                                                      ? [
                                                                                            o,
                                                                                        ]
                                                                                      : arguments
                                                                              );
                                                                    }
                                                                );
                                                            }
                                                        ),
                                                            (o = null);
                                                    })
                                                    .promise();
                                            },
                                            then: function (t, r, i) {
                                                function n(t, e, r, i) {
                                                    return function () {
                                                        var a = this,
                                                            s = arguments,
                                                            u = function () {
                                                                var o, u;
                                                                if (!(t < c)) {
                                                                    if (
                                                                        (o =
                                                                            r.apply(
                                                                                a,
                                                                                s
                                                                            )) ===
                                                                        e.promise()
                                                                    )
                                                                        throw new TypeError(
                                                                            "Thenable self-resolution"
                                                                        );
                                                                    (u =
                                                                        o &&
                                                                        ("object" ==
                                                                            typeof o ||
                                                                            "function" ==
                                                                                typeof o) &&
                                                                        o.then),
                                                                        mo(u)
                                                                            ? i
                                                                                ? u.call(
                                                                                      o,
                                                                                      n(
                                                                                          c,
                                                                                          e,
                                                                                          l,
                                                                                          i
                                                                                      ),
                                                                                      n(
                                                                                          c,
                                                                                          e,
                                                                                          d,
                                                                                          i
                                                                                      )
                                                                                  )
                                                                                : (c++,
                                                                                  u.call(
                                                                                      o,
                                                                                      n(
                                                                                          c,
                                                                                          e,
                                                                                          l,
                                                                                          i
                                                                                      ),
                                                                                      n(
                                                                                          c,
                                                                                          e,
                                                                                          d,
                                                                                          i
                                                                                      ),
                                                                                      n(
                                                                                          c,
                                                                                          e,
                                                                                          l,
                                                                                          e.notifyWith
                                                                                      )
                                                                                  ))
                                                                            : (r !==
                                                                                  l &&
                                                                                  ((a =
                                                                                      void 0),
                                                                                  (s =
                                                                                      [
                                                                                          o,
                                                                                      ])),
                                                                              (
                                                                                  i ||
                                                                                  e.resolveWith
                                                                              )(
                                                                                  a,
                                                                                  s
                                                                              ));
                                                                }
                                                            },
                                                            m = i
                                                                ? u
                                                                : function () {
                                                                      try {
                                                                          u();
                                                                      } catch (o) {
                                                                          ho
                                                                              .Deferred
                                                                              .exceptionHook &&
                                                                              ho.Deferred.exceptionHook(
                                                                                  o,
                                                                                  m.stackTrace
                                                                              ),
                                                                              c <=
                                                                                  t +
                                                                                      1 &&
                                                                                  (r !==
                                                                                      d &&
                                                                                      ((a =
                                                                                          void 0),
                                                                                      (s =
                                                                                          [
                                                                                              o,
                                                                                          ])),
                                                                                  e.rejectWith(
                                                                                      a,
                                                                                      s
                                                                                  ));
                                                                      }
                                                                  };
                                                        t
                                                            ? m()
                                                            : (ho.Deferred
                                                                  .getStackHook &&
                                                                  (m.stackTrace =
                                                                      ho.Deferred.getStackHook()),
                                                              o.setTimeout(m));
                                                    };
                                                }
                                                var c = 0;
                                                return ho
                                                    .Deferred(function (o) {
                                                        e[0][3].add(
                                                            n(
                                                                0,
                                                                o,
                                                                mo(i) ? i : l,
                                                                o.notifyWith
                                                            )
                                                        ),
                                                            e[1][3].add(
                                                                n(
                                                                    0,
                                                                    o,
                                                                    mo(t)
                                                                        ? t
                                                                        : l
                                                                )
                                                            ),
                                                            e[2][3].add(
                                                                n(
                                                                    0,
                                                                    o,
                                                                    mo(r)
                                                                        ? r
                                                                        : d
                                                                )
                                                            );
                                                    })
                                                    .promise();
                                            },
                                            promise: function (o) {
                                                return null != o
                                                    ? ho.extend(o, i)
                                                    : i;
                                            },
                                        },
                                        n = {};
                                    return (
                                        ho.each(e, function (o, t) {
                                            var c = t[2],
                                                a = t[5];
                                            (i[t[1]] = c.add),
                                                a &&
                                                    c.add(
                                                        function () {
                                                            r = a;
                                                        },
                                                        e[3 - o][2].disable,
                                                        e[3 - o][3].disable,
                                                        e[0][2].lock,
                                                        e[0][3].lock
                                                    ),
                                                c.add(t[3].fire),
                                                (n[t[0]] = function () {
                                                    return (
                                                        n[t[0] + "With"](
                                                            this === n
                                                                ? void 0
                                                                : this,
                                                            arguments
                                                        ),
                                                        this
                                                    );
                                                }),
                                                (n[t[0] + "With"] = c.fireWith);
                                        }),
                                        i.promise(n),
                                        t && t.call(n, n),
                                        n
                                    );
                                },
                                when: function (o) {
                                    var t = arguments.length,
                                        e = t,
                                        r = Array(e),
                                        i = to.call(arguments),
                                        n = ho.Deferred(),
                                        c = function (o) {
                                            return function (e) {
                                                (r[o] = this),
                                                    (i[o] =
                                                        1 < arguments.length
                                                            ? to.call(arguments)
                                                            : e),
                                                    --t || n.resolveWith(r, i);
                                            };
                                        };
                                    if (
                                        t <= 1 &&
                                        (u(
                                            o,
                                            n.done(c(e)).resolve,
                                            n.reject,
                                            !t
                                        ),
                                        "pending" === n.state() ||
                                            mo(i[e] && i[e].then))
                                    )
                                        return n.then();
                                    for (; e--; ) u(i[e], c(e), n.reject);
                                    return n.promise();
                                },
                            });
                        var Eo =
                            /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
                        (ho.Deferred.exceptionHook = function (t, e) {
                            o.console &&
                                o.console.warn &&
                                t &&
                                Eo.test(t.name) &&
                                o.console.warn(
                                    "jQuery.Deferred exception: " + t.message,
                                    t.stack,
                                    e
                                );
                        }),
                            (ho.readyException = function (t) {
                                o.setTimeout(function () {
                                    throw t;
                                });
                            });
                        var Ao = ho.Deferred();
                        (ho.fn.ready = function (o) {
                            return (
                                Ao.then(o).catch(function (o) {
                                    ho.readyException(o);
                                }),
                                this
                            );
                        }),
                            ho.extend({
                                isReady: !1,
                                readyWait: 1,
                                ready: function (o) {
                                    (!0 === o ? --ho.readyWait : ho.isReady) ||
                                        ((ho.isReady = !0) !== o &&
                                            0 < --ho.readyWait) ||
                                        Ao.resolveWith(Z, [ho]);
                                },
                            }),
                            (ho.ready.then = Ao.then),
                            "complete" === Z.readyState ||
                            ("loading" !== Z.readyState &&
                                !Z.documentElement.doScroll)
                                ? o.setTimeout(ho.ready)
                                : (Z.addEventListener("DOMContentLoaded", m),
                                  o.addEventListener("load", m));
                        var jo = function (o, t, e, i, n, c, a) {
                                var l = 0,
                                    s = o.length,
                                    d = null == e;
                                if ("object" === r(e))
                                    for (l in ((n = !0), e))
                                        jo(o, t, l, e[l], !0, c, a);
                                else if (
                                    void 0 !== i &&
                                    ((n = !0),
                                    mo(i) || (a = !0),
                                    d &&
                                        (a
                                            ? (t.call(o, i), (t = null))
                                            : ((d = t),
                                              (t = function (o, t, e) {
                                                  return d.call(ho(o), e);
                                              }))),
                                    t)
                                )
                                    for (; l < s; l++)
                                        t(
                                            o[l],
                                            e,
                                            a ? i : i.call(o[l], l, t(o[l], e))
                                        );
                                return n
                                    ? o
                                    : d
                                    ? t.call(o)
                                    : s
                                    ? t(o[0], e)
                                    : c;
                            },
                            qo = /^-ms-/,
                            Lo = /-([a-z])/g,
                            No = function (o) {
                                return (
                                    1 === o.nodeType ||
                                    9 === o.nodeType ||
                                    !+o.nodeType
                                );
                            };
                        (w.uid = 1),
                            (w.prototype = {
                                cache: function (o) {
                                    var t = o[this.expando];
                                    return (
                                        t ||
                                            ((t = {}),
                                            No(o) &&
                                                (o.nodeType
                                                    ? (o[this.expando] = t)
                                                    : Object.defineProperty(
                                                          o,
                                                          this.expando,
                                                          {
                                                              value: t,
                                                              configurable: !0,
                                                          }
                                                      ))),
                                        t
                                    );
                                },
                                set: function (o, t, e) {
                                    var r,
                                        i = this.cache(o);
                                    if ("string" == typeof t) i[f(t)] = e;
                                    else for (r in t) i[f(r)] = t[r];
                                    return i;
                                },
                                get: function (o, t) {
                                    return void 0 === t
                                        ? this.cache(o)
                                        : o[this.expando] &&
                                              o[this.expando][f(t)];
                                },
                                access: function (o, t, e) {
                                    return void 0 === t ||
                                        (t &&
                                            "string" == typeof t &&
                                            void 0 === e)
                                        ? this.get(o, t)
                                        : (this.set(o, t, e),
                                          void 0 !== e ? e : t);
                                },
                                remove: function (o, t) {
                                    var e,
                                        r = o[this.expando];
                                    if (void 0 !== r) {
                                        if (void 0 !== t) {
                                            e = (t = Array.isArray(t)
                                                ? t.map(f)
                                                : (t = f(t)) in r
                                                ? [t]
                                                : t.match(So) || []).length;
                                            for (; e--; ) delete r[t[e]];
                                        }
                                        (void 0 === t || ho.isEmptyObject(r)) &&
                                            (o.nodeType
                                                ? (o[this.expando] = void 0)
                                                : delete o[this.expando]);
                                    }
                                },
                                hasData: function (o) {
                                    var t = o[this.expando];
                                    return void 0 !== t && !ho.isEmptyObject(t);
                                },
                            });
                        var Do = new w(),
                            Oo = new w(),
                            Mo = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
                            Po = /[A-Z]/g;
                        ho.extend({
                            hasData: function (o) {
                                return Oo.hasData(o) || Do.hasData(o);
                            },
                            data: function (o, t, e) {
                                return Oo.access(o, t, e);
                            },
                            removeData: function (o, t) {
                                Oo.remove(o, t);
                            },
                            _data: function (o, t, e) {
                                return Do.access(o, t, e);
                            },
                            _removeData: function (o, t) {
                                Do.remove(o, t);
                            },
                        }),
                            ho.fn.extend({
                                data: function (o, t) {
                                    var e,
                                        r,
                                        i,
                                        n = this[0],
                                        c = n && n.attributes;
                                    if (void 0 === o) {
                                        if (
                                            this.length &&
                                            ((i = Oo.get(n)),
                                            1 === n.nodeType &&
                                                !Do.get(n, "hasDataAttrs"))
                                        ) {
                                            for (e = c.length; e--; )
                                                c[e] &&
                                                    0 ===
                                                        (r = c[e].name).indexOf(
                                                            "data-"
                                                        ) &&
                                                    ((r = f(r.slice(5))),
                                                    h(n, r, i[r]));
                                            Do.set(n, "hasDataAttrs", !0);
                                        }
                                        return i;
                                    }
                                    return "object" == typeof o
                                        ? this.each(function () {
                                              Oo.set(this, o);
                                          })
                                        : jo(
                                              this,
                                              function (t) {
                                                  var e;
                                                  if (n && void 0 === t)
                                                      return void 0 !==
                                                          (e = Oo.get(n, o))
                                                          ? e
                                                          : void 0 !==
                                                            (e = h(n, o))
                                                          ? e
                                                          : void 0;
                                                  this.each(function () {
                                                      Oo.set(this, o, t);
                                                  });
                                              },
                                              null,
                                              t,
                                              1 < arguments.length,
                                              null,
                                              !0
                                          );
                                },
                                removeData: function (o) {
                                    return this.each(function () {
                                        Oo.remove(this, o);
                                    });
                                },
                            }),
                            ho.extend({
                                queue: function (o, t, e) {
                                    var r;
                                    if (o)
                                        return (
                                            (t = (t || "fx") + "queue"),
                                            (r = Do.get(o, t)),
                                            e &&
                                                (!r || Array.isArray(e)
                                                    ? (r = Do.access(
                                                          o,
                                                          t,
                                                          ho.makeArray(e)
                                                      ))
                                                    : r.push(e)),
                                            r || []
                                        );
                                },
                                dequeue: function (o, t) {
                                    t = t || "fx";
                                    var e = ho.queue(o, t),
                                        r = e.length,
                                        i = e.shift(),
                                        n = ho._queueHooks(o, t);
                                    "inprogress" === i &&
                                        ((i = e.shift()), r--),
                                        i &&
                                            ("fx" === t &&
                                                e.unshift("inprogress"),
                                            delete n.stop,
                                            i.call(
                                                o,
                                                function () {
                                                    ho.dequeue(o, t);
                                                },
                                                n
                                            )),
                                        !r && n && n.empty.fire();
                                },
                                _queueHooks: function (o, t) {
                                    var e = t + "queueHooks";
                                    return (
                                        Do.get(o, e) ||
                                        Do.access(o, e, {
                                            empty: ho
                                                .Callbacks("once memory")
                                                .add(function () {
                                                    Do.remove(o, [
                                                        t + "queue",
                                                        e,
                                                    ]);
                                                }),
                                        })
                                    );
                                },
                            }),
                            ho.fn.extend({
                                queue: function (o, t) {
                                    var e = 2;
                                    return (
                                        "string" != typeof o &&
                                            ((t = o), (o = "fx"), e--),
                                        arguments.length < e
                                            ? ho.queue(this[0], o)
                                            : void 0 === t
                                            ? this
                                            : this.each(function () {
                                                  var e = ho.queue(this, o, t);
                                                  ho._queueHooks(this, o),
                                                      "fx" === o &&
                                                          "inprogress" !==
                                                              e[0] &&
                                                          ho.dequeue(this, o);
                                              })
                                    );
                                },
                                dequeue: function (o) {
                                    return this.each(function () {
                                        ho.dequeue(this, o);
                                    });
                                },
                                clearQueue: function (o) {
                                    return this.queue(o || "fx", []);
                                },
                                promise: function (o, t) {
                                    var e,
                                        r = 1,
                                        i = ho.Deferred(),
                                        n = this,
                                        c = this.length,
                                        a = function () {
                                            --r || i.resolveWith(n, [n]);
                                        };
                                    for (
                                        "string" != typeof o &&
                                            ((t = o), (o = void 0)),
                                            o = o || "fx";
                                        c--;

                                    )
                                        (e = Do.get(n[c], o + "queueHooks")) &&
                                            e.empty &&
                                            (r++, e.empty.add(a));
                                    return a(), i.promise(t);
                                },
                            });
                        var Bo = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
                            Io = new RegExp(
                                "^(?:([+-])=|)(" + Bo + ")([a-z%]*)$",
                                "i"
                            ),
                            Ro = ["Top", "Right", "Bottom", "Left"],
                            Ho = Z.documentElement,
                            Wo = function (o) {
                                return ho.contains(o.ownerDocument, o);
                            },
                            Fo = { composed: !0 };
                        Ho.getRootNode &&
                            (Wo = function (o) {
                                return (
                                    ho.contains(o.ownerDocument, o) ||
                                    o.getRootNode(Fo) === o.ownerDocument
                                );
                            });
                        var Uo = function (o, t) {
                                return (
                                    "none" === (o = t || o).style.display ||
                                    ("" === o.style.display &&
                                        Wo(o) &&
                                        "none" === ho.css(o, "display"))
                                );
                            },
                            $o = function (o, t, e, r) {
                                var i,
                                    n,
                                    c = {};
                                for (n in t)
                                    (c[n] = o.style[n]), (o.style[n] = t[n]);
                                for (n in ((i = e.apply(o, r || [])), t))
                                    o.style[n] = c[n];
                                return i;
                            },
                            Xo = {};
                        ho.fn.extend({
                            show: function () {
                                return b(this, !0);
                            },
                            hide: function () {
                                return b(this);
                            },
                            toggle: function (o) {
                                return "boolean" == typeof o
                                    ? o
                                        ? this.show()
                                        : this.hide()
                                    : this.each(function () {
                                          Uo(this)
                                              ? ho(this).show()
                                              : ho(this).hide();
                                      });
                            },
                        });
                        var Yo = /^(?:checkbox|radio)$/i,
                            Vo = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i,
                            Go = /^$|^module$|\/(?:java|ecma)script/i,
                            Jo = {
                                option: [
                                    1,
                                    "<select multiple='multiple'>",
                                    "</select>",
                                ],
                                thead: [1, "<table>", "</table>"],
                                col: [
                                    2,
                                    "<table><colgroup>",
                                    "</colgroup></table>",
                                ],
                                tr: [2, "<table><tbody>", "</tbody></table>"],
                                td: [
                                    3,
                                    "<table><tbody><tr>",
                                    "</tr></tbody></table>",
                                ],
                                _default: [0, "", ""],
                            };
                        (Jo.optgroup = Jo.option),
                            (Jo.tbody =
                                Jo.tfoot =
                                Jo.colgroup =
                                Jo.caption =
                                    Jo.thead),
                            (Jo.th = Jo.td);
                        var Ko,
                            Qo,
                            Zo = /<|&#?\w+;/;
                        (Ko = Z.createDocumentFragment().appendChild(
                            Z.createElement("div")
                        )),
                            (Qo = Z.createElement("input")).setAttribute(
                                "type",
                                "radio"
                            ),
                            Qo.setAttribute("checked", "checked"),
                            Qo.setAttribute("name", "t"),
                            Ko.appendChild(Qo),
                            (uo.checkClone = Ko.cloneNode(!0).cloneNode(
                                !0
                            ).lastChild.checked),
                            (Ko.innerHTML = "<textarea>x</textarea>"),
                            (uo.noCloneChecked = !!Ko.cloneNode(!0).lastChild
                                .defaultValue);
                        var ot = /^key/,
                            tt =
                                /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
                            et = /^([^.]*)(?:\.(.+)|)/;
                        (ho.event = {
                            global: {},
                            add: function (o, t, e, r, i) {
                                var n,
                                    c,
                                    a,
                                    l,
                                    s,
                                    d,
                                    u,
                                    m,
                                    p,
                                    f,
                                    w,
                                    h = Do.get(o);
                                if (h)
                                    for (
                                        e.handler &&
                                            ((e = (n = e).handler),
                                            (i = n.selector)),
                                            i && ho.find.matchesSelector(Ho, i),
                                            e.guid || (e.guid = ho.guid++),
                                            (l = h.events) ||
                                                (l = h.events = {}),
                                            (c = h.handle) ||
                                                (c = h.handle =
                                                    function (t) {
                                                        return void 0 !== ho &&
                                                            ho.event
                                                                .triggered !==
                                                                t.type
                                                            ? ho.event.dispatch.apply(
                                                                  o,
                                                                  arguments
                                                              )
                                                            : void 0;
                                                    }),
                                            s = (t = (t || "").match(So) || [
                                                "",
                                            ]).length;
                                        s--;

                                    )
                                        (p = w = (a = et.exec(t[s]) || [])[1]),
                                            (f = (a[2] || "")
                                                .split(".")
                                                .sort()),
                                            p &&
                                                ((u =
                                                    ho.event.special[p] || {}),
                                                (p =
                                                    (i
                                                        ? u.delegateType
                                                        : u.bindType) || p),
                                                (u = ho.event.special[p] || {}),
                                                (d = ho.extend(
                                                    {
                                                        type: p,
                                                        origType: w,
                                                        data: r,
                                                        handler: e,
                                                        guid: e.guid,
                                                        selector: i,
                                                        needsContext:
                                                            i &&
                                                            ho.expr.match.needsContext.test(
                                                                i
                                                            ),
                                                        namespace: f.join("."),
                                                    },
                                                    n
                                                )),
                                                (m = l[p]) ||
                                                    (((m = l[p] =
                                                        []).delegateCount = 0),
                                                    (u.setup &&
                                                        !1 !==
                                                            u.setup.call(
                                                                o,
                                                                r,
                                                                f,
                                                                c
                                                            )) ||
                                                        (o.addEventListener &&
                                                            o.addEventListener(
                                                                p,
                                                                c
                                                            ))),
                                                u.add &&
                                                    (u.add.call(o, d),
                                                    d.handler.guid ||
                                                        (d.handler.guid =
                                                            e.guid)),
                                                i
                                                    ? m.splice(
                                                          m.delegateCount++,
                                                          0,
                                                          d
                                                      )
                                                    : m.push(d),
                                                (ho.event.global[p] = !0));
                            },
                            remove: function (o, t, e, r, i) {
                                var n,
                                    c,
                                    a,
                                    l,
                                    s,
                                    d,
                                    u,
                                    m,
                                    p,
                                    f,
                                    w,
                                    h = Do.hasData(o) && Do.get(o);
                                if (h && (l = h.events)) {
                                    for (
                                        s = (t = (t || "").match(So) || [""])
                                            .length;
                                        s--;

                                    )
                                        if (
                                            ((p = w =
                                                (a = et.exec(t[s]) || [])[1]),
                                            (f = (a[2] || "")
                                                .split(".")
                                                .sort()),
                                            p)
                                        ) {
                                            for (
                                                u = ho.event.special[p] || {},
                                                    m =
                                                        l[
                                                            (p =
                                                                (r
                                                                    ? u.delegateType
                                                                    : u.bindType) ||
                                                                p)
                                                        ] || [],
                                                    a =
                                                        a[2] &&
                                                        new RegExp(
                                                            "(^|\\.)" +
                                                                f.join(
                                                                    "\\.(?:.*\\.|)"
                                                                ) +
                                                                "(\\.|$)"
                                                        ),
                                                    c = n = m.length;
                                                n--;

                                            )
                                                (d = m[n]),
                                                    (!i && w !== d.origType) ||
                                                        (e &&
                                                            e.guid !==
                                                                d.guid) ||
                                                        (a &&
                                                            !a.test(
                                                                d.namespace
                                                            )) ||
                                                        (r &&
                                                            r !== d.selector &&
                                                            ("**" !== r ||
                                                                !d.selector)) ||
                                                        (m.splice(n, 1),
                                                        d.selector &&
                                                            m.delegateCount--,
                                                        u.remove &&
                                                            u.remove.call(
                                                                o,
                                                                d
                                                            ));
                                            c &&
                                                !m.length &&
                                                ((u.teardown &&
                                                    !1 !==
                                                        u.teardown.call(
                                                            o,
                                                            f,
                                                            h.handle
                                                        )) ||
                                                    ho.removeEvent(
                                                        o,
                                                        p,
                                                        h.handle
                                                    ),
                                                delete l[p]);
                                        } else
                                            for (p in l)
                                                ho.event.remove(
                                                    o,
                                                    p + t[s],
                                                    e,
                                                    r,
                                                    !0
                                                );
                                    ho.isEmptyObject(l) &&
                                        Do.remove(o, "handle events");
                                }
                            },
                            dispatch: function (o) {
                                var t,
                                    e,
                                    r,
                                    i,
                                    n,
                                    c,
                                    a = ho.event.fix(o),
                                    l = new Array(arguments.length),
                                    s =
                                        (Do.get(this, "events") || {})[
                                            a.type
                                        ] || [],
                                    d = ho.event.special[a.type] || {};
                                for (l[0] = a, t = 1; t < arguments.length; t++)
                                    l[t] = arguments[t];
                                if (
                                    ((a.delegateTarget = this),
                                    !d.preDispatch ||
                                        !1 !== d.preDispatch.call(this, a))
                                ) {
                                    for (
                                        c = ho.event.handlers.call(this, a, s),
                                            t = 0;
                                        (i = c[t++]) &&
                                        !a.isPropagationStopped();

                                    )
                                        for (
                                            a.currentTarget = i.elem, e = 0;
                                            (n = i.handlers[e++]) &&
                                            !a.isImmediatePropagationStopped();

                                        )
                                            (a.rnamespace &&
                                                !1 !== n.namespace &&
                                                !a.rnamespace.test(
                                                    n.namespace
                                                )) ||
                                                ((a.handleObj = n),
                                                (a.data = n.data),
                                                void 0 !==
                                                    (r = (
                                                        (
                                                            ho.event.special[
                                                                n.origType
                                                            ] || {}
                                                        ).handle || n.handler
                                                    ).apply(i.elem, l)) &&
                                                    !1 === (a.result = r) &&
                                                    (a.preventDefault(),
                                                    a.stopPropagation()));
                                    return (
                                        d.postDispatch &&
                                            d.postDispatch.call(this, a),
                                        a.result
                                    );
                                }
                            },
                            handlers: function (o, t) {
                                var e,
                                    r,
                                    i,
                                    n,
                                    c,
                                    a = [],
                                    l = t.delegateCount,
                                    s = o.target;
                                if (
                                    l &&
                                    s.nodeType &&
                                    !("click" === o.type && 1 <= o.button)
                                )
                                    for (; s !== this; s = s.parentNode || this)
                                        if (
                                            1 === s.nodeType &&
                                            ("click" !== o.type ||
                                                !0 !== s.disabled)
                                        ) {
                                            for (
                                                n = [], c = {}, e = 0;
                                                e < l;
                                                e++
                                            )
                                                void 0 ===
                                                    c[
                                                        (i =
                                                            (r = t[e])
                                                                .selector + " ")
                                                    ] &&
                                                    (c[i] = r.needsContext
                                                        ? -1 <
                                                          ho(i, this).index(s)
                                                        : ho.find(
                                                              i,
                                                              this,
                                                              null,
                                                              [s]
                                                          ).length),
                                                    c[i] && n.push(r);
                                            n.length &&
                                                a.push({
                                                    elem: s,
                                                    handlers: n,
                                                });
                                        }
                                return (
                                    (s = this),
                                    l < t.length &&
                                        a.push({
                                            elem: s,
                                            handlers: t.slice(l),
                                        }),
                                    a
                                );
                            },
                            addProp: function (o, t) {
                                Object.defineProperty(ho.Event.prototype, o, {
                                    enumerable: !0,
                                    configurable: !0,
                                    get: mo(t)
                                        ? function () {
                                              if (this.originalEvent)
                                                  return t(this.originalEvent);
                                          }
                                        : function () {
                                              if (this.originalEvent)
                                                  return this.originalEvent[o];
                                          },
                                    set: function (t) {
                                        Object.defineProperty(this, o, {
                                            enumerable: !0,
                                            configurable: !0,
                                            writable: !0,
                                            value: t,
                                        });
                                    },
                                });
                            },
                            fix: function (o) {
                                return o[ho.expando] ? o : new ho.Event(o);
                            },
                            special: {
                                load: { noBubble: !0 },
                                click: {
                                    setup: function (o) {
                                        var t = this || o;
                                        return (
                                            Yo.test(t.type) &&
                                                t.click &&
                                                n(t, "input") &&
                                                T(t, "click", x),
                                            !1
                                        );
                                    },
                                    trigger: function (o) {
                                        var t = this || o;
                                        return (
                                            Yo.test(t.type) &&
                                                t.click &&
                                                n(t, "input") &&
                                                T(t, "click"),
                                            !0
                                        );
                                    },
                                    _default: function (o) {
                                        var t = o.target;
                                        return (
                                            (Yo.test(t.type) &&
                                                t.click &&
                                                n(t, "input") &&
                                                Do.get(t, "click")) ||
                                            n(t, "a")
                                        );
                                    },
                                },
                                beforeunload: {
                                    postDispatch: function (o) {
                                        void 0 !== o.result &&
                                            o.originalEvent &&
                                            (o.originalEvent.returnValue =
                                                o.result);
                                    },
                                },
                            },
                        }),
                            (ho.removeEvent = function (o, t, e) {
                                o.removeEventListener &&
                                    o.removeEventListener(t, e);
                            }),
                            (ho.Event = function (o, t) {
                                if (!(this instanceof ho.Event))
                                    return new ho.Event(o, t);
                                o && o.type
                                    ? ((this.originalEvent = o),
                                      (this.type = o.type),
                                      (this.isDefaultPrevented =
                                          o.defaultPrevented ||
                                          (void 0 === o.defaultPrevented &&
                                              !1 === o.returnValue)
                                              ? x
                                              : k),
                                      (this.target =
                                          o.target && 3 === o.target.nodeType
                                              ? o.target.parentNode
                                              : o.target),
                                      (this.currentTarget = o.currentTarget),
                                      (this.relatedTarget = o.relatedTarget))
                                    : (this.type = o),
                                    t && ho.extend(this, t),
                                    (this.timeStamp =
                                        (o && o.timeStamp) || Date.now()),
                                    (this[ho.expando] = !0);
                            }),
                            (ho.Event.prototype = {
                                constructor: ho.Event,
                                isDefaultPrevented: k,
                                isPropagationStopped: k,
                                isImmediatePropagationStopped: k,
                                isSimulated: !1,
                                preventDefault: function () {
                                    var o = this.originalEvent;
                                    (this.isDefaultPrevented = x),
                                        o &&
                                            !this.isSimulated &&
                                            o.preventDefault();
                                },
                                stopPropagation: function () {
                                    var o = this.originalEvent;
                                    (this.isPropagationStopped = x),
                                        o &&
                                            !this.isSimulated &&
                                            o.stopPropagation();
                                },
                                stopImmediatePropagation: function () {
                                    var o = this.originalEvent;
                                    (this.isImmediatePropagationStopped = x),
                                        o &&
                                            !this.isSimulated &&
                                            o.stopImmediatePropagation(),
                                        this.stopPropagation();
                                },
                            }),
                            ho.each(
                                {
                                    altKey: !0,
                                    bubbles: !0,
                                    cancelable: !0,
                                    changedTouches: !0,
                                    ctrlKey: !0,
                                    detail: !0,
                                    eventPhase: !0,
                                    metaKey: !0,
                                    pageX: !0,
                                    pageY: !0,
                                    shiftKey: !0,
                                    view: !0,
                                    char: !0,
                                    code: !0,
                                    charCode: !0,
                                    key: !0,
                                    keyCode: !0,
                                    button: !0,
                                    buttons: !0,
                                    clientX: !0,
                                    clientY: !0,
                                    offsetX: !0,
                                    offsetY: !0,
                                    pointerId: !0,
                                    pointerType: !0,
                                    screenX: !0,
                                    screenY: !0,
                                    targetTouches: !0,
                                    toElement: !0,
                                    touches: !0,
                                    which: function (o) {
                                        var t = o.button;
                                        return null == o.which &&
                                            ot.test(o.type)
                                            ? null != o.charCode
                                                ? o.charCode
                                                : o.keyCode
                                            : !o.which &&
                                              void 0 !== t &&
                                              tt.test(o.type)
                                            ? 1 & t
                                                ? 1
                                                : 2 & t
                                                ? 3
                                                : 4 & t
                                                ? 2
                                                : 0
                                            : o.which;
                                    },
                                },
                                ho.event.addProp
                            ),
                            ho.each(
                                { focus: "focusin", blur: "focusout" },
                                function (o, t) {
                                    ho.event.special[o] = {
                                        setup: function () {
                                            return T(this, o, z), !1;
                                        },
                                        trigger: function () {
                                            return T(this, o), !0;
                                        },
                                        delegateType: t,
                                    };
                                }
                            ),
                            ho.each(
                                {
                                    mouseenter: "mouseover",
                                    mouseleave: "mouseout",
                                    pointerenter: "pointerover",
                                    pointerleave: "pointerout",
                                },
                                function (o, t) {
                                    ho.event.special[o] = {
                                        delegateType: t,
                                        bindType: t,
                                        handle: function (o) {
                                            var e,
                                                r = o.relatedTarget,
                                                i = o.handleObj;
                                            return (
                                                (r &&
                                                    (r === this ||
                                                        ho.contains(
                                                            this,
                                                            r
                                                        ))) ||
                                                    ((o.type = i.origType),
                                                    (e = i.handler.apply(
                                                        this,
                                                        arguments
                                                    )),
                                                    (o.type = t)),
                                                e
                                            );
                                        },
                                    };
                                }
                            ),
                            ho.fn.extend({
                                on: function (o, t, e, r) {
                                    return C(this, o, t, e, r);
                                },
                                one: function (o, t, e, r) {
                                    return C(this, o, t, e, r, 1);
                                },
                                off: function (o, t, e) {
                                    var r, i;
                                    if (o && o.preventDefault && o.handleObj)
                                        return (
                                            (r = o.handleObj),
                                            ho(o.delegateTarget).off(
                                                r.namespace
                                                    ? r.origType +
                                                          "." +
                                                          r.namespace
                                                    : r.origType,
                                                r.selector,
                                                r.handler
                                            ),
                                            this
                                        );
                                    if ("object" == typeof o) {
                                        for (i in o) this.off(i, t, o[i]);
                                        return this;
                                    }
                                    return (
                                        (!1 !== t && "function" != typeof t) ||
                                            ((e = t), (t = void 0)),
                                        !1 === e && (e = k),
                                        this.each(function () {
                                            ho.event.remove(this, o, e, t);
                                        })
                                    );
                                },
                            });
                        var rt =
                                /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,
                            it = /<script|<style|<link/i,
                            nt = /checked\s*(?:[^=]|=\s*.checked.)/i,
                            ct = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
                        ho.extend({
                            htmlPrefilter: function (o) {
                                return o.replace(rt, "<$1></$2>");
                            },
                            clone: function (o, t, e) {
                                var r,
                                    i,
                                    n,
                                    c,
                                    a,
                                    l,
                                    s,
                                    d = o.cloneNode(!0),
                                    u = Wo(o);
                                if (
                                    !(
                                        uo.noCloneChecked ||
                                        (1 !== o.nodeType &&
                                            11 !== o.nodeType) ||
                                        ho.isXMLDoc(o)
                                    )
                                )
                                    for (
                                        c = v(d), r = 0, i = (n = v(o)).length;
                                        r < i;
                                        r++
                                    )
                                        (a = n[r]),
                                            (l = c[r]),
                                            "input" ===
                                                (s =
                                                    l.nodeName.toLowerCase()) &&
                                            Yo.test(a.type)
                                                ? (l.checked = a.checked)
                                                : ("input" !== s &&
                                                      "textarea" !== s) ||
                                                  (l.defaultValue =
                                                      a.defaultValue);
                                if (t)
                                    if (e)
                                        for (
                                            n = n || v(o),
                                                c = c || v(d),
                                                r = 0,
                                                i = n.length;
                                            r < i;
                                            r++
                                        )
                                            j(n[r], c[r]);
                                    else j(o, d);
                                return (
                                    0 < (c = v(d, "script")).length &&
                                        y(c, !u && v(o, "script")),
                                    d
                                );
                            },
                            cleanData: function (o) {
                                for (
                                    var t, e, r, i = ho.event.special, n = 0;
                                    void 0 !== (e = o[n]);
                                    n++
                                )
                                    if (No(e)) {
                                        if ((t = e[Do.expando])) {
                                            if (t.events)
                                                for (r in t.events)
                                                    i[r]
                                                        ? ho.event.remove(e, r)
                                                        : ho.removeEvent(
                                                              e,
                                                              r,
                                                              t.handle
                                                          );
                                            e[Do.expando] = void 0;
                                        }
                                        e[Oo.expando] &&
                                            (e[Oo.expando] = void 0);
                                    }
                            },
                        }),
                            ho.fn.extend({
                                detach: function (o) {
                                    return L(this, o, !0);
                                },
                                remove: function (o) {
                                    return L(this, o);
                                },
                                text: function (o) {
                                    return jo(
                                        this,
                                        function (o) {
                                            return void 0 === o
                                                ? ho.text(this)
                                                : this.empty().each(
                                                      function () {
                                                          (1 !==
                                                              this.nodeType &&
                                                              11 !==
                                                                  this
                                                                      .nodeType &&
                                                              9 !==
                                                                  this
                                                                      .nodeType) ||
                                                              (this.textContent =
                                                                  o);
                                                      }
                                                  );
                                        },
                                        null,
                                        o,
                                        arguments.length
                                    );
                                },
                                append: function () {
                                    return q(this, arguments, function (o) {
                                        (1 !== this.nodeType &&
                                            11 !== this.nodeType &&
                                            9 !== this.nodeType) ||
                                            S(this, o).appendChild(o);
                                    });
                                },
                                prepend: function () {
                                    return q(this, arguments, function (o) {
                                        if (
                                            1 === this.nodeType ||
                                            11 === this.nodeType ||
                                            9 === this.nodeType
                                        ) {
                                            var t = S(this, o);
                                            t.insertBefore(o, t.firstChild);
                                        }
                                    });
                                },
                                before: function () {
                                    return q(this, arguments, function (o) {
                                        this.parentNode &&
                                            this.parentNode.insertBefore(
                                                o,
                                                this
                                            );
                                    });
                                },
                                after: function () {
                                    return q(this, arguments, function (o) {
                                        this.parentNode &&
                                            this.parentNode.insertBefore(
                                                o,
                                                this.nextSibling
                                            );
                                    });
                                },
                                empty: function () {
                                    for (
                                        var o, t = 0;
                                        null != (o = this[t]);
                                        t++
                                    )
                                        1 === o.nodeType &&
                                            (ho.cleanData(v(o, !1)),
                                            (o.textContent = ""));
                                    return this;
                                },
                                clone: function (o, t) {
                                    return (
                                        (o = null != o && o),
                                        (t = null == t ? o : t),
                                        this.map(function () {
                                            return ho.clone(this, o, t);
                                        })
                                    );
                                },
                                html: function (o) {
                                    return jo(
                                        this,
                                        function (o) {
                                            var t = this[0] || {},
                                                e = 0,
                                                r = this.length;
                                            if (
                                                void 0 === o &&
                                                1 === t.nodeType
                                            )
                                                return t.innerHTML;
                                            if (
                                                "string" == typeof o &&
                                                !it.test(o) &&
                                                !Jo[
                                                    (Vo.exec(o) || [
                                                        "",
                                                        "",
                                                    ])[1].toLowerCase()
                                                ]
                                            ) {
                                                o = ho.htmlPrefilter(o);
                                                try {
                                                    for (; e < r; e++)
                                                        1 ===
                                                            (t = this[e] || {})
                                                                .nodeType &&
                                                            (ho.cleanData(
                                                                v(t, !1)
                                                            ),
                                                            (t.innerHTML = o));
                                                    t = 0;
                                                } catch (o) {}
                                            }
                                            t && this.empty().append(o);
                                        },
                                        null,
                                        o,
                                        arguments.length
                                    );
                                },
                                replaceWith: function () {
                                    var o = [];
                                    return q(
                                        this,
                                        arguments,
                                        function (t) {
                                            var e = this.parentNode;
                                            ho.inArray(this, o) < 0 &&
                                                (ho.cleanData(v(this)),
                                                e && e.replaceChild(t, this));
                                        },
                                        o
                                    );
                                },
                            }),
                            ho.each(
                                {
                                    appendTo: "append",
                                    prependTo: "prepend",
                                    insertBefore: "before",
                                    insertAfter: "after",
                                    replaceAll: "replaceWith",
                                },
                                function (o, t) {
                                    ho.fn[o] = function (o) {
                                        for (
                                            var e,
                                                r = [],
                                                i = ho(o),
                                                n = i.length - 1,
                                                c = 0;
                                            c <= n;
                                            c++
                                        )
                                            (e =
                                                c === n
                                                    ? this
                                                    : this.clone(!0)),
                                                ho(i[c])[t](e),
                                                ro.apply(r, e.get());
                                        return this.pushStack(r);
                                    };
                                }
                            );
                        var at = new RegExp("^(" + Bo + ")(?!px)[a-z%]+$", "i"),
                            lt = function (t) {
                                var e = t.ownerDocument.defaultView;
                                return (
                                    (e && e.opener) || (e = o),
                                    e.getComputedStyle(t)
                                );
                            },
                            st = new RegExp(Ro.join("|"), "i");
                        !(function () {
                            function t() {
                                if (s) {
                                    (l.style.cssText =
                                        "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0"),
                                        (s.style.cssText =
                                            "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%"),
                                        Ho.appendChild(l).appendChild(s);
                                    var t = o.getComputedStyle(s);
                                    (r = "1%" !== t.top),
                                        (a = 12 === e(t.marginLeft)),
                                        (s.style.right = "60%"),
                                        (c = 36 === e(t.right)),
                                        (i = 36 === e(t.width)),
                                        (s.style.position = "absolute"),
                                        (n = 12 === e(s.offsetWidth / 3)),
                                        Ho.removeChild(l),
                                        (s = null);
                                }
                            }
                            function e(o) {
                                return Math.round(parseFloat(o));
                            }
                            var r,
                                i,
                                n,
                                c,
                                a,
                                l = Z.createElement("div"),
                                s = Z.createElement("div");
                            s.style &&
                                ((s.style.backgroundClip = "content-box"),
                                (s.cloneNode(!0).style.backgroundClip = ""),
                                (uo.clearCloneStyle =
                                    "content-box" === s.style.backgroundClip),
                                ho.extend(uo, {
                                    boxSizingReliable: function () {
                                        return t(), i;
                                    },
                                    pixelBoxStyles: function () {
                                        return t(), c;
                                    },
                                    pixelPosition: function () {
                                        return t(), r;
                                    },
                                    reliableMarginLeft: function () {
                                        return t(), a;
                                    },
                                    scrollboxSize: function () {
                                        return t(), n;
                                    },
                                }));
                        })();
                        var dt = ["Webkit", "Moz", "ms"],
                            ut = Z.createElement("div").style,
                            mt = {},
                            pt = /^(none|table(?!-c[ea]).+)/,
                            ft = /^--/,
                            wt = {
                                position: "absolute",
                                visibility: "hidden",
                                display: "block",
                            },
                            ht = { letterSpacing: "0", fontWeight: "400" };
                        ho.extend({
                            cssHooks: {
                                opacity: {
                                    get: function (o, t) {
                                        if (t) {
                                            var e = N(o, "opacity");
                                            return "" === e ? "1" : e;
                                        }
                                    },
                                },
                            },
                            cssNumber: {
                                animationIterationCount: !0,
                                columnCount: !0,
                                fillOpacity: !0,
                                flexGrow: !0,
                                flexShrink: !0,
                                fontWeight: !0,
                                gridArea: !0,
                                gridColumn: !0,
                                gridColumnEnd: !0,
                                gridColumnStart: !0,
                                gridRow: !0,
                                gridRowEnd: !0,
                                gridRowStart: !0,
                                lineHeight: !0,
                                opacity: !0,
                                order: !0,
                                orphans: !0,
                                widows: !0,
                                zIndex: !0,
                                zoom: !0,
                            },
                            cssProps: {},
                            style: function (o, t, e, r) {
                                if (
                                    o &&
                                    3 !== o.nodeType &&
                                    8 !== o.nodeType &&
                                    o.style
                                ) {
                                    var i,
                                        n,
                                        c,
                                        a = f(t),
                                        l = ft.test(t),
                                        s = o.style;
                                    if (
                                        (l || (t = O(a)),
                                        (c = ho.cssHooks[t] || ho.cssHooks[a]),
                                        void 0 === e)
                                    )
                                        return c &&
                                            "get" in c &&
                                            void 0 !== (i = c.get(o, !1, r))
                                            ? i
                                            : s[t];
                                    "string" == (n = typeof e) &&
                                        (i = Io.exec(e)) &&
                                        i[1] &&
                                        ((e = g(o, t, i)), (n = "number")),
                                        null != e &&
                                            e == e &&
                                            ("number" !== n ||
                                                l ||
                                                (e +=
                                                    (i && i[3]) ||
                                                    (ho.cssNumber[a]
                                                        ? ""
                                                        : "px")),
                                            uo.clearCloneStyle ||
                                                "" !== e ||
                                                0 !== t.indexOf("background") ||
                                                (s[t] = "inherit"),
                                            (c &&
                                                "set" in c &&
                                                void 0 ===
                                                    (e = c.set(o, e, r))) ||
                                                (l
                                                    ? s.setProperty(t, e)
                                                    : (s[t] = e)));
                                }
                            },
                            css: function (o, t, e, r) {
                                var i,
                                    n,
                                    c,
                                    a = f(t);
                                return (
                                    ft.test(t) || (t = O(a)),
                                    (c = ho.cssHooks[t] || ho.cssHooks[a]) &&
                                        "get" in c &&
                                        (i = c.get(o, !0, e)),
                                    void 0 === i && (i = N(o, t, r)),
                                    "normal" === i && t in ht && (i = ht[t]),
                                    "" === e || e
                                        ? ((n = parseFloat(i)),
                                          !0 === e || isFinite(n) ? n || 0 : i)
                                        : i
                                );
                            },
                        }),
                            ho.each(["height", "width"], function (o, t) {
                                ho.cssHooks[t] = {
                                    get: function (o, e, r) {
                                        if (e)
                                            return !pt.test(
                                                ho.css(o, "display")
                                            ) ||
                                                (o.getClientRects().length &&
                                                    o.getBoundingClientRect()
                                                        .width)
                                                ? B(o, t, r)
                                                : $o(o, wt, function () {
                                                      return B(o, t, r);
                                                  });
                                    },
                                    set: function (o, e, r) {
                                        var i,
                                            n = lt(o),
                                            c =
                                                !uo.scrollboxSize() &&
                                                "absolute" === n.position,
                                            a =
                                                (c || r) &&
                                                "border-box" ===
                                                    ho.css(
                                                        o,
                                                        "boxSizing",
                                                        !1,
                                                        n
                                                    ),
                                            l = r ? P(o, t, r, a, n) : 0;
                                        return (
                                            a &&
                                                c &&
                                                (l -= Math.ceil(
                                                    o[
                                                        "offset" +
                                                            t[0].toUpperCase() +
                                                            t.slice(1)
                                                    ] -
                                                        parseFloat(n[t]) -
                                                        P(
                                                            o,
                                                            t,
                                                            "border",
                                                            !1,
                                                            n
                                                        ) -
                                                        0.5
                                                )),
                                            l &&
                                                (i = Io.exec(e)) &&
                                                "px" !== (i[3] || "px") &&
                                                ((o.style[t] = e),
                                                (e = ho.css(o, t))),
                                            M(0, e, l)
                                        );
                                    },
                                };
                            }),
                            (ho.cssHooks.marginLeft = D(
                                uo.reliableMarginLeft,
                                function (o, t) {
                                    if (t)
                                        return (
                                            (parseFloat(N(o, "marginLeft")) ||
                                                o.getBoundingClientRect().left -
                                                    $o(
                                                        o,
                                                        { marginLeft: 0 },
                                                        function () {
                                                            return o.getBoundingClientRect()
                                                                .left;
                                                        }
                                                    )) + "px"
                                        );
                                }
                            )),
                            ho.each(
                                { margin: "", padding: "", border: "Width" },
                                function (o, t) {
                                    (ho.cssHooks[o + t] = {
                                        expand: function (e) {
                                            for (
                                                var r = 0,
                                                    i = {},
                                                    n =
                                                        "string" == typeof e
                                                            ? e.split(" ")
                                                            : [e];
                                                r < 4;
                                                r++
                                            )
                                                i[o + Ro[r] + t] =
                                                    n[r] || n[r - 2] || n[0];
                                            return i;
                                        },
                                    }),
                                        "margin" !== o &&
                                            (ho.cssHooks[o + t].set = M);
                                }
                            ),
                            ho.fn.extend({
                                css: function (o, t) {
                                    return jo(
                                        this,
                                        function (o, t, e) {
                                            var r,
                                                i,
                                                n = {},
                                                c = 0;
                                            if (Array.isArray(t)) {
                                                for (
                                                    r = lt(o), i = t.length;
                                                    c < i;
                                                    c++
                                                )
                                                    n[t[c]] = ho.css(
                                                        o,
                                                        t[c],
                                                        !1,
                                                        r
                                                    );
                                                return n;
                                            }
                                            return void 0 !== e
                                                ? ho.style(o, t, e)
                                                : ho.css(o, t);
                                        },
                                        o,
                                        t,
                                        1 < arguments.length
                                    );
                                },
                            }),
                            (((ho.Tween = I).prototype = {
                                constructor: I,
                                init: function (o, t, e, r, i, n) {
                                    (this.elem = o),
                                        (this.prop = e),
                                        (this.easing = i || ho.easing._default),
                                        (this.options = t),
                                        (this.start = this.now = this.cur()),
                                        (this.end = r),
                                        (this.unit =
                                            n || (ho.cssNumber[e] ? "" : "px"));
                                },
                                cur: function () {
                                    var o = I.propHooks[this.prop];
                                    return o && o.get
                                        ? o.get(this)
                                        : I.propHooks._default.get(this);
                                },
                                run: function (o) {
                                    var t,
                                        e = I.propHooks[this.prop];
                                    return (
                                        this.options.duration
                                            ? (this.pos = t =
                                                  ho.easing[this.easing](
                                                      o,
                                                      this.options.duration * o,
                                                      0,
                                                      1,
                                                      this.options.duration
                                                  ))
                                            : (this.pos = t = o),
                                        (this.now =
                                            (this.end - this.start) * t +
                                            this.start),
                                        this.options.step &&
                                            this.options.step.call(
                                                this.elem,
                                                this.now,
                                                this
                                            ),
                                        e && e.set
                                            ? e.set(this)
                                            : I.propHooks._default.set(this),
                                        this
                                    );
                                },
                            }).init.prototype = I.prototype),
                            ((I.propHooks = {
                                _default: {
                                    get: function (o) {
                                        var t;
                                        return 1 !== o.elem.nodeType ||
                                            (null != o.elem[o.prop] &&
                                                null == o.elem.style[o.prop])
                                            ? o.elem[o.prop]
                                            : (t = ho.css(
                                                  o.elem,
                                                  o.prop,
                                                  ""
                                              )) && "auto" !== t
                                            ? t
                                            : 0;
                                    },
                                    set: function (o) {
                                        ho.fx.step[o.prop]
                                            ? ho.fx.step[o.prop](o)
                                            : 1 !== o.elem.nodeType ||
                                              (!ho.cssHooks[o.prop] &&
                                                  null ==
                                                      o.elem.style[O(o.prop)])
                                            ? (o.elem[o.prop] = o.now)
                                            : ho.style(
                                                  o.elem,
                                                  o.prop,
                                                  o.now + o.unit
                                              );
                                    },
                                },
                            }).scrollTop = I.propHooks.scrollLeft =
                                {
                                    set: function (o) {
                                        o.elem.nodeType &&
                                            o.elem.parentNode &&
                                            (o.elem[o.prop] = o.now);
                                    },
                                }),
                            (ho.easing = {
                                linear: function (o) {
                                    return o;
                                },
                                swing: function (o) {
                                    return 0.5 - Math.cos(o * Math.PI) / 2;
                                },
                                _default: "swing",
                            }),
                            (ho.fx = I.prototype.init),
                            (ho.fx.step = {});
                        var gt,
                            bt,
                            vt,
                            yt,
                            _t = /^(?:toggle|show|hide)$/,
                            xt = /queueHooks$/;
                        (ho.Animation = ho.extend(U, {
                            tweeners: {
                                "*": [
                                    function (o, t) {
                                        var e = this.createTween(o, t);
                                        return g(e.elem, o, Io.exec(t), e), e;
                                    },
                                ],
                            },
                            tweener: function (o, t) {
                                mo(o)
                                    ? ((t = o), (o = ["*"]))
                                    : (o = o.match(So));
                                for (var e, r = 0, i = o.length; r < i; r++)
                                    (e = o[r]),
                                        (U.tweeners[e] = U.tweeners[e] || []),
                                        U.tweeners[e].unshift(t);
                            },
                            prefilters: [
                                function (o, t, e) {
                                    var r,
                                        i,
                                        n,
                                        c,
                                        a,
                                        l,
                                        s,
                                        d,
                                        u = "width" in t || "height" in t,
                                        m = this,
                                        p = {},
                                        f = o.style,
                                        w = o.nodeType && Uo(o),
                                        h = Do.get(o, "fxshow");
                                    for (r in (e.queue ||
                                        (null ==
                                            (c = ho._queueHooks(o, "fx"))
                                                .unqueued &&
                                            ((c.unqueued = 0),
                                            (a = c.empty.fire),
                                            (c.empty.fire = function () {
                                                c.unqueued || a();
                                            })),
                                        c.unqueued++,
                                        m.always(function () {
                                            m.always(function () {
                                                c.unqueued--,
                                                    ho.queue(o, "fx").length ||
                                                        c.empty.fire();
                                            });
                                        })),
                                    t))
                                        if (((i = t[r]), _t.test(i))) {
                                            if (
                                                (delete t[r],
                                                (n = n || "toggle" === i),
                                                i === (w ? "hide" : "show"))
                                            ) {
                                                if (
                                                    "show" !== i ||
                                                    !h ||
                                                    void 0 === h[r]
                                                )
                                                    continue;
                                                w = !0;
                                            }
                                            p[r] =
                                                (h && h[r]) || ho.style(o, r);
                                        }
                                    if (
                                        (l = !ho.isEmptyObject(t)) ||
                                        !ho.isEmptyObject(p)
                                    )
                                        for (r in (u &&
                                            1 === o.nodeType &&
                                            ((e.overflow = [
                                                f.overflow,
                                                f.overflowX,
                                                f.overflowY,
                                            ]),
                                            null == (s = h && h.display) &&
                                                (s = Do.get(o, "display")),
                                            "none" ===
                                                (d = ho.css(o, "display")) &&
                                                (s
                                                    ? (d = s)
                                                    : (b([o], !0),
                                                      (s =
                                                          o.style.display || s),
                                                      (d = ho.css(
                                                          o,
                                                          "display"
                                                      )),
                                                      b([o]))),
                                            ("inline" === d ||
                                                ("inline-block" === d &&
                                                    null != s)) &&
                                                "none" === ho.css(o, "float") &&
                                                (l ||
                                                    (m.done(function () {
                                                        f.display = s;
                                                    }),
                                                    null == s &&
                                                        ((d = f.display),
                                                        (s =
                                                            "none" === d
                                                                ? ""
                                                                : d))),
                                                (f.display = "inline-block"))),
                                        e.overflow &&
                                            ((f.overflow = "hidden"),
                                            m.always(function () {
                                                (f.overflow = e.overflow[0]),
                                                    (f.overflowX =
                                                        e.overflow[1]),
                                                    (f.overflowY =
                                                        e.overflow[2]);
                                            })),
                                        (l = !1),
                                        p))
                                            l ||
                                                (h
                                                    ? "hidden" in h &&
                                                      (w = h.hidden)
                                                    : (h = Do.access(
                                                          o,
                                                          "fxshow",
                                                          { display: s }
                                                      )),
                                                n && (h.hidden = !w),
                                                w && b([o], !0),
                                                m.done(function () {
                                                    for (r in (w || b([o]),
                                                    Do.remove(o, "fxshow"),
                                                    p))
                                                        ho.style(o, r, p[r]);
                                                })),
                                                (l = F(w ? h[r] : 0, r, m)),
                                                r in h ||
                                                    ((h[r] = l.start),
                                                    w &&
                                                        ((l.end = l.start),
                                                        (l.start = 0)));
                                },
                            ],
                            prefilter: function (o, t) {
                                t
                                    ? U.prefilters.unshift(o)
                                    : U.prefilters.push(o);
                            },
                        })),
                            (ho.speed = function (o, t, e) {
                                var r =
                                    o && "object" == typeof o
                                        ? ho.extend({}, o)
                                        : {
                                              complete:
                                                  e ||
                                                  (!e && t) ||
                                                  (mo(o) && o),
                                              duration: o,
                                              easing:
                                                  (e && t) ||
                                                  (t && !mo(t) && t),
                                          };
                                return (
                                    ho.fx.off
                                        ? (r.duration = 0)
                                        : "number" != typeof r.duration &&
                                          (r.duration in ho.fx.speeds
                                              ? (r.duration =
                                                    ho.fx.speeds[r.duration])
                                              : (r.duration =
                                                    ho.fx.speeds._default)),
                                    (null != r.queue && !0 !== r.queue) ||
                                        (r.queue = "fx"),
                                    (r.old = r.complete),
                                    (r.complete = function () {
                                        mo(r.old) && r.old.call(this),
                                            r.queue &&
                                                ho.dequeue(this, r.queue);
                                    }),
                                    r
                                );
                            }),
                            ho.fn.extend({
                                fadeTo: function (o, t, e, r) {
                                    return this.filter(Uo)
                                        .css("opacity", 0)
                                        .show()
                                        .end()
                                        .animate({ opacity: t }, o, e, r);
                                },
                                animate: function (o, t, e, r) {
                                    var i = ho.isEmptyObject(o),
                                        n = ho.speed(t, e, r),
                                        c = function () {
                                            var t = U(
                                                this,
                                                ho.extend({}, o),
                                                n
                                            );
                                            (i || Do.get(this, "finish")) &&
                                                t.stop(!0);
                                        };
                                    return (
                                        (c.finish = c),
                                        i || !1 === n.queue
                                            ? this.each(c)
                                            : this.queue(n.queue, c)
                                    );
                                },
                                stop: function (o, t, e) {
                                    var r = function (o) {
                                        var t = o.stop;
                                        delete o.stop, t(e);
                                    };
                                    return (
                                        "string" != typeof o &&
                                            ((e = t), (t = o), (o = void 0)),
                                        t &&
                                            !1 !== o &&
                                            this.queue(o || "fx", []),
                                        this.each(function () {
                                            var t = !0,
                                                i =
                                                    null != o &&
                                                    o + "queueHooks",
                                                n = ho.timers,
                                                c = Do.get(this);
                                            if (i) c[i] && c[i].stop && r(c[i]);
                                            else
                                                for (i in c)
                                                    c[i] &&
                                                        c[i].stop &&
                                                        xt.test(i) &&
                                                        r(c[i]);
                                            for (i = n.length; i--; )
                                                n[i].elem !== this ||
                                                    (null != o &&
                                                        n[i].queue !== o) ||
                                                    (n[i].anim.stop(e),
                                                    (t = !1),
                                                    n.splice(i, 1));
                                            (!t && e) || ho.dequeue(this, o);
                                        })
                                    );
                                },
                                finish: function (o) {
                                    return (
                                        !1 !== o && (o = o || "fx"),
                                        this.each(function () {
                                            var t,
                                                e = Do.get(this),
                                                r = e[o + "queue"],
                                                i = e[o + "queueHooks"],
                                                n = ho.timers,
                                                c = r ? r.length : 0;
                                            for (
                                                e.finish = !0,
                                                    ho.queue(this, o, []),
                                                    i &&
                                                        i.stop &&
                                                        i.stop.call(this, !0),
                                                    t = n.length;
                                                t--;

                                            )
                                                n[t].elem === this &&
                                                    n[t].queue === o &&
                                                    (n[t].anim.stop(!0),
                                                    n.splice(t, 1));
                                            for (t = 0; t < c; t++)
                                                r[t] &&
                                                    r[t].finish &&
                                                    r[t].finish.call(this);
                                            delete e.finish;
                                        })
                                    );
                                },
                            }),
                            ho.each(
                                ["toggle", "show", "hide"],
                                function (o, t) {
                                    var e = ho.fn[t];
                                    ho.fn[t] = function (o, r, i) {
                                        return null == o ||
                                            "boolean" == typeof o
                                            ? e.apply(this, arguments)
                                            : this.animate(W(t, !0), o, r, i);
                                    };
                                }
                            ),
                            ho.each(
                                {
                                    slideDown: W("show"),
                                    slideUp: W("hide"),
                                    slideToggle: W("toggle"),
                                    fadeIn: { opacity: "show" },
                                    fadeOut: { opacity: "hide" },
                                    fadeToggle: { opacity: "toggle" },
                                },
                                function (o, t) {
                                    ho.fn[o] = function (o, e, r) {
                                        return this.animate(t, o, e, r);
                                    };
                                }
                            ),
                            (ho.timers = []),
                            (ho.fx.tick = function () {
                                var o,
                                    t = 0,
                                    e = ho.timers;
                                for (gt = Date.now(); t < e.length; t++)
                                    (o = e[t])() ||
                                        e[t] !== o ||
                                        e.splice(t--, 1);
                                e.length || ho.fx.stop(), (gt = void 0);
                            }),
                            (ho.fx.timer = function (o) {
                                ho.timers.push(o), ho.fx.start();
                            }),
                            (ho.fx.interval = 13),
                            (ho.fx.start = function () {
                                bt || ((bt = !0), R());
                            }),
                            (ho.fx.stop = function () {
                                bt = null;
                            }),
                            (ho.fx.speeds = {
                                slow: 600,
                                fast: 200,
                                _default: 400,
                            }),
                            (ho.fn.delay = function (t, e) {
                                return (
                                    (t = (ho.fx && ho.fx.speeds[t]) || t),
                                    (e = e || "fx"),
                                    this.queue(e, function (e, r) {
                                        var i = o.setTimeout(e, t);
                                        r.stop = function () {
                                            o.clearTimeout(i);
                                        };
                                    })
                                );
                            }),
                            (vt = Z.createElement("input")),
                            (yt = Z.createElement("select").appendChild(
                                Z.createElement("option")
                            )),
                            (vt.type = "checkbox"),
                            (uo.checkOn = "" !== vt.value),
                            (uo.optSelected = yt.selected),
                            ((vt = Z.createElement("input")).value = "t"),
                            (vt.type = "radio"),
                            (uo.radioValue = "t" === vt.value);
                        var kt,
                            zt = ho.expr.attrHandle;
                        ho.fn.extend({
                            attr: function (o, t) {
                                return jo(
                                    this,
                                    ho.attr,
                                    o,
                                    t,
                                    1 < arguments.length
                                );
                            },
                            removeAttr: function (o) {
                                return this.each(function () {
                                    ho.removeAttr(this, o);
                                });
                            },
                        }),
                            ho.extend({
                                attr: function (o, t, e) {
                                    var r,
                                        i,
                                        n = o.nodeType;
                                    if (3 !== n && 8 !== n && 2 !== n)
                                        return void 0 === o.getAttribute
                                            ? ho.prop(o, t, e)
                                            : ((1 === n && ho.isXMLDoc(o)) ||
                                                  (i =
                                                      ho.attrHooks[
                                                          t.toLowerCase()
                                                      ] ||
                                                      (ho.expr.match.bool.test(
                                                          t
                                                      )
                                                          ? kt
                                                          : void 0)),
                                              void 0 !== e
                                                  ? null === e
                                                      ? void ho.removeAttr(o, t)
                                                      : i &&
                                                        "set" in i &&
                                                        void 0 !==
                                                            (r = i.set(o, e, t))
                                                      ? r
                                                      : (o.setAttribute(
                                                            t,
                                                            e + ""
                                                        ),
                                                        e)
                                                  : i &&
                                                    "get" in i &&
                                                    null !== (r = i.get(o, t))
                                                  ? r
                                                  : null ==
                                                    (r = ho.find.attr(o, t))
                                                  ? void 0
                                                  : r);
                                },
                                attrHooks: {
                                    type: {
                                        set: function (o, t) {
                                            if (
                                                !uo.radioValue &&
                                                "radio" === t &&
                                                n(o, "input")
                                            ) {
                                                var e = o.value;
                                                return (
                                                    o.setAttribute("type", t),
                                                    e && (o.value = e),
                                                    t
                                                );
                                            }
                                        },
                                    },
                                },
                                removeAttr: function (o, t) {
                                    var e,
                                        r = 0,
                                        i = t && t.match(So);
                                    if (i && 1 === o.nodeType)
                                        for (; (e = i[r++]); )
                                            o.removeAttribute(e);
                                },
                            }),
                            (kt = {
                                set: function (o, t, e) {
                                    return (
                                        !1 === t
                                            ? ho.removeAttr(o, e)
                                            : o.setAttribute(e, e),
                                        e
                                    );
                                },
                            }),
                            ho.each(
                                ho.expr.match.bool.source.match(/\w+/g),
                                function (o, t) {
                                    var e = zt[t] || ho.find.attr;
                                    zt[t] = function (o, t, r) {
                                        var i,
                                            n,
                                            c = t.toLowerCase();
                                        return (
                                            r ||
                                                ((n = zt[c]),
                                                (zt[c] = i),
                                                (i =
                                                    null != e(o, t, r)
                                                        ? c
                                                        : null),
                                                (zt[c] = n)),
                                            i
                                        );
                                    };
                                }
                            );
                        var Ct = /^(?:input|select|textarea|button)$/i,
                            Tt = /^(?:a|area)$/i;
                        ho.fn.extend({
                            prop: function (o, t) {
                                return jo(
                                    this,
                                    ho.prop,
                                    o,
                                    t,
                                    1 < arguments.length
                                );
                            },
                            removeProp: function (o) {
                                return this.each(function () {
                                    delete this[ho.propFix[o] || o];
                                });
                            },
                        }),
                            ho.extend({
                                prop: function (o, t, e) {
                                    var r,
                                        i,
                                        n = o.nodeType;
                                    if (3 !== n && 8 !== n && 2 !== n)
                                        return (
                                            (1 === n && ho.isXMLDoc(o)) ||
                                                ((t = ho.propFix[t] || t),
                                                (i = ho.propHooks[t])),
                                            void 0 !== e
                                                ? i &&
                                                  "set" in i &&
                                                  void 0 !==
                                                      (r = i.set(o, e, t))
                                                    ? r
                                                    : (o[t] = e)
                                                : i &&
                                                  "get" in i &&
                                                  null !== (r = i.get(o, t))
                                                ? r
                                                : o[t]
                                        );
                                },
                                propHooks: {
                                    tabIndex: {
                                        get: function (o) {
                                            var t = ho.find.attr(o, "tabindex");
                                            return t
                                                ? parseInt(t, 10)
                                                : Ct.test(o.nodeName) ||
                                                  (Tt.test(o.nodeName) &&
                                                      o.href)
                                                ? 0
                                                : -1;
                                        },
                                    },
                                },
                                propFix: { for: "htmlFor", class: "className" },
                            }),
                            uo.optSelected ||
                                (ho.propHooks.selected = {
                                    get: function (o) {
                                        var t = o.parentNode;
                                        return (
                                            t &&
                                                t.parentNode &&
                                                t.parentNode.selectedIndex,
                                            null
                                        );
                                    },
                                    set: function (o) {
                                        var t = o.parentNode;
                                        t &&
                                            (t.selectedIndex,
                                            t.parentNode &&
                                                t.parentNode.selectedIndex);
                                    },
                                }),
                            ho.each(
                                [
                                    "tabIndex",
                                    "readOnly",
                                    "maxLength",
                                    "cellSpacing",
                                    "cellPadding",
                                    "rowSpan",
                                    "colSpan",
                                    "useMap",
                                    "frameBorder",
                                    "contentEditable",
                                ],
                                function () {
                                    ho.propFix[this.toLowerCase()] = this;
                                }
                            ),
                            ho.fn.extend({
                                addClass: function (o) {
                                    var t,
                                        e,
                                        r,
                                        i,
                                        n,
                                        c,
                                        a,
                                        l = 0;
                                    if (mo(o))
                                        return this.each(function (t) {
                                            ho(this).addClass(
                                                o.call(this, t, X(this))
                                            );
                                        });
                                    if ((t = Y(o)).length)
                                        for (; (e = this[l++]); )
                                            if (
                                                ((i = X(e)),
                                                (r =
                                                    1 === e.nodeType &&
                                                    " " + $(i) + " "))
                                            ) {
                                                for (c = 0; (n = t[c++]); )
                                                    r.indexOf(" " + n + " ") <
                                                        0 && (r += n + " ");
                                                i !== (a = $(r)) &&
                                                    e.setAttribute("class", a);
                                            }
                                    return this;
                                },
                                removeClass: function (o) {
                                    var t,
                                        e,
                                        r,
                                        i,
                                        n,
                                        c,
                                        a,
                                        l = 0;
                                    if (mo(o))
                                        return this.each(function (t) {
                                            ho(this).removeClass(
                                                o.call(this, t, X(this))
                                            );
                                        });
                                    if (!arguments.length)
                                        return this.attr("class", "");
                                    if ((t = Y(o)).length)
                                        for (; (e = this[l++]); )
                                            if (
                                                ((i = X(e)),
                                                (r =
                                                    1 === e.nodeType &&
                                                    " " + $(i) + " "))
                                            ) {
                                                for (c = 0; (n = t[c++]); )
                                                    for (
                                                        ;
                                                        -1 <
                                                        r.indexOf(
                                                            " " + n + " "
                                                        );

                                                    )
                                                        r = r.replace(
                                                            " " + n + " ",
                                                            " "
                                                        );
                                                i !== (a = $(r)) &&
                                                    e.setAttribute("class", a);
                                            }
                                    return this;
                                },
                                toggleClass: function (o, t) {
                                    var e = typeof o,
                                        r = "string" === e || Array.isArray(o);
                                    return "boolean" == typeof t && r
                                        ? t
                                            ? this.addClass(o)
                                            : this.removeClass(o)
                                        : mo(o)
                                        ? this.each(function (e) {
                                              ho(this).toggleClass(
                                                  o.call(this, e, X(this), t),
                                                  t
                                              );
                                          })
                                        : this.each(function () {
                                              var t, i, n, c;
                                              if (r)
                                                  for (
                                                      i = 0,
                                                          n = ho(this),
                                                          c = Y(o);
                                                      (t = c[i++]);

                                                  )
                                                      n.hasClass(t)
                                                          ? n.removeClass(t)
                                                          : n.addClass(t);
                                              else
                                                  (void 0 !== o &&
                                                      "boolean" !== e) ||
                                                      ((t = X(this)) &&
                                                          Do.set(
                                                              this,
                                                              "__className__",
                                                              t
                                                          ),
                                                      this.setAttribute &&
                                                          this.setAttribute(
                                                              "class",
                                                              t || !1 === o
                                                                  ? ""
                                                                  : Do.get(
                                                                        this,
                                                                        "__className__"
                                                                    ) || ""
                                                          ));
                                          });
                                },
                                hasClass: function (o) {
                                    var t,
                                        e,
                                        r = 0;
                                    for (t = " " + o + " "; (e = this[r++]); )
                                        if (
                                            1 === e.nodeType &&
                                            -1 <
                                                (" " + $(X(e)) + " ").indexOf(t)
                                        )
                                            return !0;
                                    return !1;
                                },
                            });
                        var St = /\r/g;
                        ho.fn.extend({
                            val: function (o) {
                                var t,
                                    e,
                                    r,
                                    i = this[0];
                                return arguments.length
                                    ? ((r = mo(o)),
                                      this.each(function (e) {
                                          var i;
                                          1 === this.nodeType &&
                                              (null ==
                                              (i = r
                                                  ? o.call(
                                                        this,
                                                        e,
                                                        ho(this).val()
                                                    )
                                                  : o)
                                                  ? (i = "")
                                                  : "number" == typeof i
                                                  ? (i += "")
                                                  : Array.isArray(i) &&
                                                    (i = ho.map(
                                                        i,
                                                        function (o) {
                                                            return null == o
                                                                ? ""
                                                                : o + "";
                                                        }
                                                    )),
                                              ((t =
                                                  ho.valHooks[this.type] ||
                                                  ho.valHooks[
                                                      this.nodeName.toLowerCase()
                                                  ]) &&
                                                  "set" in t &&
                                                  void 0 !==
                                                      t.set(
                                                          this,
                                                          i,
                                                          "value"
                                                      )) ||
                                                  (this.value = i));
                                      }))
                                    : i
                                    ? (t =
                                          ho.valHooks[i.type] ||
                                          ho.valHooks[
                                              i.nodeName.toLowerCase()
                                          ]) &&
                                      "get" in t &&
                                      void 0 !== (e = t.get(i, "value"))
                                        ? e
                                        : "string" == typeof (e = i.value)
                                        ? e.replace(St, "")
                                        : null == e
                                        ? ""
                                        : e
                                    : void 0;
                            },
                        }),
                            ho.extend({
                                valHooks: {
                                    option: {
                                        get: function (o) {
                                            var t = ho.find.attr(o, "value");
                                            return null != t
                                                ? t
                                                : $(ho.text(o));
                                        },
                                    },
                                    select: {
                                        get: function (o) {
                                            var t,
                                                e,
                                                r,
                                                i = o.options,
                                                c = o.selectedIndex,
                                                a = "select-one" === o.type,
                                                l = a ? null : [],
                                                s = a ? c + 1 : i.length;
                                            for (
                                                r = c < 0 ? s : a ? c : 0;
                                                r < s;
                                                r++
                                            )
                                                if (
                                                    ((e = i[r]).selected ||
                                                        r === c) &&
                                                    !e.disabled &&
                                                    (!e.parentNode.disabled ||
                                                        !n(
                                                            e.parentNode,
                                                            "optgroup"
                                                        ))
                                                ) {
                                                    if (((t = ho(e).val()), a))
                                                        return t;
                                                    l.push(t);
                                                }
                                            return l;
                                        },
                                        set: function (o, t) {
                                            for (
                                                var e,
                                                    r,
                                                    i = o.options,
                                                    n = ho.makeArray(t),
                                                    c = i.length;
                                                c--;

                                            )
                                                ((r = i[c]).selected =
                                                    -1 <
                                                    ho.inArray(
                                                        ho.valHooks.option.get(
                                                            r
                                                        ),
                                                        n
                                                    )) && (e = !0);
                                            return (
                                                e || (o.selectedIndex = -1), n
                                            );
                                        },
                                    },
                                },
                            }),
                            ho.each(["radio", "checkbox"], function () {
                                (ho.valHooks[this] = {
                                    set: function (o, t) {
                                        if (Array.isArray(t))
                                            return (o.checked =
                                                -1 <
                                                ho.inArray(ho(o).val(), t));
                                    },
                                }),
                                    uo.checkOn ||
                                        (ho.valHooks[this].get = function (o) {
                                            return null ===
                                                o.getAttribute("value")
                                                ? "on"
                                                : o.value;
                                        });
                            }),
                            (uo.focusin = "onfocusin" in o);
                        var Et = /^(?:focusinfocus|focusoutblur)$/,
                            At = function (o) {
                                o.stopPropagation();
                            };
                        ho.extend(ho.event, {
                            trigger: function (t, e, r, i) {
                                var n,
                                    c,
                                    a,
                                    l,
                                    s,
                                    d,
                                    u,
                                    m,
                                    p = [r || Z],
                                    f = ao.call(t, "type") ? t.type : t,
                                    w = ao.call(t, "namespace")
                                        ? t.namespace.split(".")
                                        : [];
                                if (
                                    ((c = m = a = r = r || Z),
                                    3 !== r.nodeType &&
                                        8 !== r.nodeType &&
                                        !Et.test(f + ho.event.triggered) &&
                                        (-1 < f.indexOf(".") &&
                                            ((f = (w = f.split(".")).shift()),
                                            w.sort()),
                                        (s = f.indexOf(":") < 0 && "on" + f),
                                        ((t = t[ho.expando]
                                            ? t
                                            : new ho.Event(
                                                  f,
                                                  "object" == typeof t && t
                                              )).isTrigger = i ? 2 : 3),
                                        (t.namespace = w.join(".")),
                                        (t.rnamespace = t.namespace
                                            ? new RegExp(
                                                  "(^|\\.)" +
                                                      w.join("\\.(?:.*\\.|)") +
                                                      "(\\.|$)"
                                              )
                                            : null),
                                        (t.result = void 0),
                                        t.target || (t.target = r),
                                        (e =
                                            null == e
                                                ? [t]
                                                : ho.makeArray(e, [t])),
                                        (u = ho.event.special[f] || {}),
                                        i ||
                                            !u.trigger ||
                                            !1 !== u.trigger.apply(r, e)))
                                ) {
                                    if (!i && !u.noBubble && !po(r)) {
                                        for (
                                            l = u.delegateType || f,
                                                Et.test(l + f) ||
                                                    (c = c.parentNode);
                                            c;
                                            c = c.parentNode
                                        )
                                            p.push(c), (a = c);
                                        a === (r.ownerDocument || Z) &&
                                            p.push(
                                                a.defaultView ||
                                                    a.parentWindow ||
                                                    o
                                            );
                                    }
                                    for (
                                        n = 0;
                                        (c = p[n++]) &&
                                        !t.isPropagationStopped();

                                    )
                                        (m = c),
                                            (t.type =
                                                1 < n ? l : u.bindType || f),
                                            (d =
                                                (Do.get(c, "events") || {})[
                                                    t.type
                                                ] && Do.get(c, "handle")) &&
                                                d.apply(c, e),
                                            (d = s && c[s]) &&
                                                d.apply &&
                                                No(c) &&
                                                ((t.result = d.apply(c, e)),
                                                !1 === t.result &&
                                                    t.preventDefault());
                                    return (
                                        (t.type = f),
                                        i ||
                                            t.isDefaultPrevented() ||
                                            (u._default &&
                                                !1 !==
                                                    u._default.apply(
                                                        p.pop(),
                                                        e
                                                    )) ||
                                            !No(r) ||
                                            (s &&
                                                mo(r[f]) &&
                                                !po(r) &&
                                                ((a = r[s]) && (r[s] = null),
                                                (ho.event.triggered = f),
                                                t.isPropagationStopped() &&
                                                    m.addEventListener(f, At),
                                                r[f](),
                                                t.isPropagationStopped() &&
                                                    m.removeEventListener(
                                                        f,
                                                        At
                                                    ),
                                                (ho.event.triggered = void 0),
                                                a && (r[s] = a))),
                                        t.result
                                    );
                                }
                            },
                            simulate: function (o, t, e) {
                                var r = ho.extend(new ho.Event(), e, {
                                    type: o,
                                    isSimulated: !0,
                                });
                                ho.event.trigger(r, null, t);
                            },
                        }),
                            ho.fn.extend({
                                trigger: function (o, t) {
                                    return this.each(function () {
                                        ho.event.trigger(o, t, this);
                                    });
                                },
                                triggerHandler: function (o, t) {
                                    var e = this[0];
                                    if (e) return ho.event.trigger(o, t, e, !0);
                                },
                            }),
                            uo.focusin ||
                                ho.each(
                                    { focus: "focusin", blur: "focusout" },
                                    function (o, t) {
                                        var e = function (o) {
                                            ho.event.simulate(
                                                t,
                                                o.target,
                                                ho.event.fix(o)
                                            );
                                        };
                                        ho.event.special[t] = {
                                            setup: function () {
                                                var r =
                                                        this.ownerDocument ||
                                                        this,
                                                    i = Do.access(r, t);
                                                i ||
                                                    r.addEventListener(
                                                        o,
                                                        e,
                                                        !0
                                                    ),
                                                    Do.access(
                                                        r,
                                                        t,
                                                        (i || 0) + 1
                                                    );
                                            },
                                            teardown: function () {
                                                var r =
                                                        this.ownerDocument ||
                                                        this,
                                                    i = Do.access(r, t) - 1;
                                                i
                                                    ? Do.access(r, t, i)
                                                    : (r.removeEventListener(
                                                          o,
                                                          e,
                                                          !0
                                                      ),
                                                      Do.remove(r, t));
                                            },
                                        };
                                    }
                                );
                        var jt = o.location,
                            qt = Date.now(),
                            Lt = /\?/;
                        ho.parseXML = function (t) {
                            var e;
                            if (!t || "string" != typeof t) return null;
                            try {
                                e = new o.DOMParser().parseFromString(
                                    t,
                                    "text/xml"
                                );
                            } catch (t) {
                                e = void 0;
                            }
                            return (
                                (e &&
                                    !e.getElementsByTagName("parsererror")
                                        .length) ||
                                    ho.error("Invalid XML: " + t),
                                e
                            );
                        };
                        var Nt = /\[\]$/,
                            Dt = /\r?\n/g,
                            Ot = /^(?:submit|button|image|reset|file)$/i,
                            Mt = /^(?:input|select|textarea|keygen)/i;
                        (ho.param = function (o, t) {
                            var e,
                                r = [],
                                i = function (o, t) {
                                    var e = mo(t) ? t() : t;
                                    r[r.length] =
                                        encodeURIComponent(o) +
                                        "=" +
                                        encodeURIComponent(null == e ? "" : e);
                                };
                            if (null == o) return "";
                            if (
                                Array.isArray(o) ||
                                (o.jquery && !ho.isPlainObject(o))
                            )
                                ho.each(o, function () {
                                    i(this.name, this.value);
                                });
                            else for (e in o) V(e, o[e], t, i);
                            return r.join("&");
                        }),
                            ho.fn.extend({
                                serialize: function () {
                                    return ho.param(this.serializeArray());
                                },
                                serializeArray: function () {
                                    return this.map(function () {
                                        var o = ho.prop(this, "elements");
                                        return o ? ho.makeArray(o) : this;
                                    })
                                        .filter(function () {
                                            var o = this.type;
                                            return (
                                                this.name &&
                                                !ho(this).is(":disabled") &&
                                                Mt.test(this.nodeName) &&
                                                !Ot.test(o) &&
                                                (this.checked || !Yo.test(o))
                                            );
                                        })
                                        .map(function (o, t) {
                                            var e = ho(this).val();
                                            return null == e
                                                ? null
                                                : Array.isArray(e)
                                                ? ho.map(e, function (o) {
                                                      return {
                                                          name: t.name,
                                                          value: o.replace(
                                                              Dt,
                                                              "\r\n"
                                                          ),
                                                      };
                                                  })
                                                : {
                                                      name: t.name,
                                                      value: e.replace(
                                                          Dt,
                                                          "\r\n"
                                                      ),
                                                  };
                                        })
                                        .get();
                                },
                            });
                        var Pt = /%20/g,
                            Bt = /#.*$/,
                            It = /([?&])_=[^&]*/,
                            Rt = /^(.*?):[ \t]*([^\r\n]*)$/gm,
                            Ht = /^(?:GET|HEAD)$/,
                            Wt = /^\/\//,
                            Ft = {},
                            Ut = {},
                            $t = "*/".concat("*"),
                            Xt = Z.createElement("a");
                        (Xt.href = jt.href),
                            ho.extend({
                                active: 0,
                                lastModified: {},
                                etag: {},
                                ajaxSettings: {
                                    url: jt.href,
                                    type: "GET",
                                    isLocal:
                                        /^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(
                                            jt.protocol
                                        ),
                                    global: !0,
                                    processData: !0,
                                    async: !0,
                                    contentType:
                                        "application/x-www-form-urlencoded; charset=UTF-8",
                                    accepts: {
                                        "*": $t,
                                        text: "text/plain",
                                        html: "text/html",
                                        xml: "application/xml, text/xml",
                                        json: "application/json, text/javascript",
                                    },
                                    contents: {
                                        xml: /\bxml\b/,
                                        html: /\bhtml/,
                                        json: /\bjson\b/,
                                    },
                                    responseFields: {
                                        xml: "responseXML",
                                        text: "responseText",
                                        json: "responseJSON",
                                    },
                                    converters: {
                                        "* text": String,
                                        "text html": !0,
                                        "text json": JSON.parse,
                                        "text xml": ho.parseXML,
                                    },
                                    flatOptions: { url: !0, context: !0 },
                                },
                                ajaxSetup: function (o, t) {
                                    return t
                                        ? K(K(o, ho.ajaxSettings), t)
                                        : K(ho.ajaxSettings, o);
                                },
                                ajaxPrefilter: G(Ft),
                                ajaxTransport: G(Ut),
                                ajax: function (t, e) {
                                    function r(t, e, r, a) {
                                        var s,
                                            m,
                                            p,
                                            y,
                                            _,
                                            x = e;
                                        d ||
                                            ((d = !0),
                                            l && o.clearTimeout(l),
                                            (i = void 0),
                                            (c = a || ""),
                                            (k.readyState = 0 < t ? 4 : 0),
                                            (s =
                                                (200 <= t && t < 300) ||
                                                304 === t),
                                            r &&
                                                (y = (function (o, t, e) {
                                                    for (
                                                        var r,
                                                            i,
                                                            n,
                                                            c,
                                                            a = o.contents,
                                                            l = o.dataTypes;
                                                        "*" === l[0];

                                                    )
                                                        l.shift(),
                                                            void 0 === r &&
                                                                (r =
                                                                    o.mimeType ||
                                                                    t.getResponseHeader(
                                                                        "Content-Type"
                                                                    ));
                                                    if (r)
                                                        for (i in a)
                                                            if (
                                                                a[i] &&
                                                                a[i].test(r)
                                                            ) {
                                                                l.unshift(i);
                                                                break;
                                                            }
                                                    if (l[0] in e) n = l[0];
                                                    else {
                                                        for (i in e) {
                                                            if (
                                                                !l[0] ||
                                                                o.converters[
                                                                    i +
                                                                        " " +
                                                                        l[0]
                                                                ]
                                                            ) {
                                                                n = i;
                                                                break;
                                                            }
                                                            c || (c = i);
                                                        }
                                                        n = n || c;
                                                    }
                                                    if (n)
                                                        return (
                                                            n !== l[0] &&
                                                                l.unshift(n),
                                                            e[n]
                                                        );
                                                })(f, k, r)),
                                            (y = (function (o, t, e, r) {
                                                var i,
                                                    n,
                                                    c,
                                                    a,
                                                    l,
                                                    s = {},
                                                    d = o.dataTypes.slice();
                                                if (d[1])
                                                    for (c in o.converters)
                                                        s[c.toLowerCase()] =
                                                            o.converters[c];
                                                for (n = d.shift(); n; )
                                                    if (
                                                        (o.responseFields[n] &&
                                                            (e[
                                                                o.responseFields[
                                                                    n
                                                                ]
                                                            ] = t),
                                                        !l &&
                                                            r &&
                                                            o.dataFilter &&
                                                            (t = o.dataFilter(
                                                                t,
                                                                o.dataType
                                                            )),
                                                        (l = n),
                                                        (n = d.shift()))
                                                    )
                                                        if ("*" === n) n = l;
                                                        else if (
                                                            "*" !== l &&
                                                            l !== n
                                                        ) {
                                                            if (
                                                                !(c =
                                                                    s[
                                                                        l +
                                                                            " " +
                                                                            n
                                                                    ] ||
                                                                    s["* " + n])
                                                            )
                                                                for (i in s)
                                                                    if (
                                                                        (a =
                                                                            i.split(
                                                                                " "
                                                                            ))[1] ===
                                                                            n &&
                                                                        (c =
                                                                            s[
                                                                                l +
                                                                                    " " +
                                                                                    a[0]
                                                                            ] ||
                                                                            s[
                                                                                "* " +
                                                                                    a[0]
                                                                            ])
                                                                    ) {
                                                                        !0 === c
                                                                            ? (c =
                                                                                  s[
                                                                                      i
                                                                                  ])
                                                                            : !0 !==
                                                                                  s[
                                                                                      i
                                                                                  ] &&
                                                                              ((n =
                                                                                  a[0]),
                                                                              d.unshift(
                                                                                  a[1]
                                                                              ));
                                                                        break;
                                                                    }
                                                            if (!0 !== c)
                                                                if (
                                                                    c &&
                                                                    o.throws
                                                                )
                                                                    t = c(t);
                                                                else
                                                                    try {
                                                                        t =
                                                                            c(
                                                                                t
                                                                            );
                                                                    } catch (o) {
                                                                        return {
                                                                            state: "parsererror",
                                                                            error: c
                                                                                ? o
                                                                                : "No conversion from " +
                                                                                  l +
                                                                                  " to " +
                                                                                  n,
                                                                        };
                                                                    }
                                                        }
                                                return {
                                                    state: "success",
                                                    data: t,
                                                };
                                            })(f, y, k, s)),
                                            s
                                                ? (f.ifModified &&
                                                      ((_ =
                                                          k.getResponseHeader(
                                                              "Last-Modified"
                                                          )) &&
                                                          (ho.lastModified[n] =
                                                              _),
                                                      (_ =
                                                          k.getResponseHeader(
                                                              "etag"
                                                          )) &&
                                                          (ho.etag[n] = _)),
                                                  204 === t || "HEAD" === f.type
                                                      ? (x = "nocontent")
                                                      : 304 === t
                                                      ? (x = "notmodified")
                                                      : ((x = y.state),
                                                        (m = y.data),
                                                        (s = !(p = y.error))))
                                                : ((p = x),
                                                  (!t && x) ||
                                                      ((x = "error"),
                                                      t < 0 && (t = 0))),
                                            (k.status = t),
                                            (k.statusText = (e || x) + ""),
                                            s
                                                ? g.resolveWith(w, [m, x, k])
                                                : g.rejectWith(w, [k, x, p]),
                                            k.statusCode(v),
                                            (v = void 0),
                                            u &&
                                                h.trigger(
                                                    s
                                                        ? "ajaxSuccess"
                                                        : "ajaxError",
                                                    [k, f, s ? m : p]
                                                ),
                                            b.fireWith(w, [k, x]),
                                            u &&
                                                (h.trigger("ajaxComplete", [
                                                    k,
                                                    f,
                                                ]),
                                                --ho.active ||
                                                    ho.event.trigger(
                                                        "ajaxStop"
                                                    )));
                                    }
                                    "object" == typeof t &&
                                        ((e = t), (t = void 0)),
                                        (e = e || {});
                                    var i,
                                        n,
                                        c,
                                        a,
                                        l,
                                        s,
                                        d,
                                        u,
                                        m,
                                        p,
                                        f = ho.ajaxSetup({}, e),
                                        w = f.context || f,
                                        h =
                                            f.context &&
                                            (w.nodeType || w.jquery)
                                                ? ho(w)
                                                : ho.event,
                                        g = ho.Deferred(),
                                        b = ho.Callbacks("once memory"),
                                        v = f.statusCode || {},
                                        y = {},
                                        _ = {},
                                        x = "canceled",
                                        k = {
                                            readyState: 0,
                                            getResponseHeader: function (o) {
                                                var t;
                                                if (d) {
                                                    if (!a)
                                                        for (
                                                            a = {};
                                                            (t = Rt.exec(c));

                                                        )
                                                            a[
                                                                t[1].toLowerCase() +
                                                                    " "
                                                            ] = (
                                                                a[
                                                                    t[1].toLowerCase() +
                                                                        " "
                                                                ] || []
                                                            ).concat(t[2]);
                                                    t =
                                                        a[
                                                            o.toLowerCase() +
                                                                " "
                                                        ];
                                                }
                                                return null == t
                                                    ? null
                                                    : t.join(", ");
                                            },
                                            getAllResponseHeaders: function () {
                                                return d ? c : null;
                                            },
                                            setRequestHeader: function (o, t) {
                                                return (
                                                    null == d &&
                                                        ((o = _[
                                                            o.toLowerCase()
                                                        ] =
                                                            _[
                                                                o.toLowerCase()
                                                            ] || o),
                                                        (y[o] = t)),
                                                    this
                                                );
                                            },
                                            overrideMimeType: function (o) {
                                                return (
                                                    null == d &&
                                                        (f.mimeType = o),
                                                    this
                                                );
                                            },
                                            statusCode: function (o) {
                                                var t;
                                                if (o)
                                                    if (d)
                                                        k.always(o[k.status]);
                                                    else
                                                        for (t in o)
                                                            v[t] = [v[t], o[t]];
                                                return this;
                                            },
                                            abort: function (o) {
                                                var t = o || x;
                                                return (
                                                    i && i.abort(t),
                                                    r(0, t),
                                                    this
                                                );
                                            },
                                        };
                                    if (
                                        (g.promise(k),
                                        (f.url = (
                                            (t || f.url || jt.href) + ""
                                        ).replace(Wt, jt.protocol + "//")),
                                        (f.type =
                                            e.method ||
                                            e.type ||
                                            f.method ||
                                            f.type),
                                        (f.dataTypes = (f.dataType || "*")
                                            .toLowerCase()
                                            .match(So) || [""]),
                                        null == f.crossDomain)
                                    ) {
                                        s = Z.createElement("a");
                                        try {
                                            (s.href = f.url),
                                                (s.href = s.href),
                                                (f.crossDomain =
                                                    Xt.protocol +
                                                        "//" +
                                                        Xt.host !=
                                                    s.protocol + "//" + s.host);
                                        } catch (t) {
                                            f.crossDomain = !0;
                                        }
                                    }
                                    if (
                                        (f.data &&
                                            f.processData &&
                                            "string" != typeof f.data &&
                                            (f.data = ho.param(
                                                f.data,
                                                f.traditional
                                            )),
                                        J(Ft, f, e, k),
                                        d)
                                    )
                                        return k;
                                    for (m in ((u = ho.event && f.global) &&
                                        0 == ho.active++ &&
                                        ho.event.trigger("ajaxStart"),
                                    (f.type = f.type.toUpperCase()),
                                    (f.hasContent = !Ht.test(f.type)),
                                    (n = f.url.replace(Bt, "")),
                                    f.hasContent
                                        ? f.data &&
                                          f.processData &&
                                          0 ===
                                              (f.contentType || "").indexOf(
                                                  "application/x-www-form-urlencoded"
                                              ) &&
                                          (f.data = f.data.replace(Pt, "+"))
                                        : ((p = f.url.slice(n.length)),
                                          f.data &&
                                              (f.processData ||
                                                  "string" == typeof f.data) &&
                                              ((n +=
                                                  (Lt.test(n) ? "&" : "?") +
                                                  f.data),
                                              delete f.data),
                                          !1 === f.cache &&
                                              ((n = n.replace(It, "$1")),
                                              (p =
                                                  (Lt.test(n) ? "&" : "?") +
                                                  "_=" +
                                                  qt++ +
                                                  p)),
                                          (f.url = n + p)),
                                    f.ifModified &&
                                        (ho.lastModified[n] &&
                                            k.setRequestHeader(
                                                "If-Modified-Since",
                                                ho.lastModified[n]
                                            ),
                                        ho.etag[n] &&
                                            k.setRequestHeader(
                                                "If-None-Match",
                                                ho.etag[n]
                                            )),
                                    ((f.data &&
                                        f.hasContent &&
                                        !1 !== f.contentType) ||
                                        e.contentType) &&
                                        k.setRequestHeader(
                                            "Content-Type",
                                            f.contentType
                                        ),
                                    k.setRequestHeader(
                                        "Accept",
                                        f.dataTypes[0] &&
                                            f.accepts[f.dataTypes[0]]
                                            ? f.accepts[f.dataTypes[0]] +
                                                  ("*" !== f.dataTypes[0]
                                                      ? ", " + $t + "; q=0.01"
                                                      : "")
                                            : f.accepts["*"]
                                    ),
                                    f.headers))
                                        k.setRequestHeader(m, f.headers[m]);
                                    if (
                                        f.beforeSend &&
                                        (!1 === f.beforeSend.call(w, k, f) || d)
                                    )
                                        return k.abort();
                                    if (
                                        ((x = "abort"),
                                        b.add(f.complete),
                                        k.done(f.success),
                                        k.fail(f.error),
                                        (i = J(Ut, f, e, k)))
                                    ) {
                                        if (
                                            ((k.readyState = 1),
                                            u && h.trigger("ajaxSend", [k, f]),
                                            d)
                                        )
                                            return k;
                                        f.async &&
                                            0 < f.timeout &&
                                            (l = o.setTimeout(function () {
                                                k.abort("timeout");
                                            }, f.timeout));
                                        try {
                                            (d = !1), i.send(y, r);
                                        } catch (t) {
                                            if (d) throw t;
                                            r(-1, t);
                                        }
                                    } else r(-1, "No Transport");
                                    return k;
                                },
                                getJSON: function (o, t, e) {
                                    return ho.get(o, t, e, "json");
                                },
                                getScript: function (o, t) {
                                    return ho.get(o, void 0, t, "script");
                                },
                            }),
                            ho.each(["get", "post"], function (o, t) {
                                ho[t] = function (o, e, r, i) {
                                    return (
                                        mo(e) &&
                                            ((i = i || r),
                                            (r = e),
                                            (e = void 0)),
                                        ho.ajax(
                                            ho.extend(
                                                {
                                                    url: o,
                                                    type: t,
                                                    dataType: i,
                                                    data: e,
                                                    success: r,
                                                },
                                                ho.isPlainObject(o) && o
                                            )
                                        )
                                    );
                                };
                            }),
                            (ho._evalUrl = function (o, t) {
                                return ho.ajax({
                                    url: o,
                                    type: "GET",
                                    dataType: "script",
                                    cache: !0,
                                    async: !1,
                                    global: !1,
                                    converters: {
                                        "text script": function () {},
                                    },
                                    dataFilter: function (o) {
                                        ho.globalEval(o, t);
                                    },
                                });
                            }),
                            ho.fn.extend({
                                wrapAll: function (o) {
                                    var t;
                                    return (
                                        this[0] &&
                                            (mo(o) && (o = o.call(this[0])),
                                            (t = ho(o, this[0].ownerDocument)
                                                .eq(0)
                                                .clone(!0)),
                                            this[0].parentNode &&
                                                t.insertBefore(this[0]),
                                            t
                                                .map(function () {
                                                    for (
                                                        var o = this;
                                                        o.firstElementChild;

                                                    )
                                                        o = o.firstElementChild;
                                                    return o;
                                                })
                                                .append(this)),
                                        this
                                    );
                                },
                                wrapInner: function (o) {
                                    return mo(o)
                                        ? this.each(function (t) {
                                              ho(this).wrapInner(
                                                  o.call(this, t)
                                              );
                                          })
                                        : this.each(function () {
                                              var t = ho(this),
                                                  e = t.contents();
                                              e.length
                                                  ? e.wrapAll(o)
                                                  : t.append(o);
                                          });
                                },
                                wrap: function (o) {
                                    var t = mo(o);
                                    return this.each(function (e) {
                                        ho(this).wrapAll(
                                            t ? o.call(this, e) : o
                                        );
                                    });
                                },
                                unwrap: function (o) {
                                    return (
                                        this.parent(o)
                                            .not("body")
                                            .each(function () {
                                                ho(this).replaceWith(
                                                    this.childNodes
                                                );
                                            }),
                                        this
                                    );
                                },
                            }),
                            (ho.expr.pseudos.hidden = function (o) {
                                return !ho.expr.pseudos.visible(o);
                            }),
                            (ho.expr.pseudos.visible = function (o) {
                                return !!(
                                    o.offsetWidth ||
                                    o.offsetHeight ||
                                    o.getClientRects().length
                                );
                            }),
                            (ho.ajaxSettings.xhr = function () {
                                try {
                                    return new o.XMLHttpRequest();
                                } catch (o) {}
                            });
                        var Yt = { 0: 200, 1223: 204 },
                            Vt = ho.ajaxSettings.xhr();
                        (uo.cors = !!Vt && "withCredentials" in Vt),
                            (uo.ajax = Vt = !!Vt),
                            ho.ajaxTransport(function (t) {
                                var e, r;
                                if (uo.cors || (Vt && !t.crossDomain))
                                    return {
                                        send: function (i, n) {
                                            var c,
                                                a = t.xhr();
                                            if (
                                                (a.open(
                                                    t.type,
                                                    t.url,
                                                    t.async,
                                                    t.username,
                                                    t.password
                                                ),
                                                t.xhrFields)
                                            )
                                                for (c in t.xhrFields)
                                                    a[c] = t.xhrFields[c];
                                            for (c in (t.mimeType &&
                                                a.overrideMimeType &&
                                                a.overrideMimeType(t.mimeType),
                                            t.crossDomain ||
                                                i["X-Requested-With"] ||
                                                (i["X-Requested-With"] =
                                                    "XMLHttpRequest"),
                                            i))
                                                a.setRequestHeader(c, i[c]);
                                            (e = function (o) {
                                                return function () {
                                                    e &&
                                                        ((e =
                                                            r =
                                                            a.onload =
                                                            a.onerror =
                                                            a.onabort =
                                                            a.ontimeout =
                                                            a.onreadystatechange =
                                                                null),
                                                        "abort" === o
                                                            ? a.abort()
                                                            : "error" === o
                                                            ? "number" !=
                                                              typeof a.status
                                                                ? n(0, "error")
                                                                : n(
                                                                      a.status,
                                                                      a.statusText
                                                                  )
                                                            : n(
                                                                  Yt[
                                                                      a.status
                                                                  ] || a.status,
                                                                  a.statusText,
                                                                  "text" !==
                                                                      (a.responseType ||
                                                                          "text") ||
                                                                      "string" !=
                                                                          typeof a.responseText
                                                                      ? {
                                                                            binary: a.response,
                                                                        }
                                                                      : {
                                                                            text: a.responseText,
                                                                        },
                                                                  a.getAllResponseHeaders()
                                                              ));
                                                };
                                            }),
                                                (a.onload = e()),
                                                (r =
                                                    a.onerror =
                                                    a.ontimeout =
                                                        e("error")),
                                                void 0 !== a.onabort
                                                    ? (a.onabort = r)
                                                    : (a.onreadystatechange =
                                                          function () {
                                                              4 ===
                                                                  a.readyState &&
                                                                  o.setTimeout(
                                                                      function () {
                                                                          e &&
                                                                              r();
                                                                      }
                                                                  );
                                                          }),
                                                (e = e("abort"));
                                            try {
                                                a.send(
                                                    (t.hasContent && t.data) ||
                                                        null
                                                );
                                            } catch (i) {
                                                if (e) throw i;
                                            }
                                        },
                                        abort: function () {
                                            e && e();
                                        },
                                    };
                            }),
                            ho.ajaxPrefilter(function (o) {
                                o.crossDomain && (o.contents.script = !1);
                            }),
                            ho.ajaxSetup({
                                accepts: {
                                    script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript",
                                },
                                contents: { script: /\b(?:java|ecma)script\b/ },
                                converters: {
                                    "text script": function (o) {
                                        return ho.globalEval(o), o;
                                    },
                                },
                            }),
                            ho.ajaxPrefilter("script", function (o) {
                                void 0 === o.cache && (o.cache = !1),
                                    o.crossDomain && (o.type = "GET");
                            }),
                            ho.ajaxTransport("script", function (o) {
                                var t, e;
                                if (o.crossDomain || o.scriptAttrs)
                                    return {
                                        send: function (r, i) {
                                            (t = ho("<script>")
                                                .attr(o.scriptAttrs || {})
                                                .prop({
                                                    charset: o.scriptCharset,
                                                    src: o.url,
                                                })
                                                .on(
                                                    "load error",
                                                    (e = function (o) {
                                                        t.remove(),
                                                            (e = null),
                                                            o &&
                                                                i(
                                                                    "error" ===
                                                                        o.type
                                                                        ? 404
                                                                        : 200,
                                                                    o.type
                                                                );
                                                    })
                                                )),
                                                Z.head.appendChild(t[0]);
                                        },
                                        abort: function () {
                                            e && e();
                                        },
                                    };
                            });
                        var Gt,
                            Jt = [],
                            Kt = /(=)\?(?=&|$)|\?\?/;
                        ho.ajaxSetup({
                            jsonp: "callback",
                            jsonpCallback: function () {
                                var o = Jt.pop() || ho.expando + "_" + qt++;
                                return (this[o] = !0), o;
                            },
                        }),
                            ho.ajaxPrefilter("json jsonp", function (t, e, r) {
                                var i,
                                    n,
                                    c,
                                    a =
                                        !1 !== t.jsonp &&
                                        (Kt.test(t.url)
                                            ? "url"
                                            : "string" == typeof t.data &&
                                              0 ===
                                                  (t.contentType || "").indexOf(
                                                      "application/x-www-form-urlencoded"
                                                  ) &&
                                              Kt.test(t.data) &&
                                              "data");
                                if (a || "jsonp" === t.dataTypes[0])
                                    return (
                                        (i = t.jsonpCallback =
                                            mo(t.jsonpCallback)
                                                ? t.jsonpCallback()
                                                : t.jsonpCallback),
                                        a
                                            ? (t[a] = t[a].replace(
                                                  Kt,
                                                  "$1" + i
                                              ))
                                            : !1 !== t.jsonp &&
                                              (t.url +=
                                                  (Lt.test(t.url) ? "&" : "?") +
                                                  t.jsonp +
                                                  "=" +
                                                  i),
                                        (t.converters["script json"] =
                                            function () {
                                                return (
                                                    c ||
                                                        ho.error(
                                                            i +
                                                                " was not called"
                                                        ),
                                                    c[0]
                                                );
                                            }),
                                        (t.dataTypes[0] = "json"),
                                        (n = o[i]),
                                        (o[i] = function () {
                                            c = arguments;
                                        }),
                                        r.always(function () {
                                            void 0 === n
                                                ? ho(o).removeProp(i)
                                                : (o[i] = n),
                                                t[i] &&
                                                    ((t.jsonpCallback =
                                                        e.jsonpCallback),
                                                    Jt.push(i)),
                                                c && mo(n) && n(c[0]),
                                                (c = n = void 0);
                                        }),
                                        "script"
                                    );
                            }),
                            (uo.createHTMLDocument =
                                (((Gt =
                                    Z.implementation.createHTMLDocument(
                                        ""
                                    ).body).innerHTML =
                                    "<form></form><form></form>"),
                                2 === Gt.childNodes.length)),
                            (ho.parseHTML = function (o, t, e) {
                                return "string" != typeof o
                                    ? []
                                    : ("boolean" == typeof t &&
                                          ((e = t), (t = !1)),
                                      t ||
                                          (uo.createHTMLDocument
                                              ? (((r = (t =
                                                    Z.implementation.createHTMLDocument(
                                                        ""
                                                    )).createElement(
                                                    "base"
                                                )).href = Z.location.href),
                                                t.head.appendChild(r))
                                              : (t = Z)),
                                      (n = !e && []),
                                      (i = xo.exec(o))
                                          ? [t.createElement(i[1])]
                                          : ((i = _([o], t, n)),
                                            n && n.length && ho(n).remove(),
                                            ho.merge([], i.childNodes)));
                                var r, i, n;
                            }),
                            (ho.fn.load = function (o, t, e) {
                                var r,
                                    i,
                                    n,
                                    c = this,
                                    a = o.indexOf(" ");
                                return (
                                    -1 < a &&
                                        ((r = $(o.slice(a))),
                                        (o = o.slice(0, a))),
                                    mo(t)
                                        ? ((e = t), (t = void 0))
                                        : t &&
                                          "object" == typeof t &&
                                          (i = "POST"),
                                    0 < c.length &&
                                        ho
                                            .ajax({
                                                url: o,
                                                type: i || "GET",
                                                dataType: "html",
                                                data: t,
                                            })
                                            .done(function (o) {
                                                (n = arguments),
                                                    c.html(
                                                        r
                                                            ? ho("<div>")
                                                                  .append(
                                                                      ho.parseHTML(
                                                                          o
                                                                      )
                                                                  )
                                                                  .find(r)
                                                            : o
                                                    );
                                            })
                                            .always(
                                                e &&
                                                    function (o, t) {
                                                        c.each(function () {
                                                            e.apply(
                                                                this,
                                                                n || [
                                                                    o.responseText,
                                                                    t,
                                                                    o,
                                                                ]
                                                            );
                                                        });
                                                    }
                                            ),
                                    this
                                );
                            }),
                            ho.each(
                                [
                                    "ajaxStart",
                                    "ajaxStop",
                                    "ajaxComplete",
                                    "ajaxError",
                                    "ajaxSuccess",
                                    "ajaxSend",
                                ],
                                function (o, t) {
                                    ho.fn[t] = function (o) {
                                        return this.on(t, o);
                                    };
                                }
                            ),
                            (ho.expr.pseudos.animated = function (o) {
                                return ho.grep(ho.timers, function (t) {
                                    return o === t.elem;
                                }).length;
                            }),
                            (ho.offset = {
                                setOffset: function (o, t, e) {
                                    var r,
                                        i,
                                        n,
                                        c,
                                        a,
                                        l,
                                        s = ho.css(o, "position"),
                                        d = ho(o),
                                        u = {};
                                    "static" === s &&
                                        (o.style.position = "relative"),
                                        (a = d.offset()),
                                        (n = ho.css(o, "top")),
                                        (l = ho.css(o, "left")),
                                        ("absolute" === s || "fixed" === s) &&
                                        -1 < (n + l).indexOf("auto")
                                            ? ((c = (r = d.position()).top),
                                              (i = r.left))
                                            : ((c = parseFloat(n) || 0),
                                              (i = parseFloat(l) || 0)),
                                        mo(t) &&
                                            (t = t.call(
                                                o,
                                                e,
                                                ho.extend({}, a)
                                            )),
                                        null != t.top &&
                                            (u.top = t.top - a.top + c),
                                        null != t.left &&
                                            (u.left = t.left - a.left + i),
                                        "using" in t
                                            ? t.using.call(o, u)
                                            : d.css(u);
                                },
                            }),
                            ho.fn.extend({
                                offset: function (o) {
                                    if (arguments.length)
                                        return void 0 === o
                                            ? this
                                            : this.each(function (t) {
                                                  ho.offset.setOffset(
                                                      this,
                                                      o,
                                                      t
                                                  );
                                              });
                                    var t,
                                        e,
                                        r = this[0];
                                    return r
                                        ? r.getClientRects().length
                                            ? ((t = r.getBoundingClientRect()),
                                              (e = r.ownerDocument.defaultView),
                                              {
                                                  top: t.top + e.pageYOffset,
                                                  left: t.left + e.pageXOffset,
                                              })
                                            : { top: 0, left: 0 }
                                        : void 0;
                                },
                                position: function () {
                                    if (this[0]) {
                                        var o,
                                            t,
                                            e,
                                            r = this[0],
                                            i = { top: 0, left: 0 };
                                        if ("fixed" === ho.css(r, "position"))
                                            t = r.getBoundingClientRect();
                                        else {
                                            for (
                                                t = this.offset(),
                                                    e = r.ownerDocument,
                                                    o =
                                                        r.offsetParent ||
                                                        e.documentElement;
                                                o &&
                                                (o === e.body ||
                                                    o === e.documentElement) &&
                                                "static" ===
                                                    ho.css(o, "position");

                                            )
                                                o = o.parentNode;
                                            o &&
                                                o !== r &&
                                                1 === o.nodeType &&
                                                (((i = ho(o).offset()).top +=
                                                    ho.css(
                                                        o,
                                                        "borderTopWidth",
                                                        !0
                                                    )),
                                                (i.left += ho.css(
                                                    o,
                                                    "borderLeftWidth",
                                                    !0
                                                )));
                                        }
                                        return {
                                            top:
                                                t.top -
                                                i.top -
                                                ho.css(r, "marginTop", !0),
                                            left:
                                                t.left -
                                                i.left -
                                                ho.css(r, "marginLeft", !0),
                                        };
                                    }
                                },
                                offsetParent: function () {
                                    return this.map(function () {
                                        for (
                                            var o = this.offsetParent;
                                            o &&
                                            "static" === ho.css(o, "position");

                                        )
                                            o = o.offsetParent;
                                        return o || Ho;
                                    });
                                },
                            }),
                            ho.each(
                                {
                                    scrollLeft: "pageXOffset",
                                    scrollTop: "pageYOffset",
                                },
                                function (o, t) {
                                    var e = "pageYOffset" === t;
                                    ho.fn[o] = function (r) {
                                        return jo(
                                            this,
                                            function (o, r, i) {
                                                var n;
                                                if (
                                                    (po(o)
                                                        ? (n = o)
                                                        : 9 === o.nodeType &&
                                                          (n = o.defaultView),
                                                    void 0 === i)
                                                )
                                                    return n ? n[t] : o[r];
                                                n
                                                    ? n.scrollTo(
                                                          e ? n.pageXOffset : i,
                                                          e ? i : n.pageYOffset
                                                      )
                                                    : (o[r] = i);
                                            },
                                            o,
                                            r,
                                            arguments.length
                                        );
                                    };
                                }
                            ),
                            ho.each(["top", "left"], function (o, t) {
                                ho.cssHooks[t] = D(
                                    uo.pixelPosition,
                                    function (o, e) {
                                        if (e)
                                            return (
                                                (e = N(o, t)),
                                                at.test(e)
                                                    ? ho(o).position()[t] + "px"
                                                    : e
                                            );
                                    }
                                );
                            }),
                            ho.each(
                                { Height: "height", Width: "width" },
                                function (o, t) {
                                    ho.each(
                                        {
                                            padding: "inner" + o,
                                            content: t,
                                            "": "outer" + o,
                                        },
                                        function (e, r) {
                                            ho.fn[r] = function (i, n) {
                                                var c =
                                                        arguments.length &&
                                                        (e ||
                                                            "boolean" !=
                                                                typeof i),
                                                    a =
                                                        e ||
                                                        (!0 === i || !0 === n
                                                            ? "margin"
                                                            : "border");
                                                return jo(
                                                    this,
                                                    function (t, e, i) {
                                                        var n;
                                                        return po(t)
                                                            ? 0 ===
                                                              r.indexOf("outer")
                                                                ? t["inner" + o]
                                                                : t.document
                                                                      .documentElement[
                                                                      "client" +
                                                                          o
                                                                  ]
                                                            : 9 === t.nodeType
                                                            ? ((n =
                                                                  t.documentElement),
                                                              Math.max(
                                                                  t.body[
                                                                      "scroll" +
                                                                          o
                                                                  ],
                                                                  n[
                                                                      "scroll" +
                                                                          o
                                                                  ],
                                                                  t.body[
                                                                      "offset" +
                                                                          o
                                                                  ],
                                                                  n[
                                                                      "offset" +
                                                                          o
                                                                  ],
                                                                  n[
                                                                      "client" +
                                                                          o
                                                                  ]
                                                              ))
                                                            : void 0 === i
                                                            ? ho.css(t, e, a)
                                                            : ho.style(
                                                                  t,
                                                                  e,
                                                                  i,
                                                                  a
                                                              );
                                                    },
                                                    t,
                                                    c ? i : void 0,
                                                    c
                                                );
                                            };
                                        }
                                    );
                                }
                            ),
                            ho.each(
                                "blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(
                                    " "
                                ),
                                function (o, t) {
                                    ho.fn[t] = function (o, e) {
                                        return 0 < arguments.length
                                            ? this.on(t, null, o, e)
                                            : this.trigger(t);
                                    };
                                }
                            ),
                            ho.fn.extend({
                                hover: function (o, t) {
                                    return this.mouseenter(o).mouseleave(
                                        t || o
                                    );
                                },
                            }),
                            ho.fn.extend({
                                bind: function (o, t, e) {
                                    return this.on(o, null, t, e);
                                },
                                unbind: function (o, t) {
                                    return this.off(o, null, t);
                                },
                                delegate: function (o, t, e, r) {
                                    return this.on(t, o, e, r);
                                },
                                undelegate: function (o, t, e) {
                                    return 1 === arguments.length
                                        ? this.off(o, "**")
                                        : this.off(t, o || "**", e);
                                },
                            }),
                            (ho.proxy = function (o, t) {
                                var e, r, i;
                                if (
                                    ("string" == typeof t &&
                                        ((e = o[t]), (t = o), (o = e)),
                                    mo(o))
                                )
                                    return (
                                        (r = to.call(arguments, 2)),
                                        ((i = function () {
                                            return o.apply(
                                                t || this,
                                                r.concat(to.call(arguments))
                                            );
                                        }).guid = o.guid =
                                            o.guid || ho.guid++),
                                        i
                                    );
                            }),
                            (ho.holdReady = function (o) {
                                o ? ho.readyWait++ : ho.ready(!0);
                            }),
                            (ho.isArray = Array.isArray),
                            (ho.parseJSON = JSON.parse),
                            (ho.nodeName = n),
                            (ho.isFunction = mo),
                            (ho.isWindow = po),
                            (ho.camelCase = f),
                            (ho.type = r),
                            (ho.now = Date.now),
                            (ho.isNumeric = function (o) {
                                var t = ho.type(o);
                                return (
                                    ("number" === t || "string" === t) &&
                                    !isNaN(o - parseFloat(o))
                                );
                            }),
                            "function" == typeof s &&
                                s.amd &&
                                s("jquery", [], function () {
                                    return ho;
                                });
                        var Qt = o.jQuery,
                            Zt = o.$;
                        return (
                            (ho.noConflict = function (t) {
                                return (
                                    o.$ === ho && (o.$ = Zt),
                                    t && o.jQuery === ho && (o.jQuery = Qt),
                                    ho
                                );
                            }),
                            t || (o.jQuery = o.$ = ho),
                            ho
                        );
                    }
                );
            var d = {
                cipher: {},
                hash: {},
                keyexchange: {},
                mode: {},
                misc: {},
                codec: {},
                exception: {
                    corrupt: function (o) {
                        (this.toString = function () {
                            return "CORRUPT: " + this.message;
                        }),
                            (this.message = o);
                    },
                    invalid: function (o) {
                        (this.toString = function () {
                            return "INVALID: " + this.message;
                        }),
                            (this.message = o);
                    },
                    bug: function (o) {
                        (this.toString = function () {
                            return "BUG: " + this.message;
                        }),
                            (this.message = o);
                    },
                    notReady: function (o) {
                        (this.toString = function () {
                            return "NOT READY: " + this.message;
                        }),
                            (this.message = o);
                    },
                },
            };
            "undefined" != typeof module &&
                module.exports &&
                (module.exports = d),
                "function" == typeof s &&
                    s("sjcl", [], function () {
                        return d;
                    }),
                (d.cipher.aes = function (o) {
                    this.s[0][0][0] || this.O();
                    var t,
                        e,
                        r,
                        i,
                        n = this.s[0][4],
                        c = this.s[1],
                        a = 1;
                    if (4 !== (t = o.length) && 6 !== t && 8 !== t)
                        throw new d.exception.invalid("invalid aes key size");
                    for (
                        this.b = [(r = o.slice(0)), (i = [])], o = t;
                        o < 4 * t + 28;
                        o++
                    )
                        (e = r[o - 1]),
                            (0 == o % t || (8 === t && 4 == o % t)) &&
                                ((e =
                                    (n[e >>> 24] << 24) ^
                                    (n[(e >> 16) & 255] << 16) ^
                                    (n[(e >> 8) & 255] << 8) ^
                                    n[255 & e]),
                                0 == o % t &&
                                    ((e = (e << 8) ^ (e >>> 24) ^ (a << 24)),
                                    (a = (a << 1) ^ (283 * (a >> 7))))),
                            (r[o] = r[o - t] ^ e);
                    for (t = 0; o; t++, o--)
                        (e = r[3 & t ? o : o - 4]),
                            (i[t] =
                                o <= 4 || t < 4
                                    ? e
                                    : c[0][n[e >>> 24]] ^
                                      c[1][n[(e >> 16) & 255]] ^
                                      c[2][n[(e >> 8) & 255]] ^
                                      c[3][n[255 & e]]);
                }),
                (d.cipher.aes.prototype = {
                    encrypt: function (t) {
                        return o(this, t, 0);
                    },
                    decrypt: function (t) {
                        return o(this, t, 1);
                    },
                    s: [
                        [[], [], [], [], []],
                        [[], [], [], [], []],
                    ],
                    O: function () {
                        var o,
                            t,
                            e,
                            r,
                            i,
                            n,
                            c,
                            a = this.s[0],
                            l = this.s[1],
                            s = a[4],
                            d = l[4],
                            u = [],
                            m = [];
                        for (o = 0; o < 256; o++)
                            m[(u[o] = (o << 1) ^ (283 * (o >> 7))) ^ o] = o;
                        for (t = e = 0; !s[t]; t ^= r || 1, e = m[e] || 1)
                            for (
                                n =
                                    ((n =
                                        e ^
                                        (e << 1) ^
                                        (e << 2) ^
                                        (e << 3) ^
                                        (e << 4)) >>
                                        8) ^
                                    (255 & n) ^
                                    99,
                                    c =
                                        (16843009 *
                                            (i =
                                                u[
                                                    (o =
                                                        u[
                                                            (r =
                                                                u[
                                                                    (d[
                                                                        (s[t] =
                                                                            n)
                                                                    ] = t)
                                                                ])
                                                        ])
                                                ])) ^
                                        (65537 * o) ^
                                        (257 * r) ^
                                        (16843008 * t),
                                    i = (257 * u[n]) ^ (16843008 * n),
                                    o = 0;
                                o < 4;
                                o++
                            )
                                (a[o][t] = i = (i << 24) ^ (i >>> 8)),
                                    (l[o][n] = c = (c << 24) ^ (c >>> 8));
                        for (o = 0; o < 5; o++)
                            (a[o] = a[o].slice(0)), (l[o] = l[o].slice(0));
                    },
                }),
                (d.bitArray = {
                    bitSlice: function (o, t, e) {
                        return (
                            (o = d.bitArray
                                .$(o.slice(t / 32), 32 - (31 & t))
                                .slice(1)),
                            void 0 === e ? o : d.bitArray.clamp(o, e - t)
                        );
                    },
                    extract: function (o, t, e) {
                        var r = Math.floor((-t - e) & 31);
                        return (
                            (-32 & ((t + e - 1) ^ t)
                                ? (o[(t / 32) | 0] << (32 - r)) ^
                                  (o[(t / 32 + 1) | 0] >>> r)
                                : o[(t / 32) | 0] >>> r) &
                            ((1 << e) - 1)
                        );
                    },
                    concat: function (o, t) {
                        if (0 === o.length || 0 === t.length)
                            return o.concat(t);
                        var e = o[o.length - 1],
                            r = d.bitArray.getPartial(e);
                        return 32 === r
                            ? o.concat(t)
                            : d.bitArray.$(
                                  t,
                                  r,
                                  0 | e,
                                  o.slice(0, o.length - 1)
                              );
                    },
                    bitLength: function (o) {
                        var t = o.length;
                        return 0 === t
                            ? 0
                            : 32 * (t - 1) + d.bitArray.getPartial(o[t - 1]);
                    },
                    clamp: function (o, t) {
                        if (32 * o.length < t) return o;
                        var e = (o = o.slice(0, Math.ceil(t / 32))).length;
                        return (
                            (t &= 31),
                            0 < e &&
                                t &&
                                (o[e - 1] = d.bitArray.partial(
                                    t,
                                    o[e - 1] & (2147483648 >> (t - 1)),
                                    1
                                )),
                            o
                        );
                    },
                    partial: function (o, t, e) {
                        return 32 === o
                            ? t
                            : (e ? 0 | t : t << (32 - o)) + 1099511627776 * o;
                    },
                    getPartial: function (o) {
                        return Math.round(o / 1099511627776) || 32;
                    },
                    equal: function (o, t) {
                        if (d.bitArray.bitLength(o) !== d.bitArray.bitLength(t))
                            return !1;
                        var e,
                            r = 0;
                        for (e = 0; e < o.length; e++) r |= o[e] ^ t[e];
                        return 0 === r;
                    },
                    $: function (o, t, e, r) {
                        var i;
                        for (void (i = 0) === r && (r = []); 32 <= t; t -= 32)
                            r.push(e), (e = 0);
                        if (0 === t) return r.concat(o);
                        for (i = 0; i < o.length; i++)
                            r.push(e | (o[i] >>> t)), (e = o[i] << (32 - t));
                        return (
                            (i = o.length ? o[o.length - 1] : 0),
                            (o = d.bitArray.getPartial(i)),
                            r.push(
                                d.bitArray.partial(
                                    (t + o) & 31,
                                    32 < t + o ? e : r.pop(),
                                    1
                                )
                            ),
                            r
                        );
                    },
                    i: function (o, t) {
                        return [
                            o[0] ^ t[0],
                            o[1] ^ t[1],
                            o[2] ^ t[2],
                            o[3] ^ t[3],
                        ];
                    },
                    byteswapM: function (o) {
                        var t, e;
                        for (t = 0; t < o.length; ++t)
                            (e = o[t]),
                                (o[t] =
                                    (e >>> 24) |
                                    ((e >>> 8) & 65280) |
                                    ((65280 & e) << 8) |
                                    (e << 24));
                        return o;
                    },
                }),
                (d.codec.utf8String = {
                    fromBits: function (o) {
                        var t,
                            e,
                            r = "",
                            i = d.bitArray.bitLength(o);
                        for (t = 0; t < i / 8; t++)
                            0 == (3 & t) && (e = o[t / 4]),
                                (r += String.fromCharCode(e >>> 24)),
                                (e <<= 8);
                        return decodeURIComponent(escape(r));
                    },
                    toBits: function (o) {
                        o = unescape(encodeURIComponent(o));
                        var t,
                            e = [],
                            r = 0;
                        for (t = 0; t < o.length; t++)
                            (r = (r << 8) | o.charCodeAt(t)),
                                3 == (3 & t) && (e.push(r), (r = 0));
                        return (
                            3 & t && e.push(d.bitArray.partial(8 * (3 & t), r)),
                            e
                        );
                    },
                }),
                (d.codec.hex = {
                    fromBits: function (o) {
                        var t,
                            e = "";
                        for (t = 0; t < o.length; t++)
                            e += (0xf00000000000 + (0 | o[t]))
                                .toString(16)
                                .substr(4);
                        return e.substr(0, d.bitArray.bitLength(o) / 4);
                    },
                    toBits: function (o) {
                        var t,
                            e,
                            r = [];
                        for (
                            e = (o = o.replace(/\s|0x/g, "")).length,
                                o += "00000000",
                                t = 0;
                            t < o.length;
                            t += 8
                        )
                            r.push(0 ^ parseInt(o.substr(t, 8), 16));
                        return d.bitArray.clamp(r, 4 * e);
                    },
                }),
                (d.codec.base32 = {
                    B: "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567",
                    X: "0123456789ABCDEFGHIJKLMNOPQRSTUV",
                    BITS: 32,
                    BASE: 5,
                    REMAINING: 27,
                    fromBits: function (o, t, e) {
                        var r = d.codec.base32.BASE,
                            i = d.codec.base32.REMAINING,
                            n = "",
                            c = 0,
                            a = d.codec.base32.B,
                            l = 0,
                            s = d.bitArray.bitLength(o);
                        for (
                            e && (a = d.codec.base32.X), e = 0;
                            n.length * r < s;

                        )
                            (n += a.charAt((l ^ (o[e] >>> c)) >>> i)),
                                c < r
                                    ? ((l = o[e] << (r - c)), (c += i), e++)
                                    : ((l <<= r), (c -= r));
                        for (; 7 & n.length && !t; ) n += "=";
                        return n;
                    },
                    toBits: function (o, t) {
                        o = o.replace(/\s|=/g, "").toUpperCase();
                        var e,
                            r,
                            i = d.codec.base32.BITS,
                            n = d.codec.base32.BASE,
                            c = d.codec.base32.REMAINING,
                            a = [],
                            l = 0,
                            s = d.codec.base32.B,
                            u = 0,
                            m = "base32";
                        for (
                            t && ((s = d.codec.base32.X), (m = "base32hex")),
                                e = 0;
                            e < o.length;
                            e++
                        ) {
                            if ((r = s.indexOf(o.charAt(e))) < 0) {
                                if (!t)
                                    try {
                                        return d.codec.base32hex.toBits(o);
                                    } catch (o) {}
                                throw new d.exception.invalid(
                                    "this isn't " + m + "!"
                                );
                            }
                            c < l
                                ? ((l -= c),
                                  a.push(u ^ (r >>> l)),
                                  (u = r << (i - l)))
                                : (u ^= r << (i - (l += n)));
                        }
                        return (
                            56 & l && a.push(d.bitArray.partial(56 & l, u, 1)),
                            a
                        );
                    },
                }),
                (d.codec.base32hex = {
                    fromBits: function (o, t) {
                        return d.codec.base32.fromBits(o, t, 1);
                    },
                    toBits: function (o) {
                        return d.codec.base32.toBits(o, 1);
                    },
                }),
                (d.codec.base64 = {
                    B: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",
                    fromBits: function (o, t, e) {
                        var r = "",
                            i = 0,
                            n = d.codec.base64.B,
                            c = 0,
                            a = d.bitArray.bitLength(o);
                        for (
                            e && (n = n.substr(0, 62) + "-_"), e = 0;
                            6 * r.length < a;

                        )
                            (r += n.charAt((c ^ (o[e] >>> i)) >>> 26)),
                                i < 6
                                    ? ((c = o[e] << (6 - i)), (i += 26), e++)
                                    : ((c <<= 6), (i -= 6));
                        for (; 3 & r.length && !t; ) r += "=";
                        return r;
                    },
                    toBits: function (o, t) {
                        o = o.replace(/\s|=/g, "");
                        var e,
                            r,
                            i = [],
                            n = 0,
                            c = d.codec.base64.B,
                            a = 0;
                        for (
                            t && (c = c.substr(0, 62) + "-_"), e = 0;
                            e < o.length;
                            e++
                        ) {
                            if ((r = c.indexOf(o.charAt(e))) < 0)
                                throw new d.exception.invalid(
                                    "this isn't base64!"
                                );
                            26 < n
                                ? ((n -= 26),
                                  i.push(a ^ (r >>> n)),
                                  (a = r << (32 - n)))
                                : (a ^= r << (32 - (n += 6)));
                        }
                        return (
                            56 & n && i.push(d.bitArray.partial(56 & n, a, 1)),
                            i
                        );
                    },
                }),
                (d.codec.base64url = {
                    fromBits: function (o) {
                        return d.codec.base64.fromBits(o, 1, 1);
                    },
                    toBits: function (o) {
                        return d.codec.base64.toBits(o, 1);
                    },
                }),
                (d.hash.sha256 = function (o) {
                    this.b[0] || this.O(),
                        o
                            ? ((this.F = o.F.slice(0)),
                              (this.A = o.A.slice(0)),
                              (this.l = o.l))
                            : this.reset();
                }),
                (d.hash.sha256.hash = function (o) {
                    return new d.hash.sha256().update(o).finalize();
                }),
                (d.hash.sha256.prototype = {
                    blockSize: 512,
                    reset: function () {
                        return (
                            (this.F = this.Y.slice(0)),
                            (this.A = []),
                            (this.l = 0),
                            this
                        );
                    },
                    update: function (o) {
                        "string" == typeof o &&
                            (o = d.codec.utf8String.toBits(o));
                        var e,
                            r = (this.A = d.bitArray.concat(this.A, o));
                        for (
                            e = this.l,
                                o = this.l = e + d.bitArray.bitLength(o),
                                e = (512 + e) & -512;
                            e <= o;
                            e += 512
                        )
                            t(this, r.splice(0, 16));
                        return this;
                    },
                    finalize: function () {
                        var o,
                            e = this.A,
                            r = this.F;
                        for (
                            o =
                                (e = d.bitArray.concat(e, [
                                    d.bitArray.partial(1, 1),
                                ])).length + 2;
                            15 & o;
                            o++
                        )
                            e.push(0);
                        for (
                            e.push(Math.floor(this.l / 4294967296)),
                                e.push(0 | this.l);
                            e.length;

                        )
                            t(this, e.splice(0, 16));
                        return this.reset(), r;
                    },
                    Y: [],
                    b: [],
                    O: function () {
                        function o(o) {
                            return (4294967296 * (o - Math.floor(o))) | 0;
                        }
                        var t,
                            e = 0,
                            r = 2;
                        o: for (; e < 64; r++) {
                            for (t = 2; t * t <= r; t++)
                                if (0 == r % t) continue o;
                            e < 8 && (this.Y[e] = o(Math.pow(r, 0.5))),
                                (this.b[e] = o(Math.pow(r, 1 / 3))),
                                e++;
                        }
                    },
                }),
                (d.mode.ccm = {
                    name: "ccm",
                    G: [],
                    listenProgress: function (o) {
                        d.mode.ccm.G.push(o);
                    },
                    unListenProgress: function (o) {
                        -1 < (o = d.mode.ccm.G.indexOf(o)) &&
                            d.mode.ccm.G.splice(o, 1);
                    },
                    fa: function (o) {
                        var t,
                            e = d.mode.ccm.G.slice();
                        for (t = 0; t < e.length; t += 1) e[t](o);
                    },
                    encrypt: function (o, t, e, r, i) {
                        var n,
                            c = t.slice(0),
                            a = d.bitArray,
                            l = a.bitLength(e) / 8,
                            s = a.bitLength(c) / 8;
                        if (((i = i || 64), (r = r || []), l < 7))
                            throw new d.exception.invalid(
                                "ccm: iv must be at least 7 bytes"
                            );
                        for (n = 2; n < 4 && s >>> (8 * n); n++);
                        return (
                            n < 15 - l && (n = 15 - l),
                            (e = a.clamp(e, 8 * (15 - n))),
                            (t = d.mode.ccm.V(o, t, e, r, i, n)),
                            (c = d.mode.ccm.C(o, c, e, t, i, n)),
                            a.concat(c.data, c.tag)
                        );
                    },
                    decrypt: function (o, t, e, r, i) {
                        (i = i || 64), (r = r || []);
                        var n = d.bitArray,
                            c = n.bitLength(e) / 8,
                            a = n.bitLength(t),
                            l = n.clamp(t, a - i),
                            s = n.bitSlice(t, a - i);
                        if (((a = (a - i) / 8), c < 7))
                            throw new d.exception.invalid(
                                "ccm: iv must be at least 7 bytes"
                            );
                        for (t = 2; t < 4 && a >>> (8 * t); t++);
                        if (
                            (t < 15 - c && (t = 15 - c),
                            (e = n.clamp(e, 8 * (15 - t))),
                            (l = d.mode.ccm.C(o, l, e, s, i, t)),
                            (o = d.mode.ccm.V(o, l.data, e, r, i, t)),
                            !n.equal(l.tag, o))
                        )
                            throw new d.exception.corrupt(
                                "ccm: tag doesn't match"
                            );
                        return l.data;
                    },
                    na: function (o, t, e, r, i, n) {
                        var c = [],
                            a = d.bitArray,
                            l = a.i;
                        if (
                            ((r = [
                                a.partial(
                                    8,
                                    (t.length ? 64 : 0) |
                                        ((r - 2) << 2) |
                                        (n - 1)
                                ),
                            ]),
                            ((r = a.concat(r, e))[3] |= i),
                            (r = o.encrypt(r)),
                            t.length)
                        )
                            for (
                                (e = a.bitLength(t) / 8) <= 65279
                                    ? (c = [a.partial(16, e)])
                                    : e <= 4294967295 &&
                                      (c = a.concat(
                                          [a.partial(16, 65534)],
                                          [e]
                                      )),
                                    c = a.concat(c, t),
                                    t = 0;
                                t < c.length;
                                t += 4
                            )
                                r = o.encrypt(
                                    l(r, c.slice(t, t + 4).concat([0, 0, 0]))
                                );
                        return r;
                    },
                    V: function (o, t, e, r, i, n) {
                        var c = d.bitArray,
                            a = c.i;
                        if ((i /= 8) % 2 || i < 4 || 16 < i)
                            throw new d.exception.invalid(
                                "ccm: invalid tag length"
                            );
                        if (4294967295 < r.length || 4294967295 < t.length)
                            throw new d.exception.bug(
                                "ccm: can't deal with 4GiB or more data"
                            );
                        for (
                            e = d.mode.ccm.na(
                                o,
                                r,
                                e,
                                i,
                                c.bitLength(t) / 8,
                                n
                            ),
                                r = 0;
                            r < t.length;
                            r += 4
                        )
                            e = o.encrypt(
                                a(e, t.slice(r, r + 4).concat([0, 0, 0]))
                            );
                        return c.clamp(e, 8 * i);
                    },
                    C: function (o, t, e, r, i, n) {
                        var c,
                            a = d.bitArray;
                        c = a.i;
                        var l = t.length,
                            s = a.bitLength(t),
                            u = l / 50,
                            m = u;
                        if (
                            ((e = a
                                .concat([a.partial(8, n - 1)], e)
                                .concat([0, 0, 0])
                                .slice(0, 4)),
                            (r = a.bitSlice(c(r, o.encrypt(e)), 0, i)),
                            !l)
                        )
                            return { tag: r, data: [] };
                        for (c = 0; c < l; c += 4)
                            u < c && (d.mode.ccm.fa(c / l), (u += m)),
                                e[3]++,
                                (i = o.encrypt(e)),
                                (t[c] ^= i[0]),
                                (t[c + 1] ^= i[1]),
                                (t[c + 2] ^= i[2]),
                                (t[c + 3] ^= i[3]);
                        return { tag: r, data: a.clamp(t, s) };
                    },
                }),
                (d.mode.ocb2 = {
                    name: "ocb2",
                    encrypt: function (o, t, e, r, i, n) {
                        if (128 !== d.bitArray.bitLength(e))
                            throw new d.exception.invalid(
                                "ocb iv must be 128 bits"
                            );
                        var c,
                            a = d.mode.ocb2.S,
                            l = d.bitArray,
                            s = l.i,
                            u = [0, 0, 0, 0];
                        e = a(o.encrypt(e));
                        var m,
                            p = [];
                        for (
                            r = r || [], i = i || 64, c = 0;
                            c + 4 < t.length;
                            c += 4
                        )
                            (u = s(u, (m = t.slice(c, c + 4)))),
                                (p = p.concat(s(e, o.encrypt(s(e, m))))),
                                (e = a(e));
                        return (
                            (m = t.slice(c)),
                            (t = l.bitLength(m)),
                            (c = o.encrypt(s(e, [0, 0, 0, t]))),
                            (u = s(
                                u,
                                s(
                                    (m = l.clamp(
                                        s(m.concat([0, 0, 0]), c),
                                        t
                                    )).concat([0, 0, 0]),
                                    c
                                )
                            )),
                            (u = o.encrypt(s(u, s(e, a(e))))),
                            r.length &&
                                (u = s(u, n ? r : d.mode.ocb2.pmac(o, r))),
                            p.concat(l.concat(m, l.clamp(u, i)))
                        );
                    },
                    decrypt: function (o, t, e, r, i, n) {
                        if (128 !== d.bitArray.bitLength(e))
                            throw new d.exception.invalid(
                                "ocb iv must be 128 bits"
                            );
                        i = i || 64;
                        var c,
                            a,
                            l = d.mode.ocb2.S,
                            s = d.bitArray,
                            u = s.i,
                            m = [0, 0, 0, 0],
                            p = l(o.encrypt(e)),
                            f = d.bitArray.bitLength(t) - i,
                            w = [];
                        for (r = r || [], e = 0; e + 4 < f / 32; e += 4)
                            (m = u(
                                m,
                                (c = u(p, o.decrypt(u(p, t.slice(e, e + 4)))))
                            )),
                                (w = w.concat(c)),
                                (p = l(p));
                        if (
                            ((a = f - 32 * e),
                            (m = u(
                                m,
                                (c = u(
                                    (c = o.encrypt(u(p, [0, 0, 0, a]))),
                                    s.clamp(t.slice(e), a).concat([0, 0, 0])
                                ))
                            )),
                            (m = o.encrypt(u(m, u(p, l(p))))),
                            r.length &&
                                (m = u(m, n ? r : d.mode.ocb2.pmac(o, r))),
                            !s.equal(s.clamp(m, i), s.bitSlice(t, f)))
                        )
                            throw new d.exception.corrupt(
                                "ocb: tag doesn't match"
                            );
                        return w.concat(s.clamp(c, a));
                    },
                    pmac: function (o, t) {
                        var e,
                            r = d.mode.ocb2.S,
                            i = d.bitArray,
                            n = i.i,
                            c = [0, 0, 0, 0],
                            a = n((a = o.encrypt([0, 0, 0, 0])), r(r(a)));
                        for (e = 0; e + 4 < t.length; e += 4)
                            (a = r(a)),
                                (c = n(c, o.encrypt(n(a, t.slice(e, e + 4)))));
                        return (
                            (e = t.slice(e)),
                            i.bitLength(e) < 128 &&
                                ((a = n(a, r(a))),
                                (e = i.concat(e, [-2147483648, 0, 0, 0]))),
                            (c = n(c, e)),
                            o.encrypt(n(r(n(a, r(a))), c))
                        );
                    },
                    S: function (o) {
                        return [
                            (o[0] << 1) ^ (o[1] >>> 31),
                            (o[1] << 1) ^ (o[2] >>> 31),
                            (o[2] << 1) ^ (o[3] >>> 31),
                            (o[3] << 1) ^ (135 * (o[0] >>> 31)),
                        ];
                    },
                }),
                (d.mode.gcm = {
                    name: "gcm",
                    encrypt: function (o, t, e, r, i) {
                        var n = t.slice(0);
                        return (
                            (t = d.bitArray),
                            (r = r || []),
                            (o = d.mode.gcm.C(!0, o, n, r, e, i || 128)),
                            t.concat(o.data, o.tag)
                        );
                    },
                    decrypt: function (o, t, e, r, i) {
                        var n = t.slice(0),
                            c = d.bitArray,
                            a = c.bitLength(n);
                        if (
                            ((r = r || []),
                            (n =
                                (i = i || 128) <= a
                                    ? ((t = c.bitSlice(n, a - i)),
                                      c.bitSlice(n, 0, a - i))
                                    : ((t = n), [])),
                            (o = d.mode.gcm.C(!1, o, n, r, e, i)),
                            !c.equal(o.tag, t))
                        )
                            throw new d.exception.corrupt(
                                "gcm: tag doesn't match"
                            );
                        return o.data;
                    },
                    ka: function (o, t) {
                        var e,
                            r,
                            i,
                            n,
                            c,
                            a = d.bitArray.i;
                        for (
                            i = [0, 0, 0, 0], n = t.slice(0), e = 0;
                            e < 128;
                            e++
                        ) {
                            for (
                                (r =
                                    0 !=
                                    (o[Math.floor(e / 32)] &
                                        (1 << (31 - (e % 32))))) &&
                                    (i = a(i, n)),
                                    c = 0 != (1 & n[3]),
                                    r = 3;
                                0 < r;
                                r--
                            )
                                n[r] = (n[r] >>> 1) | ((1 & n[r - 1]) << 31);
                            (n[0] >>>= 1), c && (n[0] ^= -520093696);
                        }
                        return i;
                    },
                    j: function (o, t, e) {
                        var r,
                            i = e.length;
                        for (t = t.slice(0), r = 0; r < i; r += 4)
                            (t[0] ^= 4294967295 & e[r]),
                                (t[1] ^= 4294967295 & e[r + 1]),
                                (t[2] ^= 4294967295 & e[r + 2]),
                                (t[3] ^= 4294967295 & e[r + 3]),
                                (t = d.mode.gcm.ka(t, o));
                        return t;
                    },
                    C: function (o, t, e, r, i, n) {
                        var c,
                            a,
                            l,
                            s,
                            u,
                            m,
                            p,
                            f,
                            w = d.bitArray;
                        for (
                            m = e.length,
                                p = w.bitLength(e),
                                f = w.bitLength(r),
                                a = w.bitLength(i),
                                c = t.encrypt([0, 0, 0, 0]),
                                i =
                                    96 === a
                                        ? ((i = i.slice(0)), w.concat(i, [1]))
                                        : ((i = d.mode.gcm.j(
                                              c,
                                              [0, 0, 0, 0],
                                              i
                                          )),
                                          d.mode.gcm.j(c, i, [
                                              0,
                                              0,
                                              Math.floor(a / 4294967296),
                                              4294967295 & a,
                                          ])),
                                a = d.mode.gcm.j(c, [0, 0, 0, 0], r),
                                u = i.slice(0),
                                r = a.slice(0),
                                o || (r = d.mode.gcm.j(c, a, e)),
                                s = 0;
                            s < m;
                            s += 4
                        )
                            u[3]++,
                                (l = t.encrypt(u)),
                                (e[s] ^= l[0]),
                                (e[s + 1] ^= l[1]),
                                (e[s + 2] ^= l[2]),
                                (e[s + 3] ^= l[3]);
                        return (
                            (e = w.clamp(e, p)),
                            o && (r = d.mode.gcm.j(c, a, e)),
                            (o = [
                                Math.floor(f / 4294967296),
                                4294967295 & f,
                                Math.floor(p / 4294967296),
                                4294967295 & p,
                            ]),
                            (r = d.mode.gcm.j(c, r, o)),
                            (l = t.encrypt(i)),
                            (r[0] ^= l[0]),
                            (r[1] ^= l[1]),
                            (r[2] ^= l[2]),
                            (r[3] ^= l[3]),
                            { tag: w.bitSlice(r, 0, n), data: e }
                        );
                    },
                }),
                (d.misc.hmac = function (o, t) {
                    this.W = t = t || d.hash.sha256;
                    var e,
                        r = [[], []],
                        i = t.prototype.blockSize / 32;
                    for (
                        this.w = [new t(), new t()],
                            o.length > i && (o = t.hash(o)),
                            e = 0;
                        e < i;
                        e++
                    )
                        (r[0][e] = 909522486 ^ o[e]),
                            (r[1][e] = 1549556828 ^ o[e]);
                    this.w[0].update(r[0]),
                        this.w[1].update(r[1]),
                        (this.R = new t(this.w[0]));
                }),
                (d.misc.hmac.prototype.encrypt = d.misc.hmac.prototype.mac =
                    function (o) {
                        if (this.aa)
                            throw new d.exception.invalid(
                                "encrypt on already updated hmac called!"
                            );
                        return this.update(o), this.digest(o);
                    }),
                (d.misc.hmac.prototype.reset = function () {
                    (this.R = new this.W(this.w[0])), (this.aa = !1);
                }),
                (d.misc.hmac.prototype.update = function (o) {
                    (this.aa = !0), this.R.update(o);
                }),
                (d.misc.hmac.prototype.digest = function () {
                    var o = this.R.finalize();
                    return (
                        (o = new this.W(this.w[1]).update(o).finalize()),
                        this.reset(),
                        o
                    );
                }),
                (d.misc.pbkdf2 = function (o, t, e, r, i) {
                    if (((e = e || 1e3), r < 0 || e < 0))
                        throw d.exception.invalid("invalid params to pbkdf2");
                    "string" == typeof o && (o = d.codec.utf8String.toBits(o)),
                        "string" == typeof t &&
                            (t = d.codec.utf8String.toBits(t)),
                        (o = new (i = i || d.misc.hmac)(o));
                    var n,
                        c,
                        a,
                        l,
                        s = [],
                        u = d.bitArray;
                    for (l = 1; 32 * s.length < (r || 1); l++) {
                        for (
                            i = n = o.encrypt(u.concat(t, [l])), c = 1;
                            c < e;
                            c++
                        )
                            for (n = o.encrypt(n), a = 0; a < n.length; a++)
                                i[a] ^= n[a];
                        s = s.concat(i);
                    }
                    return r && (s = u.clamp(s, r)), s;
                }),
                (d.prng = function (o) {
                    (this.c = [new d.hash.sha256()]),
                        (this.m = [0]),
                        (this.P = 0),
                        (this.H = {}),
                        (this.N = 0),
                        (this.U = {}),
                        (this.Z = this.f = this.o = this.ha = 0),
                        (this.b = [0, 0, 0, 0, 0, 0, 0, 0]),
                        (this.h = [0, 0, 0, 0]),
                        (this.L = void 0),
                        (this.M = o),
                        (this.D = !1),
                        (this.K = { progress: {}, seeded: {} }),
                        (this.u = this.ga = 0),
                        (this.I = 1),
                        (this.J = 2),
                        (this.ca = 65536),
                        (this.T = [
                            0, 48, 64, 96, 128, 192, 256, 384, 512, 768, 1024,
                        ]),
                        (this.da = 3e4),
                        (this.ba = 80);
                }),
                (d.prng.prototype = {
                    randomWords: function (o, t) {
                        var e,
                            r,
                            c = [];
                        if ((e = this.isReady(t)) === this.u)
                            throw new d.exception.notReady(
                                "generator isn't seeded"
                            );
                        if (e & this.J) {
                            (e = !(e & this.I)), (r = []);
                            var a,
                                l = 0;
                            for (
                                this.Z = r[0] = new Date().valueOf() + this.da,
                                    a = 0;
                                a < 16;
                                a++
                            )
                                r.push((4294967296 * Math.random()) | 0);
                            for (
                                a = 0;
                                a < this.c.length &&
                                ((r = r.concat(this.c[a].finalize())),
                                (l += this.m[a]),
                                (this.m[a] = 0),
                                e || !(this.P & (1 << a)));
                                a++
                            );
                            for (
                                this.P >= 1 << this.c.length &&
                                    (this.c.push(new d.hash.sha256()),
                                    this.m.push(0)),
                                    this.f -= l,
                                    l > this.o && (this.o = l),
                                    this.P++,
                                    this.b = d.hash.sha256.hash(
                                        this.b.concat(r)
                                    ),
                                    this.L = new d.cipher.aes(this.b),
                                    e = 0;
                                e < 4 &&
                                ((this.h[e] = (this.h[e] + 1) | 0), !this.h[e]);
                                e++
                            );
                        }
                        for (e = 0; e < o; e += 4)
                            0 == (e + 1) % this.ca && i(this),
                                (r = n(this)),
                                c.push(r[0], r[1], r[2], r[3]);
                        return i(this), c.slice(0, o);
                    },
                    setDefaultParanoia: function (o, t) {
                        if (
                            0 === o &&
                            "Setting paranoia=0 will ruin your security; use it only for testing" !==
                                t
                        )
                            throw "Setting paranoia=0 will ruin your security; use it only for testing";
                        this.M = o;
                    },
                    addEntropy: function (o, t, r) {
                        r = r || "user";
                        var i,
                            n,
                            c = new Date().valueOf(),
                            a = this.H[r],
                            l = this.isReady(),
                            s = 0;
                        switch (
                            (void 0 === (i = this.U[r]) &&
                                (i = this.U[r] = this.ha++),
                            void 0 === a && (a = this.H[r] = 0),
                            (this.H[r] = (this.H[r] + 1) % this.c.length),
                            typeof o)
                        ) {
                            case "number":
                                void 0 === t && (t = 1),
                                    this.c[a].update([
                                        i,
                                        this.N++,
                                        1,
                                        t,
                                        c,
                                        1,
                                        0 | o,
                                    ]);
                                break;
                            case "object":
                                if (
                                    "[object Uint32Array]" ===
                                    (r = Object.prototype.toString.call(o))
                                ) {
                                    for (n = [], r = 0; r < o.length; r++)
                                        n.push(o[r]);
                                    o = n;
                                } else
                                    for (
                                        "[object Array]" !== r && (s = 1),
                                            r = 0;
                                        r < o.length && !s;
                                        r++
                                    )
                                        "number" != typeof o[r] && (s = 1);
                                if (!s) {
                                    if (void 0 === t)
                                        for (r = t = 0; r < o.length; r++)
                                            for (n = o[r]; 0 < n; )
                                                t++, (n >>>= 1);
                                    this.c[a].update(
                                        [i, this.N++, 2, t, c, o.length].concat(
                                            o
                                        )
                                    );
                                }
                                break;
                            case "string":
                                void 0 === t && (t = o.length),
                                    this.c[a].update([
                                        i,
                                        this.N++,
                                        3,
                                        t,
                                        c,
                                        o.length,
                                    ]),
                                    this.c[a].update(o);
                                break;
                            default:
                                s = 1;
                        }
                        if (s)
                            throw new d.exception.bug(
                                "random: addEntropy only supports number, array of numbers or string"
                            );
                        (this.m[a] += t),
                            (this.f += t),
                            l === this.u &&
                                (this.isReady() !== this.u &&
                                    e("seeded", Math.max(this.o, this.f)),
                                e("progress", this.getProgress()));
                    },
                    isReady: function (o) {
                        return (
                            (o = this.T[void 0 !== o ? o : this.M]),
                            this.o && this.o >= o
                                ? this.m[0] > this.ba &&
                                  new Date().valueOf() > this.Z
                                    ? this.J | this.I
                                    : this.I
                                : this.f >= o
                                ? this.J | this.u
                                : this.u
                        );
                    },
                    getProgress: function (o) {
                        return (
                            (o = this.T[o || this.M]),
                            this.o >= o ? 1 : this.f > o ? 1 : this.f / o
                        );
                    },
                    startCollectors: function () {
                        if (!this.D) {
                            if (
                                ((this.a = {
                                    loadTimeCollector: c(this, this.ma),
                                    mouseCollector: c(this, this.oa),
                                    keyboardCollector: c(this, this.la),
                                    accelerometerCollector: c(this, this.ea),
                                    touchCollector: c(this, this.qa),
                                }),
                                window.addEventListener)
                            )
                                window.addEventListener(
                                    "load",
                                    this.a.loadTimeCollector,
                                    !1
                                ),
                                    window.addEventListener(
                                        "mousemove",
                                        this.a.mouseCollector,
                                        !1
                                    ),
                                    window.addEventListener(
                                        "keypress",
                                        this.a.keyboardCollector,
                                        !1
                                    ),
                                    window.addEventListener(
                                        "devicemotion",
                                        this.a.accelerometerCollector,
                                        !1
                                    ),
                                    window.addEventListener(
                                        "touchmove",
                                        this.a.touchCollector,
                                        !1
                                    );
                            else {
                                if (!document.attachEvent)
                                    throw new d.exception.bug(
                                        "can't attach event"
                                    );
                                document.attachEvent(
                                    "onload",
                                    this.a.loadTimeCollector
                                ),
                                    document.attachEvent(
                                        "onmousemove",
                                        this.a.mouseCollector
                                    ),
                                    document.attachEvent(
                                        "keypress",
                                        this.a.keyboardCollector
                                    );
                            }
                            this.D = !0;
                        }
                    },
                    stopCollectors: function () {
                        this.D &&
                            (window.removeEventListener
                                ? (window.removeEventListener(
                                      "load",
                                      this.a.loadTimeCollector,
                                      !1
                                  ),
                                  window.removeEventListener(
                                      "mousemove",
                                      this.a.mouseCollector,
                                      !1
                                  ),
                                  window.removeEventListener(
                                      "keypress",
                                      this.a.keyboardCollector,
                                      !1
                                  ),
                                  window.removeEventListener(
                                      "devicemotion",
                                      this.a.accelerometerCollector,
                                      !1
                                  ),
                                  window.removeEventListener(
                                      "touchmove",
                                      this.a.touchCollector,
                                      !1
                                  ))
                                : document.detachEvent &&
                                  (document.detachEvent(
                                      "onload",
                                      this.a.loadTimeCollector
                                  ),
                                  document.detachEvent(
                                      "onmousemove",
                                      this.a.mouseCollector
                                  ),
                                  document.detachEvent(
                                      "keypress",
                                      this.a.keyboardCollector
                                  )),
                            (this.D = !1));
                    },
                    addEventListener: function (o, t) {
                        this.K[o][this.ga++] = t;
                    },
                    removeEventListener: function (o, t) {
                        var e,
                            r,
                            i = this.K[o],
                            n = [];
                        for (r in i)
                            i.hasOwnProperty(r) && i[r] === t && n.push(r);
                        for (e = 0; e < n.length; e++) delete i[(r = n[e])];
                    },
                    la: function () {
                        r(1);
                    },
                    oa: function (o) {
                        var t, e;
                        try {
                            (t = o.x || o.clientX || o.offsetX || 0),
                                (e = o.y || o.clientY || o.offsetY || 0);
                        } catch (o) {
                            e = t = 0;
                        }
                        0 != t &&
                            0 != e &&
                            d.random.addEntropy([t, e], 2, "mouse"),
                            r(0);
                    },
                    qa: function (o) {
                        (o = o.touches[0] || o.changedTouches[0]),
                            d.random.addEntropy(
                                [o.pageX || o.clientX, o.pageY || o.clientY],
                                1,
                                "touch"
                            ),
                            r(0);
                    },
                    ma: function () {
                        r(2);
                    },
                    ea: function (o) {
                        if (
                            ((o =
                                o.accelerationIncludingGravity.x ||
                                o.accelerationIncludingGravity.y ||
                                o.accelerationIncludingGravity.z),
                            window.orientation)
                        ) {
                            var t = window.orientation;
                            "number" == typeof t &&
                                d.random.addEntropy(t, 1, "accelerometer");
                        }
                        o && d.random.addEntropy(o, 2, "accelerometer"), r(0);
                    },
                }),
                (d.random = new d.prng(6));
            o: try {
                var u, m, p, f;
                if ((f = "undefined" != typeof module && module.exports)) {
                    var w;
                    try {
                        w = l("crypto");
                    } catch (o) {
                        w = null;
                    }
                    f = m = w;
                }
                if (f && m.randomBytes)
                    (u = m.randomBytes(128)),
                        (u = new Uint32Array(new Uint8Array(u).buffer)),
                        d.random.addEntropy(u, 1024, "crypto['randomBytes']");
                else if (
                    "undefined" != typeof window &&
                    "undefined" != typeof Uint32Array
                ) {
                    if (
                        ((p = new Uint32Array(32)),
                        window.crypto && window.crypto.getRandomValues)
                    )
                        window.crypto.getRandomValues(p);
                    else {
                        if (
                            !window.msCrypto ||
                            !window.msCrypto.getRandomValues
                        )
                            break o;
                        window.msCrypto.getRandomValues(p);
                    }
                    d.random.addEntropy(p, 1024, "crypto['getRandomValues']");
                }
            } catch (o) {
                "undefined" != typeof window &&
                    window.console &&
                    (console.log(
                        "There was an error collecting entropy from the browser:"
                    ),
                    console.log(o));
            }
            (d.json = {
                defaults: {
                    v: 1,
                    iter: 1e3,
                    ks: 128,
                    ts: 64,
                    mode: "ccm",
                    adata: "",
                    cipher: "aes",
                },
                ja: function (o, t, e, r) {
                    (e = e || {}), (r = r || {});
                    var i,
                        n = d.json,
                        c = n.g({ iv: d.random.randomWords(4, 0) }, n.defaults);
                    if (
                        (n.g(c, e),
                        (e = c.adata),
                        "string" == typeof c.salt &&
                            (c.salt = d.codec.base64.toBits(c.salt)),
                        "string" == typeof c.iv &&
                            (c.iv = d.codec.base64.toBits(c.iv)),
                        !d.mode[c.mode] ||
                            !d.cipher[c.cipher] ||
                            ("string" == typeof o && c.iter <= 100) ||
                            (64 !== c.ts && 96 !== c.ts && 128 !== c.ts) ||
                            (128 !== c.ks && 192 !== c.ks && 256 !== c.ks) ||
                            c.iv.length < 2 ||
                            4 < c.iv.length)
                    )
                        throw new d.exception.invalid(
                            "json encrypt: invalid parameters"
                        );
                    return (
                        "string" == typeof o
                            ? ((o = (i = d.misc.cachedPbkdf2(o, c)).key.slice(
                                  0,
                                  c.ks / 32
                              )),
                              (c.salt = i.salt))
                            : d.ecc &&
                              o instanceof d.ecc.elGamal.publicKey &&
                              ((i = o.kem()),
                              (c.kemtag = i.tag),
                              (o = i.key.slice(0, c.ks / 32))),
                        "string" == typeof t &&
                            (t = d.codec.utf8String.toBits(t)),
                        "string" == typeof e &&
                            (c.adata = e = d.codec.utf8String.toBits(e)),
                        (i = new d.cipher[c.cipher](o)),
                        n.g(r, c),
                        (r.key = o),
                        (c.ct =
                            "ccm" === c.mode &&
                            d.arrayBuffer &&
                            d.arrayBuffer.ccm &&
                            t instanceof ArrayBuffer
                                ? d.arrayBuffer.ccm.encrypt(i, t, c.iv, e, c.ts)
                                : d.mode[c.mode].encrypt(i, t, c.iv, e, c.ts)),
                        c
                    );
                },
                encrypt: function (o, t, e, r) {
                    var i = d.json,
                        n = i.ja.apply(i, arguments);
                    return i.encode(n);
                },
                ia: function (o, t, e, r) {
                    (e = e || {}), (r = r || {});
                    var i,
                        n,
                        c = d.json;
                    if (
                        ((i = (t = c.g(c.g(c.g({}, c.defaults), t), e, !0))
                            .adata),
                        "string" == typeof t.salt &&
                            (t.salt = d.codec.base64.toBits(t.salt)),
                        "string" == typeof t.iv &&
                            (t.iv = d.codec.base64.toBits(t.iv)),
                        !d.mode[t.mode] ||
                            !d.cipher[t.cipher] ||
                            ("string" == typeof o && t.iter <= 100) ||
                            (64 !== t.ts && 96 !== t.ts && 128 !== t.ts) ||
                            (128 !== t.ks && 192 !== t.ks && 256 !== t.ks) ||
                            !t.iv ||
                            t.iv.length < 2 ||
                            4 < t.iv.length)
                    )
                        throw new d.exception.invalid(
                            "json decrypt: invalid parameters"
                        );
                    return (
                        "string" == typeof o
                            ? ((o = (n = d.misc.cachedPbkdf2(o, t)).key.slice(
                                  0,
                                  t.ks / 32
                              )),
                              (t.salt = n.salt))
                            : d.ecc &&
                              o instanceof d.ecc.elGamal.secretKey &&
                              (o = o
                                  .unkem(d.codec.base64.toBits(t.kemtag))
                                  .slice(0, t.ks / 32)),
                        "string" == typeof i &&
                            (i = d.codec.utf8String.toBits(i)),
                        (n = new d.cipher[t.cipher](o)),
                        (i =
                            "ccm" === t.mode &&
                            d.arrayBuffer &&
                            d.arrayBuffer.ccm &&
                            t.ct instanceof ArrayBuffer
                                ? d.arrayBuffer.ccm.decrypt(
                                      n,
                                      t.ct,
                                      t.iv,
                                      t.tag,
                                      i,
                                      t.ts
                                  )
                                : d.mode[t.mode].decrypt(
                                      n,
                                      t.ct,
                                      t.iv,
                                      i,
                                      t.ts
                                  )),
                        c.g(r, t),
                        (r.key = o),
                        1 === e.raw ? i : d.codec.utf8String.fromBits(i)
                    );
                },
                decrypt: function (o, t, e, r) {
                    var i = d.json;
                    return i.ia(o, i.decode(t), e, r);
                },
                encode: function (o) {
                    var t,
                        e = "{",
                        r = "";
                    for (t in o)
                        if (o.hasOwnProperty(t)) {
                            if (!t.match(/^[a-z0-9]+$/i))
                                throw new d.exception.invalid(
                                    "json encode: invalid property name"
                                );
                            switch (
                                ((e += r + '"' + t + '":'),
                                (r = ","),
                                typeof o[t])
                            ) {
                                case "number":
                                case "boolean":
                                    e += o[t];
                                    break;
                                case "string":
                                    e += '"' + escape(o[t]) + '"';
                                    break;
                                case "object":
                                    e +=
                                        '"' +
                                        d.codec.base64.fromBits(o[t], 0) +
                                        '"';
                                    break;
                                default:
                                    throw new d.exception.bug(
                                        "json encode: unsupported type"
                                    );
                            }
                        }
                    return e + "}";
                },
                decode: function (o) {
                    if (!(o = o.replace(/\s/g, "")).match(/^\{.*\}$/))
                        throw new d.exception.invalid(
                            "json decode: this isn't json!"
                        );
                    o = o.replace(/^\{|\}$/g, "").split(/,/);
                    var t,
                        e,
                        r = {};
                    for (t = 0; t < o.length; t++) {
                        if (
                            !(e = o[t].match(
                                /^\s*(?:(["']?)([a-z][a-z0-9]*)\1)\s*:\s*(?:(-?\d+)|"([a-z0-9+\/%*_.@=\-]*)"|(true|false))$/i
                            ))
                        )
                            throw new d.exception.invalid(
                                "json decode: this isn't json!"
                            );
                        null != e[3]
                            ? (r[e[2]] = parseInt(e[3], 10))
                            : null != e[4]
                            ? (r[e[2]] = e[2].match(/^(ct|adata|salt|iv)$/)
                                  ? d.codec.base64.toBits(e[4])
                                  : unescape(e[4]))
                            : null != e[5] && (r[e[2]] = "true" === e[5]);
                    }
                    return r;
                },
                g: function (o, t, e) {
                    if ((void 0 === o && (o = {}), void 0 === t)) return o;
                    for (var r in t)
                        if (t.hasOwnProperty(r)) {
                            if (e && void 0 !== o[r] && o[r] !== t[r])
                                throw new d.exception.invalid(
                                    "required parameter overridden"
                                );
                            o[r] = t[r];
                        }
                    return o;
                },
                sa: function (o, t) {
                    var e,
                        r = {};
                    for (e in o)
                        o.hasOwnProperty(e) && o[e] !== t[e] && (r[e] = o[e]);
                    return r;
                },
                ra: function (o, t) {
                    var e,
                        r = {};
                    for (e = 0; e < t.length; e++)
                        void 0 !== o[t[e]] && (r[t[e]] = o[t[e]]);
                    return r;
                },
            }),
                (d.encrypt = d.json.encrypt),
                (d.decrypt = d.json.decrypt),
                (d.misc.pa = {}),
                (d.misc.cachedPbkdf2 = function (o, t) {
                    var e,
                        r = d.misc.pa;
                    return (
                        (e = (t = t || {}).iter || 1e3),
                        ((e = (r = r[o] = r[o] || {})[e] =
                            r[e] || {
                                firstSalt:
                                    t.salt && t.salt.length
                                        ? t.salt.slice(0)
                                        : d.random.randomWords(2, 0),
                            })[(r = void 0 === t.salt ? e.firstSalt : t.salt)] =
                            e[r] || d.misc.pbkdf2(o, r, t.iter)),
                        { key: e[r].slice(0), salt: r.slice(0) }
                    );
                }),
                s("modules/utils", ["sjcl", "jquery"], function (o, t) {
                    window.wootric_property_warning = !1;
                    var e = function () {
                            for (
                                var o = 0,
                                    t = "",
                                    e = "abcdefghijklmnopqrstuvwxyz0123456789";
                                o < 16;

                            )
                                (t += e.charAt(
                                    Math.floor(Math.random() * e.length)
                                )),
                                    o++;
                            return t;
                        },
                        r = function (t, r) {
                            var i = new Date(),
                                n = e();
                            return o.codec.hex.fromBits(
                                o.hash.sha256.hash([t, r, i, n].join(" "))
                            );
                        },
                        i = function (o, e) {
                            return t.extend(!0, {}, o, e);
                        },
                        n = function (o, t, e) {
                            return o >= t && o <= e;
                        },
                        c = function () {
                            if (window.wootric_show_logs) {
                                for (
                                    var o = [], t = 0;
                                    t < arguments.length;
                                    t++
                                )
                                    o.push(arguments[t]);
                                console.log(o.join(" "));
                            }
                        };
                    return {
                        buildUniqueLink: r,
                        inRange: n,
                        log: c,
                        logServerError: function () {
                            c("[!] The SDK is unable to reach Wootric servers");
                        },
                        isMobile: function () {
                            return window.matchMedia(
                                "only screen and (max-width: 760px)"
                            ).matches;
                        },
                        isZoomed: function () {
                            var o = !1,
                                e =
                                    document.getElementsByTagName(
                                        "meta"
                                    ).viewport;
                            if (!e) return o;
                            var r = e.content.split(",");
                            return (
                                r.length > 0 &&
                                    t.map(r, function (t) {
                                        (-1 === t.indexOf("initial-scale") &&
                                            -1 === t.indexOf("device-width")) ||
                                            (o = !0);
                                    }),
                                o
                            );
                        },
                        concat: i,
                        chooseEligibilityServer: function (o, t) {
                            return (
                                o ||
                                    (o = t.eligibility_secondary_server
                                        ? "secondary"
                                        : "main"),
                                o
                            );
                        },
                        getEligibilityServerURL: function (o, t) {
                            return "main" == o
                                ? t.eligibility_server
                                : t.eligibility_secondary_server;
                        },
                        parseWootricProperties: function (o) {
                            if (!t.isEmptyObject(o)) {
                                var e = {
                                    original_picklist_answers_array: !0,
                                    core_picklist_answers_array: !0,
                                };
                                return (
                                    Object.keys(o).map(function (t) {
                                        if (t in e) return !0;
                                        "object" == typeof o[t] &&
                                            null !== typeof o[t] &&
                                            (!1 ===
                                                window.wootric_property_warning &&
                                                ((window.wootric_property_warning =
                                                    !0),
                                                console.log(
                                                    "Wootric: Warning: Wootric does not support objects to be passed as properties."
                                                )),
                                            delete o[t]);
                                    }),
                                    o
                                );
                            }
                        },
                        originURL: function (o) {
                            var t = "";
                            if (window.location) {
                                var e = window.location.href;
                                t = o ? e : e.split("#")[0];
                            }
                            return t;
                        },
                        startsWith: function (o, t) {
                            return String.prototype.startsWith
                                ? o.startsWith(t)
                                : o.substring(0, t.length) === t;
                        },
                    };
                }),
                s("modules/config", ["jquery", "./utils"], function (o, t) {
                    var e = o.noConflict(!0),
                        r = {
                            survey_immediately:
                                "Wootric: Warning: Remove survey immediately before deploying or else customers will be surveyed repeatedly.",
                            invalid_token:
                                "Wootric: Error: Account token invalid. Got: ",
                            required_token:
                                "Wootric: Error: Account token required.",
                            empty_email: "Wootric: Warning: Email is empty.",
                            invalid_created_at:
                                "Wootric: Warning: Invalid created_at, expecting 10-digit Unix timestamp in seconds.",
                            invalid_survey_type:
                                "Wootric: Warning: Invalid survey_type, expecting nps, ces or csat. Falling back to nps...",
                            invalid_callback:
                                "Wootric: Provided callback must be a funtion",
                            unregistered_channel:
                                "Wootric: Warning: Unregistered channel detected setting value to 'web'",
                        },
                        i = {
                            AU: {
                                server: "https://app.wootric.au",
                                eligibility_server:
                                    "https://eligibility.wootric.au",
                                eligibility_secondary_server:
                                    "https://eligibility.wootric.au",
                            },
                            EU: {
                                server: "https://app.wootric.eu",
                                eligibility_server:
                                    "https://eligibility.wootric.eu",
                                eligibility_secondary_server:
                                    "https://eligibility.wootric.eu",
                            },
                            US: {
                                server: "https://production.wootric.com",
                                eligibility_server:
                                    "https://wootric-eligibility.herokuapp.com",
                                eligibility_secondary_server:
                                    "https://eligibility.wootric.com",
                            },
                        },
                        n = ["web", "mobile"],
                        c = function (o) {
                            return parseInt(o, 10) != o;
                        },
                        a = function (o) {
                            var t = [
                                {
                                    old_name: "survey_callback",
                                    new_name: "after_show",
                                },
                                {
                                    old_name: "response_callback",
                                    new_name: "after_response",
                                },
                                {
                                    old_name: "decline_callback",
                                    new_name: "after_decline",
                                },
                            ];
                            o.settings.callbacks ||
                                ((o.settings.callbacks = {}),
                                e.each(t, function (t, r) {
                                    if (o.settings[r.old_name]) {
                                        var i = o.settings[r.old_name];
                                        e.isFunction(i) &&
                                            (o.settings.callbacks[r.new_name] =
                                                i),
                                            delete o[r.old_name];
                                    }
                                }));
                        },
                        l = function (o) {
                            if (
                                (!0 === o.survey_immediately &&
                                    t.log(r.survey_immediately),
                                o.settings.account_token)
                            ) {
                                var i = [],
                                    l = /^NPS-(EU-|AU-|)[A-Za-z0-9]{8}$/,
                                    s = o.settings.account_token.split(",");
                                e.each(s, function (o, n) {
                                    (n = e.trim(n)),
                                        l.test(n)
                                            ? i.push(n)
                                            : t.log(r.invalid_token + n);
                                }),
                                    (o.settings.account_token = i.toString());
                            } else t.log(r.required_token);
                            if (
                                (o.settings.channel &&
                                    -1 === e.inArray(o.settings.channel, n) &&
                                    (t.log(r.unregistered_channel),
                                    (o.settings.channel = "web")),
                                "string" == typeof o.settings.email &&
                                    (o.settings.email.trim() ||
                                        t.log(r.empty_email)),
                                c(o.settings.created_at))
                            )
                                t.log(r.invalid_created_at);
                            else {
                                var d = Math.pow(10, 9),
                                    u = Math.pow(10, 10) - 1,
                                    m = parseInt(o.settings.created_at, 10);
                                (m < d || m > u) && t.log(r.invalid_created_at);
                            }
                            a(o),
                                o.settings.callbacks
                                    ? e.each(
                                          o.settings.callbacks,
                                          function (e, i) {
                                              "function" != typeof i &&
                                                  (t.log(r.invalid_callback, e),
                                                  (o.settings.callbacks[e] =
                                                      void 0));
                                          }
                                      )
                                    : (o.settings.callbacks = {});
                        };
                    return {
                        build: function (o) {
                            var t = "US";
                            o.account_token &&
                                /^NPS-(EU|AU)-/.test(o.account_token) &&
                                (t = o.account_token
                                    .substring(4, 6)
                                    .toUpperCase());
                            var r = {
                                    aria: !0,
                                    version: "1.12.9",
                                    server: i[t].server,
                                    eligibility_server: i[t].eligibility_server,
                                    eligibility_secondary_server:
                                        i[t].eligibility_secondary_server,
                                    first_survey: null,
                                    time_delay: null,
                                    registered_percent: null,
                                    visitor_percent: null,
                                    resurvey_throttle: null,
                                    decline_resurvey_throttle: null,
                                    disable_surveyed_cookie: !1,
                                    daily_response_cap: null,
                                    messages: null,
                                    survey_immediately: !1,
                                    settings: {},
                                    audience_text: null,
                                    priority: 0,
                                    extra_questions: [],
                                    permission_labels: {},
                                    rule_id: null,
                                    powered_by: !0,
                                    scale_color: null,
                                },
                                n = {
                                    server: window.wootric_server,
                                    eligibility_server:
                                        window.wootric_eligibility_server,
                                    eligibility_secondary_server:
                                        window.wootric_eligibility_secondary_server,
                                    first_survey: window.wootric_first_survey,
                                    time_delay: window.wootric_time_delay,
                                    registered_percent:
                                        window.wootric_registered_percent,
                                    visitor_percent: window.visitor_percent,
                                    resurvey_throttle:
                                        window.wootric_resurvey_throttle,
                                    decline_resurvey_throttle:
                                        window.wootric_decline_resurvey_throttle,
                                    disable_surveyed_cookie:
                                        window.wootric_no_surveyed_cookie,
                                    daily_response_cap:
                                        window.wootric_daily_response_cap,
                                    messages: window.customMessages,
                                    settings: window.wootricSettings,
                                    survey_immediately:
                                        window.wootric_survey_immediately,
                                    audience_text:
                                        window.wootricSettings
                                            .wootric_recommend_target,
                                    survey_type_scale:
                                        window.wootricSettings
                                            .survey_type_scale,
                                    priority: 0,
                                    custom_primary_color:
                                        window.wootricSettings
                                            .custom_primary_color,
                                    custom_secondary_color:
                                        window.wootricSettings
                                            .custom_secondary_color,
                                    use_filled_score_scale:
                                        window.wootricSettings
                                            .use_filled_score_scale,
                                },
                                c = e.extend(!0, {}, r, n);
                            return l(c), c;
                        },
                        version: function () {
                            return "wootric-js-sdk-1.12.9";
                        },
                    };
                }),
                s("modules/cookie", [], function () {
                    var o = function (o) {
                            var t = window.wootricSettings || {},
                                e = t.account_token;
                            return e ? e.replace("-", "_") + "_" + o : o;
                        },
                        t = function (t, e, r) {
                            t = o(t);
                            var i,
                                n,
                                c =
                                    "https:" === window.location.protocol
                                        ? "; secure"
                                        : "";
                            r
                                ? ((i = new Date()),
                                  "throttle" === t.split("_")[2]
                                      ? ((e = i.getTime() + 3600 * r * 1e3),
                                        i.setTime(e))
                                      : i.setTime(
                                            i.getTime() + 24 * r * 60 * 60 * 1e3
                                        ),
                                  (n = "; expires=" + i.toGMTString()))
                                : (n = ""),
                                (document.cookie =
                                    t +
                                    "=" +
                                    e +
                                    n +
                                    c +
                                    "; SameSite=Lax; path=/");
                        },
                        e = function (o) {
                            var t, e, r, i;
                            for (
                                i = o + "=",
                                    e = document.cookie.split(";"),
                                    r = 0;
                                r < e.length;

                            ) {
                                for (t = e[r]; " " === t.charAt(0); )
                                    t = t.substring(1, t.length);
                                if (0 === t.indexOf(i))
                                    return t.substring(i.length, t.length);
                                r++;
                            }
                            return null;
                        };
                    return {
                        create: t,
                        read: function (t) {
                            return e(o(t)) || e(t);
                        },
                    };
                }),
                s("modules/visual", {
                    version: "dac082bdb9eeb75be7512a9b06f86a1676be11b1",
                    webBeacon:
                        "<div class='wootric-beacon-parent'><form id='wootric-form'><div class='wootric-beacon-contents'><div role='button' aria-label='Close survey' aria-hidden='false' tabindex='23' id='wootric-close' dir='ltr' class='wootric-close-right'><div class='wootric-x-wrapper'><svg id='wootric-x' viewBox='0 0 20 20'><g stroke='none' stroke-width='1' fill='none' fill-rule='evenodd' stroke-linecap='round' stroke-linejoin='round'><g id='close-icon' transform='translate(2.000000, 2.000000)' stroke='#6C6C6C' stroke-width='3'><path d='M0.082205267,0.082205267 L15.7130199,15.7130199 M16,0 L0,16' id='path1098'></path></g></g></svg></div><div id='wootric-dismiss'>dismiss</div></div><div tabindex='18' id='wootric-extra-question' class='wootric-modal-hidden' name='' aria-hidden='true'><p id='wootric-extra-label'></p><div id='wootric-extra-dropdown' class='wootric-select wootric-modal-hidden'><select id='wootric-extra-answer' name='wootric-extra-select'><option id='wootric-extra-q' value='' selected='selected'></option><option id='answer-1' value='' class='wootric-modal-hidden'></option><option id='answer-2' value='' class='wootric-modal-hidden'></option><option id='answer-3' value='' class='wootric-modal-hidden'></option><option id='answer-4' value='' class='wootric-modal-hidden'></option><option id='answer-5' value='' class='wootric-modal-hidden'></option><option id='answer-6' value='' class='wootric-modal-hidden'></option><option id='answer-7' value='' class='wootric-modal-hidden'></option><option id='answer-8' value='' class='wootric-modal-hidden'></option><option id='answer-9' value='' class='wootric-modal-hidden'></option><option id='answer-10' value='' class='wootric-modal-hidden'></option></select> <svg class='wootric-select-toggle' viewBox='0 0 512 512'><path d='M73.092,164.452h255.813c4.949,0,9.233-1.807,12.848-5.424c3.613-3.616,5.427-7.898,5.427-12.847    c0-4.949-1.813-9.229-5.427-12.85L213.846,5.424C210.232,1.812,205.951,0,200.999,0s-9.233,1.812-12.85,5.424L60.242,133.331    c-3.617,3.617-5.424,7.901-5.424,12.85c0,4.948,1.807,9.231,5.424,12.847C63.863,162.645,68.144,164.452,73.092,164.452z' data-original='#000000' class='active-path' data-old_color='#7f7f7f' fill='#7f7f7f'/><path d='M328.905,237.549H73.092c-4.952,0-9.233,1.808-12.85,5.421c-3.617,3.617-5.424,7.898-5.424,12.847    c0,4.949,1.807,9.233,5.424,12.848L188.149,396.57c3.621,3.617,7.902,5.428,12.85,5.428s9.233-1.811,12.847-5.428l127.907-127.906    c3.613-3.614,5.427-7.898,5.427-12.848c0-4.948-1.813-9.229-5.427-12.847C338.139,239.353,333.854,237.549,328.905,237.549z' data-original='#000000' class='active-path' data-old_color='#7f7f7f' fill='#7f7f7f'/></svg></div><input role='button' value='' id='wootric-extra-submit' type='submit'></div><div tabindex='16' class='thanks wootric-modal-hidden' id='wootric-thanks'><p></p></div><div tabindex='26' class='wootric-modal-hidden' id='driver-picklist'><ul tabindex='27' id='picklist'></ul></div><div class='wootric-feedback-wrapper wootric-modal-collapsed' id='wootric-feedback' aria-hidden='true'><div class='shadow-box'><textarea role='textbox' tabindex='14' name='feedback' rows='2' placeholder='' id='wootric-text' disabled='disabled'></textarea> <input role='button' tabindex='15' type='submit' value='' class='wootric-submit' id='wootric-submit' disabled='disabled'></div></div><div class='wootric-share-wrapper wootric-modal-collapsed' id='wootric-share' aria-hidden='true'><div tabindex='17' class='wootric-followup'><p></p></div><div class='wootric-followup-btns'><div class='followup-btns'><span><div role='button' class='wootric-like-button' aria-label='Like on Facebook' id='wootric-facebook'><svg viewBox='0 0 12 12' preserveAspectRatio='xMidYMid meet' class='fb-icon'><path class='fb-icon' d='M9.1,0.1V2H8C7.6,2,7.3,2.1,7.1,2.3C7,2.4,6.9,2.7,6.9,3v1.4H9L8.8,6.5H6.9V12H4.7V6.5H2.9V4.4h1.8V2.8 c0-0.9,0.3-1.6,0.7-2.1C6,0.2,6.6,0,7.5,0C8.2,0,8.7,0,9.1,0.1z'></path></svg>Share</div><div role='button' aria-label='Tweet on Twitter' class='wootric-twitter-button' id='wootric-twitter'><svg viewBox='0 0 512 512' class='twitter-icon'><path d='M419.6 168.6c-11.7 5.2-24.2 8.7-37.4 10.2 13.4-8.1 23.8-20.8 28.6-36 -12.6 7.5-26.5 12.9-41.3 15.8 -11.9-12.6-28.8-20.6-47.5-20.6 -42 0-72.9 39.2-63.4 79.9 -54.1-2.7-102.1-28.6-134.2-68 -17 29.2-8.8 67.5 20.1 86.9 -10.7-0.3-20.7-3.3-29.5-8.1 -0.7 30.2 20.9 58.4 52.2 64.6 -9.2 2.5-19.2 3.1-29.4 1.1 8.3 25.9 32.3 44.7 60.8 45.2 -27.4 21.4-61.8 31-96.4 27 28.8 18.5 63 29.2 99.8 29.2 120.8 0 189.1-102.1 185-193.6C399.9 193.1 410.9 181.7 419.6 168.6z'/></svg>Tweet</div><input role='button' tabindex='21' class='wootric-thank-you-button-outline' type='button' id='wootric-social-link' value='' disabled='disabled'> <input role='button ' tabindex='20' class='wootric-no-thanks-button' type='button' id='wootric-decline' value='' disabled='disabled'></span></div></div></div><div tabindex='1' class='wootric-question' id='wootric-question' aria-label='Feedback form' aria-hidden='false'><p tabindex='1' id='wootric-language-direction' role='heading' aria-level='1'></p></div><div aria-label='Authorize share feedback' aria-hidden='true' tabindex='24' id='wootric-share-feedback' class='wootric-modal-hidden'><p><input type='checkbox' name='wootric-feedback-grant' id='wootric-feedback-grant' checked='checked'><span id='wootric-permission-label'></span></p></div><div class='wootric-score' id='wootric-fullscore' tabindex='3' aria-label='' aria-hidden='false' dir='ltr'><label id='wootric-not-likely-label' aria-hidden='true'></label><ul id='wootric-score'><li role='button' tabindex='3' value='0'>0</li><li role='button' tabindex='4' value='1'>1</li><li role='button' tabindex='5' value='2'>2</li><li role='button' tabindex='6' value='3'>3</li><li role='button' tabindex='7' value='4'>4</li><li role='button' tabindex='8' value='5'>5</li><li role='button' tabindex='9' value='6'>6</li><li role='button' tabindex='10' value='7'>7</li><li role='button' tabindex='11' value='8'>8</li><li role='button' tabindex='12' value='9'>9</li><li role='button' tabindex='13' value='10'>10</li></ul><label id='wootric-likely-label' aria-hidden='true'></label><div class='wootric-alt-anchors'><label aria-hidden='true' class='wootric-alt-anchors__anchor wootric-alt-anchors__anchor--negative'></label> <span class='wootric-alt-anchors__spacer'></span> <label aria-hidden='true' class='wootric-alt-anchors__anchor wootric-alt-anchors__anchor--positive'></label></div></div><div class='wootric-feedback-wrapper wootric-modal-collapsed' id='wootric-secundary-submit' aria-hidden='true'><input role='button' tabindex='15' type='submit' class='wootric-submit' id='wootric-submit-dpl' disabled='disabled'></div></div></form><div class='wootric-footer'><div class='wootric-powered-by' tabindex='22' aria-label='powered by inmoment'>powered by <a href='//www.wootric.com' target='_blank' role='link' class='wootric-link'>InMoment</a></div><span id='wootric-opt-out-wrapper' class='wootric-modal-hidden'><div class='wootric-separator'>&bull;</div><div id='wootric-opt-out' class='wootric-opt-out' tabindex='23' aria-label='opt out from surveys'>opt out</div></span><span id='wootric-feedback-disclaimer-wrapper' class='wootric-modal-hidden'><div class='wootric-separator'>&bull;</div><div id='wootric-feedback-disclaimer' class='wootric-feedback-disclaimer' tabindex='25' aria-label='Learn how we handle your data'><span id='wootric-feedback-disclaimer-text'></span> <a href='//' id='wootric-disclaimer-link' target='_blank' role='link' class='wootric-disclaimer-link'>here</a></div></span></div></div>",
                    style: '#wootric-modal *{-moz-box-sizing:border-box !important;-moz-appearance:none;-webkit-box-sizing:border-box !important;-webkit-user-select:none;-webkit-appearance:none;appearance:none;box-sizing:border-box !important;clear:both;float:none;height:auto;margin:0;min-height:0;min-width:0;padding:0;position:relative;text-align:center;width:auto}#wootric-modal *:focus{outline:none}#wootric-modal INPUT,#wootric-modal TEXTAREA,#wootric-modal P{-webkit-user-select:auto}#wootric-modal .clearfix:before,#wootric-modal .clearfix:after{content:" ";display:table}#wootric-modal .clearfix:after{clear:both}#wootric-modal .device{display:none}#wootric-modal .floatleft{float:left !important}#wootric-modal .floatright{float:right !important}#wootric-modal .inlineblock{display:inline-block !important;vertical-align:top !important}#wootric-modal .relative,#wootric-modal.relative{position:relative}#wootric-modal .fixed,#wootric-modal.fixed{-webkit-transform:translateZ(0);position:fixed !important}#wootric-modal .wootric-modal-hidden,#wootric-modal.wootric-modal-hidden{display:none !important}#wootric-modal .wootric-modal-collapsed{-moz-transition:margin .3s ease;-moz-transition:max-height .3s ease;-moz-transition:padding .3s ease;-webkit-transition:margin .3s ease;-webkit-transition:max-height .3s ease;-webkit-transition:padding .3s ease;margin-bottom:0 !important;margin-top:0 !important;max-height:0 !important;overflow:hidden;padding-bottom:0 !important;padding-top:0 !important;transition:margin .3s ease;transition:max-height .3s ease;transition:padding .3s ease}#wootric-modal .wootric-beacon-contents div{-moz-transition:margin .3s ease;-moz-transition:max-height .3s ease;-moz-transition:padding .3s ease;-webkit-transition:margin .3s ease;-webkit-transition:max-height .3s ease;-webkit-transition:padding .3s ease;transition:margin .3s ease;transition:max-height .3s ease;transition:padding .3s ease}body.wootric-modal-showing{-moz-transition:padding .3s ease;-webkit-transition:padding .3s ease;transition:padding .3s ease}#wootric-modal{-moz-transition:top .5s ease;-webkit-transition:top .5s ease;font-family:Arial,sans-serif;font-size:16px;left:0;position:fixed;right:0;top:-100%;transition:top .5s ease;width:100%;z-index:10000000001}#wootric-modal.show{top:0px}#wootric-modal.wootric-bottom{-moz-transition:bottom .5s ease;-webkit-transition:bottom .5s ease;bottom:-100%;top:auto;transition:bottom .5s ease}#wootric-modal.wootric-bottom.show{bottom:0px;top:auto}#wootric-modal .wootric-beacon-parent{border-bottom:5px solid;position:relative;min-width:600px;width:100%}#wootric-modal.wootric-survey-type-ces .wootric-beacon-parent,#wootric-modal.wootric-survey-type-csat .wootric-beacon-parent{min-width:600px}#wootric-modal.wootric-bottom .wootric-beacon-parent{border-bottom:none;border-top:5px solid}#wootric-modal #wootric-close{-moz-border-radius:17px;-moz-transition:width .25s ease;-webkit-transition:width .25s ease;align-items:center;border-radius:17px;color:#6c6c6c;cursor:pointer;display:flex;font-size:.875em;font-weight:200;height:34px;overflow:hidden;padding-left:34px;padding:0px;position:absolute;text-align:left;top:10px;transition:width .25s ease;width:34px;z-index:1}#wootric-modal #wootric-close #wootric-dismiss{display:none;white-space:nowrap}.wootric-close-left{left:10px}.wootric-close-right{right:10px}#wootric-modal.compact #wootric-close{-moz-border-radius:14px;border-radius:14px;display:flex;font-size:.75em;font-weight:400;height:28px;width:28px}#wootric-modal #wootric-close:focus,#wootric-modal #wootric-close:hover{align-items:center;display:flex;justify-content:center;width:110px}#wootric-modal #wootric-close:focus #wootric-dismiss,#wootric-modal #wootric-close:hover #wootric-dismiss{display:inline}#wootric-modal #wootric-close:focus #wootric-x,#wootric-modal #wootric-close:hover #wootric-x{margin:0 9px 0 0}#wootric-modal.compact #wootric-close:hover{width:80px}#wootric-modal #wootric-close #wootric-x{-moz-border-radius:17px;border-radius:17px;color:#6c6c6c;cursor:pointer;float:left;height:14px;left:0;margin:0 9px;width:14px;z-index:1}#wootric-modal.compact #wootric-close #wootric-x{-moz-border-radius:14px;border-radius:14px;height:10px;margin:0 8px;width:10px}#wootric-modal #wootric-fullscore,#wootric-modal #wootric-question,#wootric-modal #wootric-feedback,#wootric-modal #wootric-share{margin:0 0 .85em}#wootric-modal.compact #wootric-fullscore,#wootric-modal.compact #wootric-question,#wootric-modal.compact #wootric-feedback,#wootric-modal.compact #wootric-share{margin:0 0 .5em}#wootric-modal.spacious #wootric-fullscore,#wootric-modal.spacious #wootric-question,#wootric-modal.spacious #wootric-feedback,#wootric-modal.spacious #wootric-share{margin:0 0 1.15em}#wootric-modal .wootric-visible{display:inline}#wootric-modal p{font-size:1em;line-height:1.5em;margin:0;padding:0 4em}#wootric-modal.compact p{font-size:.875em}#wootric-modal.spacious p{font-size:1.125em;font-weight:200}#wootric-modal form,#wootric-modal .wootric-beacon-contents{left:0;text-align:center;top:0;width:100%;z-index:1}#wootric-modal .wootric-beacon-contents{padding:1.25em 0 .25em}#wootric-modal.compact .wootric-beacon-contents{padding:.5em 0 0}#wootric-modal.spacious .wootric-beacon-contents{padding:1.75em 0 .5em}#wootric-modal ul{display:inline-block;line-height:2.25em;margin:0 .25em;overflow:visible;padding:0}#wootric-modal li{-moz-border-radius:25px;border-radius:25px;cursor:pointer;display:inline;font-size:.875em;margin-right:3px;padding:13px 17px}#wootric-modal li:first-child{margin-left:3px}#wootric-modal.compact li{font-size:.875em;padding:8px 12px}#wootric-modal.spacious li{font-size:1em;padding:14px 18px}#wootric-modal li.selected,#wootric-modal li.selected:hover{background-color:#b3cdff;color:#253746}#wootric-modal li:last-child{padding:13px}#wootric-modal.compact li:last-child{padding:8px}#wootric-modal.spacious li:last-child{padding:14px}#wootric-modal label{display:inline-block;font-size:.875em;font-style:italic;padding:1em 0 0}#wootric-modal.compact label{padding:0}#wootric-modal.spacious label{padding:1.25em 0 0}#wootric-score li{display:none}#wootric-modal .wootric-score #wootric-not-likely-label{padding:0 0 1em !important}#wootric-modal .wootric-score #wootric-likely-label{padding:0 0 1em !important}#wootric-modal .wootric-feedback-wrapper{max-height:240}#wootric-modal .wootric-feedback-wrapper input,#wootric-modal .wootric-feedback-wrapper textarea{display:inline-block;margin:0;vertical-align:top}#wootric-modal textarea{border-right:rgba(0,0,0,0);border-radius:4px 0 0 4px;box-shadow:none;font-family:Arial,sans-serif;font-size:.813em;height:3.8em;line-height:1.125em;padding:.7em;resize:none;text-align:left;width:50%}#wootric-modal.compact textarea{font-size:.75em;line-height:normal}#wootric-modal.spacious textarea{font-size:.875em;line-height:1.313em}.wootric-alt-anchors{display:none;justify-content:center;order:2 !important;width:100%}.wootric-alt-anchors__anchor{padding:10px 0 0 0 !important}.wootric-alt-anchors__spacer{display:inline-block}.wootric-survey-type-nps .wootric-alt-anchors__spacer{width:350px !important}.wootric-survey-type-ces .wootric-alt-anchors__spacer{width:200px !important}.wootric-survey-type-csat .wootric-alt-anchors__spacer{width:100px !important}@media only screen and (max-height: 480px){#wootric-modal{max-height:320px;overflow-x:hidden;overflow-y:auto;text-align:center}}@media only screen and (max-width: 780px){#wootric-modal.wootric-desktop-modal #wootric-not-likely-label,#wootric-modal.wootric-desktop-modal #wootric-likely-label{display:none}#wootric-modal.wootric-desktop-modal .wootric-alt-anchors{display:flex}}@media only screen and (max-width: 440px){#wootric-modal .ces ul,#wootric-modal .csat ul{display:block !important}}@media only screen and (max-width: 580px){#wootric-modal .wootric-followup-btns{margin-bottom:0}#wootric-modal .wootric-like-button,#wootric-modal .wootric-twitter-button,#wootric-modal .wootric-no-thanks-button,#wootric-modal .wootric-thank-you-button-outline{margin-bottom:5px !important}}@media only screen and (orientation: landscape){.wootric-mobile-modal textarea{height:100px !important;font-size:1.625em !important;line-height:normal !important;max-height:100px !important;padding:1em !important;width:70% !important;border-radius:.25em 0 0 .25em}.wootric-mobile-modal #wootric-thanks{margin:3em 0 .5em !important;padding:0}.wootric-mobile-modal #wootric-thanks p{font-size:1.75em !important;line-height:1.5 !important}.wootric-mobile-modal .wootric-submit{font-size:1.5em !important;height:100px !important;padding:1em 2.5em !important}.wootric-mobile-modal #picklist li{font-size:1.75em !important}.wootric-mobile-modal #wootric-dismiss{display:none !important}.wootric-mobile-modal #wootric-fullscore,.wootric-mobile-modal #wootric-feedback,.wootric-mobile-modal #wootric-share{margin:0 0 .85em !important}.wootric-mobile-modal #wootric-fullscore.wootric-modal-collapsed,.wootric-mobile-modal #wootric-feedback.wootric-modal-collapsed,.wootric-mobile-modal #wootric-share.wootric-modal-collapsed{margin:0 !important}.wootric-mobile-modal #wootric-fullscore,.wootric-mobile-modal #wootric-share{margin:0 auto 1.6em !important}.wootric-mobile-modal #wootric-fullscore .wootric-followup,.wootric-mobile-modal #wootric-share .wootric-followup{padding:0 0 2em}.wootric-mobile-modal #wootric-fullscore .wootric-followup p,.wootric-mobile-modal #wootric-share .wootric-followup p{font-size:1.5em !important;line-height:normal}.wootric-mobile-modal #wootric-fullscore .wootric-followup-btns,.wootric-mobile-modal #wootric-share .wootric-followup-btns{margin:0 auto;max-width:90vw !important;width:90vw !important}.wootric-mobile-modal #wootric-fullscore .wootric-followup-btns .wootric-like-button,.wootric-mobile-modal #wootric-share .wootric-followup-btns .wootric-like-button{align-items:center;border-radius:6px;color:#fff;display:flex;font-size:1.875em !important;height:65px;justify-content:center;margin:5px !important;padding:7px 16px}.wootric-mobile-modal #wootric-fullscore .wootric-followup-btns .fb-icon,.wootric-mobile-modal #wootric-share .wootric-followup-btns .fb-icon{fill:#fff;flex:none;flex-grow:0;height:40px;margin-right:4px;order:0;width:35px}.wootric-mobile-modal #wootric-fullscore .wootric-followup-btns .wootric-no-thanks-button,.wootric-mobile-modal #wootric-share .wootric-followup-btns .wootric-no-thanks-button{align-items:center;border:2px solid #253746;border-radius:6px !important;display:flex;font-size:1.75em !important;height:65px;justify-content:center;margin:5px !important;padding:5px 18px}.wootric-mobile-modal #wootric-fullscore .wootric-followup-btns .wootric-no-thanks-button,.wootric-mobile-modal #wootric-fullscore .wootric-followup-btns .wootric-thank-you-button-outline,.wootric-mobile-modal #wootric-share .wootric-followup-btns .wootric-no-thanks-button,.wootric-mobile-modal #wootric-share .wootric-followup-btns .wootric-thank-you-button-outline{align-items:center;background:#fff;border:1px solid;border-radius:6px !important;display:flex;font-size:1.75em !important;height:65px;justify-content:center;margin:5px !important;padding:5px 18px}.wootric-mobile-modal #wootric-fullscore .wootric-followup-btns .wootric-twitter-button,.wootric-mobile-modal #wootric-share .wootric-followup-btns .wootric-twitter-button{align-items:center;border-radius:6px;color:#fff;font-family:"IBM Plex Sans",sans-serif !important;font-size:1.875em !important;height:65px;justify-content:center;margin:5px !important;padding:7px 16px}.wootric-mobile-modal #wootric-fullscore .wootric-followup-btns .twitter-icon,.wootric-mobile-modal #wootric-share .wootric-followup-btns .twitter-icon{fill:#fff;flex:none;flex-grow:0;height:55;margin-right:4px;order:0;width:55px}.wootric-mobile-modal.compact #wootric-fullscore,.wootric-mobile-modal.compact #wootric-feedback,.wootric-mobile-modal.compact #wootric-share{margin:0 auto .8em !important}.wootric-mobile-modal.compact #wootric-fullscore.wootric-modal-collapsed,.wootric-mobile-modal.compact #wootric-feedback.wootric-modal-collapsed,.wootric-mobile-modal.compact #wootric-share.wootric-modal-collapsed{margin:0 !important}.wootric-mobile-modal.compact #wootric-question{margin:3.3em 0 1.8em !important}.wootric-mobile-modal #wootric-question{margin:3.6em 0 2em !important}.wootric-mobile-modal #wootric-question p{font-size:1.75em;line-height:normal}.wootric-mobile-modal #wootric-close{border-radius:48px !important;border-width:1.5px !important;height:48px !important;right:10px !important;top:10px !important;width:48px !important}.wootric-mobile-modal #wootric-close #wootric-x{height:26px !important;width:26px !important}.wootric-mobile-modal .wootric-beacon-parent{border-bottom:7px solid #e9ebed !important;border-top:0 !important;min-width:auto !important}.wootric-mobile-modal.wootric-bottom .wootric-beacon-parent{border-bottom:0 #fafafa !important;border-top:7px solid !important}.wootric-mobile-modal #wootric-fullscore{display:flex;flex-direction:row;flex-wrap:wrap;justify-content:space-between !important;max-width:100% !important;padding:0;width:min-content}.wootric-mobile-modal #wootric-fullscore.nps ul li,.wootric-mobile-modal #wootric-fullscore.ces ul li,.wootric-mobile-modal #wootric-fullscore.csat ul li,.wootric-mobile-modal #wootric-fullscore.csat_custom .wootric-mobile-modal #wootric-fullscore.csat_custom_2 ul li{font-size:1.8em}.wootric-mobile-modal #wootric-fullscore.nps ul li{height:8vw !important;line-height:7.5vw !important;width:6vw !important}.wootric-mobile-modal #wootric-fullscore.ces ul li,.wootric-mobile-modal #wootric-fullscore.csat ul li,.wootric-mobile-modal #wootric-fullscore.csat_custom ul li,.wootric-mobile-modal #wootric-fullscore.csat_custom_2 ul li{height:8vw !important;line-height:8vw !important;width:10vw !important}.wootric-mobile-modal #wootric-fullscore.ces ul li:nth-child(2),.wootric-mobile-modal #wootric-fullscore.csat ul li:nth-child(2),.wootric-mobile-modal #wootric-fullscore.csat_custom ul li:nth-child(2),.wootric-mobile-modal #wootric-fullscore.csat_custom_2 ul li:nth-child(2){border-radius:100% 0 0 100% !important;margin-left:0 !important}.wootric-mobile-modal #wootric-fullscore.ces ul li:nth-child(8){border-radius:0 100% 100% 0 !important;border-width:1.5px 1.5px 1.5px 1.5px !important;margin-right:0 !important}.wootric-mobile-modal #wootric-fullscore.csat ul li:nth-child(6){border-radius:0 100% 100% 0 !important;border-width:1.5px 1.5px 1.5px 1.5px !important;margin-right:0 !important}.wootric-mobile-modal #wootric-fullscore.csat_custom ul li:nth-child(11){border-radius:0 100% 100% 0 !important;border-width:1.5px 1.5px 1.5px 1.5px !important;margin-right:0 !important}.wootric-mobile-modal #wootric-fullscore.csat_custom_2 ul li:nth-child(8){border-radius:0 100% 100% 0 !important;border-width:1.5px 1.5px 1.5px 1.5px !important;margin-right:0 !important}.wootric-mobile-modal #wootric-fullscore #wootric-score{display:inline-flex !important;flex:0 1 100%;justify-content:center;margin:0 auto;order:1 !important;padding:0 0 2%;width:fit-content !important}.wootric-mobile-modal #wootric-fullscore #wootric-score li{border-color:#dadada;border-radius:0;border-style:solid;border-width:1.5px 0 1.5px 1.5px;flex-wrap:nowrap;margin:0;padding:0}.wootric-mobile-modal #wootric-fullscore #wootric-score li.wootric-visible{display:inline-block !important}.wootric-mobile-modal #wootric-fullscore #wootric-score li.wootric-visible:first-child,.wootric-mobile-modal #wootric-fullscore #wootric-score li.wootric-visible:last-child{width:8vw !important}.wootric-mobile-modal #wootric-fullscore #wootric-score li.wootric-visible:first-child{border-radius:100% 0 0 100%;margin-left:0;padding:0 0 0 4px}.wootric-mobile-modal #wootric-fullscore #wootric-score li.wootric-visible:last-child{border-radius:0 100% 100% 0;border-width:1.5px 1.5px 1.5px 1.5px;margin-right:0;padding:0 4px 0 0}.wootric-mobile-modal #wootric-likely-label,.wootric-mobile-modal #wootric-not-likely-label{font-size:1.5em !important;order:2 !important;width:fit-content}.wootric-mobile-modal #wootric-likely-label:first-child,.wootric-mobile-modal #wootric-likely-label:last-child,.wootric-mobile-modal #wootric-not-likely-label:first-child,.wootric-mobile-modal #wootric-not-likely-label:last-child{padding:0 !important}.wootric-mobile-modal .wootric-powered-by,.wootric-mobile-modal .wootric-opt-out,.wootric-mobile-modal .wootric-feedback-disclaimer{font-size:1.2em;padding:0 0 .2em !important}.wootric-mobile-modal-zoomed #wootric-question{margin:2em 0 1em !important}.wootric-mobile-modal-zoomed #wootric-question p{font-size:1.2em;margin-top:1.8em}.wootric-mobile-modal-zoomed #wootric-fullscore,.wootric-mobile-modal-zoomed #wootric-feedback,.wootric-mobile-modal-zoomed #wootric-share{margin:0 0 .85em !important}.wootric-mobile-modal-zoomed #wootric-fullscore.wootric-modal-collapsed,.wootric-mobile-modal-zoomed #wootric-feedback.wootric-modal-collapsed,.wootric-mobile-modal-zoomed #wootric-share.wootric-modal-collapsed{margin:0 !important}.wootric-mobile-modal-zoomed.compact #wootric-fullscore,.wootric-mobile-modal-zoomed.compact #wootric-feedback,.wootric-mobile-modal-zoomed.compact #wootric-share{margin:0 auto 1em !important}.wootric-mobile-modal-zoomed.compact #wootric-fullscore.wootric-modal-collapsed,.wootric-mobile-modal-zoomed.compact #wootric-feedback.wootric-modal-collapsed,.wootric-mobile-modal-zoomed.compact #wootric-share.wootric-modal-collapsed{margin:0 !important}.wootric-mobile-modal-zoomed.compact #wootric-thanks{margin:2.5em 0 0 !important;padding:0}.wootric-mobile-modal-zoomed.compact #wootric-fullscore .wootric-followup,.wootric-mobile-modal-zoomed.compact #wootric-share .wootric-followup{padding:0 0 .8em !important}.wootric-mobile-modal-zoomed.compact #wootric-question{margin:2.2em 0 .8em !important}.wootric-mobile-modal-zoomed.compact .wootric-powered-by{margin:0 0 .2em}.wootric-mobile-modal-zoomed .wootric-beacon-parent{border-bottom:5px solid #fafafa !important;border-top:0px !important;min-width:auto !important}.wootric-mobile-modal-zoomed.wootric-bottom .wootric-beacon-parent{border-bottom:0 !important;border-top:5px solid #fafafa !important}.wootric-mobile-modal-zoomed #wootric-close{border-radius:30px !important;border-width:1px !important;height:30px !important;width:30px !important}.wootric-mobile-modal-zoomed #wootric-close #wootric-x{height:12px !important;margin:0 8px !important;width:12px !important}.wootric-mobile-modal-zoomed #wootric-dismiss{display:none !important}.wootric-mobile-modal-zoomed textarea{zoom:1;border-radius:4px;font-size:1.125em !important;height:4em !important;line-height:normal !important;margin:0 !important;max-height:4em !important;padding:.5em;width:70% !important}.wootric-mobile-modal-zoomed .wootric-submit{font-size:1.1em !important;height:4.1em !important;padding:1.3em}.wootric-mobile-modal-zoomed #wootric-thanks{margin:1.5em 0 0 !important}.wootric-mobile-modal-zoomed #wootric-thanks p{font-size:1.2em !important}.wootric-mobile-modal-zoomed #picklist li{font-size:1.2em !important}.wootric-mobile-modal-zoomed #wootric-fullscore{margin:0 auto 1.2em !important}.wootric-mobile-modal-zoomed #wootric-fullscore.nps ul li,.wootric-mobile-modal-zoomed #wootric-fullscore.ces ul li,.wootric-mobile-modal-zoomed #wootric-fullscore.csat ul li,.wootric-mobile-modal-zoomed #wootric-fullscore.csat_custom ul li,.wootric-mobile-modal-zoomed #wootric-fullscore.csat_custom_2 ul li{font-size:1.2em}.wootric-mobile-modal-zoomed #wootric-fullscore.nps ul li{height:8vw !important;line-height:7.5vw !important}.wootric-mobile-modal-zoomed #wootric-fullscore.ces ul li,.wootric-mobile-modal-zoomed #wootric-fullscore.csat ul li,.wootric-mobile-modal-zoomed #wootric-fullscore.csat_custom ul li,.wootric-mobile-modal-zoomed #wootric-fullscore.csat_custom_2 ul li{height:8vw !important;line-height:8vw !important}.wootric-mobile-modal-zoomed #wootric-fullscore.ces ul li{width:9vw !important}.wootric-mobile-modal-zoomed #wootric-fullscore.ces ul li:nth-child(2),.wootric-mobile-modal-zoomed #wootric-fullscore.ces ul li:nth-child(8){width:10vw !important}.wootric-mobile-modal-zoomed #wootric-fullscore.csat ul li{width:10vw !important}.wootric-mobile-modal-zoomed #wootric-fullscore.csat ul li:nth-child(2),.wootric-mobile-modal-zoomed #wootric-fullscore.csat ul li:nth-child(6){width:11vw !important}.wootric-mobile-modal-zoomed #wootric-fullscore.csat_custom ul li{width:10vw !important}.wootric-mobile-modal-zoomed #wootric-fullscore.csat_custom ul li:nth-child(2),.wootric-mobile-modal-zoomed #wootric-fullscore.csat_custom ul li:nth-child(11){width:11vw !important}.wootric-mobile-modal-zoomed #wootric-fullscore.csat_custom_2 ul li{width:10vw !important}.wootric-mobile-modal-zoomed #wootric-fullscore.csat_custom_2 ul li:nth-child(2),.wootric-mobile-modal-zoomed #wootric-fullscore.csat_custom_2 ul li:nth-child(8){width:11vw !important}.wootric-mobile-modal-zoomed label{font-size:1.1em !important}.wootric-mobile-modal-zoomed #wootric-fullscore,.wootric-mobile-modal-zoomed #wootric-share{margin:0 auto .8em !important}.wootric-mobile-modal-zoomed #wootric-fullscore .wootric-followup,.wootric-mobile-modal-zoomed #wootric-share .wootric-followup{padding:0 0 2em}.wootric-mobile-modal-zoomed #wootric-fullscore .wootric-followup p,.wootric-mobile-modal-zoomed #wootric-share .wootric-followup p{font-size:1em !important;line-height:normal}.wootric-mobile-modal-zoomed #wootric-fullscore .wootric-followup-btns,.wootric-mobile-modal-zoomed #wootric-share .wootric-followup-btns{margin:0 auto;max-width:90vw !important;width:90vw !important}.wootric-mobile-modal-zoomed #wootric-fullscore .wootric-followup-btns .wootric-like-button,.wootric-mobile-modal-zoomed #wootric-share .wootric-followup-btns .wootric-like-button{align-items:center;border-radius:3px;color:#fff;display:flex;font-size:.875em !important;height:36px;justify-content:center;margin:5px !important;padding:7px 16px}.wootric-mobile-modal-zoomed #wootric-fullscore .wootric-followup-btns .fb-icon,.wootric-mobile-modal-zoomed #wootric-share .wootric-followup-btns .fb-icon{fill:#fff;flex:none;flex-grow:0;height:40px;margin-right:4px;order:0;width:16px}.wootric-mobile-modal-zoomed #wootric-fullscore .wootric-followup-btns .wootric-no-thanks-button,.wootric-mobile-modal-zoomed #wootric-share .wootric-followup-btns .wootric-no-thanks-button{align-items:center;border:1px solid #253746;border-radius:3px !important;display:flex;font-size:.875em !important;height:36px;justify-content:center;margin:5px !important;padding:5px 18px}.wootric-mobile-modal-zoomed #wootric-fullscore .wootric-followup-btns .wootric-no-thanks-button,.wootric-mobile-modal-zoomed #wootric-fullscore .wootric-followup-btns .wootric-thank-you-button-outline,.wootric-mobile-modal-zoomed #wootric-share .wootric-followup-btns .wootric-no-thanks-button,.wootric-mobile-modal-zoomed #wootric-share .wootric-followup-btns .wootric-thank-you-button-outline{align-items:center;background:#fff;border:1px solid;border-radius:3px !important;display:flex;font-size:.875em !important;height:36px;justify-content:center;margin:5px !important;padding:5px 18px}.wootric-mobile-modal-zoomed #wootric-fullscore .wootric-followup-btns .wootric-twitter-button,.wootric-mobile-modal-zoomed #wootric-share .wootric-followup-btns .wootric-twitter-button{align-items:center;border-radius:6px;color:#fff;font-family:"IBM Plex Sans",sans-serif !important;font-size:.875em !important;height:36px;justify-content:center;margin:5px !important;padding:7px 16px}.wootric-mobile-modal-zoomed #wootric-fullscore .wootric-followup-btns .twitter-icon,.wootric-mobile-modal-zoomed #wootric-share .wootric-followup-btns .twitter-icon{fill:#fff;flex:none;flex-grow:0;height:55;margin-right:4px;order:0;width:28px}.wootric-mobile-modal-zoomed .device{display:block}.wootric-mobile-modal-zoomed .screen{display:none}.wootric-mobile-modal-zoomed #wootric-likely-label,.wootric-mobile-modal-zoomed #wootric-not-likely-label{font-size:1.5em !important}.wootric-mobile-modal-zoomed .wootric-powered-by,.wootric-mobile-modal-zoomed .wootric-opt-out,.wootric-mobile-modal-zoomed .wootric-feedback-disclaimer{font-size:.9em !important}.wootric-mobile-modal-zoomed #wootric-extra-question .wootric-select{border-right:1px solid #dadada}.wootric-mobile-modal-zoomed #wootric-extra-question .wootric-select-toggle{right:1px}.wootric-mobile-modal-zoomed #wootric-extra-question #wootric-extra-submit{border-radius:4px}}@media only screen and (orientation: portrait){#wootric-modal.wootric-mobile-modal #wootric-question{margin:7em 0 2.8em !important}#wootric-modal.wootric-mobile-modal #wootric-question p{font-size:3.1em;line-height:normal}#wootric-modal.wootric-mobile-modal #wootric-fullscore.wootric-modal-collapsed,#wootric-modal.wootric-mobile-modal #wootric-feedback.wootric-modal-collapsed,#wootric-modal.wootric-mobile-modal #wootric-share.wootric-modal-collapsed{margin:0 !important}#wootric-modal.wootric-mobile-modal.compact #wootric-fullscore,#wootric-modal.wootric-mobile-modal.compact #wootric-feedback,#wootric-modal.wootric-mobile-modal.compact #wootric-share{margin:0 auto 1.2em !important}#wootric-modal.wootric-mobile-modal.compact #wootric-fullscore.wootric-modal-collapsed,#wootric-modal.wootric-mobile-modal.compact #wootric-feedback.wootric-modal-collapsed,#wootric-modal.wootric-mobile-modal.compact #wootric-share.wootric-modal-collapsed{margin:0 !important}#wootric-modal.wootric-mobile-modal.compact #wootric-question{margin:6.5em 0 2.3em !important}#wootric-modal.wootric-mobile-modal .wootric-beacon-parent{border-bottom:12px solid #fafafa !important;border-top:0px !important;min-width:auto !important}#wootric-modal.wootric-mobile-modal.wootric-bottom .wootric-beacon-parent{border-bottom:0 !important;border-top:12px solid #fafafa !important}#wootric-modal.wootric-mobile-modal #wootric-close{border-radius:80px !important;border-width:3px !important;height:80px !important;right:25px;width:80px !important;top:25px}#wootric-modal.wootric-mobile-modal #wootric-close #wootric-x{height:38px;margin:0 18px;width:38px}#wootric-modal.wootric-mobile-modal #wootric-dismiss{display:none !important}#wootric-modal.wootric-mobile-modal textarea{border-radius:8px;font-size:2.875em !important;height:10.5em;line-height:normal !important;margin:1% 1% 0 !important;max-height:10.5em !important;padding:1.8em;width:92%}#wootric-modal.wootric-mobile-modal .wootric-submit{border-radius:8px !important;font-size:3em !important;margin:1.6em 0 1em;padding:3.6em 0 !important;width:92%}#wootric-modal.wootric-mobile-modal #wootric-thanks{margin:7em 0 1.8em !important;padding:0}#wootric-modal.wootric-mobile-modal #wootric-thanks p{font-size:2.8em !important;line-height:1.5 !important;padding:0 1em}#wootric-modal.wootric-mobile-modal #picklist li{border-width:3px;font-size:2.8em !important;padding:16px 20px !important}#wootric-modal.wootric-mobile-modal #wootric-fullscore{display:flex;flex-direction:row;flex-wrap:wrap;justify-content:space-between !important;margin:0 auto 3.2em !important;max-width:100% !important;padding:0 4em;width:min-content}#wootric-modal.wootric-mobile-modal #wootric-fullscore.nps ul{display:block !important}#wootric-modal.wootric-mobile-modal #wootric-fullscore.nps ul li{font-size:3em;height:13vw !important;line-height:12.5vw !important;width:calc(10vw - .25em) !important}#wootric-modal.wootric-mobile-modal #wootric-fullscore.nps ul li:nth-child(1){border-radius:100% 0 0 100% !important;border-width:3px 0 3px 3px !important;margin-left:0 !important;padding:0 0 0 4px !important}#wootric-modal.wootric-mobile-modal #wootric-fullscore.nps ul li:nth-child(11){border-radius:0 100% 100% 0 !important;border-width:3px 3px 3px 3px !important;padding:0 4px 0 0 !important;margin-right:0 !important}#wootric-modal.wootric-mobile-modal #wootric-fullscore.ces ul li,#wootric-modal.wootric-mobile-modal #wootric-fullscore.csat ul li,#wootric-modal.wootric-mobile-modal #wootric-fullscore.csat_custom ul li,#wootric-modal.wootric-mobile-modal #wootric-fullscore.csat_custom_2 ul li{font-size:3.6em}#wootric-modal.wootric-mobile-modal #wootric-fullscore.ces ul li:nth-child(2),#wootric-modal.wootric-mobile-modal #wootric-fullscore.csat ul li:nth-child(2),#wootric-modal.wootric-mobile-modal #wootric-fullscore.csat_custom ul li:nth-child(2),#wootric-modal.wootric-mobile-modal #wootric-fullscore.csat_custom_2 ul li:nth-child(2){border-radius:100% 0 0 100% !important;border-width:3px 0 3px 3px !important;margin-left:0 !important;padding:0 0 0 4px !important}#wootric-modal.wootric-mobile-modal #wootric-fullscore.ces ul li{height:14vw !important;line-height:14vw !important;width:14vw !important}#wootric-modal.wootric-mobile-modal #wootric-fullscore.ces ul li:nth-child(2),#wootric-modal.wootric-mobile-modal #wootric-fullscore.ces ul li:nth-child(8){width:16vw !important}#wootric-modal.wootric-mobile-modal #wootric-fullscore.ces ul li:nth-child(8){border-radius:0 100% 100% 0 !important;border-width:3px 3px 3px 3px !important;margin-right:0 !important;padding:0 4px 0 0 !important}#wootric-modal.wootric-mobile-modal #wootric-fullscore.csat ul li{height:14.5vw !important;line-height:14.5vw !important;width:17vw !important}#wootric-modal.wootric-mobile-modal #wootric-fullscore.csat ul li:nth-child(2),#wootric-modal.wootric-mobile-modal #wootric-fullscore.csat ul li:nth-child(6){width:18vw !important}#wootric-modal.wootric-mobile-modal #wootric-fullscore.csat ul li:nth-child(6){border-radius:0 100% 100% 0 !important;border-width:3px 3px 3px 3px !important;padding:0 4px 0 0 !important;margin-right:0 !important}#wootric-modal.wootric-mobile-modal #wootric-fullscore.csat_custom ul{font-size:3em}#wootric-modal.wootric-mobile-modal #wootric-fullscore.csat_custom ul li{height:14.5vw !important;line-height:14.5vw !important;width:calc(10vw - .25em) !important}#wootric-modal.wootric-mobile-modal #wootric-fullscore.csat_custom ul li:nth-child(11){border-radius:0 100% 100% 0 !important;border-width:3px 3px 3px 3px !important;padding:0 4px 0 0 !important;margin-right:0 !important}#wootric-modal.wootric-mobile-modal #wootric-fullscore.csat_custom_2 ul li{height:14.5vw !important;line-height:14.5vw !important;width:17vw !important}#wootric-modal.wootric-mobile-modal #wootric-fullscore.csat_custom_2 ul li:nth-child(2),#wootric-modal.wootric-mobile-modal #wootric-fullscore.csat_custom_2 ul li:nth-child(8){width:18vw !important}#wootric-modal.wootric-mobile-modal #wootric-fullscore.csat_custom_2 ul li:nth-child(8){border-radius:0 100% 100% 0 !important;border-width:3px 3px 3px 3px !important;padding:0 4px 0 0 !important;margin-right:0 !important}#wootric-modal.wootric-mobile-modal #wootric-fullscore #wootric-score{display:inline-flex !important;flex:0 1 100%;justify-content:center;margin:0 auto;order:1 !important;padding:0 0 2%;width:fit-content !important}#wootric-modal.wootric-mobile-modal #wootric-fullscore #wootric-score.ltr li:first-child{border-radius:100% 0 0 100%;margin-left:0;padding:0 0 0 4px}#wootric-modal.wootric-mobile-modal #wootric-fullscore #wootric-score.ltr li:last-child{border-radius:0 100% 100% 0;border-width:3px 3px 3px 3px;margin-right:0;padding:0 4px 0 0}#wootric-modal.wootric-mobile-modal #wootric-fullscore #wootric-score.rtl li:last-child{border-right:0px;border-radius:100% 0 0 100%;margin-left:0;padding:0 0 0 4px}#wootric-modal.wootric-mobile-modal #wootric-fullscore #wootric-score.rtl li:first-child{border-radius:0 100% 100% 0;border-width:2px 2px 2px 2px;margin-right:0;padding:0 4px 0 0}#wootric-modal.wootric-mobile-modal #wootric-fullscore #wootric-score li{border-color:#dadada;border-radius:0;border-style:solid;border-width:3px 0 3px 3px;flex-wrap:nowrap;margin:0;padding:0}#wootric-modal.wootric-mobile-modal #wootric-fullscore #wootric-score li.wootric-visible{display:inline-block !important}#wootric-modal.wootric-mobile-modal #wootric-fullscore #wootric-score li.wootric-visible:first-child,#wootric-modal.wootric-mobile-modal #wootric-fullscore #wootric-score li.wootric-visible:last-child{width:12vw !important}#wootric-modal.wootric-mobile-modal label{font-size:1em}#wootric-modal.wootric-mobile-modal #wootric-likely-label,#wootric-modal.wootric-mobile-modal #wootric-not-likely-label{font-size:2.5em;order:2 !important;padding:0 !important;width:fit-content}#wootric-modal.wootric-mobile-modal #wootric-fullscore,#wootric-modal.wootric-mobile-modal #wootric-share{margin:0 auto 1.8em !important}#wootric-modal.wootric-mobile-modal #wootric-fullscore .wootric-followup,#wootric-modal.wootric-mobile-modal #wootric-share .wootric-followup{padding:0 0 3em}#wootric-modal.wootric-mobile-modal #wootric-fullscore .wootric-followup p,#wootric-modal.wootric-mobile-modal #wootric-share .wootric-followup p{font-size:2.5em !important;line-height:normal}#wootric-modal.wootric-mobile-modal #wootric-fullscore span,#wootric-modal.wootric-mobile-modal #wootric-share span{cursor:pointer;display:inline !important;opacity:1}#wootric-modal.wootric-mobile-modal #wootric-fullscore .wootric-followup-btns,#wootric-modal.wootric-mobile-modal #wootric-share .wootric-followup-btns{margin:0 auto;max-width:80vw !important;width:80vw !important}#wootric-modal.wootric-mobile-modal #wootric-fullscore .wootric-followup-btns .wootric-like-button,#wootric-modal.wootric-mobile-modal #wootric-share .wootric-followup-btns .wootric-like-button{align-items:center;background:#395693;border-radius:9px;color:#fff;display:inline-flex;flex:none;font-size:2.625em !important;height:95px;margin-bottom:12px !important;width:780px}#wootric-modal.wootric-mobile-modal #wootric-fullscore .wootric-followup-btns .fb-icon,#wootric-modal.wootric-mobile-modal #wootric-share .wootric-followup-btns .fb-icon{fill:#fff;flex:none;flex-grow:0;height:55px;margin-right:8px;order:0;width:50px}#wootric-modal.wootric-mobile-modal #wootric-fullscore .wootric-followup-btns .wootric-no-thanks-button,#wootric-modal.wootric-mobile-modal #wootric-share .wootric-followup-btns .wootric-no-thanks-button{border:3px solid #253746}#wootric-modal.wootric-mobile-modal #wootric-fullscore .wootric-followup-btns .wootric-no-thanks-button,#wootric-modal.wootric-mobile-modal #wootric-fullscore .wootric-followup-btns .wootric-thank-you-button-outline,#wootric-modal.wootric-mobile-modal #wootric-share .wootric-followup-btns .wootric-no-thanks-button,#wootric-modal.wootric-mobile-modal #wootric-share .wootric-followup-btns .wootric-thank-you-button-outline{align-items:center;border:2px solid !important;border-radius:9px !important;display:inline-flex;font-size:2.5em !important;height:95px;justify-content:center;margin-bottom:12px !important;width:780px !important}#wootric-modal.wootric-mobile-modal #wootric-fullscore .wootric-followup-btns .wootric-no-thanks-button,#wootric-modal.wootric-mobile-modal #wootric-share .wootric-followup-btns .wootric-no-thanks-button{margin-bottom:5px !important}#wootric-modal.wootric-mobile-modal #wootric-fullscore .wootric-followup-btns .wootric-twitter-button,#wootric-modal.wootric-mobile-modal #wootric-share .wootric-followup-btns .wootric-twitter-button{align-items:center;background:#115d8d;border-radius:9px;color:#fff;display:inline-flex;font-size:2.625em !important;height:95px;justify-content:center;margin-bottom:12px !important;width:780px !important}#wootric-modal.wootric-mobile-modal #wootric-fullscore .wootric-followup-btns .twitter-icon,#wootric-modal.wootric-mobile-modal #wootric-share .wootric-followup-btns .twitter-icon{fill:#fff;flex:none;flex-grow:0;height:75;margin-right:4px;order:0;width:75px}#wootric-modal.wootric-mobile-modal .device{display:block}#wootric-modal.wootric-mobile-modal .screen,#wootric-modal.wootric-mobile-modal .wootric-separator{display:none}#wootric-modal.wootric-mobile-modal .wootric-powered-by,#wootric-modal.wootric-mobile-modal .wootric-opt-out,#wootric-modal.wootric-mobile-modal .wootric-feedback-disclaimer{font-size:2.4em;padding-bottom:20px;padding-top:30px;width:100%}#wootric-modal.wootric-mobile-modal .wootric-opt-out,#wootric-modal.wootric-mobile-modal .wootric-feedback-disclaimer{padding:0 0 1.8em}#wootric-modal.wootric-mobile-modal #wootric-extra-question .wootric-select{border-right:1px solid #dadada}#wootric-modal.wootric-mobile-modal #wootric-extra-question .wootric-select-toggle{right:1px}#wootric-modal.wootric-mobile-modal #wootric-extra-question #wootric-extra-submit{border-radius:4px}#wootric-modal.wootric-mobile-modal-zoomed #wootric-question{margin:2em 0 1em !important}#wootric-modal.wootric-mobile-modal-zoomed #wootric-question p{font-size:1.2em;margin-top:1.8em;padding:0 1.5em}#wootric-modal.wootric-mobile-modal-zoomed #wootric-fullscore.wootric-modal-collapsed,#wootric-modal.wootric-mobile-modal-zoomed #wootric-feedback.wootric-modal-collapsed,#wootric-modal.wootric-mobile-modal-zoomed #wootric-share.wootric-modal-collapsed{margin:0 !important}#wootric-modal.wootric-mobile-modal-zoomed.compact #wootric-fullscore,#wootric-modal.wootric-mobile-modal-zoomed.compact #wootric-feedback,#wootric-modal.wootric-mobile-modal-zoomed.compact #wootric-share{margin:0 auto 1em !important}#wootric-modal.wootric-mobile-modal-zoomed.compact #wootric-fullscore.wootric-modal-collapsed,#wootric-modal.wootric-mobile-modal-zoomed.compact #wootric-feedback.wootric-modal-collapsed,#wootric-modal.wootric-mobile-modal-zoomed.compact #wootric-share.wootric-modal-collapsed{margin:0 !important}#wootric-modal.wootric-mobile-modal-zoomed.compact #wootric-fullscore .wootric-followup,#wootric-modal.wootric-mobile-modal-zoomed.compact #wootric-share .wootric-followup{padding:0 0 .8em !important}#wootric-modal.wootric-mobile-modal-zoomed.compact #wootric-question{margin:2.2em 0 .8em !important}#wootric-modal.wootric-mobile-modal-zoomed.compact .wootric-powered-by{margin:0 0 .2em}#wootric-modal.wootric-mobile-modal-zoomed .wootric-beacon-parent{border-bottom:5px solid #fafafa !important;border-top:0px !important;min-width:auto !important}#wootric-modal.wootric-mobile-modal-zoomed.wootric-bottom .wootric-beacon-parent{border-bottom:0 !important;border-top:5px solid #fafafa !important}#wootric-modal.wootric-mobile-modal-zoomed #wootric-close{border-radius:32px !important;border-width:1px !important;height:32px !important;right:10px;width:32px !important;top:10px}#wootric-modal.wootric-mobile-modal-zoomed #wootric-close #wootric-x{height:14px;margin:0 8px;width:14px}#wootric-modal.wootric-mobile-modal-zoomed #wootric-dismiss{display:none !important}#wootric-modal.wootric-mobile-modal-zoomed textarea{zoom:1;border-radius:4px;font-size:1.125em !important;height:4em;line-height:normal !important;margin:2% 2% 0 !important;max-height:4em !important;padding:.5em;width:92%}#wootric-modal.wootric-mobile-modal-zoomed .wootric-submit{border-radius:4px !important;font-size:1.1em !important;margin:.5em 0 0;padding:1em 0 !important;width:92%}#wootric-modal.wootric-mobile-modal-zoomed #wootric-thanks{margin:2em 0 .5em !important}#wootric-modal.wootric-mobile-modal-zoomed #wootric-thanks p{font-size:1.1em !important}#wootric-modal.wootric-mobile-modal-zoomed #picklist li{border-width:1px;font-size:.875em !important;margin:7px 4px 4px !important;padding:8px 10px !important}#wootric-modal.wootric-mobile-modal-zoomed #wootric-fullscore{margin:0 auto 1em !important;padding:0 2em}#wootric-modal.wootric-mobile-modal-zoomed #wootric-fullscore.nps ul li,#wootric-modal.wootric-mobile-modal-zoomed #wootric-fullscore.ces ul li{font-size:1.2em}#wootric-modal.wootric-mobile-modal-zoomed #wootric-fullscore.nps ul li{height:14vw !important;line-height:13vw !important}#wootric-modal.wootric-mobile-modal-zoomed #wootric-fullscore.nps ul li:nth-child(1){border-width:1.5px 0 1.5px 1.5px !important}#wootric-modal.wootric-mobile-modal-zoomed #wootric-fullscore.nps ul li:nth-child(11){border-width:1.5px 1.5px 1.5px 1.5px !important}#wootric-modal.wootric-mobile-modal-zoomed #wootric-fullscore.ces ul li:nth-child(2),#wootric-modal.wootric-mobile-modal-zoomed #wootric-fullscore.csat ul li:nth-child(2),#wootric-modal.wootric-mobile-modal-zoomed #wootric-fullscore.csat_custom ul li:nth-child(2),#wootric-modal.wootric-mobile-modal-zoomed #wootric-fullscore.csat_custom_2 ul li:nth-child(2){border-width:1.5px 0 1.5px 1.5px !important}#wootric-modal.wootric-mobile-modal-zoomed #wootric-fullscore.ces ul li{height:14vw !important;line-height:13vw !important;width:13vw !important}#wootric-modal.wootric-mobile-modal-zoomed #wootric-fullscore.ces ul li:nth-child(2),#wootric-modal.wootric-mobile-modal-zoomed #wootric-fullscore.ces ul li:nth-child(8){width:14vw !important}#wootric-modal.wootric-mobile-modal-zoomed #wootric-fullscore.ces ul li:nth-child(8){border-width:1.5px 1.5px 1.5px 1.5px !important}#wootric-modal.wootric-mobile-modal-zoomed #wootric-fullscore.csat ul li{font-size:1.5em;height:15vw !important;line-height:14vw !important;width:17vw !important}#wootric-modal.wootric-mobile-modal-zoomed #wootric-fullscore.csat ul li:nth-child(2),#wootric-modal.wootric-mobile-modal-zoomed #wootric-fullscore.csat ul li:nth-child(6){width:18vw !important}#wootric-modal.wootric-mobile-modal-zoomed #wootric-fullscore.csat ul li:nth-child(6){border-width:1.5px 1.5px 1.5px 1.5px !important}#wootric-modal.wootric-mobile-modal-zoomed #wootric-fullscore.csat_custom ul li{font-size:.4em;height:15vw !important;line-height:14vw !important;width:11vw !important}#wootric-modal.wootric-mobile-modal-zoomed #wootric-fullscore.csat_custom ul li:nth-child(11){border-width:1.5px 1.5px 1.5px 1.5px !important}#wootric-modal.wootric-mobile-modal-zoomed #wootric-fullscore.csat_custom_2 ul li{font-size:1.5em;height:15vw !important;line-height:14vw !important;width:17vw !important}#wootric-modal.wootric-mobile-modal-zoomed #wootric-fullscore.csat_custom_2 ul li:nth-child(2),#wootric-modal.wootric-mobile-modal-zoomed #wootric-fullscore.csat_custom_2 ul li:nth-child(8){width:18vw !important}#wootric-modal.wootric-mobile-modal-zoomed #wootric-fullscore.csat_custom_2 ul li:nth-child(8){border-width:1.5px 1.5px 1.5px 1.5px !important}#wootric-modal.wootric-mobile-modal-zoomed #wootric-fullscore #wootric-score li{border-width:1.5px 0 1.5px 1.5px}#wootric-modal.wootric-mobile-modal-zoomed #wootric-fullscore #wootric-score li.wootric-visible:last-child{border-width:1.5px 1.5px 1.5px 1.5px}#wootric-modal.wootric-mobile-modal-zoomed label{font-size:1em}#wootric-modal.wootric-mobile-modal-zoomed #wootric-fullscore,#wootric-modal.wootric-mobile-modal-zoomed #wootric-share{margin:0 auto 1em !important}#wootric-modal.wootric-mobile-modal-zoomed #wootric-fullscore .wootric-followup,#wootric-modal.wootric-mobile-modal-zoomed #wootric-share .wootric-followup{padding:.2em 0 1.2em}#wootric-modal.wootric-mobile-modal-zoomed #wootric-fullscore .wootric-followup p,#wootric-modal.wootric-mobile-modal-zoomed #wootric-share .wootric-followup p{font-size:1em !important}#wootric-modal.wootric-mobile-modal-zoomed #wootric-fullscore span,#wootric-modal.wootric-mobile-modal-zoomed #wootric-share span{cursor:pointer;display:flex !important;flex-direction:column;opacity:1}#wootric-modal.wootric-mobile-modal-zoomed #wootric-fullscore .wootric-followup-btns,#wootric-modal.wootric-mobile-modal-zoomed #wootric-share .wootric-followup-btns{margin:0 auto;max-width:80vw !important;width:80vw !important}#wootric-modal.wootric-mobile-modal-zoomed #wootric-fullscore .wootric-followup-btns .wootric-like-button,#wootric-modal.wootric-mobile-modal-zoomed #wootric-share .wootric-followup-btns .wootric-like-button{align-items:center;background:#395693;border:.8px solid #395693 !important;border-radius:3.6px;color:#fff;display:inline-flex;flex:none;font-size:1.05em !important;height:38px;margin-bottom:4.8px !important;max-width:100%;width:312px}#wootric-modal.wootric-mobile-modal-zoomed #wootric-fullscore .wootric-followup-btns .fb-icon,#wootric-modal.wootric-mobile-modal-zoomed #wootric-share .wootric-followup-btns .fb-icon{fill:#fff;flex:none;flex-grow:0;height:22px;margin-right:3.2px;order:0;width:20px}#wootric-modal.wootric-mobile-modal-zoomed #wootric-fullscore .wootric-followup-btns .wootric-no-thanks-button,#wootric-modal.wootric-mobile-modal-zoomed #wootric-fullscore .wootric-followup-btns .wootric-thank-you-button-outline,#wootric-modal.wootric-mobile-modal-zoomed #wootric-share .wootric-followup-btns .wootric-no-thanks-button,#wootric-modal.wootric-mobile-modal-zoomed #wootric-share .wootric-followup-btns .wootric-thank-you-button-outline{align-items:center;border:.8px solid !important;border-radius:3.6px !important;display:inline-flex;font-size:1em !important;height:38px;justify-content:center;margin-bottom:4.8px !important;max-width:100%;width:312px !important}#wootric-modal.wootric-mobile-modal-zoomed #wootric-fullscore .wootric-followup-btns .wootric-no-thanks-button,#wootric-modal.wootric-mobile-modal-zoomed #wootric-share .wootric-followup-btns .wootric-no-thanks-button{border:.8px solid #253746}#wootric-modal.wootric-mobile-modal-zoomed #wootric-fullscore .wootric-followup-btns .wootric-twitter-button,#wootric-modal.wootric-mobile-modal-zoomed #wootric-share .wootric-followup-btns .wootric-twitter-button{align-items:center;background:#115d8d;border:.8px solid #115d8d !important;border-radius:3.6px;color:#fff;display:inline-flex;font-size:1em !important;height:38px;justify-content:center;margin-bottom:4.8px !important;max-width:100%;width:312px !important}#wootric-modal.wootric-mobile-modal-zoomed #wootric-fullscore .wootric-followup-btns .twitter-icon,#wootric-modal.wootric-mobile-modal-zoomed #wootric-share .wootric-followup-btns .twitter-icon{fill:#fff;flex:none;flex-grow:0;height:30;margin-right:0;order:0;width:30px}#wootric-modal.wootric-mobile-modal-zoomed .device{display:block}#wootric-modal.wootric-mobile-modal-zoomed .screen,#wootric-modal.wootric-mobile-modal-zoomed .wootric-separator{display:none}#wootric-modal.wootric-mobile-modal-zoomed #wootric-likely-label,#wootric-modal.wootric-mobile-modal-zoomed #wootric-not-likely-label{font-size:.8em;order:2 !important;padding:0 !important;width:fit-content}#wootric-modal.wootric-mobile-modal-zoomed .wootric-powered-by,#wootric-modal.wootric-mobile-modal-zoomed .wootric-opt-out,#wootric-modal.wootric-mobile-modal-zoomed .wootric-feedback-disclaimer{font-size:.8em;padding:0 0 .2em}#wootric-modal.wootric-mobile-modal-zoomed #wootric-extra-question .wootric-select{border-right:1px solid #dadada}#wootric-modal.wootric-mobile-modal-zoomed #wootric-extra-question .wootric-select-toggle{right:1px}#wootric-modal.wootric-mobile-modal-zoomed #wootric-extra-question #wootric-extra-submit{border-radius:4px}}#wootric-modal .wootric-submit{border-radius:0 4px 4px 0;border:1px solid #dadada;color:#fff;cursor:pointer;font-size:.813em;height:3.8em;line-height:1.125em;margin-left:-5px !important;padding:1.262em;text-transform:uppercase}#wootric-modal #wootric-secundary-submit{margin-bottom:10px}#wootric-modal #wootric-secundary-submit .wootric-submit{border-radius:4px !important;margin-left:0 !important}#wootric-modal.light .wootric-submit{background:#253746;border:1px solid #253746}#wootric-modal.dark .wootric-submit{background:#66737e}#wootric-modal .wootric-submit:hover{background:#465562}.wootric-submit--rtl{border-radius:4px 0px 0px 4px !important;margin-left:0 !important;margin-right:-5px !important}#wootric-modal.compact .wootric-submit{font-size:.813em;line-height:.688em}#wootric-modal.spacious .wootric-submit{font-size:.938em;line-height:1.5em}#wootric-modal #wootric-text{max-height:53px}.wootric-text--rtl{border-radius:0px 4px 4px 0px !important}@-moz-document url-prefix(){#wootric-modal .wootric-submit{padding:16px;padding-bottom:17px}}#wootric-modal ::-webkit-input-placeholder{font-weight:normal}#wootric-modal .wootric-explain{font-size:.8em}#wootric-modal .wootric-share-wrapper p{font-size:.9em;max-width:none}#wootric-modal .wootric-share-wrapper span{cursor:pointer;display:flex;opacity:1}#wootric-modal .wootric-share-wrapper span:hover{opacity:1}#wootric-modal .wootric-share-wrapper span:not(.decline) label{display:none}#wootric-modal .wootric-share-wrapper span:not(.decline) i{font-size:1.5em}#wootric-modal .wootric-share-wrapper span.decline{font-size:.875em}#wootric-modal .wootric-footer{color:#253746;display:block;font-size:.75em;padding-bottom:10px}#wootric-modal .wootric-powered-by{display:inline-block;font-weight:500}#wootric-modal .wootric-opt-out-wrapper,#wootric-modal .wootric-feedback-disclaimer-wrapper{display:none !important}#wootric-modal .wootric-separator{display:inline-block;margin:0 5px}#wootric-modal .wootric-opt-out{cursor:pointer;display:inline-block}#wootric-modal .wootric-feedback-disclaimer{display:inline-block}#wootric-modal .wootric-opt-out-message,#wootric-modal .wootric-feedback-disclaimer-message{margin-bottom:30px}#wootric-modal .wootric-powered-by .wootric-link,#wootric-modal .wootric-feedback-disclaimer .wootric-disclaimer-link{color:#253746 !important;font-weight:600;text-decoration:none}#wootric-modal .wootric-powered-by .wootric-link:hover,#wootric-modal .wootric-feedback-disclaimer .wootric-disclaimer-link:hover{color:#253746 !important}#wootric-modal .wootric-twitter-button{align-items:center;background-color:#115d8d;border-radius:4px;color:#fff;display:flex;font-size:1em !important;height:36px;justify-content:center;margin:3px !important;padding:7px 16px}#wootric-modal .wootric-twitter-button:hover{background-color:#0c7abf}#wootric-modal .wootric-like-button{align-items:center;background:#395693;border-radius:4px;color:#fff;display:flex;font-size:1em !important;height:36px;justify-content:center;margin:3px !important;padding:7px 16px}#wootric-modal .wootric-like-button:hover{background:#213a6f;cursor:pointer}#wootric-modal .wootric-thank-you-button-outline{align-items:center;border:1px solid !important;border-radius:4px;display:flex;font-family:Arial,sans-serif;font-size:.875em !important;height:36px;justify-content:center;margin:3px !important;padding:7px 16px}#wootric-modal .wootric-thank-you-button-outline:hover{background:#e9ebed !important;border:1px solid #0058ff !important;color:#0058ff !important;cursor:pointer}#wootric-modal .wootric-no-thanks-button{align-items:center;border:1px solid;border-radius:4px;display:flex;font-family:Arial,sans-serif;font-size:.875em !important;height:36px;justify-content:center;margin:3px !important;padding:7px 16px}#wootric-modal .wootric-no-thanks-button:hover{cursor:pointer}#wootric-modal div{font-family:Arial,sans-serif;text-align:center}#wootric-modal.compact .thanks{padding:0 0 10px 0}#wootric-modal .thanks{color:#7da52d;font-weight:600;padding:15px 0}#wootric-modal .wootric-followup{color:#253746;font-size:.875em;padding:0 0 .7em}#wootric-modal .wootric-followup p{font-size:.875em !important}#wootric-modal .wootric-followup-btns{display:flex;flex-wrap:wrap;justify-content:center;margin-bottom:1em}#wootric-modal .wootric-followup-btns__row{display:flex}#wootric-modal .wootric-followup-btns input{margin:0}#wootric-modal.dark #wootric-text::placeholder{color:#f4f5f6}#wootric-modal.dark .wootric-powered-by,#wootric-modal.dark .wootric-feedback-disclaimer{color:#dadada !important}#wootric-modal.dark .wootric-powered-by .wootric-link,#wootric-modal.dark .wootric-opt-out,#wootric-modal.dark .wootric-separator,#wootric-modal.dark .wootric-feedback-disclaimer .wootric-disclaimer-link{color:#dadada !important}#wootric-modal.dark .wootric-no-thanks-button,#wootric-modal.dark .wootric-no-thanks-button-outline{background:rgba(0,0,0,0) !important;border-color:#fff !important;color:#fff !important}#wootric-modal.dark .wootric-no-thanks-button:hover,#wootric-modal.dark .wootric-no-thanks-button-outline:hover{background:#b4b4b4 !important}#wootric-modal.light .wootric-no-thanks-button,#wootric-modal.light .wootric-no-thanks-button-outline{background:rgba(0,0,0,0);border-color:#253746;color:#253746}#wootric-modal.light .wootric-no-thanks-button:hover,#wootric-modal.light .wootric-no-thanks-button-outline:hover{background:#e9ebed}#wootric-modal.dark .wootric-thank-you-button-outline{background:#0058ff !important;border-color:#fff !important;color:#fff !important}#wootric-modal.dark .wootric-thank-you-button-outline:hover{background:#80acff !important}#wootric-modal.light .wootric-thank-you-button-outline{background:rgba(0,0,0,0);border-color:#0058ff;color:#0058ff}#wootric-modal.light .wootric-thank-you-button-outline:hover{background:#b3cdff}#wootric-modal .wootric-beacon-parent{-moz-box-shadow:0 0 28px rgba(0,0,0,.1);background-color:#fff;border-color:#e9ebed !important;box-shadow:0 0 28px rgba(0,0,0,.1);color:#253746}#wootric-modal .wootric-beacon-parent #wootric-question p{color:#253746;font-weight:600;max-width:none}#wootric-modal.dark .wootric-beacon-parent{-moz-box-shadow:0 0 28px rgba(0,0,0,.28);background-color:#253746;border-color:#465562;box-shadow:0 0 28px rgba(0,0,0,.28);color:#dadada}#wootric-modal.dark .wootric-beacon-parent #wootric-question p{color:#dadada}#wootric-modal #wootric-thanks p{color:#253746;font-weight:600;max-width:none}#wootric-modal.dark #wootric-thanks p{color:#dadada;font-weight:600}#wootric-modal #wootric-close{border:1px solid #dadada}#wootric-modal #wootric-close:focus,#wootric-modal #wootric-close:hover{background-color:#dadada;color:#253746}#wootric-modal.dark #wootric-close{border-color:#fff !important;border-style:solid;border-width:1px}#wootric-modal.dark #wootric-close:focus,#wootric-modal.dark #wootric-close:hover{background-color:#dadada !important;color:#253746 !important}#wootric-modal li{border:1px solid #dadada}#driver-picklist{display:inline-block}#driver-picklist.wootric-modal-hidden{display:none}#picklist{display:flex !important;flex-direction:row;flex-wrap:wrap;justify-content:center !important;line-height:unset !important;max-width:100% !important}#picklist li{background:#fff;border:1px solid #dadada;border-radius:4px;color:#253746;font-family:Arial,sans-serif;font-style:unset;margin:0 4px 12px !important;padding:8px 10px !important}#picklist li.selected{background-color:#fff !important;border:1px solid !important;border-color:#0058ff;color:#0058ff !important}#picklist li:hover{background:rgba(0,88,255,.06) !important}#wootric-modal.dark li{border-color:#fff !important;border-style:solid;border-width:1px;color:#fff !important}#wootric-modal #wootric-score li:focus,#wootric-modal #wootric-score li:hover{background:#ccdeff;color:#253746 !important}#wootric-modal.dark li.selected{color:#253746 !important}#wootric-modal.dark li:focus,#wootric-modal.dark li:hover{color:#253746}#wootric-modal.dark li:focus:not(.selected),#wootric-modal.dark li:hover:not(.selected){background:#ccdeff}#wootric-modal.dark #close-icon{stroke:#fff !important}#wootric-modal.dark #wootric-close:hover #close-icon{stroke:#6c6c6c !important}#wootric-modal.dark #picklist{display:flex !important;flex-direction:row;flex-wrap:wrap;justify-content:center !important;line-height:unset !important;max-width:100% !important}#wootric-modal.dark #picklist li{background:unset;border:1px solid #fff;border-radius:4px;color:#fff}#wootric-modal.dark #picklist li.selected{background-color:#b3cdff !important;border:1px solid #ccdeff !important;color:#253746 !important}#wootric-modal.dark #picklist li:hover{background-color:rgba(179,205,255,.2) !important;border:1px solid #ccdeff !important;color:#fff !important}#wootric-modal label{color:#66737e}#wootric-modal.dark label{color:#fff}#wootric-modal textarea{color:#253746;background-color:#fff;border:1px solid #253746}#wootric-modal.dark textarea{color:#dadada;background-color:#253746;border:1px solid #dadada}#wootric-modal .wootric-share-wrapper p{color:#253746}#wootric-modal.dark .wootric-share-wrapper p{color:#fff}#wootric-modal.dark [class^=icon-],#wootric-modal.dark [class*=" icon-"]{color:#777}#wootric-modal.dark [class^=icon-]:hover,#wootric-modal.dark [class*=" icon-"]:hover{color:#b9b9b9}#wootric-modal.light [class^=icon-],#wootric-modal.light [class*=" icon-"]{color:#fff}#wootric-modal.light [class^=icon-]:hover,#wootric-modal.light [class*=" icon-"]:hover{color:#fff}#wootric-modal #wootric-share #wootric-social-link{display:inline-block}#wootric-modal #wootric-share #wootric-decline{display:inline-block}#wootric-modal .twitter-icon{fill:#fff;flex:none;flex-grow:0;height:30;margin-right:0;order:0;width:27px}#wootric-modal .fb-icon{fill:#fff;flex:none;flex-grow:0;height:30;margin-right:4px;order:0;width:19px}#wootric-modal .wootric-offscreen{clip:rect(1px 1px 1px 1px);clip:rect(1px, 1px, 1px, 1px);height:1px;overflow:hidden;position:absolute;white-space:nowrap;width:1px}#wootric-extra-question{margin-bottom:10px}#wootric-extra-question #wootric-extra-label{color:#253746;font-weight:600;margin-bottom:5px}#wootric-extra-question .wootric-select{background:rgba(0,0,0,0);border:1px solid #dadada;border-right:none;border-radius:3px;display:inline-block;height:35px;margin:15px 0;padding:6px 10px;position:relative;top:-1.25px}#wootric-extra-question .wootric-select select{background:rgba(0,0,0,0);border:0;bottom:100%;cursor:pointer;font-size:.875em;margin:0 auto;text-align:left;top:0px;width:280px;z-index:1}#wootric-extra-question .wootric-select-toggle{width:25px;margin:0;position:absolute;right:5px}#wootric-extra-question #wootric-extra-submit{border-radius:0 4px 4px 0;border:1px solid #dadada;color:#fff;cursor:pointer;height:35px;font-size:.875em;line-height:1.125em;margin-left:-3px;padding:2px 18px 2px;text-transform:uppercase}#wootric-modal.light #wootric-extra-submit{background:#253746}#wootric-modal.light .wootric-select select{color:#253746}#wootric-modal.dark #wootric-extra-submit{background:#66737e}#wootric-modal.dark .wootric-select select{color:#dadada}#wootric-modal.dark .wootric-select select option{background-color:#253746}#wootric-extra-submit:hover{background:#465562 !important}#wootric-share-feedback{margin:-13px 0 -2px 0}#wootric-share-feedback p{font-size:.875em;margin:5px 0 16px 0}#wootric-share-feedback #wootric-feedback-grant{appearance:checkbox;-ms-appearance:checkbox;-webkit-appearance:checkbox;-moz-appearance:checkbox;transform:scale(1.2);-ms-transform:scale(1.2);-moz-transform:scale(1.2);-webkit-transform:scale(1.2);margin-right:6px}#wootric-modal.light .wootric-share-feedback p{color:#253746}#wootric-modal.dark .wootric-share-feedback p{color:#dadada}.wootric-open-ended-modal #wootric-not-likely-label,.wootric-open-ended-modal #wootric-likely-label{display:none !important}.wootric-powered-by--disabled .wootric-powered-by{display:none !important}.wootric-score--nps.wootric-score--gradient li{color:#fff !important;color:#fff !important;color:#fff !important;color:#fff !important;color:#fff !important;color:#fff !important;color:#fff !important;color:#fff !important;color:#fff !important;color:#fff !important;color:#fff !important}.wootric-score--nps.wootric-score--gradient li:nth-child(1){background:#f50028;border-color:#f50028 !important}.wootric-score--nps.wootric-score--gradient li:nth-child(1):hover,.wootric-score--nps.wootric-score--gradient li:nth-child(1).selected{background:#ff294c !important}.wootric-score--nps.wootric-score--gradient li:nth-child(2){background:#fc083e;border-color:#fc083e !important}.wootric-score--nps.wootric-score--gradient li:nth-child(2):hover,.wootric-score--nps.wootric-score--gradient li:nth-child(2).selected{background:#fd3a65 !important}.wootric-score--nps.wootric-score--gradient li:nth-child(3){background:#fc4e3f;border-color:#fc4e3f !important}.wootric-score--nps.wootric-score--gradient li:nth-child(3):hover,.wootric-score--nps.wootric-score--gradient li:nth-child(3).selected{background:#fd7c71 !important}.wootric-score--nps.wootric-score--gradient li:nth-child(4){background:#fc7d3b;border-color:#fc7d3b !important}.wootric-score--nps.wootric-score--gradient li:nth-child(4):hover,.wootric-score--nps.wootric-score--gradient li:nth-child(4).selected{background:#fd9e6d !important}.wootric-score--nps.wootric-score--gradient li:nth-child(5){background:#fca43b;border-color:#fca43b !important}.wootric-score--nps.wootric-score--gradient li:nth-child(5):hover,.wootric-score--nps.wootric-score--gradient li:nth-child(5).selected{background:#fdbb6d !important}.wootric-score--nps.wootric-score--gradient li:nth-child(6){background:#fdc621;border-color:#fdc621 !important}.wootric-score--nps.wootric-score--gradient li:nth-child(6):hover,.wootric-score--nps.wootric-score--gradient li:nth-child(6).selected{background:#fdd354 !important}.wootric-score--nps.wootric-score--gradient li:nth-child(7){background:#e2ca25;border-color:#e2ca25 !important}.wootric-score--nps.wootric-score--gradient li:nth-child(7):hover,.wootric-score--nps.wootric-score--gradient li:nth-child(7).selected{background:#e8d552 !important}.wootric-score--nps.wootric-score--gradient li:nth-child(8){background:#bad426;border-color:#bad426 !important}.wootric-score--nps.wootric-score--gradient li:nth-child(8):hover,.wootric-score--nps.wootric-score--gradient li:nth-child(8).selected{background:#c9df4e !important}.wootric-score--nps.wootric-score--gradient li:nth-child(9){background:#8dd72b;border-color:#8dd72b !important}.wootric-score--nps.wootric-score--gradient li:nth-child(9):hover,.wootric-score--nps.wootric-score--gradient li:nth-child(9).selected{background:#a4df56 !important}.wootric-score--nps.wootric-score--gradient li:nth-child(10){background:#5bd82b;border-color:#5bd82b !important}.wootric-score--nps.wootric-score--gradient li:nth-child(10):hover,.wootric-score--nps.wootric-score--gradient li:nth-child(10).selected{background:#7ce056 !important}.wootric-score--nps.wootric-score--gradient li:nth-child(11){background:#24b928;border-color:#24b928 !important}.wootric-score--nps.wootric-score--gradient li:nth-child(11):hover,.wootric-score--nps.wootric-score--gradient li:nth-child(11).selected{background:#38d83c !important}.wootric-score--ces.wootric-score--gradient li{color:#fff !important;color:#fff !important;color:#fff !important;color:#fff !important;color:#fff !important;color:#fff !important;color:#fff !important}.wootric-score--ces.wootric-score--gradient li:nth-child(2){background:#f50028;border-color:#f50028 !important}.wootric-score--ces.wootric-score--gradient li:nth-child(2):hover,.wootric-score--ces.wootric-score--gradient li:nth-child(2).selected{background:#ff294c !important}.wootric-score--ces.wootric-score--gradient li:nth-child(3){background:#fc4e3f;border-color:#fc4e3f !important}.wootric-score--ces.wootric-score--gradient li:nth-child(3):hover,.wootric-score--ces.wootric-score--gradient li:nth-child(3).selected{background:#fd7c71 !important}.wootric-score--ces.wootric-score--gradient li:nth-child(4){background:#fc7d3b;border-color:#fc7d3b !important}.wootric-score--ces.wootric-score--gradient li:nth-child(4):hover,.wootric-score--ces.wootric-score--gradient li:nth-child(4).selected{background:#fd9e6d !important}.wootric-score--ces.wootric-score--gradient li:nth-child(5){background:#fdc621;border-color:#fdc621 !important}.wootric-score--ces.wootric-score--gradient li:nth-child(5):hover,.wootric-score--ces.wootric-score--gradient li:nth-child(5).selected{background:#fdd354 !important}.wootric-score--ces.wootric-score--gradient li:nth-child(6){background:#bad426;border-color:#bad426 !important}.wootric-score--ces.wootric-score--gradient li:nth-child(6):hover,.wootric-score--ces.wootric-score--gradient li:nth-child(6).selected{background:#c9df4e !important}.wootric-score--ces.wootric-score--gradient li:nth-child(7){background:#5bd82b;border-color:#5bd82b !important}.wootric-score--ces.wootric-score--gradient li:nth-child(7):hover,.wootric-score--ces.wootric-score--gradient li:nth-child(7).selected{background:#7ce056 !important}.wootric-score--ces.wootric-score--gradient li:nth-child(8){background:#24b928;border-color:#24b928 !important}.wootric-score--ces.wootric-score--gradient li:nth-child(8):hover,.wootric-score--ces.wootric-score--gradient li:nth-child(8).selected{background:#38d83c !important}.wootric-score--csat.wootric-score--gradient li{color:#fff !important;color:#fff !important;color:#fff !important;color:#fff !important;color:#fff !important}.wootric-score--csat.wootric-score--gradient li:nth-child(2){background:#f50028;border-color:#f50028 !important}.wootric-score--csat.wootric-score--gradient li:nth-child(2):hover,.wootric-score--csat.wootric-score--gradient li:nth-child(2).selected{background:#ff294c !important}.wootric-score--csat.wootric-score--gradient li:nth-child(3){background:#fc7d3b;border-color:#fc7d3b !important}.wootric-score--csat.wootric-score--gradient li:nth-child(3):hover,.wootric-score--csat.wootric-score--gradient li:nth-child(3).selected{background:#fd9e6d !important}.wootric-score--csat.wootric-score--gradient li:nth-child(4){background:#fdc621;border-color:#fdc621 !important}.wootric-score--csat.wootric-score--gradient li:nth-child(4):hover,.wootric-score--csat.wootric-score--gradient li:nth-child(4).selected{background:#fdd354 !important}.wootric-score--csat.wootric-score--gradient li:nth-child(5){background:#bad426;border-color:#bad426 !important}.wootric-score--csat.wootric-score--gradient li:nth-child(5):hover,.wootric-score--csat.wootric-score--gradient li:nth-child(5).selected{background:#c9df4e !important}.wootric-score--csat.wootric-score--gradient li:nth-child(6){background:#24b928;border-color:#24b928 !important}.wootric-score--csat.wootric-score--gradient li:nth-child(6):hover,.wootric-score--csat.wootric-score--gradient li:nth-child(6).selected{background:#38d83c !important}.wootric-score--csat_custom.wootric-score--gradient li{color:#fff !important;color:#fff !important;color:#fff !important;color:#fff !important;color:#fff !important;color:#fff !important;color:#fff !important;color:#fff !important;color:#fff !important;color:#fff !important}.wootric-score--csat_custom.wootric-score--gradient li:nth-child(2){background:#f50028;border-color:#f50028 !important}.wootric-score--csat_custom.wootric-score--gradient li:nth-child(2):hover,.wootric-score--csat_custom.wootric-score--gradient li:nth-child(2).selected{background:#ff294c !important}.wootric-score--csat_custom.wootric-score--gradient li:nth-child(3){background:#fc4e3f;border-color:#fc4e3f !important}.wootric-score--csat_custom.wootric-score--gradient li:nth-child(3):hover,.wootric-score--csat_custom.wootric-score--gradient li:nth-child(3).selected{background:#fd7c71 !important}.wootric-score--csat_custom.wootric-score--gradient li:nth-child(4){background:#fc7d3b;border-color:#fc7d3b !important}.wootric-score--csat_custom.wootric-score--gradient li:nth-child(4):hover,.wootric-score--csat_custom.wootric-score--gradient li:nth-child(4).selected{background:#fd9e6d !important}.wootric-score--csat_custom.wootric-score--gradient li:nth-child(5){background:#fca43b;border-color:#fca43b !important}.wootric-score--csat_custom.wootric-score--gradient li:nth-child(5):hover,.wootric-score--csat_custom.wootric-score--gradient li:nth-child(5).selected{background:#fdbb6d !important}.wootric-score--csat_custom.wootric-score--gradient li:nth-child(6){background:#fdc621;border-color:#fdc621 !important}.wootric-score--csat_custom.wootric-score--gradient li:nth-child(6):hover,.wootric-score--csat_custom.wootric-score--gradient li:nth-child(6).selected{background:#fdd354 !important}.wootric-score--csat_custom.wootric-score--gradient li:nth-child(7){background:#e2ca25;border-color:#e2ca25 !important}.wootric-score--csat_custom.wootric-score--gradient li:nth-child(7):hover,.wootric-score--csat_custom.wootric-score--gradient li:nth-child(7).selected{background:#e8d552 !important}.wootric-score--csat_custom.wootric-score--gradient li:nth-child(8){background:#bad426;border-color:#bad426 !important}.wootric-score--csat_custom.wootric-score--gradient li:nth-child(8):hover,.wootric-score--csat_custom.wootric-score--gradient li:nth-child(8).selected{background:#c9df4e !important}.wootric-score--csat_custom.wootric-score--gradient li:nth-child(9){background:#8dd72b;border-color:#8dd72b !important}.wootric-score--csat_custom.wootric-score--gradient li:nth-child(9):hover,.wootric-score--csat_custom.wootric-score--gradient li:nth-child(9).selected{background:#a4df56 !important}.wootric-score--csat_custom.wootric-score--gradient li:nth-child(10){background:#5bd82b;border-color:#5bd82b !important}.wootric-score--csat_custom.wootric-score--gradient li:nth-child(10):hover,.wootric-score--csat_custom.wootric-score--gradient li:nth-child(10).selected{background:#7ce056 !important}.wootric-score--csat_custom.wootric-score--gradient li:nth-child(11){background:#24b928;border-color:#24b928 !important}.wootric-score--csat_custom.wootric-score--gradient li:nth-child(11):hover,.wootric-score--csat_custom.wootric-score--gradient li:nth-child(11).selected{background:#38d83c !important}.wootric-score--csat_custom_2.wootric-score--gradient li{color:#fff !important;color:#fff !important;color:#fff !important;color:#fff !important;color:#fff !important;color:#fff !important;color:#fff !important}.wootric-score--csat_custom_2.wootric-score--gradient li:nth-child(2){background:#f50028;border-color:#f50028 !important}.wootric-score--csat_custom_2.wootric-score--gradient li:nth-child(2):hover,.wootric-score--csat_custom_2.wootric-score--gradient li:nth-child(2).selected{background:#ff294c !important}.wootric-score--csat_custom_2.wootric-score--gradient li:nth-child(3){background:#fc4e3f;border-color:#fc4e3f !important}.wootric-score--csat_custom_2.wootric-score--gradient li:nth-child(3):hover,.wootric-score--csat_custom_2.wootric-score--gradient li:nth-child(3).selected{background:#fd7c71 !important}.wootric-score--csat_custom_2.wootric-score--gradient li:nth-child(4){background:#fc7d3b;border-color:#fc7d3b !important}.wootric-score--csat_custom_2.wootric-score--gradient li:nth-child(4):hover,.wootric-score--csat_custom_2.wootric-score--gradient li:nth-child(4).selected{background:#fd9e6d !important}.wootric-score--csat_custom_2.wootric-score--gradient li:nth-child(5){background:#fdc621;border-color:#fdc621 !important}.wootric-score--csat_custom_2.wootric-score--gradient li:nth-child(5):hover,.wootric-score--csat_custom_2.wootric-score--gradient li:nth-child(5).selected{background:#fdd354 !important}.wootric-score--csat_custom_2.wootric-score--gradient li:nth-child(6){background:#bad426;border-color:#bad426 !important}.wootric-score--csat_custom_2.wootric-score--gradient li:nth-child(6):hover,.wootric-score--csat_custom_2.wootric-score--gradient li:nth-child(6).selected{background:#c9df4e !important}.wootric-score--csat_custom_2.wootric-score--gradient li:nth-child(7){background:#5bd82b;border-color:#5bd82b !important}.wootric-score--csat_custom_2.wootric-score--gradient li:nth-child(7):hover,.wootric-score--csat_custom_2.wootric-score--gradient li:nth-child(7).selected{background:#7ce056 !important}.wootric-score--csat_custom_2.wootric-score--gradient li:nth-child(8){background:#24b928;border-color:#24b928 !important}.wootric-score--csat_custom_2.wootric-score--gradient li:nth-child(8):hover,.wootric-score--csat_custom_2.wootric-score--gradient li:nth-child(8).selected{background:#38d83c !important}.wootric-score--nps.wootric-score--three-color li{color:#fff !important;color:#fff !important;color:#fff !important;color:#fff !important;color:#fff !important;color:#fff !important;color:#fff !important;color:#fff !important;color:#fff !important;color:#fff !important;color:#fff !important}.wootric-score--nps.wootric-score--three-color li:nth-child(1){background:#ae2e29;border-color:#ae2e29 !important}.wootric-score--nps.wootric-score--three-color li:nth-child(1):hover,.wootric-score--nps.wootric-score--three-color li:nth-child(1).selected{background:#d03f3a !important}.wootric-score--nps.wootric-score--three-color li:nth-child(2){background:#ae2e29;border-color:#ae2e29 !important}.wootric-score--nps.wootric-score--three-color li:nth-child(2):hover,.wootric-score--nps.wootric-score--three-color li:nth-child(2).selected{background:#d03f3a !important}.wootric-score--nps.wootric-score--three-color li:nth-child(3){background:#ae2e29;border-color:#ae2e29 !important}.wootric-score--nps.wootric-score--three-color li:nth-child(3):hover,.wootric-score--nps.wootric-score--three-color li:nth-child(3).selected{background:#d03f3a !important}.wootric-score--nps.wootric-score--three-color li:nth-child(4){background:#ae2e29;border-color:#ae2e29 !important}.wootric-score--nps.wootric-score--three-color li:nth-child(4):hover,.wootric-score--nps.wootric-score--three-color li:nth-child(4).selected{background:#d03f3a !important}.wootric-score--nps.wootric-score--three-color li:nth-child(5){background:#ae2e29;border-color:#ae2e29 !important}.wootric-score--nps.wootric-score--three-color li:nth-child(5):hover,.wootric-score--nps.wootric-score--three-color li:nth-child(5).selected{background:#d03f3a !important}.wootric-score--nps.wootric-score--three-color li:nth-child(6){background:#ae2e29;border-color:#ae2e29 !important}.wootric-score--nps.wootric-score--three-color li:nth-child(6):hover,.wootric-score--nps.wootric-score--three-color li:nth-child(6).selected{background:#d03f3a !important}.wootric-score--nps.wootric-score--three-color li:nth-child(7){background:#ae2e29;border-color:#ae2e29 !important}.wootric-score--nps.wootric-score--three-color li:nth-child(7):hover,.wootric-score--nps.wootric-score--three-color li:nth-child(7).selected{background:#d03f3a !important}.wootric-score--nps.wootric-score--three-color li:nth-child(8){background:#606060;border-color:#606060 !important}.wootric-score--nps.wootric-score--three-color li:nth-child(8):hover,.wootric-score--nps.wootric-score--three-color li:nth-child(8).selected{background:#7a7a7a !important}.wootric-score--nps.wootric-score--three-color li:nth-child(9){background:#606060;border-color:#606060 !important}.wootric-score--nps.wootric-score--three-color li:nth-child(9):hover,.wootric-score--nps.wootric-score--three-color li:nth-child(9).selected{background:#7a7a7a !important}.wootric-score--nps.wootric-score--three-color li:nth-child(10){background:#147255;border-color:#147255 !important}.wootric-score--nps.wootric-score--three-color li:nth-child(10):hover,.wootric-score--nps.wootric-score--three-color li:nth-child(10).selected{background:#1c9d75 !important}.wootric-score--nps.wootric-score--three-color li:nth-child(11){background:#147255;border-color:#147255 !important}.wootric-score--nps.wootric-score--three-color li:nth-child(11):hover,.wootric-score--nps.wootric-score--three-color li:nth-child(11).selected{background:#1c9d75 !important}.wootric-score--ces.wootric-score--three-color li{color:#fff !important;color:#fff !important;color:#fff !important;color:#fff !important;color:#fff !important;color:#fff !important;color:#fff !important}.wootric-score--ces.wootric-score--three-color li:nth-child(2){background:#ae2e29;border-color:#ae2e29 !important}.wootric-score--ces.wootric-score--three-color li:nth-child(2):hover,.wootric-score--ces.wootric-score--three-color li:nth-child(2).selected{background:#d03f3a !important}.wootric-score--ces.wootric-score--three-color li:nth-child(3){background:#ae2e29;border-color:#ae2e29 !important}.wootric-score--ces.wootric-score--three-color li:nth-child(3):hover,.wootric-score--ces.wootric-score--three-color li:nth-child(3).selected{background:#d03f3a !important}.wootric-score--ces.wootric-score--three-color li:nth-child(4){background:#ae2e29;border-color:#ae2e29 !important}.wootric-score--ces.wootric-score--three-color li:nth-child(4):hover,.wootric-score--ces.wootric-score--three-color li:nth-child(4).selected{background:#d03f3a !important}.wootric-score--ces.wootric-score--three-color li:nth-child(5){background:#606060;border-color:#606060 !important}.wootric-score--ces.wootric-score--three-color li:nth-child(5):hover,.wootric-score--ces.wootric-score--three-color li:nth-child(5).selected{background:#7a7a7a !important}.wootric-score--ces.wootric-score--three-color li:nth-child(6){background:#606060;border-color:#606060 !important}.wootric-score--ces.wootric-score--three-color li:nth-child(6):hover,.wootric-score--ces.wootric-score--three-color li:nth-child(6).selected{background:#7a7a7a !important}.wootric-score--ces.wootric-score--three-color li:nth-child(7){background:#147255;border-color:#147255 !important}.wootric-score--ces.wootric-score--three-color li:nth-child(7):hover,.wootric-score--ces.wootric-score--three-color li:nth-child(7).selected{background:#1c9d75 !important}.wootric-score--ces.wootric-score--three-color li:nth-child(8){background:#147255;border-color:#147255 !important}.wootric-score--ces.wootric-score--three-color li:nth-child(8):hover,.wootric-score--ces.wootric-score--three-color li:nth-child(8).selected{background:#1c9d75 !important}.wootric-score--csat.wootric-score--three-color li{color:#fff !important;color:#fff !important;color:#fff !important;color:#fff !important;color:#fff !important}.wootric-score--csat.wootric-score--three-color li:nth-child(2){background:#ae2e29;border-color:#ae2e29 !important}.wootric-score--csat.wootric-score--three-color li:nth-child(2):hover,.wootric-score--csat.wootric-score--three-color li:nth-child(2).selected{background:#d03f3a !important}.wootric-score--csat.wootric-score--three-color li:nth-child(3){background:#ae2e29;border-color:#ae2e29 !important}.wootric-score--csat.wootric-score--three-color li:nth-child(3):hover,.wootric-score--csat.wootric-score--three-color li:nth-child(3).selected{background:#d03f3a !important}.wootric-score--csat.wootric-score--three-color li:nth-child(4){background:#606060;border-color:#606060 !important}.wootric-score--csat.wootric-score--three-color li:nth-child(4):hover,.wootric-score--csat.wootric-score--three-color li:nth-child(4).selected{background:#7a7a7a !important}.wootric-score--csat.wootric-score--three-color li:nth-child(5){background:#147255;border-color:#147255 !important}.wootric-score--csat.wootric-score--three-color li:nth-child(5):hover,.wootric-score--csat.wootric-score--three-color li:nth-child(5).selected{background:#1c9d75 !important}.wootric-score--csat.wootric-score--three-color li:nth-child(6){background:#147255;border-color:#147255 !important}.wootric-score--csat.wootric-score--three-color li:nth-child(6):hover,.wootric-score--csat.wootric-score--three-color li:nth-child(6).selected{background:#1c9d75 !important}.wootric-score--csat_custom.wootric-score--three-color li{color:#fff !important;color:#fff !important;color:#fff !important;color:#fff !important;color:#fff !important;color:#fff !important;color:#fff !important;color:#fff !important;color:#fff !important;color:#fff !important}.wootric-score--csat_custom.wootric-score--three-color li:nth-child(2){background:#ae2e29;border-color:#ae2e29 !important}.wootric-score--csat_custom.wootric-score--three-color li:nth-child(2):hover,.wootric-score--csat_custom.wootric-score--three-color li:nth-child(2).selected{background:#d03f3a !important}.wootric-score--csat_custom.wootric-score--three-color li:nth-child(3){background:#ae2e29;border-color:#ae2e29 !important}.wootric-score--csat_custom.wootric-score--three-color li:nth-child(3):hover,.wootric-score--csat_custom.wootric-score--three-color li:nth-child(3).selected{background:#d03f3a !important}.wootric-score--csat_custom.wootric-score--three-color li:nth-child(4){background:#ae2e29;border-color:#ae2e29 !important}.wootric-score--csat_custom.wootric-score--three-color li:nth-child(4):hover,.wootric-score--csat_custom.wootric-score--three-color li:nth-child(4).selected{background:#d03f3a !important}.wootric-score--csat_custom.wootric-score--three-color li:nth-child(5){background:#ae2e29;border-color:#ae2e29 !important}.wootric-score--csat_custom.wootric-score--three-color li:nth-child(5):hover,.wootric-score--csat_custom.wootric-score--three-color li:nth-child(5).selected{background:#d03f3a !important}.wootric-score--csat_custom.wootric-score--three-color li:nth-child(6){background:#ae2e29;border-color:#ae2e29 !important}.wootric-score--csat_custom.wootric-score--three-color li:nth-child(6):hover,.wootric-score--csat_custom.wootric-score--three-color li:nth-child(6).selected{background:#d03f3a !important}.wootric-score--csat_custom.wootric-score--three-color li:nth-child(7){background:#ae2e29;border-color:#ae2e29 !important}.wootric-score--csat_custom.wootric-score--three-color li:nth-child(7):hover,.wootric-score--csat_custom.wootric-score--three-color li:nth-child(7).selected{background:#d03f3a !important}.wootric-score--csat_custom.wootric-score--three-color li:nth-child(8){background:#606060;border-color:#606060 !important}.wootric-score--csat_custom.wootric-score--three-color li:nth-child(8):hover,.wootric-score--csat_custom.wootric-score--three-color li:nth-child(8).selected{background:#7a7a7a !important}.wootric-score--csat_custom.wootric-score--three-color li:nth-child(9){background:#606060;border-color:#606060 !important}.wootric-score--csat_custom.wootric-score--three-color li:nth-child(9):hover,.wootric-score--csat_custom.wootric-score--three-color li:nth-child(9).selected{background:#7a7a7a !important}.wootric-score--csat_custom.wootric-score--three-color li:nth-child(10){background:#147255;border-color:#147255 !important}.wootric-score--csat_custom.wootric-score--three-color li:nth-child(10):hover,.wootric-score--csat_custom.wootric-score--three-color li:nth-child(10).selected{background:#1c9d75 !important}.wootric-score--csat_custom.wootric-score--three-color li:nth-child(11){background:#147255;border-color:#147255 !important}.wootric-score--csat_custom.wootric-score--three-color li:nth-child(11):hover,.wootric-score--csat_custom.wootric-score--three-color li:nth-child(11).selected{background:#1c9d75 !important}.wootric-score--csat_custom_2.wootric-score--three-color li{color:#fff !important;color:#fff !important;color:#fff !important;color:#fff !important;color:#fff !important;color:#fff !important;color:#fff !important}.wootric-score--csat_custom_2.wootric-score--three-color li:nth-child(2){background:#ae2e29;border-color:#ae2e29 !important}.wootric-score--csat_custom_2.wootric-score--three-color li:nth-child(2):hover,.wootric-score--csat_custom_2.wootric-score--three-color li:nth-child(2).selected{background:#d03f3a !important}.wootric-score--csat_custom_2.wootric-score--three-color li:nth-child(3){background:#ae2e29;border-color:#ae2e29 !important}.wootric-score--csat_custom_2.wootric-score--three-color li:nth-child(3):hover,.wootric-score--csat_custom_2.wootric-score--three-color li:nth-child(3).selected{background:#d03f3a !important}.wootric-score--csat_custom_2.wootric-score--three-color li:nth-child(4){background:#ae2e29;border-color:#ae2e29 !important}.wootric-score--csat_custom_2.wootric-score--three-color li:nth-child(4):hover,.wootric-score--csat_custom_2.wootric-score--three-color li:nth-child(4).selected{background:#d03f3a !important}.wootric-score--csat_custom_2.wootric-score--three-color li:nth-child(5){background:#606060;border-color:#606060 !important}.wootric-score--csat_custom_2.wootric-score--three-color li:nth-child(5):hover,.wootric-score--csat_custom_2.wootric-score--three-color li:nth-child(5).selected{background:#7a7a7a !important}.wootric-score--csat_custom_2.wootric-score--three-color li:nth-child(6){background:#606060;border-color:#606060 !important}.wootric-score--csat_custom_2.wootric-score--three-color li:nth-child(6):hover,.wootric-score--csat_custom_2.wootric-score--three-color li:nth-child(6).selected{background:#7a7a7a !important}.wootric-score--csat_custom_2.wootric-score--three-color li:nth-child(7){background:#147255;border-color:#147255 !important}.wootric-score--csat_custom_2.wootric-score--three-color li:nth-child(7):hover,.wootric-score--csat_custom_2.wootric-score--three-color li:nth-child(7).selected{background:#1c9d75 !important}.wootric-score--csat_custom_2.wootric-score--three-color li:nth-child(8){background:#147255;border-color:#147255 !important}.wootric-score--csat_custom_2.wootric-score--three-color li:nth-child(8):hover,.wootric-score--csat_custom_2.wootric-score--three-color li:nth-child(8).selected{background:#1c9d75 !important}#wootric-modal.custom-colors .wootric-submit,#wootric-modal.custom-colors .wootric-thank-you-button-outline{border:1px solid var(--secondary-color-border) !important}#wootric-modal.custom-colors li.selected:hover{background-color:var(--hover-selected-background-color) !important;border:1px solid var(--hover-selected-border-color) !important;color:var(--hover-selected-font-color) !important}#wootric-modal.custom-colors .wootric-submit,#wootric-modal.custom-colors .wootric-thank-you-button-outline,#wootric-modal.custom-colors #wootric-share,#wootric-modal.custom-colors #wootric-submit-dpl,#wootric-modal.custom-colors #wootric-social-link{background:var(--secondary-color) !important;color:var(--secondary-font-color) !important}#wootric-modal.custom-colors #wootric-feedback-grant{color:var(--accent-color) !important}#wootric-modal.custom-colors .wootric-submit:hover,#wootric-modal.custom-colors #wootric-share:hover,#wootric-modal.custom-colors .wootric-thank-you-button-outline:hover,#wootric-modal.custom-colors #wootric-submit-dpl:hover,#wootric-modal.custom-colors #wootric-social-link:hover{background:var(--secondary-color-hover) !important}#wootric-modal.custom-colors #wootric-text:focus,#wootric-modal.custom-colors #driver-picklist:focus{box-shadow:0 0 0 .25em var(--secondary-color)}#wootric-modal.custom-colors #wootric-score li:hover,#wootric-modal.custom-colors #driver-picklist li:hover,#wootric-modal.custom-colors li:hover{background-color:var(--hover-background-color) !important;border:1px solid var(--hover-border-color) !important;color:var(--hover-font-color) !important}#wootric-modal.custom-colors li{background-color:var(--background-color) !important;border:1px solid var(--border-color) !important;color:var(--font-color) !important}#wootric-modal.custom-colors li.selected{background-color:var(--primary-color) !important;border:1px solid var(--default-border-color) !important;color:var(--default-font-color) !important}#wootric-modal.custom-colors .shadow-box{margin:0 auto;max-width:750px;position:relative;width:60%}#wootric-modal.custom-colors #wootric-text{border-radius:.25em;width:100%}#wootric-modal.custom-colors #wootric-submit{position:absolute;right:0;top:0}#wootric-modal.custom-colors.wootric-mobile-modal .shadow-box{margin:unset;max-width:unset;position:unset;width:unset}#wootric-modal.custom-colors.wootric-mobile-modal #wootric-submit{margin-left:unset;position:unset;right:unset;top:unset}#wootric-modal.custom-colors.wootric-mobile-modal #wootric-text{width:92%}#wootric-modal.custom-colors.wootric-mobile-modal #driver-picklist li:hover,#wootric-modal.custom-colors.wootric-mobile-modal #wootric-score li:hover{background-color:var(--background-color) !important;border:1px solid var(--border-color) !important;color:var(--font-color) !important}#wootric-modal.custom-colors.wootric-mobile-modal #driver-picklist li.selected,#wootric-modal.custom-colors.wootric-mobile-modal #driver-picklist li.selected:hover,#wootric-modal.custom-colors.wootric-mobile-modal #wootric-score li.selected:hover{background-color:var(--primary-color) !important;border:1px solid var(--default-border-color) !important;color:var(--default-font-color) !important}',
                }),
                s("modules/social", ["jquery"], function (o) {
                    var t, e, r, i, n, c, a, l, s, d;
                    e = {};
                    var u = o.noConflict(!0);
                    return (
                        (t = window),
                        (l = function (o, t) {
                            (e = o.settings),
                                (s = t),
                                a(),
                                u("#wootric-twitter").click(d);
                        }),
                        (a = function () {
                            if (void 0 !== e.facebook_page) {
                                document
                                    .getElementById("wootric-facebook")
                                    .addEventListener("click", function () {
                                        return (
                                            window.open(
                                                e.facebook_page,
                                                "facebook-share-dialog",
                                                "width=800,height=600"
                                            ),
                                            !1
                                        );
                                    });
                            }
                        }),
                        (d = function () {
                            var o, a, l, d, m, p, f, w;
                            (w = 575),
                                (o = 437),
                                (a = n(w)),
                                (p = c(o)),
                                (d = []),
                                (m = u("#wootric-text", t.document).val()),
                                (m = ".@" + e.twitter_account + " " + m);
                            try {
                                d.push("text=" + encodeURIComponent(m));
                            } catch (o) {
                                console.warn(
                                    "could not parse feedback content",
                                    o
                                );
                            }
                            return (
                                d.push("url="),
                                (f = r(d)),
                                (l = i(w, o, p, a)),
                                window.open(f, "twitter", l),
                                s.closeOnClick(2e3),
                                !1
                            );
                        }),
                        (i = function (o, t, e, r) {
                            return (
                                "status=1,width=" +
                                o +
                                ",height=" +
                                t +
                                ",top=" +
                                e +
                                ",left=" +
                                r
                            );
                        }),
                        (r = function (o) {
                            var t, e, r, i, n;
                            for (
                                n = "https://twitter.com/intent/tweet",
                                    e = !0,
                                    t = 0,
                                    r = o.length;
                                t < r;
                                t++
                            )
                                (i = o[t]),
                                    e ? ((n += "?"), (e = !1)) : (n += "&"),
                                    (n += i);
                            return n;
                        }),
                        (n = function (o) {
                            return u(t).width() > o
                                ? (u(t).width() - o) / 2
                                : (window.screen.availWidth - o) / 2;
                        }),
                        (c = function (o) {
                            return u(t).height() > o
                                ? (u(t).height() - o) / 2
                                : (window.screen.availHeight - o) / 2;
                        }),
                        { initFb: a, initSocialFeatures: l, twitterTweet: d }
                    );
                }),
                s(
                    "modules/extra_question",
                    ["jquery", "./utils"],
                    function (o, t) {
                        var e = o.noConflict(!0),
                            r = function (o) {
                                for (
                                    var e = 0;
                                    e < o.extra_questions.length;
                                    e++
                                ) {
                                    var r = o.extra_questions[e];
                                    r.locales[o.language] ||
                                        (t.log(
                                            "[!] A missing translation to your extra questions has been detected.",
                                            "Falling back to English..."
                                        ),
                                        (o.language = "EN")),
                                        r.locales &&
                                            !o.language &&
                                            (t.log(
                                                "[!] Lang code required for multiple extra questions.",
                                                " Falling back to English..."
                                            ),
                                            (o.language = "EN")),
                                        a(r, o.language);
                                }
                            },
                            i = function () {
                                return e("#wootric-modal", window.document);
                            },
                            n = function (o) {
                                switch (o) {
                                    case "string":
                                        return "";
                                    case "int":
                                        return "_amount";
                                    case "date":
                                        return "_date";
                                    default:
                                        return (
                                            t.log(
                                                "[!] Undefined input_type:",
                                                o
                                            ),
                                            ""
                                        );
                                }
                            },
                            c = function () {
                                var o = { name: "", value: "" },
                                    r = i();
                                return (
                                    (o.name = r
                                        .find("#wootric-extra-question")
                                        .attr("name")),
                                    (o.value = e(
                                        "#wootric-extra-answer"
                                    ).val()),
                                    (o.name.length && o.value.length) ||
                                        t.log(
                                            "[!] Warning: parseAnswer() detected empty values..."
                                        ),
                                    o
                                );
                            },
                            a = function (o, e) {
                                switch (
                                    (i()
                                        .find("#wootric-extra-q")
                                        .text(o.locales[e].question_text),
                                    o.input_form)
                                ) {
                                    case "dropdown":
                                        l(o, e);
                                        break;
                                    default:
                                        t.log("[!] Unsupported form type");
                                }
                            },
                            l = function (o, t) {
                                var e = 1,
                                    r = o.question_id + n(o.input_type),
                                    c = i(),
                                    a = o.locales[t],
                                    l = a.button || "DONE",
                                    s = a.banner || "One last question!";
                                c
                                    .find("#wootric-extra-dropdown")
                                    .removeClass("wootric-modal-hidden"),
                                    c
                                        .find("#wootric-extra-question")
                                        .attr("name", r),
                                    c
                                        .find("#wootric-extra-submit")
                                        .attr("value", l),
                                    c.find("#wootric-extra-label").text(s);
                                for (
                                    var d = 0;
                                    d < o.locales[t].answer_options.length;
                                    d++
                                ) {
                                    var u = o.locales[t].answer_options[d],
                                        m = c.find("#answer-" + e);
                                    m.text(u),
                                        m.attr("value", u),
                                        m.removeClass("wootric-modal-hidden"),
                                        e++;
                                }
                            };
                        return {
                            build: r,
                            show: function () {
                                var o = i();
                                o
                                    .find("#wootric-extra-question")
                                    .removeClass("wootric-modal-hidden"),
                                    o
                                        .find("#wootric-fullscore")
                                        .addClass("wootric-modal-collapsed"),
                                    o
                                        .find("#wootric-thanks")
                                        .hide()
                                        .addClass("wootric-modal-hidden"),
                                    o
                                        .find("#wootric-share-feedback")
                                        .hide()
                                        .addClass("wootric-modal-hidden");
                            },
                            hide: function () {
                                var o = i();
                                o
                                    .find("#wootric-extra-question")
                                    .hide()
                                    .addClass("wootric-modal-hidden"),
                                    o
                                        .find("#wootric-thanks")
                                        .hide()
                                        .removeClass("wootric-modal-hidden"),
                                    o.find("#wootric-thanks").fadeIn();
                            },
                            parseAnswer: c,
                        };
                    }
                ),
                s(
                    "modules/survey",
                    [
                        "jquery",
                        "./visual",
                        "./cookie",
                        "./social",
                        "./utils",
                        "./extra_question",
                        "./config",
                    ],
                    function (o, t, e, r, i, n, c) {
                        var a = { driver_picklist: {} },
                            l = "",
                            s = window.document,
                            d = o.noConflict(!0),
                            u = !1,
                            m = !0,
                            p = function () {
                                d("#wootric-modal").remove();
                            },
                            f = function (o, i) {
                                var c,
                                    l,
                                    u = "wootric-powered-by";
                                if (
                                    (o.powered_by
                                        ? (u += "--enabled")
                                        : (u += "--disabled"),
                                    (c = d("<div>", {
                                        id: "wootric-modal",
                                        html: t.webBeacon,
                                        role: "dialog",
                                        "aria-label":
                                            "A feedback form has popped up.",
                                        "aria-hidden": !1,
                                        class: u,
                                    })),
                                    (l = d("<style>", { html: t.style })),
                                    l.appendTo(s.head),
                                    c.appendTo(s.body),
                                    (a = zo(o, i)),
                                    "left" ===
                                        a.settings.wootric_close_position &&
                                        (d("#wootric-close").removeClass(
                                            "wootric-close-right"
                                        ),
                                        d("#wootric-close").addClass(
                                            "wootric-close-left"
                                        )),
                                    o.sampling_group &&
                                        (a.belongs_to_sampling_group =
                                            o.sampling_group.belongs_to_sampling_group),
                                    o.survey_template &&
                                        (a.survey_template = o.survey_template),
                                    (s.config = a),
                                    (window.Wootric = ko(o, window.Wootric)),
                                    r.initSocialFeatures(a, this),
                                    d("#wootric-form", s.body).css({
                                        zIndex: Y() + 1,
                                    }),
                                    a.aria
                                        ? c.addClass("wootric-aria")
                                        : d(
                                              "#wootric-modal *[tabindex]",
                                              s.body
                                          ).removeAttr("tabindex"),
                                    w() &&
                                        (d(
                                            "#wootric-feedback-disclaimer-wrapper"
                                        ).removeClass("wootric-modal-hidden"),
                                        d(
                                            "#wootric-feedback-disclaimer-text"
                                        ).text(a.settings.disclaimer.text),
                                        d("#wootric-disclaimer-link").text(
                                            a.settings.disclaimer.link_word
                                        ),
                                        d("#wootric-disclaimer-link").attr(
                                            "href",
                                            a.settings.disclaimer.link
                                        )),
                                    a.show_opt_out &&
                                        !e.read(
                                            "Wootric_opt_out-" +
                                                a.settings.account_token
                                        ) &&
                                        (d("#wootric-opt-out").text(
                                            a.localized_texts.opt_out_button
                                        ),
                                        d(
                                            "#wootric-opt-out-wrapper"
                                        ).removeClass("wootric-modal-hidden")),
                                    window.FB)
                                )
                                    E();
                                else {
                                    var m = window.fbAsyncInit;
                                    window.fbAsyncInit = function () {
                                        if ((E(), m)) return m();
                                    };
                                }
                                return (
                                    a.extra_questions.length > 0 && n.build(a),
                                    d("#wootric-form", s.body).css({
                                        zIndex: Y() + 1,
                                    })
                                );
                            },
                            w = function () {
                                return (
                                    a.settings.disclaimer &&
                                    a.settings.disclaimer.text &&
                                    a.settings.disclaimer.link &&
                                    a.settings.disclaimer.link_word
                                );
                            },
                            h = function () {
                                a.settings.survey_type &&
                                    (a.settings.survey_type =
                                        a.settings.survey_type.toLowerCase());
                                var o = {
                                        nps: [
                                            {
                                                min: 0,
                                                max: 10,
                                                negative_type_max: 6,
                                                neutral_type_max: 8,
                                            },
                                        ],
                                        ces: [
                                            {
                                                min: 1,
                                                max: 7,
                                                negative_type_max: 3,
                                                neutral_type_max: 5,
                                            },
                                        ],
                                        csat: [
                                            {
                                                min: 1,
                                                max: 5,
                                                negative_type_max: 2,
                                                neutral_type_max: 3,
                                            },
                                            {
                                                min: 1,
                                                max: 10,
                                                negative_type_max: 6,
                                                neutral_type_max: 8,
                                            },
                                            {
                                                min: 1,
                                                max: 7,
                                                negative_type_max: 3,
                                                neutral_type_max: 5,
                                            },
                                        ],
                                    },
                                    t =
                                        parseInt(
                                            a.settings.survey_type_scale
                                        ) || 0,
                                    e =
                                        o[a.settings.survey_type][t] ||
                                        o[a.settings.survey_type][0];
                                a.settings.scale = e;
                                var r = a.settings.survey_type,
                                    i = "",
                                    n = a.settings.scale.min,
                                    c = a.settings.scale.max;
                                "csat" == a.settings.survey_type &&
                                    (1 === t
                                        ? (i = "_custom")
                                        : 2 === t && (i = "_custom_2")),
                                    d("#wootric-fullscore").addClass(
                                        a.settings.survey_type + i
                                    ),
                                    d("#wootric-score > li", s).each(function (
                                        o,
                                        t
                                    ) {
                                        if (o >= n && o <= c) {
                                            if (!a.first_screen_enabled)
                                                return !1;
                                            d(t).addClass("wootric-visible");
                                        }
                                    }),
                                    d(".wootric-score", s).addClass(
                                        "wootric-score--" + r + i
                                    ),
                                    a.scale_color &&
                                        d(".wootric-score", s).addClass(
                                            "wootric-score--" + a.scale_color
                                        );
                            },
                            g = function (o) {
                                return function (t) {
                                    13 === t.keyCode && o(t);
                                };
                            },
                            b = function () {
                                var o = d("#wootric-modal", s);
                                return (
                                    i.isMobile()
                                        ? (o.addClass("wootric-mobile-modal"),
                                          i.isZoomed() &&
                                              o.addClass(
                                                  "wootric-mobile-modal-zoomed"
                                              ))
                                        : o.addClass("wootric-desktop-modal"),
                                    d("#wootric-close", s).on({
                                        click: U,
                                        keyup: g(U),
                                    }),
                                    d("#wootric-score > li", s).on({
                                        click: x,
                                        keyup: g(x),
                                    }),
                                    d(".wootric-submit", s).on("click", V),
                                    o.on("click", ft),
                                    gt(),
                                    h(),
                                    eo()
                                );
                            },
                            v = function () {
                                d("#picklist > li", s).on({
                                    click: y,
                                    keyup: g(y),
                                });
                            },
                            y = (function () {
                                return function (o) {
                                    m ||
                                        d("#picklist > li").removeClass(
                                            "selected"
                                        );
                                    var t;
                                    d("#wootric-opt-out-wrapper").addClass(
                                        "wootric-modal-hidden"
                                    ),
                                        (t = d(o.currentTarget)),
                                        t.toggleClass("selected");
                                };
                            })(),
                            _ = function () {
                                return d("#picklist .selected");
                            },
                            x = (function () {
                                return function (o) {
                                    var t,
                                        e,
                                        r = !a.second_screen_enabled;
                                    if (
                                        (d("#wootric-opt-out-wrapper").addClass(
                                            "wootric-modal-hidden"
                                        ),
                                        (t = d(o.currentTarget)),
                                        d("#wootric-score > li", s).removeClass(
                                            "selected"
                                        ),
                                        t.addClass("selected"),
                                        to(),
                                        r)
                                    )
                                        return xo(), To();
                                    T(A()),
                                        S(O()),
                                        C(j(), q()),
                                        (e = d("#wootric-modal", s)),
                                        e
                                            .find(".wootric-submit")
                                            .attr(
                                                "value",
                                                a.localized_texts.send
                                            );
                                };
                            })(),
                            k = function () {
                                var o = d("#wootric-modal", s),
                                    t = a.language,
                                    e = a.permission_labels,
                                    r =
                                        e[t] ||
                                        a.localized_texts
                                            .ask_permission_to_share_feedback ||
                                        "I give permission to contact me about sharing my feedback";
                                o.find("#wootric-permission-label").text(r);
                            },
                            z = function (o) {
                                var t = d("#wootric-modal", s);
                                t
                                    .find("#wootric-question")
                                    .addClass("wootric-modal-hidden"),
                                    t
                                        .find("#wootric-question")
                                        .attr("aria-hidden", !0),
                                    t
                                        .find("#wootric-fullscore")
                                        .addClass("wootric-modal-hidden"),
                                    t
                                        .find("#wootric-fullscore")
                                        .attr("aria-hidden", !0),
                                    t
                                        .find("#wootric-thanks")
                                        .hide()
                                        .removeClass("wootric-modal-hidden"),
                                    t
                                        .find("#wootric-thanks")
                                        .addClass("wootric-opt-out-message"),
                                    t.find("#wootric-thanks p").text(o),
                                    t
                                        .find("#wootric-text")
                                        .attr("aria-label", o),
                                    t.find("#wootric-thanks").fadeIn(),
                                    window.setTimeout(_o, 2e3);
                            },
                            C = function (o, t) {
                                var e = d("#wootric-modal", s),
                                    r = e.find("#driver-picklist"),
                                    i = e.find("#picklist");
                                if (
                                    ((m = t.dpl_multi_select),
                                    i.empty(),
                                    t.dpl_hide_open_ended && o
                                        ? (d("#wootric-feedback").hide(),
                                          d("#wootric-secundary-submit").show(),
                                          d("#wootric-submit-dpl").removeAttr(
                                              "disabled"
                                          ))
                                        : (d("#wootric-feedback").show(),
                                          d(
                                              "#wootric-secundary-submit"
                                          ).hide()),
                                    void 0 === o || 0 === Object.keys(o).length)
                                )
                                    r.hasClass("wootric-modal-hidden") ||
                                        r.addClass("wootric-modal-hidden");
                                else {
                                    var n = Object.keys(o);
                                    t.dpl_randomize_list &&
                                        (n = n.sort(function () {
                                            return 0.5 - Math.random();
                                        }));
                                    var c = 0;
                                    n.forEach(function (t) {
                                        var e = encodeURIComponent(t);
                                        (c += 1),
                                            i.append(
                                                '<li role="button" tabindex=' +
                                                    c +
                                                    ' value="' +
                                                    e +
                                                    '">' +
                                                    o[t] +
                                                    "</li>"
                                            );
                                    }),
                                        v(),
                                        r
                                            .hide()
                                            .removeClass(
                                                "wootric-modal-hidden"
                                            ),
                                        r.fadeIn(),
                                        d("#picklist > li")[0].focus();
                                }
                            },
                            T = function (o) {
                                var t = d("#wootric-modal", s);
                                t
                                    .find(".wootric-feedback-wrapper")
                                    .attr("aria-hidden", !1)
                                    .removeClass("wootric-modal-collapsed"),
                                    t
                                        .find("#wootric-text")
                                        .removeAttr("disabled"),
                                    t
                                        .find("#wootric-submit")
                                        .removeAttr("disabled"),
                                    t
                                        .find("#wootric-question")
                                        .addClass("wootric-modal-hidden"),
                                    t
                                        .find("#wootric-thanks")
                                        .hide()
                                        .removeClass("wootric-modal-hidden"),
                                    t.find("#wootric-thanks p").text(o),
                                    t
                                        .find("#wootric-text")
                                        .attr("aria-label", o),
                                    t.find("#wootric-thanks").fadeIn(),
                                    a.ask_permission_to_share_feedback &&
                                        (k(),
                                        t
                                            .find("#wootric-text")
                                            .on(
                                                "change paste keyup",
                                                function () {
                                                    var o = t
                                                        .find(
                                                            "#wootric-share-feedback"
                                                        )
                                                        .removeClass(
                                                            "wootric-modal-hidden"
                                                        );
                                                    d(this).val()
                                                        ? o.fadeIn(325)
                                                        : o.fadeOut(325);
                                                }
                                            ));
                            },
                            S = function (o) {
                                d("#wootric-modal", s)
                                    .find("#wootric-text")
                                    .attr("placeholder", o)
                                    .focus();
                            },
                            E = function () {
                                return window.FB.Event.subscribe(
                                    "edge.create",
                                    function () {
                                        return U();
                                    }
                                );
                            },
                            A = function () {
                                return D(a.messages, X());
                            },
                            j = function () {
                                return N(a.messages, X());
                            },
                            q = function () {
                                return L(a.messages, X());
                            },
                            L = function (o, t) {
                                if (null === o) return {};
                                var e = o.driver_picklist_settings_list,
                                    r = o.driver_picklist_settings;
                                return e || r
                                    ? r && r.picklist
                                        ? r
                                        : ot(t)
                                        ? e.detractor || {}
                                        : tt(t)
                                        ? e.passive || {}
                                        : et(t)
                                        ? e.promoter || {}
                                        : {}
                                    : {};
                            },
                            N = function (o, t) {
                                if (null === o) return {};
                                var e = o.driver_picklist,
                                    r = o.picklist;
                                return e || r
                                    ? r ||
                                          (ot(t)
                                              ? e.detractor_picklist
                                              : tt(t)
                                              ? e.passive_picklist
                                              : et(t)
                                              ? e.promoter_picklist
                                              : void 0)
                                    : {};
                            },
                            D = function (o, t) {
                                var e;
                                return P(o)
                                    ? ((e = o.followup_questions_list),
                                      d.isEmptyObject(e)
                                          ? d.isEmptyObject(o.followup_question)
                                              ? void 0
                                              : o.followup_question
                                          : W(e, t))
                                    : a.localized_texts.followup_question;
                            },
                            O = function () {
                                return M(a.messages, X());
                            },
                            M = function (o, t) {
                                var e;
                                return H(o)
                                    ? a.localized_texts.followup_placeholder
                                    : ((e = o.placeholder_texts_list),
                                      d.isEmptyObject(e)
                                          ? d.isEmptyObject(o.placeholder_text)
                                              ? void 0
                                              : o.placeholder_text
                                          : F(e, t));
                            },
                            P = function (o) {
                                return (
                                    null != o &&
                                    (null != o.followup_question ||
                                        null != o.followup_questions_list)
                                );
                            },
                            B = function (o) {
                                return (
                                    o &&
                                    (o.thank_you_setup ||
                                        o.thank_you_setup_list)
                                );
                            },
                            I = function (o) {
                                return (
                                    o &&
                                    (o.thank_you_main || o.thank_you_main_list)
                                );
                            },
                            R = function (o) {
                                if (!o) return !1;
                                var t = o.thank_you_link_text,
                                    e = o.thank_you_link_url,
                                    r = o.thank_you_link_text_list,
                                    i = o.thank_you_link_url_list;
                                if ((!t && !r) || (!e && !i)) return !1;
                                var n =
                                        (t ||
                                            r.detractor_thank_you_link_text) &&
                                        (e || i.detractor_thank_you_link_url),
                                    c =
                                        (t || r.passive_thank_you_link_text) &&
                                        (e || i.passive_thank_you_link_url),
                                    a =
                                        (t || r.promoter_thank_you_link_text) &&
                                        (e || i.promoter_thank_you_link_url);
                                return n || c || a;
                            },
                            H = function (o) {
                                return !!(
                                    null === o ||
                                    (d.isEmptyObject(o.placeholder_text) &&
                                        d.isEmptyObject(
                                            o.placeholder_texts_list
                                        ))
                                );
                            },
                            W = function (o, t) {
                                return ot(t) && o.detractor_question
                                    ? o.detractor_question
                                    : tt(t) && o.passive_question
                                    ? o.passive_question
                                    : et(t) && o.promoter_question
                                    ? o.promoter_question
                                    : a.localized_texts.followup_question;
                            },
                            F = function (o, t) {
                                return ot(t) && o.detractor_text
                                    ? o.detractor_text
                                    : tt(t) && o.passive_text
                                    ? o.passive_text
                                    : et(t) && o.promoter_text
                                    ? o.promoter_text
                                    : a.localized_texts.followup_placeholder;
                            },
                            U = (function () {
                                return function (o) {
                                    var t,
                                        r,
                                        n = a.settings.channel || "web";
                                    return (
                                        _o(),
                                        o || (o = 0),
                                        u
                                            ? (window.setTimeout(_o, o),
                                              void (window.wootric_survey_running =
                                                  !1))
                                            : (a.event_name && J(),
                                              a.sampling_rule && K(),
                                              (r = {
                                                  _method: "POST",
                                                  account_token:
                                                      a.account_token,
                                                  account_id: a.account_id,
                                                  decline: {
                                                      origin_url: i.originURL(),
                                                  },
                                                  end_user: {
                                                      id: a.end_user_id,
                                                      email: a.email,
                                                      external_created_at:
                                                          a.created_at,
                                                      external_id:
                                                          a.external_id,
                                                      phone_number:
                                                          a.phone_number,
                                                      properties:
                                                          i.parseWootricProperties(
                                                              a.properties
                                                          ),
                                                  },
                                                  survey: {
                                                      id: a.survey_id,
                                                      unique_link: l,
                                                      channel: n,
                                                  },
                                                  priority: a.priority++,
                                                  metric_type:
                                                      a.settings.survey_type,
                                                  sdk_version: c.version(),
                                              }),
                                              d.isEmptyObject(
                                                  r.end_user.properties
                                              ) && delete r.end_user.properties,
                                              a.segment_user_id &&
                                                  (r.end_user.segment_user_id =
                                                      a.segment_user_id),
                                              d
                                                  .ajax({
                                                      url:
                                                          a.server +
                                                          "/declines?" +
                                                          d.param(r),
                                                  })
                                                  .fail(bt),
                                              a.disable_surveyed_cookie ||
                                                  a.belongs_to_sampling_group ||
                                                  ((t =
                                                      a.decline_resurvey_throttle),
                                                  e.create("surveyed", !0, t)),
                                              (window.wootric_survey_running =
                                                  !1),
                                              a.settings.callbacks.after_decline
                                                  ? a.settings.callbacks.after_decline()
                                                  : void 0)
                                    );
                                };
                            })(),
                            $ = function () {
                                var o = d("#wootric-score .selected", s);
                                return a.first_screen_enabled
                                    ? parseInt(o.attr("value"), 10)
                                    : 1;
                            },
                            X = function () {
                                return $();
                            },
                            Y = function () {
                                var o, t, e, r, i, n;
                                for (
                                    t = 0,
                                        i = document.getElementsByTagName("*"),
                                        e = 0,
                                        r = i.length;
                                    e < r;
                                    e++
                                )
                                    (o = i[e]),
                                        o.style &&
                                            (n = parseInt(o.style.zIndex, 10)) >
                                                t &&
                                            (t = n);
                                return t;
                            },
                            V = (function () {
                                return function (o) {
                                    return (
                                        o.preventDefault(),
                                        to(),
                                        xo(),
                                        a.extra_questions.length > 0
                                            ? (n.show(), Co())
                                            : To()
                                    );
                                };
                            })(),
                            G = function () {
                                var o = d("#wootric-feedback-grant").is(
                                    ":checked"
                                );
                                a.properties || (a.properties = {}),
                                    (a.properties.authorized_to_share_feedback =
                                        !!o);
                            },
                            J = function () {
                                a.properties || (a.properties = {}),
                                    (a.properties.custom_event_name =
                                        a.event_name);
                            },
                            K = function () {
                                a.properties || (a.properties = {}),
                                    (a.properties["Wootric Sampling Rule"] =
                                        a.sampling_rule.name);
                            },
                            Q = function () {
                                var o,
                                    t = a.settings.channel || "web",
                                    e = a.language,
                                    r = a.survey_template.id || null,
                                    n = j();
                                return (
                                    (l = i.buildUniqueLink(
                                        a.account_token,
                                        a.email
                                    )),
                                    a.event_name && J(),
                                    a.sampling_rule && K(),
                                    n && oo(n),
                                    (o = {
                                        _method: "POST",
                                        account_token: a.account_token,
                                        account_id: a.account_id,
                                        end_user: {
                                            id: a.end_user_id,
                                            external_created_at: a.created_at,
                                            external_id: a.external_id,
                                            email: a.email,
                                            phone_number: a.phone_number,
                                            properties:
                                                i.parseWootricProperties(
                                                    a.properties
                                                ),
                                        },
                                        survey: {
                                            unique_link: l,
                                            channel: t,
                                            language: e,
                                            survey_template_id: r,
                                        },
                                        metric_type: a.settings.survey_type,
                                        sdk_version: c.version(),
                                    }),
                                    a.segment_user_id &&
                                        (o.end_user.segment_user_id =
                                            a.segment_user_id),
                                    d.isEmptyObject(o.end_user.properties) &&
                                        delete o.end_user.properties,
                                    d.ajax({
                                        url:
                                            a.server + "/surveys?" + d.param(o),
                                    })
                                );
                            },
                            Z = function (o) {
                                var t = [],
                                    e = [];
                                return (
                                    o.each(function () {
                                        t.push(d(this).attr("value")),
                                            e.push(d(this).text());
                                    }),
                                    [t, e]
                                );
                            },
                            oo = function (o) {
                                a.driver_picklist || (a.driver_picklist = {});
                                var t = Z(_());
                                t[0].forEach(function (o, e) {
                                    a.driver_picklist[o] = t[1][e];
                                });
                            },
                            to = function () {
                                u = !0;
                                var o = j();
                                a.ask_permission_to_share_feedback && G(),
                                    a.event_name && J(),
                                    a.sampling_rule && K(),
                                    o && oo(o);
                                var t,
                                    r,
                                    n,
                                    m = a.settings.channel || "web",
                                    p = a.language;
                                return (
                                    (n = d("#wootric-text", s).val()),
                                    n === O() && (n = ""),
                                    (r = {
                                        _method: "POST",
                                        callback: "callback",
                                        account_token: a.account_token,
                                        account_id: a.account_id,
                                        response: {
                                            driver_picklist: a.driver_picklist,
                                            origin_url: i.originURL(),
                                            score: X(),
                                            text: n,
                                        },
                                        end_user: {
                                            id: a.end_user_id,
                                            external_created_at: a.created_at,
                                            external_id: a.external_id,
                                            email: a.email,
                                            phone_number: a.phone_number,
                                            properties:
                                                i.parseWootricProperties(
                                                    a.properties
                                                ),
                                        },
                                        survey: {
                                            id: a.survey_id,
                                            unique_link: l,
                                            channel: m,
                                            language: p,
                                        },
                                        priority: a.priority++,
                                        metric_type: a.settings.survey_type,
                                        sdk_version: c.version(),
                                    }),
                                    d.isEmptyObject(r.end_user.properties) &&
                                        delete r.end_user.properties,
                                    a.segment_user_id &&
                                        (r.end_user.segment_user_id =
                                            a.segment_user_id),
                                    d
                                        .ajax({
                                            url:
                                                a.server +
                                                "/responses?" +
                                                d.param(r),
                                        })
                                        .fail(bt),
                                    a.disable_surveyed_cookie ||
                                        a.belongs_to_sampling_group ||
                                        ((t = a.resurvey_throttle),
                                        e.create("surveyed", !0, t)),
                                    a.settings.callbacks.after_response
                                        ? a.settings.callbacks.after_response(
                                              X(),
                                              n,
                                              a.driver_picklist
                                          )
                                        : void 0
                                );
                            },
                            eo = function () {
                                var o,
                                    t,
                                    e = !a.first_screen_enabled;
                                return (
                                    d("body", s).addClass(
                                        "wootric-modal-showing"
                                    ),
                                    co(),
                                    (t = 1e3 * parseInt(a.time_delay, 10)),
                                    (a.modalTimeoutID = window.setTimeout(
                                        yo,
                                        t
                                    )),
                                    (o = d("#wootric-modal", s)),
                                    o
                                        .find("#wootric-thanks")
                                        .addClass("wootric-modal-hidden"),
                                    o
                                        .find("#wootric-question")
                                        .removeClass("wootric-modal-hidden"),
                                    e &&
                                        (o.addClass("wootric-open-ended-modal"),
                                        ro()),
                                    no()
                                );
                            },
                            ro = function () {
                                var o = d("#wootric-modal", s);
                                o
                                    .find("#wootric-question")
                                    .addClass("wootric-modal-hidden"),
                                    o
                                        .find("#wootric-question")
                                        .attr("aria-hidden", !0),
                                    o
                                        .find("#wootric-fullscore")
                                        .addClass("wootric-modal-hidden"),
                                    o
                                        .find("#wootric-fullscore")
                                        .attr("aria-hidden", !0),
                                    o
                                        .find(".wootric-submit")
                                        .attr("value", a.localized_texts.send),
                                    T(A()),
                                    S(O());
                            },
                            io = function () {
                                var o = a.settings.survey_type,
                                    t = {
                                        question:
                                            a.localized_texts.nps_question,
                                        anchors: {
                                            likely: a.localized_texts.anchors
                                                .likely,
                                            not_likely:
                                                a.localized_texts.anchors
                                                    .not_likely,
                                        },
                                    };
                                return (
                                    "ces" === o
                                        ? ((t.question =
                                              a.localized_texts.ces_question),
                                          (t.anchors.likely =
                                              a.localized_texts.ces_anchors.very_easy),
                                          (t.anchors.not_likely =
                                              a.localized_texts.ces_anchors.very_difficult))
                                        : "csat" === o &&
                                          ((t.question =
                                              a.localized_texts.csat_question),
                                          (t.anchors.likely =
                                              a.localized_texts.csat_anchors.very_satisfied),
                                          (t.anchors.not_likely =
                                              a.localized_texts.csat_anchors.very_unsatisfied)),
                                    a.settings.custom_first_question_enabled &&
                                        (t.question =
                                            a.settings.custom_first_question),
                                    t
                                );
                            },
                            no = function () {
                                var o = d("#wootric-modal", s),
                                    t = io(),
                                    e = a.localized_texts.dir;
                                return (
                                    o
                                        .find("#wootric-question p")
                                        .text(t.question)
                                        .attr("aria-label", t.question),
                                    o
                                        .find("#wootric-not-likely-label")
                                        .text(t.anchors.not_likely),
                                    o
                                        .find("#wootric-likely-label")
                                        .text(t.anchors.likely),
                                    o
                                        .find(
                                            ".wootric-alt-anchors__anchor--negative"
                                        )
                                        .text(t.anchors.not_likely),
                                    o
                                        .find(
                                            ".wootric-alt-anchors__anchor--positive"
                                        )
                                        .text(t.anchors.likely),
                                    o
                                        .find("#wootric-fullscore")
                                        .attr(
                                            "aria-label",
                                            [
                                                a.settings.scale.min,
                                                t.anchors.not_likely,
                                                a.settings.scale.max,
                                                t.anchors.likely,
                                            ].join(" ")
                                        ),
                                    o
                                        .find("#wootric-dismiss")
                                        .text(a.localized_texts.dismiss),
                                    o
                                        .find("#wootric-language-direction")
                                        .attr("dir", e),
                                    o
                                        .find("#wootric-decline")
                                        .val(
                                            a.localized_texts.social_share
                                                .decline
                                        )
                                );
                            },
                            co = function () {
                                var o, t, e, r, i, n, c;
                                return (
                                    (o = d("#wootric-modal", s)),
                                    o.addClass(
                                        "wootric-survey-type-" +
                                            a.settings.survey_type
                                    ),
                                    !a.settings.modal_theme ||
                                    ("dark" !==
                                        (t =
                                            null != (e = a.settings.modal_theme)
                                                ? e.toLowerCase()
                                                : void 0) &&
                                        "light" !== t)
                                        ? (o.addClass("light"),
                                          (a.custom_primary_color ||
                                              a.custom_colors) &&
                                              (o.addClass("custom-colors"),
                                              vo(o)))
                                        : o.addClass(
                                              a.settings.modal_theme.toLowerCase()
                                          ),
                                    !a.modal_position ||
                                    ("top" !==
                                        (r =
                                            null !=
                                            (i = a.settings.modal_position)
                                                ? i.toLowerCase()
                                                : void 0) &&
                                        "wootric-bottom" !== r)
                                        ? o.addClass("wootric-bottom")
                                        : o.addClass(
                                              a.settings.modal_position.toLowerCase()
                                          ),
                                    !a.settings.modal_footprint ||
                                    ("spacious" !==
                                        (n =
                                            null !=
                                            (c = a.settings.modal_footprint)
                                                ? c.toLowerCase()
                                                : void 0) &&
                                        "normal" !== n &&
                                        "compact" !== n)
                                        ? o.addClass("normal")
                                        : o.addClass(
                                              a.settings.modal_footprint.toLowerCase()
                                          )
                                );
                            },
                            ao = function (o) {
                                var t = parseInt(o.slice(1), 16),
                                    e = Math.round(0.8 * (t >> 16)),
                                    r = Math.round(0.8 * ((t >> 8) & 255)),
                                    i = Math.round(0.8 * (255 & t));
                                return (
                                    "#" +
                                    ("0" + e.toString(16)).slice(-2) +
                                    ("0" + r.toString(16)).slice(-2) +
                                    ("0" + i.toString(16)).slice(-2)
                                );
                            },
                            lo = function (o) {
                                if (
                                    !/^rgba?\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})(,\s*(\d?\.?\d*))?\)$/.test(
                                        o
                                    )
                                )
                                    return o;
                                var t = o.match(/\d+\.?\d*/g),
                                    e = Number(t[0]),
                                    r = Number(t[1]),
                                    i = Number(t[2]),
                                    n = void 0 !== t[3] ? Number(t[3]) : 1,
                                    c = Math.round(255 * n).toString(16);
                                c = 1 === c.length ? "0" + c : c;
                                var a = e.toString(16);
                                a = 1 === a.length ? "0" + a : a;
                                var l = r.toString(16);
                                l = 1 === l.length ? "0" + l : l;
                                var s = i.toString(16);
                                return (
                                    (s = 1 === s.length ? "0" + s : s),
                                    "#" + a + l + s + c
                                );
                            },
                            so = function (o, t) {
                                var e = parseInt(o.slice(1), 16);
                                return (
                                    "rgba(" +
                                    (e >> 16) +
                                    ", " +
                                    ((e >> 8) & 255) +
                                    ", " +
                                    (255 & e) +
                                    ", " +
                                    t +
                                    ")"
                                );
                            },
                            uo = function (o) {
                                var t = parseInt(o.slice(1, 7), 16),
                                    e = t >> 16,
                                    r = (t >> 8) & 255,
                                    i = 255 & t,
                                    n =
                                        o.length > 7
                                            ? parseInt(o.slice(7, 9), 16) / 255
                                            : 1;
                                return (
                                    (e = Math.round(255 * (1 - n) + n * e)),
                                    (r = Math.round(255 * (1 - n) + n * r)),
                                    (i = Math.round(255 * (1 - n) + n * i)),
                                    (299 * e + 587 * r + 114 * i) / 1e3 >= 128
                                        ? "black"
                                        : "white"
                                );
                            },
                            mo = function (o, t) {
                                (t = t || "#253746"),
                                    fo(o, "--secondary-color", t),
                                    fo(o, "--secondary-color-border", ao(t)),
                                    fo(
                                        o,
                                        "--secondary-color-hover",
                                        so(t, 0.8)
                                    ),
                                    fo(o, "--secondary-font-color", uo(t));
                            },
                            po = function (o) {
                                ho(d("#picklist"), o);
                            },
                            fo = function (o, t, e) {
                                o.get(0).style.setProperty(t, e);
                            },
                            wo = function (o, t) {
                                var e = ao(t),
                                    r = t;
                                fo(o, "--background-color", t),
                                    fo(o, "--border-color", e),
                                    fo(o, "--font-color", uo(lo(r))),
                                    (r = so(t, 0.3)),
                                    fo(o, "--hover-background-color", r),
                                    fo(o, "--hover-border-color", so(t, 0.5)),
                                    fo(o, "--hover-font-color", uo(lo(r))),
                                    (r = so(t, 0.8)),
                                    fo(
                                        o,
                                        "--hover-selected-background-color",
                                        r
                                    ),
                                    fo(
                                        o,
                                        "--hover-selected-border-color",
                                        so(e, 0.8)
                                    ),
                                    fo(
                                        o,
                                        "--hover-selected-font-color",
                                        uo(lo(r))
                                    ),
                                    fo(o, "--primary-color", t),
                                    fo(o, "--default-border-color", e),
                                    fo(o, "--default-font-color", uo(t)),
                                    d("#wootric-score > li", o).on(
                                        "click",
                                        function () {
                                            (t = "white"), (e = "#dadada");
                                            fo(o, "--background-color", t),
                                                fo(o, "--border-color", e),
                                                fo(
                                                    o,
                                                    "--font-color",
                                                    "#253746"
                                                );
                                        }
                                    );
                            },
                            ho = function (o, t) {
                                var e = ao(t),
                                    r = t;
                                fo(o, "--primary-color", t),
                                    fo(o, "--border-color", "#dadada"),
                                    (r = so(t, 0.3)),
                                    fo(o, "--hover-background-color", r),
                                    fo(o, "--hover-border-color", so(e, 0.5)),
                                    fo(o, "--hover-font-color", uo(lo(r))),
                                    (r = so(t, 0.8)),
                                    fo(
                                        o,
                                        "--hover-selected-background-color",
                                        r
                                    ),
                                    fo(o, "--hover-selected-border-color", r),
                                    fo(
                                        o,
                                        "--hover-selected-font-color",
                                        uo(lo(r))
                                    ),
                                    fo(o, "--default-background-color", t),
                                    fo(o, "--default-border-color", e),
                                    fo(o, "--default-font-color", uo(t)),
                                    (t = "white"),
                                    (e = "#dadada");
                                fo(o, "--background-color", t),
                                    fo(o, "--border-color", e),
                                    fo(o, "--font-color", "#253746");
                            },
                            go = function (o) {
                                if (o) return o.toString().replace(/%23/g, "#");
                            },
                            bo = function () {
                                var o = {};
                                return (
                                    (o = a.custom_primary_color
                                        ? a.settings
                                        : a.custom_colors),
                                    {
                                        primary: go(o.custom_primary_color),
                                        secondary: go(o.custom_secondary_color),
                                        filled: go(o.use_filled_score_scale),
                                    }
                                );
                            },
                            vo = function (o) {
                                var t = bo();
                                if (t) {
                                    var e = t.primary,
                                        r = t.secondary,
                                        i = t.filled;
                                    if (!o.hasClass("wootric-mobile-modal")) {
                                        var n =
                                            4 +
                                            0.5 * a.localized_texts.send.length;
                                        d("#wootric-text").css(
                                            "padding-right",
                                            n + "em"
                                        );
                                    }
                                    "true" === i
                                        ? wo(d("#wootric-modal"), e)
                                        : e && ho(d("#wootric-score"), e);
                                    var c = r || e;
                                    mo(d("#wootric-submit"), r),
                                        mo(d("#wootric-submit-dpl"), r),
                                        mo(d("#wootric-social-link"), c),
                                        mo(d("#wootric-decline"), c),
                                        fo(
                                            d("#wootric-text"),
                                            "--secondary-color",
                                            so(c, 0.3)
                                        ),
                                        fo(
                                            d("#wootric-feedback-grant"),
                                            "accent-color",
                                            c
                                        ),
                                        po(e);
                                } else o.removeClass("custom-colors");
                            },
                            yo = function () {
                                var o = d("#wootric-modal", s);
                                a.aria && o.find("#wootric-question").focus(),
                                    Q()
                                        .done(function (t) {
                                            o.addClass("show").attr(
                                                "aria-hidden",
                                                !1
                                            );
                                            var r =
                                                a.server +
                                                "/opt_out?unique_link=" +
                                                l +
                                                "&metric_type=" +
                                                a.settings.survey_type +
                                                "&end_user_email=" +
                                                a.settings.email +
                                                "&end_user_created_at=" +
                                                a.created_at +
                                                "&end_user_id=" +
                                                t.end_user_id +
                                                "&language=" +
                                                a.language +
                                                "&token=" +
                                                a.settings.account_token +
                                                "&" +
                                                d.param({
                                                    properties:
                                                        i.parseWootricProperties(
                                                            a.properties
                                                        ),
                                                });
                                            d("#wootric-opt-out").on(
                                                "click",
                                                function () {
                                                    d(
                                                        "#wootric-opt-out-wrapper"
                                                    ).addClass(
                                                        "wootric-modal-hidden"
                                                    ),
                                                        window.open(r),
                                                        d(window).on({
                                                            focus: function () {
                                                                e.read(
                                                                    "Wootric_opt_out-" +
                                                                        a
                                                                            .settings
                                                                            .account_token
                                                                ) &&
                                                                    z(
                                                                        a
                                                                            .localized_texts
                                                                            .opt_out
                                                                    );
                                                            },
                                                        });
                                                }
                                            );
                                        })
                                        .fail(bt),
                                    a.settings.callbacks.after_show &&
                                        a.settings.callbacks.after_show();
                            },
                            _o = function () {
                                var o = d("#wootric-modal", s);
                                return (
                                    o.removeClass("show"),
                                    o.attr("aria-hidden", !0),
                                    window.wootric_survey_immediately ||
                                        (window.wootric_modal_loaded = !1),
                                    d("body", s).removeClass(
                                        "wootric-modal-showing"
                                    )
                                );
                            },
                            xo = function () {
                                var o = d("#wootric-modal", s),
                                    t = $();
                                o
                                    .find(".wootric-feedback-wrapper")
                                    .addClass("wootric-modal-collapsed")
                                    .attr("aria-hidden", !0),
                                    o
                                        .find("#wootric-question")
                                        .addClass("wootric-modal-hidden")
                                        .attr("aria-hidden", !0),
                                    o
                                        .find("#wootric-fullscore")
                                        .attr("aria-hidden", !0),
                                    o
                                        .find("#wootric-thanks")
                                        .hide()
                                        .removeClass("wootric-modal-hidden")
                                        .attr("aria-label", lt(t)),
                                    o.find("#wootric-thanks p").text(lt(t)),
                                    o.find("#wootric-thanks").fadeIn(),
                                    o
                                        .find("#driver-picklist")
                                        .hide()
                                        .removeClass("wootric-modal-hidden"),
                                    a.aria &&
                                        (o.find("#wootric-thanks").focus(),
                                        o.find("#driver-picklist").focus());
                            },
                            ko = function (o, t) {
                                var e = o.custom_thank_you;
                                if (e) {
                                    t || (t = {}),
                                        t.thankYouMessages ||
                                            (t.thankYouMessages = {});
                                    !I(t.thankYouMessages) &&
                                        I(e.thank_you_messages) &&
                                        ((t.thankYouMessages.thank_you_main =
                                            e.thank_you_messages.thank_you_main),
                                        (t.thankYouMessages.thank_you_main_list =
                                            e.thank_you_messages.thank_you_main_list));
                                    !B(t.thankYouMessages) &&
                                        B(e.thank_you_messages) &&
                                        ((t.thankYouMessages.thank_you_setup =
                                            e.thank_you_messages.thank_you_setup),
                                        (t.thankYouMessages.thank_you_setup_list =
                                            e.thank_you_messages.thank_you_setup_list));
                                    !R(t.thankYouLinks) &&
                                        R(e.thank_you_links) &&
                                        (t.thankYouLinks = e.thank_you_links);
                                }
                                return t;
                            },
                            zo = function (o, t) {
                                if (
                                    ((t.localized_texts = o.localized_texts),
                                    (t.language = o.language),
                                    o.messages)
                                ) {
                                    null === t.messages && (t.messages = {});
                                    var e = o.messages.picklist,
                                        r = o.messages.driver_picklist;
                                    e && (t.messages.picklist = e),
                                        r && (t.messages.driver_picklist = r);
                                    var i = o.messages.driver_picklist_settings;
                                    i &&
                                        (t.messages.driver_picklist_settings =
                                            i);
                                    var n =
                                        o.messages
                                            .driver_picklist_settings_list;
                                    n &&
                                        (t.messages.driver_picklist_settings_list =
                                            n);
                                }
                                !P(t.messages) &&
                                    P(o.messages) &&
                                    (t.messages = o.messages),
                                    t.time_delay ||
                                        (t.time_delay = o.time_delay),
                                    t.decline_resurvey_throttle ||
                                        (t.decline_resurvey_throttle =
                                            o.decline_resurvey_throttle),
                                    t.resurvey_throttle ||
                                        (t.resurvey_throttle =
                                            o.resurvey_throttle),
                                    t.settings.survey_type ||
                                        (t.settings.survey_type =
                                            o.survey_type.toLowerCase()),
                                    t.settings.open_ended
                                        ? (t.first_screen_enabled = !1)
                                        : (t.first_screen_enabled =
                                              o.first_screen_enabled),
                                    t.settings.skip_feedback
                                        ? (t.second_screen_enabled = !1)
                                        : (t.second_screen_enabled =
                                              o.second_screen_enabled),
                                    (t.custom_colors = o.custom_colors);
                                var c = o.social;
                                return (
                                    c &&
                                        c.accounts &&
                                        (t.settings.twitter_account ||
                                            (c.twitter_enabled &&
                                                (t.settings.twitter_account =
                                                    c.accounts.twitter_account)),
                                        t.settings.facebook_page ||
                                            (c.facebook_enabled &&
                                                (t.settings.facebook_page =
                                                    c.accounts.facebook_page))),
                                    t
                                );
                            },
                            Co = function () {
                                d("#wootric-extra-submit", s).on(
                                    "click",
                                    function (o) {
                                        o.preventDefault();
                                        var t = n.parseAnswer();
                                        return (
                                            (a.properties[t.name] = t.value),
                                            to(),
                                            n.hide(),
                                            To()
                                        );
                                    }
                                );
                            },
                            To = function () {
                                var o, t;
                                if (
                                    ((o = d("#wootric-modal", s)),
                                    (t = $()),
                                    at(t))
                                )
                                    return void window.setTimeout(_o, 2e3);
                                o
                                    .find("#wootric-fullscore")
                                    .addClass("wootric-modal-collapsed"),
                                    o
                                        .find("#wootric-share-feedback")
                                        .addClass("wootric-modal-hidden"),
                                    nt(t),
                                    o
                                        .find("#wootric-share")
                                        .attr("aria-label", st(t)),
                                    o.find("#wootric-share p").text(st(t)),
                                    dt(t) && ut(t) ? So(t) : ct(),
                                    o
                                        .find("#wootric-share")
                                        .removeClass("wootric-modal-collapsed")
                                        .attr("aria-hidden", !1),
                                    o
                                        .find("#wootric-social-link")
                                        .removeAttr("disabled"),
                                    o
                                        .find("#wootric-decline")
                                        .removeAttr("disabled"),
                                    o
                                        .find("#wootric-close")
                                        .attr("aria-hidden", !1),
                                    o.find("#wootric-decline").on("click", U);
                            },
                            So = function (o) {
                                var t, e, r, i;
                                (t = d("#wootric-modal", s)),
                                    (e = d("#wootric-text", s).val()),
                                    (r = a.email),
                                    (i = ut(o)),
                                    e === O() && (e = "");
                                var n = mt(o),
                                    c = {};
                                return (
                                    n.add_email_param_to_url &&
                                        (c.wootric_email = r),
                                    n.add_score_param_to_url &&
                                        (c.wootric_score = o),
                                    n.add_comment_param_to_url &&
                                        (c.wootric_comment = e),
                                    (i = pt(i, c)),
                                    t.find("#wootric-social-link").val(dt(o)),
                                    t
                                        .find("#wootric-social-link")
                                        .on("click", function () {
                                            return Eo(i);
                                        })
                                );
                            },
                            Eo = function (o) {
                                return window.open(o), window.setTimeout(_o, 1);
                            },
                            Ao = function () {
                                var o;
                                return null != (o = window.Wootric)
                                    ? o.thankYouLinks
                                    : void 0;
                            },
                            jo = function () {
                                var o;
                                return null != (o = window.Wootric)
                                    ? o.thankYouMessages
                                    : void 0;
                            },
                            qo = function () {
                                var o;
                                return null != (o = jo())
                                    ? o.thank_you_main_list
                                    : void 0;
                            },
                            Lo = function () {
                                var o;
                                return null != (o = jo())
                                    ? o.thank_you_setup_list
                                    : void 0;
                            },
                            No = function () {
                                var o;
                                return null != (o = Ao())
                                    ? o.thank_you_link_text_list
                                    : void 0;
                            },
                            Do = function () {
                                var o;
                                return null != (o = Ao())
                                    ? o.thank_you_link_url_list
                                    : void 0;
                            },
                            Oo = function () {
                                var o;
                                return Zo(
                                    null != (o = jo())
                                        ? o.thank_you_main
                                        : void 0
                                );
                            },
                            Mo = function () {
                                var o;
                                return Zo(
                                    null != (o = qo())
                                        ? o.promoter_thank_you_main
                                        : void 0
                                );
                            },
                            Po = function () {
                                var o;
                                return Zo(
                                    null != (o = qo())
                                        ? o.passive_thank_you_main
                                        : void 0
                                );
                            },
                            Bo = function () {
                                var o;
                                return Zo(
                                    null != (o = qo())
                                        ? o.detractor_thank_you_main
                                        : void 0
                                );
                            },
                            Io = function () {
                                var o;
                                return Zo(
                                    null != (o = jo())
                                        ? o.thank_you_setup
                                        : void 0
                                );
                            },
                            Ro = function () {
                                var o;
                                return Zo(
                                    null != (o = Lo())
                                        ? o.promoter_thank_you_setup
                                        : void 0
                                );
                            },
                            Ho = function () {
                                var o;
                                return Zo(
                                    null != (o = Lo())
                                        ? o.passive_thank_you_setup
                                        : void 0
                                );
                            },
                            Wo = function () {
                                var o;
                                return Zo(
                                    null != (o = Lo())
                                        ? o.detractor_thank_you_setup
                                        : void 0
                                );
                            },
                            Fo = function () {
                                var o = Ao();
                                return Zo(o ? o.thank_you_link_url : void 0);
                            },
                            Uo = function () {
                                var o = Ao();
                                return Zo(o ? o.thank_you_link_text : void 0);
                            },
                            $o = function () {
                                var o;
                                return Zo(
                                    null != (o = No())
                                        ? o.detractor_thank_you_link_text
                                        : void 0
                                );
                            },
                            Xo = function () {
                                var o;
                                return Zo(
                                    null != (o = Do())
                                        ? o.detractor_thank_you_link_url
                                        : void 0
                                );
                            },
                            Yo = function () {
                                var o;
                                return Zo(
                                    null != (o = No())
                                        ? o.passive_thank_you_link_text
                                        : void 0
                                );
                            },
                            Vo = function () {
                                var o;
                                return Zo(
                                    null != (o = Do())
                                        ? o.passive_thank_you_link_url
                                        : void 0
                                );
                            },
                            Go = function () {
                                var o;
                                return Zo(
                                    null != (o = No())
                                        ? o.promoter_thank_you_link_text
                                        : void 0
                                );
                            },
                            Jo = function () {
                                var o;
                                return Zo(
                                    null != (o = Do())
                                        ? o.promoter_thank_you_link_url
                                        : void 0
                                );
                            },
                            Ko = function () {
                                return Zo(s.config.settings.facebook_page);
                            },
                            Qo = function () {
                                return Zo(s.config.settings.twitter_account);
                            },
                            Zo = function (o) {
                                return /\S+/.test(o) && void 0 !== o;
                            },
                            ot = function (o) {
                                return i.inRange(
                                    o,
                                    a.settings.scale.min,
                                    a.settings.scale.negative_type_max
                                );
                            },
                            tt = function (o) {
                                return i.inRange(
                                    o,
                                    a.settings.scale.negative_type_max + 1,
                                    a.settings.scale.neutral_type_max
                                );
                            },
                            et = function (o) {
                                return i.inRange(
                                    o,
                                    a.settings.scale.neutral_type_max + 1,
                                    a.settings.scale.max
                                );
                            },
                            rt = function (o) {
                                var t = d("#wootric-text", s).val();
                                return !et(o) || !Qo() || "" === t;
                            },
                            it = function (o) {
                                return !et(o) || !Ko();
                            },
                            nt = function (o) {
                                var t = d("#wootric-modal", s);
                                if (
                                    (rt(o) && t.find("#wootric-twitter").hide(),
                                    it(o))
                                )
                                    return t.find("#wootric-facebook").hide();
                            },
                            ct = function () {
                                var o;
                                return (
                                    (o = d("#wootric-modal", s)),
                                    o.find("#wootric-social-link").hide()
                                );
                            },
                            at = function (o) {
                                return (!ut(o) || !dt(o)) && it(o) && rt(o);
                            },
                            lt = function (o) {
                                return ot(o) && Bo()
                                    ? qo().detractor_thank_you_main
                                    : tt(o) && Po()
                                    ? qo().passive_thank_you_main
                                    : et(o) && Mo()
                                    ? qo().promoter_thank_you_main
                                    : Oo()
                                    ? jo().thank_you_main
                                    : a.localized_texts.final_thank_you;
                            },
                            st = function (o) {
                                return ot(o) && Wo()
                                    ? Lo().detractor_thank_you_setup
                                    : tt(o) && Ho()
                                    ? Lo().passive_thank_you_setup
                                    : et(o) && Ro()
                                    ? Lo().promoter_thank_you_setup
                                    : Io()
                                    ? jo().thank_you_setup
                                    : et(o)
                                    ? a.localized_texts.social_share.question
                                    : void 0;
                            },
                            dt = function (o) {
                                return ot(o) && $o()
                                    ? No().detractor_thank_you_link_text
                                    : tt(o) && Yo()
                                    ? No().passive_thank_you_link_text
                                    : et(o) && Go()
                                    ? No().promoter_thank_you_link_text
                                    : Uo()
                                    ? Ao().thank_you_link_text
                                    : void 0;
                            },
                            ut = function (o) {
                                return ot(o) && Xo()
                                    ? Do().detractor_thank_you_link_url
                                    : tt(o) && Vo()
                                    ? Do().passive_thank_you_link_url
                                    : et(o) && Jo()
                                    ? Do().promoter_thank_you_link_url
                                    : Fo()
                                    ? Ao().thank_you_link_url
                                    : void 0;
                            },
                            mt = function (o) {
                                var t = {
                                    add_comment_param_to_url: !0,
                                    add_email_param_to_url: !0,
                                    add_score_param_to_url: !0,
                                };
                                return (
                                    ot(o) && Xo()
                                        ? Ao()
                                              .thank_you_link_url_settings_list &&
                                          Ao().thank_you_link_url_settings_list
                                              .detractor_thank_you_link_url_settings &&
                                          (t =
                                              Ao()
                                                  .thank_you_link_url_settings_list
                                                  .detractor_thank_you_link_url_settings)
                                        : tt(o) && Vo()
                                        ? Ao()
                                              .thank_you_link_url_settings_list &&
                                          Ao().thank_you_link_url_settings_list
                                              .passive_thank_you_link_url_settings &&
                                          (t =
                                              Ao()
                                                  .thank_you_link_url_settings_list
                                                  .passive_thank_you_link_url_settings)
                                        : et(o) && Jo()
                                        ? Ao()
                                              .thank_you_link_url_settings_list &&
                                          Ao().thank_you_link_url_settings_list
                                              .promoter_thank_you_link_url_settings &&
                                          (t =
                                              Ao()
                                                  .thank_you_link_url_settings_list
                                                  .promoter_thank_you_link_url_settings)
                                        : Fo() &&
                                          Ao().thank_you_link_url_settings &&
                                          (t =
                                              Ao().thank_you_link_url_settings),
                                    t
                                );
                            },
                            pt = function (o, t) {
                                var e = o.replace(/\/+$/, "");
                                d.isEmptyObject(t) ||
                                    ((e += /[?]/.test(e) ? "&" : "?"),
                                    (e += d.param(t)));
                                return e;
                            },
                            ft = function () {
                                var o;
                                return (
                                    (o = d("#wootric-modal", s)),
                                    o.addClass("modal-locked")
                                );
                            },
                            wt = function () {
                                var o;
                                return (
                                    (o = d("#wootric-modal", s)),
                                    o.hasClass("modal-locked")
                                );
                            },
                            ht = function () {
                                if (e.read("surveyed") && !wt()) return _o();
                            },
                            gt = function () {
                                d(window).on({
                                    focus: ht,
                                    visibilitychange: ht,
                                });
                            },
                            bt = function () {
                                i.logServerError(), _o();
                            };
                        return {
                            setupSurvey: f,
                            survey: b,
                            closeOnClick: U,
                            resetSurvey: p,
                        };
                    }
                ),
                s(
                    "modules/custom_sampling",
                    ["jquery", "./utils"],
                    function (o, t) {
                        var e = o.noConflict(!0),
                            r = {},
                            i = function (o) {
                                r && (r = o);
                            },
                            n = function (o) {
                                var i = t.getEligibilityServerURL(o, r),
                                    n = {
                                        account_token: r.settings.account_token,
                                        sdk_version: r.version,
                                        event_name: r.settings.event_name,
                                    };
                                return e.ajax({
                                    url:
                                        i +
                                        "/registered_events.json?" +
                                        e.param(n),
                                });
                            },
                            c = function (o) {
                                return (
                                    (o = t.chooseEligibilityServer(o, r)),
                                    void 0 === window.wootricEventList
                                        ? n(o)
                                              .then(function (o) {
                                                  return (
                                                      (window.wootricEventList =
                                                          o),
                                                      e.inArray(
                                                          r.settings.event_name,
                                                          o
                                                      ) > -1
                                                  );
                                              })
                                              .fail(function () {
                                                  return "secondary" === o
                                                      ? c("main")
                                                      : {
                                                            error: "Wootric: unable to fetch registered events",
                                                        };
                                              })
                                        : e
                                              .Deferred()
                                              .resolve()
                                              .then(function () {
                                                  return (
                                                      e.inArray(
                                                          r.settings.event_name,
                                                          window.wootricEventList
                                                      ) > -1
                                                  );
                                              })
                                );
                            };
                        return { init: i, isRegisteredEvent: c };
                    }
                ),
                s("modules/segment", ["jquery"], function (o) {
                    var t = o.noConflict(!0);
                    return {
                        enable_property_cache: function (o) {
                            t.isEmptyObject(window.wootricSegmentProperties) &&
                                (window.wootricSegmentProperties = {
                                    track: {},
                                    identify: {},
                                }),
                                o.event_name
                                    ? (window.wootricSegmentProperties.track =
                                          t.extend({}, o.properties))
                                    : (window.wootricSegmentProperties.identify =
                                          t.extend({}, o.properties)),
                                (o.properties = t.extend(
                                    {},
                                    window.wootricSegmentProperties.identify,
                                    window.wootricSegmentProperties.track
                                ));
                        },
                        isActive: function (o) {
                            return o && null !== o.match(/segment/i);
                        },
                    };
                });
            var h = {}.hasOwnProperty;
            return (
                s(
                    "beacon",
                    [
                        "jquery",
                        "./modules/config",
                        "./modules/cookie",
                        "./modules/survey",
                        "./modules/visual",
                        "./modules/utils",
                        "./modules/custom_sampling",
                        "./modules/segment",
                    ],
                    function (o, t, e, r, i, n, c, a) {
                        var l,
                            s,
                            d,
                            u = ["active_throttles", "age", "quota"];
                        (window.wootric_event_queue = []),
                            (window.wootric_show_logs = !0),
                            (window.wootric_segment_integration = !1),
                            (window.wootric_survey_running = !1);
                        var m = o.noConflict(!0),
                            p = function (o, t) {
                                return JSON.stringify(o) === JSON.stringify(t);
                            },
                            f = function (o) {
                                for (
                                    var t = !1, e = 0;
                                    e < window.wootric_event_queue.length;
                                    e++
                                )
                                    if (p(o, window.wootric_event_queue[e])) {
                                        t = !0;
                                        break;
                                    }
                                t || window.wootric_event_queue.push(o);
                            },
                            w = function () {
                                return (
                                    !window.wootric_survey_immediately &&
                                    (window.wootric_modal_loaded
                                        ? (m("#wootric-modal").is(":visible") &&
                                              n.log(
                                                  "Wootric: Modal already loaded."
                                              ),
                                          !0)
                                        : ((window.wootric_modal_loaded = !0),
                                          !1))
                                );
                            },
                            g = function () {
                                if (x())
                                    return l.settings.event_name
                                        ? y("event")
                                        : y();
                            },
                            b = function (o) {
                                var r, i;
                                (i = {
                                    account_token: l.account_token,
                                    email: l.email,
                                    end_user_created_at: l.created_at,
                                    survey_immediately: l.survey_immediately,
                                    end_user_last_seen: e.read("last_seen"),
                                    registered_percent: l.registered_percent,
                                    language: {
                                        code: l.language,
                                        audience_text: l.audience_text,
                                        product_name: l.product_name,
                                    },
                                    sdk_version: t.version(),
                                    has_custom_messages: !m.isEmptyObject(
                                        window.customMessages
                                    ),
                                    segment_user_id: l.segment_user_id,
                                }),
                                    m.isEmptyObject(l.properties) ||
                                        (i.properties =
                                            n.parseWootricProperties(
                                                l.properties
                                            )),
                                    "event" === o
                                        ? (i.event_name = l.settings.event_name)
                                        : ((i.first_survey_delay =
                                              l.first_survey),
                                          (i.daily_response_cap =
                                              l.daily_response_cap),
                                          (i.resurvey_throttle =
                                              l.resurvey_throttle));
                                for (r in i)
                                    h.call(i, r) && (i[r] || delete i[r]);
                                return i;
                            },
                            v = function (o) {
                                return (
                                    !(
                                        window.wootric_segment_integration &&
                                        window.wootric_event_queue.length >= 5
                                    ) &&
                                    (null !== e.read("last_seen") ||
                                        o.no_last_seen_cookie ||
                                        e.create(
                                            "last_seen",
                                            new Date().getTime(),
                                            90
                                        ),
                                    !(
                                        w() &&
                                        !window.wootric_segment_integration
                                    ) &&
                                        (!!o ||
                                            (n.log(
                                                "Wootric: undefined wootricSettings object"
                                            ),
                                            !1)))
                                );
                            },
                            y = function (o, t) {
                                var e,
                                    i = b(o),
                                    c = wootricSettings.page_info,
                                    a = { url: n.originURL(!0) };
                                return (
                                    c &&
                                        (a.segment = {
                                            page: {
                                                path: c.path,
                                                name: c.name,
                                            },
                                        }),
                                    (t = n.chooseEligibilityServer(t, l)),
                                    (e =
                                        n.getEligibilityServerURL(t, l) +
                                        "/eligible.json?" +
                                        m.param(i)),
                                    (d = m
                                        .ajax({
                                            url: e,
                                            method: "POST",
                                            data: {
                                                location: JSON.stringify(a),
                                            },
                                            contentType:
                                                "application/x-www-form-urlencoded; charset=UTF-8",
                                            dataType: "json",
                                        })
                                        .done(function (o) {
                                            var t = [
                                                "ask_permission_to_share_feedback",
                                                "show_opt_out",
                                            ];
                                            m.each(t, function (t, e) {
                                                !l.hasOwnProperty(e) &&
                                                    o.settings &&
                                                    o.settings[e] &&
                                                    (l[e] = !0);
                                            }),
                                                o.settings &&
                                                    o.settings.end_user_email &&
                                                    ((l.email =
                                                        o.settings.end_user_email),
                                                    (l.settings.email =
                                                        o.settings.end_user_email)),
                                                o.settings &&
                                                    o.settings.account_token &&
                                                    (l.account_token =
                                                        o.settings.account_token),
                                                l.settings.callbacks
                                                    .after_eligible &&
                                                    l.settings.callbacks.after_eligible(
                                                        o.eligible
                                                    );
                                            var e = [
                                                "custom_first_question",
                                                "custom_first_question_enabled",
                                            ];
                                            if (
                                                (m.each(e, function (t, e) {
                                                    !l.settings.hasOwnProperty(
                                                        e
                                                    ) &&
                                                        o.settings &&
                                                        e in o.settings &&
                                                        (l.settings[e] =
                                                            o.settings[e]);
                                                }),
                                                o.eligible)
                                            )
                                                return (
                                                    o.settings.sampling_rule &&
                                                        (l.sampling_rule =
                                                            o.sampling_rule),
                                                    r.setupSurvey(
                                                        o.settings,
                                                        l
                                                    ),
                                                    (window.wootric_event_queue =
                                                        []),
                                                    (s = l.modalTimeoutID),
                                                    r.survey()
                                                );
                                            window.wootric_survey_immediately ||
                                                ((window.wootric_modal_loaded =
                                                    !1),
                                                (l.settings
                                                    .no_last_seen_cookie &&
                                                    l.settings
                                                        .no_surveyed_cookie) ||
                                                    (m.inArray(
                                                        o.details.code,
                                                        u
                                                    ) > -1 &&
                                                        (o.settings
                                                            .sampling_group
                                                            .belongs_to_sampling_group ||
                                                            _()))),
                                                window.wootric_segment_integration &&
                                                    ((window.wootric_survey_running =
                                                        !1),
                                                    k());
                                        })
                                        .fail(function (e, r) {
                                            "abort" === r
                                                ? (window.wootric_modal_loaded =
                                                      !1)
                                                : "secondary" === t
                                                ? y(o, "main")
                                                : (n.logServerError(),
                                                  window.wootric_segment_integration &&
                                                      ((window.wootric_survey_running =
                                                          !1),
                                                      k()));
                                        }))
                                );
                            },
                            _ = function () {
                                e.create("throttle", !0, 12);
                            },
                            x = function () {
                                var o,
                                    t,
                                    r = !!e.read("throttle");
                                return (
                                    !(
                                        m.isEmptyObject(
                                            wootricSettings.event_name
                                        ) &&
                                        m.isEmptyObject(
                                            wootricSettings.page_info
                                        ) &&
                                        r &&
                                        !l.disable_surveyed_cookie
                                    ) &&
                                    (!!l.settings.event_name ||
                                        (!(
                                            e.read("surveyed") &&
                                            !l.disable_surveyed_cookie
                                        ) &&
                                            (!!l.survey_immediately ||
                                                !l.created_at ||
                                                ((t =
                                                    new Date().getTime() -
                                                    1e3 * l.created_at),
                                                (o =
                                                    60 *
                                                    l.first_survey *
                                                    60 *
                                                    24 *
                                                    1e3),
                                                t >= o ||
                                                    new Date().getTime() -
                                                        e.read("last_seen") >=
                                                        o))))
                                );
                            },
                            k = function () {
                                (window.wootric_segment_integration &&
                                    (0 == window.wootric_event_queue.length ||
                                        window.wootric_survey_running)) ||
                                    ((l = window.wootric_event_queue.shift()),
                                    r.resetSurvey(),
                                    (window.wootric_survey_running = !0),
                                    l.settings.event_name
                                        ? (c.init(l),
                                          c
                                              .isRegisteredEvent()
                                              .then(function (o) {
                                                  return (
                                                      o ||
                                                          ((window.wootric_modal_loaded =
                                                              !1),
                                                          window.wootric_segment_integration &&
                                                              ((window.wootric_survey_running =
                                                                  !1),
                                                              k())),
                                                      o
                                                  );
                                              })
                                              .done(function (o) {
                                                  o && g();
                                              })
                                              .fail(n.log))
                                        : g());
                            },
                            z = function (o) {
                                var e = window.wootricSettings || o;
                                (window.wootric_segment_integration =
                                    a.isActive(e.version)),
                                    a.isActive(e.version) &&
                                        a.enable_property_cache(e),
                                    v(e) && (f(n.concat(t.build(e), e)), k());
                            };
                        return {
                            run: z,
                            stop: function () {
                                d && d.abort(),
                                    window.clearTimeout(s),
                                    m("#wootric-modal").remove();
                            },
                            version: function () {
                                return t.version();
                            },
                            commitId: function () {
                                return i.version;
                            },
                            page: function () {
                                wootricSettings.page_info &&
                                    wootricSettings.email &&
                                    (delete wootricSettings.event_name,
                                    z(wootricSettings));
                            },
                            group: function () {},
                        };
                    }
                ),
                s("main", ["beacon"], function (o) {
                    return o;
                }),
                l(["main"]),
                l("main")
            );
        })()),
        (window.wootric = function (o) {
            switch (o) {
                case "page":
                    WootricSurvey.page();
                    break;
                case "group":
                    WootricSurvey.group();
                    break;
                default:
                    WootricSurvey.run();
            }
        });
})();
